
export const NUTRITION_DATASET = [
  {
    "category": "Meal/Fruit",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 350.0,
    "protein_g": 5.0,
    "carbohydrates_g": 60.0,
    "fat_g": 12.0,
    "fiber_g": 10.0,
    "sodium_mg": 40.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Acai Bowl (1 serving)",
    "display_name_es": "Acai Bowl (1 porción)",
    "display_name_de": "Acai-Bowl (1 Portion)",
    "display_name_fr": "Bol d'açaï (1 portion)",
    "display_name_pt": "Tigela de açaí (1 porção)",
    "display_name_tr": "Acai Kasesi (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Acai puree",
        "name_es": "Puré de açaí",
        "name_de": "Acai-Püree",
        "name_fr": "Purée d'açaï",
        "name_pt": "Purê de açaí",
        "name_tr": "Acai püresi"
      },
      {
        "category_en": "Produce",
        "name_en": "Banana",
        "name_es": "Plátano",
        "name_de": "Banane",
        "name_fr": "Banane",
        "name_pt": "Banana",
        "name_tr": "Muz"
      },
      {
        "category_en": "Produce",
        "name_en": "Mixed berries",
        "name_es": "Frutos rojos mixtos",
        "name_de": "Gemischte Beeren",
        "name_fr": "Mélange de fruits rouges",
        "name_pt": "Mix de frutas vermelhas",
        "name_tr": "Karışık meyveler"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Greek yogurt",
        "name_es": "yogur griego",
        "name_de": "Griechischer Joghurt",
        "name_fr": "yaourt grec",
        "name_pt": "Iogurte grego",
        "name_tr": "Yunan yoğurdu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Granola",
        "name_es": "Granola",
        "name_de": "Granola",
        "name_fr": "Granola",
        "name_pt": "Granola",
        "name_tr": "Granola"
      },
      {
        "category_en": "Pantry",
        "name_en": "Honey",
        "name_es": "Miel",
        "name_de": "Honig",
        "name_fr": "Miel",
        "name_pt": "Mel",
        "name_tr": "Bal"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chia seeds",
        "name_es": "Semillas de chía",
        "name_de": "Chiasamen",
        "name_fr": "Graines de chia",
        "name_pt": "Sementes de chia",
        "name_tr": "Chia tohumları"
      }
    ]
  },
  {
    "category": "Beverage/Dairy-Alt",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 30.0,
    "protein_g": 1.0,
    "carbohydrates_g": 1.0,
    "fat_g": 2.5,
    "fiber_g": 1.0,
    "sodium_mg": 160.0,
    "cholesterol_mg": 0.0,
    "water_ml": 240.0,
    "display_name_en": "Almond Milk (Unsweetened 1 cup)",
    "display_name_es": "Leche de almendras (sin azúcar 1 taza)",
    "display_name_de": "Mandelmilch (ungesüßt, 1 Tasse)",
    "display_name_fr": "Lait d'amande (non sucré, 1 tasse)",
    "display_name_pt": "Leite de amêndoa (sem açúcar, 1 xícara)",
    "display_name_tr": "Badem Sütü (Tatlandırılmamış 1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Almond milk",
        "name_es": "leche de almendras",
        "name_de": "Mandelmilch",
        "name_fr": "lait d'amande",
        "name_pt": "leite de amêndoa",
        "name_tr": "Badem sütü"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 160.0,
    "protein_g": 2.0,
    "carbohydrates_g": 8.5,
    "fat_g": 14.7,
    "fiber_g": 6.7,
    "sodium_mg": 7.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Avocado (1/2 fruit)",
    "display_name_es": "Aguacate (1/2 fruta)",
    "display_name_de": "Avocado (1/2 Frucht)",
    "display_name_fr": "Avocat (1/2 fruit)",
    "display_name_pt": "Abacate (1/2 fruta)",
    "display_name_tr": "Avokado (1/2 meyve)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Avocado",
        "name_es": "Palta",
        "name_de": "Avocado",
        "name_fr": "Avocat",
        "name_pt": "Abacate",
        "name_tr": "Avokado"
      }
    ]
  },
  {
    "category": "Meal/Vegetarian",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 260.0,
    "protein_g": 7.0,
    "carbohydrates_g": 28.0,
    "fat_g": 15.0,
    "fiber_g": 10.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 0.0,
    "water_ml": 500.0,
    "display_name_en": "Avocado Toast (1 slice)",
    "display_name_es": "Tostada de aguacate (1 rebanada)",
    "display_name_de": "Avocado-Toast (1 Scheibe)",
    "display_name_fr": "Toast à l'avocat (1 tranche)",
    "display_name_pt": "Torrada de abacate (1 fatia)",
    "display_name_tr": "Avokado Tostu (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Avocado",
        "name_es": "Palta",
        "name_de": "Avocado",
        "name_fr": "Avocat",
        "name_pt": "Abacate",
        "name_tr": "Avokado"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Manteca",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Whole grain bread",
        "name_es": "pan integral",
        "name_de": "Vollkornbrot",
        "name_fr": "pain complet",
        "name_pt": "pão integral",
        "name_tr": "Tam tahıllı ekmek"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 86.0,
    "protein_g": 6.0,
    "carbohydrates_g": 0.2,
    "fat_g": 6.8,
    "fiber_g": 0.0,
    "sodium_mg": 330.0,
    "cholesterol_mg": 18.0,
    "water_ml": 0.0,
    "display_name_en": "Bacon (2 slices cooked)",
    "display_name_es": "Tocino (2 rebanadas cocidas)",
    "display_name_de": "Speck (2 Scheiben gebraten)",
    "display_name_fr": "Bacon (2 tranches cuites)",
    "display_name_pt": "Bacon (2 fatias cozidas)",
    "display_name_tr": "Pastırma (2 dilim pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Bacon",
        "name_es": "Tocino",
        "name_de": "Speck",
        "name_fr": "Lard",
        "name_pt": "Bacon",
        "name_tr": "Pastırma"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 270.0,
    "protein_g": 11.0,
    "carbohydrates_g": 55.0,
    "fat_g": 1.5,
    "fiber_g": 2.0,
    "sodium_mg": 430.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Bagel (plain)",
    "display_name_es": "Bagel (simple)",
    "display_name_de": "Bagel (natur)",
    "display_name_fr": "Bagel (nature)",
    "display_name_pt": "Bagel (simples)",
    "display_name_tr": "Simit (sade)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Bagel",
        "name_es": "Rosquilla",
        "name_de": "Bagel",
        "name_fr": "Bagel",
        "name_pt": "Bagel",
        "name_tr": "Simit"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 105.0,
    "protein_g": 1.3,
    "carbohydrates_g": 27.0,
    "fat_g": 0.4,
    "fiber_g": 3.1,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Banana",
    "display_name_es": "Banana",
    "display_name_de": "Banane",
    "display_name_fr": "Banane",
    "display_name_pt": "Banana",
    "display_name_tr": "Muz",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Banana",
        "name_es": "Banana",
        "name_de": "Banane",
        "name_fr": "Banane",
        "name_pt": "Banana",
        "name_tr": "Muz"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 480.0,
    "protein_g": 10.0,
    "carbohydrates_g": 45.0,
    "fat_g": 28.0,
    "fiber_g": 2.0,
    "sodium_mg": 1100.0,
    "cholesterol_mg": 35.0,
    "water_ml": 250.0,
    "display_name_en": "Biscuits and Gravy (1 serving)",
    "display_name_es": "Galletas y salsa (1 porción)",
    "display_name_de": "Biscuits and Gravy (1 Portion)",
    "display_name_fr": "Biscuits et sauce (1 portion)",
    "display_name_pt": "Biscoitos com molho (1 porção)",
    "display_name_tr": "Bisküvi ve Sos (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Biscuits",
        "name_es": "Galletas",
        "name_de": "Kekse",
        "name_fr": "Biscuits",
        "name_pt": "Biscoitos",
        "name_tr": "Bisküvi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Breakfast sausage",
        "name_es": "Salchichas de desayuno",
        "name_de": "Frühstückswurst",
        "name_fr": "Saucisses pour le petit-déjeuner",
        "name_pt": "Salsicha para o café da manhã",
        "name_tr": "Kahvaltılık sosis"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 42.0,
    "protein_g": 0.5,
    "carbohydrates_g": 11.0,
    "fat_g": 0.2,
    "fiber_g": 1.8,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Blueberries (1/2 cup)",
    "display_name_es": "Arándanos (1/2 taza)",
    "display_name_de": "Blaubeeren (1/2 Tasse)",
    "display_name_fr": "Myrtilles (1/2 tasse)",
    "display_name_pt": "Mirtilos (1/2 xícara)",
    "display_name_tr": "Yaban mersini (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Blueberries",
        "name_es": "Arándanos",
        "name_de": "Blaubeeren",
        "name_fr": "myrtilles",
        "name_pt": "Mirtilos",
        "name_tr": "Yaban mersini"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 80.0,
    "protein_g": 12.0,
    "carbohydrates_g": 1.0,
    "fat_g": 3.0,
    "fiber_g": 0.0,
    "sodium_mg": 650.0,
    "cholesterol_mg": 40.0,
    "water_ml": 0.0,
    "display_name_en": "Canadian Bacon (2 slices)",
    "display_name_es": "Tocino canadiense (2 rebanadas)",
    "display_name_de": "Kanadischer Speck (2 Scheiben)",
    "display_name_fr": "Bacon canadien (2 tranches)",
    "display_name_pt": "Bacon canadense (2 fatias)",
    "display_name_tr": "Kanada Pastırması (2 dilim)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Canadian bacon",
        "name_es": "Tocino canadiense",
        "name_de": "Kanadischer Speck",
        "name_fr": "bacon canadien",
        "name_pt": "bacon canadense",
        "name_tr": "Kanada pastırması"
      }
    ]
  },
  {
    "category": "Grain/Processed",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 130.0,
    "protein_g": 2.0,
    "carbohydrates_g": 31.0,
    "fat_g": 0.0,
    "fiber_g": 1.0,
    "sodium_mg": 190.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Cereal (Frosted Flakes 1 cup)",
    "display_name_es": "Cereal (Copos glaseados 1 taza)",
    "display_name_de": "Müsli (Frosted Flakes 1 Tasse)",
    "display_name_fr": "Céréales (Frosted Flakes 1 tasse)",
    "display_name_pt": "Cereal (1 xícara de Frosted Flakes)",
    "display_name_tr": "Tahıl (Şekerlenmiş Gevrek 1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Frosted flakes cereal",
        "name_es": "Cereal en copos escarchados",
        "name_de": "Frosted Flakes Müsli",
        "name_fr": "Céréales Frosted Flakes",
        "name_pt": "Cereal Frosted Flakes",
        "name_tr": "Buzlu gevrek gevreği"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 140.0,
    "protein_g": 2.0,
    "carbohydrates_g": 30.0,
    "fat_g": 3.0,
    "fiber_g": 1.0,
    "sodium_mg": 110.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Cereal Bar (Fruit)",
    "display_name_es": "Barra de cereales (fruta)",
    "display_name_de": "Müsliriegel (Frucht)",
    "display_name_fr": "Barre de céréales (fruits)",
    "display_name_pt": "Barra de Cereal (Frutas)",
    "display_name_tr": "Tahıl Barı (Meyve)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Dried fruit",
        "name_es": "Frutos secos",
        "name_de": "Trockenfrüchte",
        "name_fr": "fruits secs",
        "name_pt": "Frutas secas",
        "name_tr": "Kurutulmuş meyve"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cereal bar",
        "name_es": "Barra de cereales",
        "name_de": "Müsliriegel",
        "name_fr": "Barre de céréales",
        "name_pt": "Barra de cereal",
        "name_tr": "Tahıl barı"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Breakfast",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 340.0,
    "protein_g": 7.0,
    "carbohydrates_g": 38.0,
    "fat_g": 18.0,
    "fiber_g": 2.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 55.0,
    "water_ml": 250.0,
    "display_name_en": "Cheese Danish",
    "display_name_es": "Queso danés",
    "display_name_de": "Käse-Danish",
    "display_name_fr": "danoise au fromage",
    "display_name_pt": "Dinamarquês de Queijo",
    "display_name_tr": "Peynirli Danimarka",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon zest",
        "name_es": "ralladura de limón",
        "name_de": "Zitronenschale",
        "name_fr": "zeste de citron",
        "name_pt": "raspas de limão",
        "name_tr": "Limon kabuğu rendesi"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream cheese",
        "name_es": "Queso crema",
        "name_de": "Frischkäse",
        "name_fr": "Fromage à la crème",
        "name_pt": "Requeijão cremoso",
        "name_tr": "Krem peynir"
      },
      {
        "category_en": "Pantry",
        "name_en": "Danish pastry dough",
        "name_es": "Masa de hojaldre danesa",
        "name_de": "Dänischer Gebäckteig",
        "name_fr": "Pâte à pâtisserie danoise",
        "name_pt": "Massa folhada dinamarquesa",
        "name_tr": "Danimarka hamur işi hamuru"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Meal/Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 210.0,
    "protein_g": 6.0,
    "carbohydrates_g": 34.0,
    "fat_g": 6.0,
    "fiber_g": 2.0,
    "sodium_mg": 550.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Cheesy Grits (1 cup)",
    "display_name_es": "Sémola de queso (1 taza)",
    "display_name_de": "Käsegrütze (1 Tasse)",
    "display_name_fr": "Gruau au fromage (1 tasse)",
    "display_name_pt": "Grits com Queijo (1 xícara)",
    "display_name_tr": "Peynirli Yulaf Ezmesi (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese",
        "name_es": "Queso cheddar",
        "name_de": "Cheddar-Käse",
        "name_fr": "Fromage cheddar",
        "name_pt": "Queijo cheddar",
        "name_tr": "Çedar peyniri"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Grits",
        "name_es": "Sémola de maíz",
        "name_de": "Grütze",
        "name_fr": "Gruau de maïs",
        "name_pt": "Grits",
        "name_tr": "Yulaf ezmesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Breakfast",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 350.0,
    "protein_g": 6.0,
    "carbohydrates_g": 40.0,
    "fat_g": 19.0,
    "fiber_g": 3.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 40.0,
    "water_ml": 250.0,
    "display_name_en": "Chocolate Croissant",
    "display_name_es": "Croissant de chocolate",
    "display_name_de": "Schokoladencroissant",
    "display_name_fr": "Croissant au chocolat",
    "display_name_pt": "Croissant de chocolate",
    "display_name_tr": "Çikolatalı Kruvasan",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Croissant pastry",
        "name_es": "Masa de croissant",
        "name_de": "Croissant-Gebäck",
        "name_fr": "Pâtisserie croissant",
        "name_pt": "Massa folhada de croissant",
        "name_tr": "Kruvasan hamur işi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chocolate",
        "name_es": "Chocolate",
        "name_de": "Schokolade",
        "name_fr": "Chocolat",
        "name_pt": "Chocolate",
        "name_tr": "Çikolata"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Breakfast",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 300.0,
    "protein_g": 4.0,
    "carbohydrates_g": 35.0,
    "fat_g": 17.0,
    "fiber_g": 2.0,
    "sodium_mg": 230.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Chocolate Donut (1 medium)",
    "display_name_es": "Dona de chocolate (1 mediana)",
    "display_name_de": "Schokoladen-Donut (1 mittelgroß)",
    "display_name_fr": "Beignet au chocolat (1 moyen)",
    "display_name_pt": "Rosquinha de chocolate (1 média)",
    "display_name_tr": "Çikolatalı Donut (1 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Yeast donut",
        "name_es": "Donut de levadura",
        "name_de": "Hefedonut",
        "name_fr": "Beignet à la levure",
        "name_pt": "Rosquinha de fermento",
        "name_tr": "Mayalı donut"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chocolate glaze",
        "name_es": "Glaseado de chocolate",
        "name_de": "Schokoladenglasur",
        "name_fr": "Glaçage au chocolat",
        "name_pt": "Cobertura de chocolate",
        "name_tr": "Çikolatalı sır"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 35.0,
    "protein_g": 0.3,
    "carbohydrates_g": 1.5,
    "fat_g": 3.3,
    "fiber_g": 0.7,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Coconut Flakes (1 tbsp topping)",
    "display_name_es": "Copos de coco (1 cucharada de cobertura)",
    "display_name_de": "Kokosflocken (1 EL als Topping)",
    "display_name_fr": "Flocons de noix de coco (1 cuillère à soupe de garniture)",
    "display_name_pt": "Flocos de coco (1 colher de sopa para cobertura)",
    "display_name_tr": "Hindistan Cevizi Gevreği (1 yemek kaşığı üst malzeme)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Coconut flakes",
        "name_es": "copos de coco",
        "name_de": "Kokosflocken",
        "name_fr": "flocons de noix de coco",
        "name_pt": "Flocos de coco",
        "name_tr": "Hindistan cevizi gevreği"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 5.0,
    "protein_g": 0.3,
    "carbohydrates_g": 0.0,
    "fat_g": 0.1,
    "fiber_g": 0.0,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Coffee (black)",
    "display_name_es": "Café (negro)",
    "display_name_de": "Kaffee (schwarz)",
    "display_name_fr": "Café (noir)",
    "display_name_pt": "Café (preto)",
    "display_name_tr": "Kahve (siyah)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Coffee",
        "name_es": "Café",
        "name_de": "Kaffee",
        "name_fr": "Café",
        "name_pt": "Café",
        "name_tr": "Kahve"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 50.0,
    "protein_g": 0.5,
    "carbohydrates_g": 5.0,
    "fat_g": 3.0,
    "fiber_g": 0.0,
    "sodium_mg": 10.0,
    "cholesterol_mg": 10.0,
    "water_ml": 250.0,
    "display_name_en": "Coffee (with cream/sugar)",
    "display_name_es": "Café (con crema/azúcar)",
    "display_name_de": "Kaffee (mit Sahne/Zucker)",
    "display_name_fr": "Café (avec crème/sucre)",
    "display_name_pt": "Café (com creme/açúcar)",
    "display_name_tr": "Kahve (kremalı/şekerli)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Coffee",
        "name_es": "Café",
        "name_de": "Kaffee",
        "name_fr": "Café",
        "name_pt": "Café",
        "name_tr": "Kahve"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Coffee creamer",
        "name_es": "Crema para café",
        "name_de": "Kaffeeweißer",
        "name_fr": "Crème à café",
        "name_pt": "Creme para café",
        "name_tr": "Kahve kreması"
      }
    ]
  },
  {
    "category": "Meal/Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 130.0,
    "protein_g": 2.5,
    "carbohydrates_g": 28.0,
    "fat_g": 1.0,
    "fiber_g": 1.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Congee (1 cup plain)",
    "display_name_es": "Congee (1 taza simple)",
    "display_name_de": "Congee (1 Tasse pur)",
    "display_name_fr": "Congee (1 tasse nature)",
    "display_name_pt": "Congee (1 xícara simples)",
    "display_name_tr": "Congee (1 su bardağı sade)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Green onion (garnish)",
        "name_es": "Cebolla verde (guarnición)",
        "name_de": "Frühlingszwiebeln (zum Garnieren)",
        "name_fr": "Oignon vert (garniture)",
        "name_pt": "Cebolinha verde (para decorar)",
        "name_tr": "Yeşil soğan (süsleme)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg (optional)",
        "name_es": "Huevo (opcional)",
        "name_de": "Ei (optional)",
        "name_fr": "Œuf (facultatif)",
        "name_pt": "Ovo (opcional)",
        "name_tr": "Yumurta (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice",
        "name_es": "Arroz",
        "name_de": "Reis",
        "name_fr": "Riz",
        "name_pt": "Arroz",
        "name_tr": "Pirinç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soy sauce",
        "name_es": "Salsa de soja",
        "name_de": "Sojasauce",
        "name_fr": "Sauce soja",
        "name_pt": "Molho de soja",
        "name_tr": "Soya sosu"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 130.0,
    "protein_g": 0.0,
    "carbohydrates_g": 33.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 10.0,
    "cholesterol_mg": 0.0,
    "water_ml": 240.0,
    "display_name_en": "Cranberry Juice (1 cup)",
    "display_name_es": "Jugo de arándano (1 taza)",
    "display_name_de": "Cranberrysaft (1 Tasse)",
    "display_name_fr": "Jus de canneberge (1 tasse)",
    "display_name_pt": "Suco de cranberry (1 xícara)",
    "display_name_tr": "Kızılcık Suyu (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cranberry",
        "name_es": "Arándano",
        "name_de": "Preiselbeere",
        "name_fr": "Canneberge",
        "name_pt": "Oxicoco",
        "name_tr": "Kızılcık"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 100.0,
    "protein_g": 2.0,
    "carbohydrates_g": 2.0,
    "fat_g": 10.0,
    "fiber_g": 0.0,
    "sodium_mg": 90.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Cream Cheese (2 tbsp)",
    "display_name_es": "Queso crema (2 cucharadas)",
    "display_name_de": "Frischkäse (2 EL)",
    "display_name_fr": "Fromage à la crème (2 cuillères à soupe)",
    "display_name_pt": "Queijo creme (2 colheres de sopa)",
    "display_name_tr": "Krema Peyniri (2 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream cheese",
        "name_es": "Queso crema",
        "name_de": "Frischkäse",
        "name_fr": "Fromage à la crème",
        "name_pt": "Requeijão cremoso",
        "name_tr": "Krem peynir"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 90.0,
    "protein_g": 3.5,
    "carbohydrates_g": 14.0,
    "fat_g": 2.0,
    "fiber_g": 0.5,
    "sodium_mg": 100.0,
    "cholesterol_mg": 25.0,
    "water_ml": 0.0,
    "display_name_en": "Crepe (1 plain)",
    "display_name_es": "Crepe (1 simple)",
    "display_name_de": "Crêpe (1 pur)",
    "display_name_fr": "Crêpe (1 nature)",
    "display_name_pt": "Crepe (1 simples)",
    "display_name_tr": "Krep (1 sade)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 8.0,
    "protein_g": 0.3,
    "carbohydrates_g": 1.8,
    "fat_g": 0.0,
    "fiber_g": 0.2,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Cucumber (1/4 cup side)",
    "display_name_es": "Pepino (1/4 taza de lado)",
    "display_name_de": "Gurke (1/4 Tasse Seite)",
    "display_name_fr": "Concombre (1/4 de tasse)",
    "display_name_pt": "Pepino (1/4 de xícara como acompanhamento)",
    "display_name_tr": "Salatalık (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Breakfast",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 340.0,
    "protein_g": 7.0,
    "carbohydrates_g": 38.0,
    "fat_g": 18.0,
    "fiber_g": 2.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 55.0,
    "water_ml": 250.0,
    "display_name_en": "Danish (Cheese 1 medium)",
    "display_name_es": "Danés (Queso 1 mediano)",
    "display_name_de": "Dänisches Gebäck (Käse 1 mittelgroß)",
    "display_name_fr": "Danois (Fromage 1 moyen)",
    "display_name_pt": "Dinamarquês (Queijo 1 médio)",
    "display_name_tr": "Danimarka (Peynir 1 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream cheese",
        "name_es": "Queso crema",
        "name_de": "Frischkäse",
        "name_fr": "Fromage à la crème",
        "name_pt": "Requeijão cremoso",
        "name_tr": "Krem peynir"
      },
      {
        "category_en": "Pantry",
        "name_en": "Danish pastry dough",
        "name_es": "masa de hojaldre danesa",
        "name_de": "dänischer Gebäckteig",
        "name_fr": "Pâtisserie danoise",
        "name_pt": "massa folhada dinamarquesa",
        "name_tr": "Danimarka hamur işi hamuru"
      }
    ]
  },
  {
    "category": "Protein",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 100.0,
    "protein_g": 7.0,
    "carbohydrates_g": 1.0,
    "fat_g": 7.0,
    "fiber_g": 0.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 200.0,
    "water_ml": 0.0,
    "display_name_en": "Egg (1 egg)",
    "display_name_es": "Huevo (1 huevo)",
    "display_name_de": "Ei (1 Ei)",
    "display_name_fr": "Œuf (1 œuf)",
    "display_name_pt": "Ovo (1 ovo)",
    "display_name_tr": "Yumurta (1 yumurta)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      }
    ]
  },
  {
    "category": "Grain/Processed",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 4.0,
    "carbohydrates_g": 30.0,
    "fat_g": 5.0,
    "fiber_g": 1.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Eggo Waffle (2 waffles)",
    "display_name_es": "Eggo Waffle (2 waffles)",
    "display_name_de": "Eggo Waffel (2 Waffeln)",
    "display_name_fr": "Gaufre Eggo (2 gaufres)",
    "display_name_pt": "Waffle Eggo (2 waffles)",
    "display_name_tr": "Eggo Waffle (2 waffle)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Frozen waffles",
        "name_es": "Gofres congelados",
        "name_de": "Gefrorene Waffeln",
        "name_fr": "Gaufres surgelées",
        "name_pt": "Waffles congelados",
        "name_tr": "Dondurulmuş waffle"
      },
      {
        "category_en": "Pantry",
        "name_en": "Syrup",
        "name_es": "Jarabe",
        "name_de": "Sirup",
        "name_fr": "Sirop",
        "name_pt": "Calda",
        "name_tr": "Şurup"
      }
    ]
  },
  {
    "category": "Meal/Protein",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 600.0,
    "protein_g": 25.0,
    "carbohydrates_g": 30.0,
    "fat_g": 40.0,
    "fiber_g": 3.0,
    "sodium_mg": 1100.0,
    "cholesterol_mg": 450.0,
    "water_ml": 250.0,
    "display_name_en": "Eggs Benedict (1 serving)",
    "display_name_es": "Huevos Benedict (1 porción)",
    "display_name_de": "Eggs Benedict (1 Portion)",
    "display_name_fr": "Œufs Bénédicte (1 portion)",
    "display_name_pt": "Ovos Benedict (1 porção)",
    "display_name_tr": "Benedict Yumurtası (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Spinach (optional)",
        "name_es": "Espinacas (opcional)",
        "name_de": "Spinat (optional)",
        "name_fr": "Épinards (facultatif)",
        "name_pt": "Espinafre (opcional)",
        "name_tr": "Ispanak (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Eggs",
        "name_es": "Huevos",
        "name_de": "Eier",
        "name_fr": "Œufs",
        "name_pt": "Ovos",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "English muffin",
        "name_es": "Muffin inglés",
        "name_de": "Englischer Muffin",
        "name_fr": "Muffin anglais",
        "name_pt": "Muffin inglês",
        "name_tr": "İngiliz çöreği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ham",
        "name_es": "Jamón",
        "name_de": "Schinken",
        "name_fr": "Jambon",
        "name_pt": "Presunto",
        "name_tr": "Jambon"
      },
      {
        "category_en": "Pantry",
        "name_en": "Hollandaise mix",
        "name_es": "Mezcla para salsa holandesa",
        "name_de": "Sauce Hollandaise",
        "name_fr": "Mélange à sauce hollandaise",
        "name_pt": "Mistura para molho holandês",
        "name_tr": "Hollandaise karışımı"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 134.0,
    "protein_g": 6.0,
    "carbohydrates_g": 26.0,
    "fat_g": 1.0,
    "fiber_g": 4.4,
    "sodium_mg": 210.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "English Muffin (whole wheat)",
    "display_name_es": "Muffin inglés (integral)",
    "display_name_de": "Englischer Muffin (Vollkorn)",
    "display_name_fr": "Muffin anglais (blé entier)",
    "display_name_pt": "Muffin inglês (trigo integral)",
    "display_name_tr": "İngiliz çöreği (tam buğday)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Whole wheat English muffin",
        "name_es": "Muffin inglés de trigo integral",
        "name_de": "Vollkorn-English-Muffin",
        "name_fr": "muffin anglais au blé entier",
        "name_pt": "muffin inglês integral",
        "name_tr": "Tam buğdaylı İngiliz çöreği"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 6.0,
    "carbohydrates_g": 36.0,
    "fat_g": 1.0,
    "fiber_g": 2.0,
    "sodium_mg": 380.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "French Bread (2 slices)",
    "display_name_es": "Pan francés (2 rebanadas)",
    "display_name_de": "Französisches Brot (2 Scheiben)",
    "display_name_fr": "Pain français (2 tranches)",
    "display_name_pt": "Pão francês (2 fatias)",
    "display_name_tr": "Fransız Ekmeği (2 dilim)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "French bread",
        "name_es": "pan francés",
        "name_de": "Französisches Brot",
        "name_fr": "pain français",
        "name_pt": "pão francês",
        "name_tr": "Fransız ekmeği"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 103.0,
    "protein_g": 6.1,
    "carbohydrates_g": 0.1,
    "fat_g": 8.5,
    "fiber_g": 0.0,
    "sodium_mg": 146.0,
    "cholesterol_mg": 22.0,
    "water_ml": 0.0,
    "display_name_en": "Goat Cheese (1 oz)",
    "display_name_es": "Queso de cabra (1 oz)",
    "display_name_de": "Ziegenkäse (1 oz)",
    "display_name_fr": "Fromage de chèvre (1 oz)",
    "display_name_pt": "Queijo de cabra (28 g)",
    "display_name_tr": "Keçi Peyniri (1 ons)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Goat cheese",
        "name_es": "queso de cabra",
        "name_de": "Ziegenkäse",
        "name_fr": "fromage de chèvre",
        "name_pt": "Queijo de cabra",
        "name_tr": "Keçi peyniri"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 120.0,
    "protein_g": 3.0,
    "carbohydrates_g": 15.0,
    "fat_g": 6.0,
    "fiber_g": 3.0,
    "sodium_mg": 20.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Granola (1/4 cup topping)",
    "display_name_es": "Granola (1/4 taza de cobertura)",
    "display_name_de": "Granola (1/4 Tasse Topping)",
    "display_name_fr": "Granola (garniture de 1/4 tasse)",
    "display_name_pt": "Granola (1/4 de xícara para cobertura)",
    "display_name_tr": "Granola (1/4 su bardağı üst malzeme)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Dried fruit",
        "name_es": "Frutos secos",
        "name_de": "Trockenfrüchte",
        "name_fr": "fruits secs",
        "name_pt": "Frutas secas",
        "name_tr": "Kurutulmuş meyve"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk (optional)",
        "name_es": "Leche (opcional)",
        "name_de": "Milch (optional)",
        "name_fr": "Lait (facultatif)",
        "name_pt": "Leite (opcional)",
        "name_tr": "Süt (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt (optional)",
        "name_es": "Yogur (opcional)",
        "name_de": "Joghurt (optional)",
        "name_fr": "Yaourt (facultatif)",
        "name_pt": "Iogurte (opcional)",
        "name_tr": "Yoğurt (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Granola",
        "name_es": "Granola",
        "name_de": "Granola",
        "name_fr": "Granola",
        "name_pt": "Granola",
        "name_tr": "Granola"
      },
      {
        "category_en": "Pantry",
        "name_en": "Nuts",
        "name_es": "Nueces",
        "name_de": "Nüsse",
        "name_fr": "Noix",
        "name_pt": "Nozes",
        "name_tr": "Kuruyemişler"
      },
      {
        "category_en": "Pantry",
        "name_en": "Seeds",
        "name_es": "Semillas",
        "name_de": "Samen",
        "name_fr": "Graines",
        "name_pt": "Sementes",
        "name_tr": "Tohumlar"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 52.0,
    "protein_g": 1.1,
    "carbohydrates_g": 13.2,
    "fat_g": 0.2,
    "fiber_g": 2.0,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Grapefruit (1/2 medium)",
    "display_name_es": "Pomelo (1/2 mediano)",
    "display_name_de": "Grapefruit (1/2 mittelgroß)",
    "display_name_fr": "Pamplemousse (1/2 moyen)",
    "display_name_pt": "Toranja (1/2 média)",
    "display_name_tr": "Greyfurt (1/2 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Grapefruit",
        "name_es": "Pomelo",
        "name_de": "Grapefruit",
        "name_fr": "Pamplemousse",
        "name_pt": "Toranja",
        "name_tr": "Greyfurt"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 150.0,
    "protein_g": 3.0,
    "carbohydrates_g": 32.0,
    "fat_g": 1.0,
    "fiber_g": 2.0,
    "sodium_mg": 320.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Grits (1 cup cooked)",
    "display_name_es": "Sémola de maíz (1 taza cocida)",
    "display_name_de": "Grütze (1 Tasse gekocht)",
    "display_name_fr": "Gruau de maïs (1 tasse cuite)",
    "display_name_pt": "Grits (1 xícara cozida)",
    "display_name_tr": "İrmik (1 su bardağı pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Grits",
        "name_es": "Sémola de maíz",
        "name_de": "Grütze",
        "name_fr": "Gruau de maïs",
        "name_pt": "Grits",
        "name_tr": "Yulaf ezmesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 400.0,
    "protein_g": 15.0,
    "carbohydrates_g": 35.0,
    "fat_g": 22.0,
    "fiber_g": 2.0,
    "sodium_mg": 750.0,
    "cholesterol_mg": 60.0,
    "water_ml": 250.0,
    "display_name_en": "Ham & Cheese Croissant",
    "display_name_es": "Croissant de jamón y queso",
    "display_name_de": "Schinken-Käse-Croissant",
    "display_name_fr": "Croissant jambon-fromage",
    "display_name_pt": "Croissant de presunto e queijo",
    "display_name_tr": "Jambon ve Peynirli Kruvasan",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Ham",
        "name_es": "Jamón",
        "name_de": "Schinken",
        "name_fr": "Jambon",
        "name_pt": "Presunto",
        "name_tr": "Jambon"
      },
      {
        "category_en": "Pantry",
        "name_en": "Croissant pastry",
        "name_es": "Masa de croissant",
        "name_de": "Croissant",
        "name_fr": "Pâte à croissant",
        "name_pt": "Massa folhada de croissant",
        "name_tr": "Kruvasan hamuru"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cheese",
        "name_es": "Queso",
        "name_de": "Käse",
        "name_fr": "Fromage",
        "name_pt": "Queijo",
        "name_tr": "Peynir"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 330.0,
    "protein_g": 3.0,
    "carbohydrates_g": 38.0,
    "fat_g": 19.0,
    "fiber_g": 3.0,
    "sodium_mg": 550.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Hash Browns (1 cup)",
    "display_name_es": "Papas hash brown (1 taza)",
    "display_name_de": "Rösti (1 Tasse)",
    "display_name_fr": "Galettes de pommes de terre (1 tasse)",
    "display_name_pt": "Batatas fritas (1 xícara)",
    "display_name_tr": "Patates Kızartması (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable oil",
        "name_es": "Aceite vegetal",
        "name_de": "Pflanzenöl",
        "name_fr": "Huile végétale",
        "name_pt": "Óleo vegetal",
        "name_tr": "Bitkisel yağ"
      },
      {
        "category_en": "Pantry",
        "name_en": "Seasoning",
        "name_es": "Condimento",
        "name_de": "Gewürz",
        "name_fr": "Assaisonnement",
        "name_pt": "Tempero",
        "name_tr": "Baharat"
      }
    ]
  },
  {
    "category": "Beverage/Dairy",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 104.0,
    "protein_g": 10.0,
    "carbohydrates_g": 10.0,
    "fat_g": 2.5,
    "fiber_g": 0.0,
    "sodium_mg": 100.0,
    "cholesterol_mg": 10.0,
    "water_ml": 240.0,
    "display_name_en": "Kefir (Plain 1 cup)",
    "display_name_es": "Kéfir (natural 1 taza)",
    "display_name_de": "Kefir (Natur, 1 Tasse)",
    "display_name_fr": "Kéfir (nature, 1 tasse)",
    "display_name_pt": "Kefir (simples, 1 xícara)",
    "display_name_tr": "Kefir (Sade 1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Kefir",
        "name_es": "Kéfir",
        "name_de": "Kefir",
        "name_fr": "Kéfir",
        "name_pt": "Kefir",
        "name_tr": "Kefir"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 60.0,
    "protein_g": 4.0,
    "carbohydrates_g": 2.0,
    "fat_g": 4.0,
    "fiber_g": 0.0,
    "sodium_mg": 80.0,
    "cholesterol_mg": 15.0,
    "water_ml": 0.0,
    "display_name_en": "Labneh (2 tbsp)",
    "display_name_es": "Labneh (2 cucharadas)",
    "display_name_de": "Labneh (2 EL)",
    "display_name_fr": "Labneh (2 cuillères à soupe)",
    "display_name_pt": "Labneh (2 colheres de sopa)",
    "display_name_tr": "Labne (2 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Labneh",
        "name_es": "Labneh",
        "name_de": "Labneh",
        "name_fr": "Labneh",
        "name_pt": "Labneh",
        "name_tr": "Labne"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil (optional)",
        "name_es": "Aceite de oliva (opcional)",
        "name_de": "Olivenöl (optional)",
        "name_fr": "Huile d'olive (facultatif)",
        "name_pt": "Azeite de oliva (opcional)",
        "name_tr": "Zeytinyağı (isteğe bağlı)"
      }
    ]
  },
  {
    "category": "Meal/Vegetarian",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 300.0,
    "protein_g": 7.0,
    "carbohydrates_g": 45.0,
    "fat_g": 10.0,
    "fiber_g": 4.0,
    "sodium_mg": 500.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Manakeesh (Za'atar 1 small)",
    "display_name_es": "Manakeesh (Za'atar 1 pequeño)",
    "display_name_de": "Manakeesh (Za'atar 1 klein)",
    "display_name_fr": "Manakeesh (Za'atar 1 petit)",
    "display_name_pt": "Manakeesh (Za'atar 1 pequeno)",
    "display_name_tr": "Manakeesh (Za'atar 1 küçük)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato (optional)",
        "name_es": "Tomate (opcional)",
        "name_de": "Tomate (optional)",
        "name_fr": "Tomate (facultatif)",
        "name_pt": "Tomate (opcional)",
        "name_tr": "Domates (isteğe bağlı)"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber (optional)",
        "name_es": "Pepino (opcional)",
        "name_de": "Gurke (optional)",
        "name_fr": "Concombre (facultatif)",
        "name_pt": "Pepino (opcional)",
        "name_tr": "Salatalık (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Labneh (optional)",
        "name_es": "Labneh (opcional)",
        "name_de": "Labneh (optional)",
        "name_fr": "Labneh (facultatif)",
        "name_pt": "Labneh (opcional)",
        "name_tr": "Labne (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flatbread",
        "name_es": "Pan plano",
        "name_de": "Fladenbrot",
        "name_fr": "Pain plat",
        "name_pt": "Pão sírio",
        "name_tr": "Yassı ekmek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Za'atar",
        "name_es": "Za'atar",
        "name_de": "Za'atar",
        "name_fr": "Za'atar",
        "name_pt": "Za'atar",
        "name_tr": "Za'atar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 5.0,
    "protein_g": 0.2,
    "carbohydrates_g": 1.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 240.0,
    "display_name_en": "Mate (1 cup)",
    "display_name_es": "Mate (1 taza)",
    "display_name_de": "Mate (1 Tasse)",
    "display_name_fr": "Maté (1 tasse)",
    "display_name_pt": "Mate (1 xícara)",
    "display_name_tr": "Mate (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Yerba mate tea",
        "name_es": "Té de yerba mate",
        "name_de": "Yerba-Mate-Tee",
        "name_fr": "thé yerba maté",
        "name_pt": "Chá Mate",
        "name_tr": "Yerba mate çayı"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 190.0,
    "protein_g": 4.0,
    "carbohydrates_g": 25.0,
    "fat_g": 8.0,
    "fiber_g": 1.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 25.0,
    "water_ml": 0.0,
    "display_name_en": "Media Luna (1 pastry)",
    "display_name_es": "Media Luna (1 pastel)",
    "display_name_de": "Media Luna (1 Gebäck)",
    "display_name_fr": "Media Luna (1 pâtisserie)",
    "display_name_pt": "Media Luna (1 pastel)",
    "display_name_tr": "Media Luna (1 pasta)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Sweet croissant pastry",
        "name_es": "Pastel de croissant dulce",
        "name_de": "Süßes Croissant-Gebäck",
        "name_fr": "Pâtisserie croissant sucrée",
        "name_pt": "Massa folhada doce de croissant",
        "name_tr": "Tatlı kruvasan hamuru"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 122.0,
    "protein_g": 8.0,
    "carbohydrates_g": 12.0,
    "fat_g": 5.0,
    "fiber_g": 0.0,
    "sodium_mg": 100.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Milk (2%-1 cup)",
    "display_name_es": "Leche (2%-1 taza)",
    "display_name_de": "Milch (2%-1 Tasse)",
    "display_name_fr": "Lait (2 % - 1 tasse)",
    "display_name_pt": "Leite (2% - 1 xícara)",
    "display_name_tr": "Süt (%2-1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 2.0,
    "protein_g": 0.1,
    "carbohydrates_g": 0.5,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 240.0,
    "display_name_en": "Mint Tea (1 cup)",
    "display_name_es": "Té de menta (1 taza)",
    "display_name_de": "Minztee (1 Tasse)",
    "display_name_fr": "Thé à la menthe (1 tasse)",
    "display_name_pt": "Chá de menta (1 xícara)",
    "display_name_tr": "Nane Çayı (1 fincan)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Mint leaves",
        "name_es": "hojas de menta",
        "name_de": "Minzblätter",
        "name_fr": "feuilles de menthe",
        "name_pt": "Folhas de hortelã",
        "name_tr": "Nane yaprakları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tea",
        "name_es": "Té",
        "name_de": "Tee",
        "name_fr": "Thé",
        "name_pt": "Chá",
        "name_tr": "Çay"
      }
    ]
  },
  {
    "category": "Grain/Dessert",
    "meal_type": "Breakfast",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 380.0,
    "protein_g": 5.0,
    "carbohydrates_g": 55.0,
    "fat_g": 16.0,
    "fiber_g": 2.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 50.0,
    "water_ml": 250.0,
    "display_name_en": "Muffin (Blueberry 1 large)",
    "display_name_es": "Muffin (Arándano 1 grande)",
    "display_name_de": "Muffin (Blaubeere, 1 groß)",
    "display_name_fr": "Muffin (Myrtille 1 grand)",
    "display_name_pt": "Muffin (Mirtilo 1 grande)",
    "display_name_tr": "Muffin (Yaban Mersinli 1 büyük)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Blueberries",
        "name_es": "Arándanos",
        "name_de": "Blaubeeren",
        "name_fr": "myrtilles",
        "name_pt": "Mirtilos",
        "name_tr": "Yaban mersini"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Baking powder",
        "name_es": "Polvo para hornear",
        "name_de": "Backpulver",
        "name_fr": "Levure chimique",
        "name_pt": "Fermento em pó",
        "name_tr": "Kabartma tozu"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 160.0,
    "protein_g": 6.0,
    "carbohydrates_g": 28.0,
    "fat_g": 3.0,
    "fiber_g": 4.0,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Oatmeal (1 cup cooked)",
    "display_name_es": "Avena (1 taza cocida)",
    "display_name_de": "Haferflocken (1 Tasse gekocht)",
    "display_name_fr": "Gruau (1 tasse cuite)",
    "display_name_pt": "Aveia (1 xícara cozida)",
    "display_name_tr": "Yulaf ezmesi (1 su bardağı pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Banana (optional)",
        "name_es": "Plátano (opcional)",
        "name_de": "Banane (optional)",
        "name_fr": "Banane (facultatif)",
        "name_pt": "Banana (opcional)",
        "name_tr": "Muz (isteğe bağlı)"
      },
      {
        "category_en": "Produce",
        "name_en": "Berries (optional)",
        "name_es": "Bayas (opcional)",
        "name_de": "Beeren (optional)",
        "name_fr": "Baies (facultatif)",
        "name_pt": "Frutas vermelhas (opcional)",
        "name_tr": "Meyveler (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk (optional)",
        "name_es": "Leche (opcional)",
        "name_de": "Milch (optional)",
        "name_fr": "Lait (facultatif)",
        "name_pt": "Leite (opcional)",
        "name_tr": "Süt (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt (optional)",
        "name_es": "Yogur (opcional)",
        "name_de": "Joghurt (optional)",
        "name_fr": "Yaourt (facultatif)",
        "name_pt": "Iogurte (opcional)",
        "name_tr": "Yoğurt (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oats",
        "name_es": "Avena",
        "name_de": "Hafer",
        "name_fr": "Avoine",
        "name_pt": "Aveia",
        "name_tr": "Yulaf"
      },
      {
        "category_en": "Pantry",
        "name_en": "Honey",
        "name_es": "Miel",
        "name_de": "Honig",
        "name_fr": "Miel",
        "name_pt": "Mel",
        "name_tr": "Bal"
      },
      {
        "category_en": "Pantry",
        "name_en": "Nuts",
        "name_es": "Nueces",
        "name_de": "Nüsse",
        "name_fr": "Noix",
        "name_pt": "Nozes",
        "name_tr": "Kuruyemişler"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 35.0,
    "protein_g": 0.2,
    "carbohydrates_g": 1.0,
    "fat_g": 3.5,
    "fiber_g": 0.5,
    "sodium_mg": 210.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Olives (5 side)",
    "display_name_es": "Aceitunas (5 lados)",
    "display_name_de": "Oliven (5 Stück)",
    "display_name_fr": "Olives (5 côtés)",
    "display_name_pt": "Azeitonas (5 unidades)",
    "display_name_tr": "Zeytin (5 taraflı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Olives",
        "name_es": "Aceitunas",
        "name_de": "Oliven",
        "name_fr": "Olives",
        "name_pt": "Azeitonas",
        "name_tr": "Zeytinler"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 112.0,
    "protein_g": 1.7,
    "carbohydrates_g": 25.8,
    "fat_g": 0.5,
    "fiber_g": 0.7,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 240.0,
    "display_name_en": "Orange Juice (1 cup)",
    "display_name_es": "Jugo de naranja (1 taza)",
    "display_name_de": "Orangensaft (1 Tasse)",
    "display_name_fr": "Jus d'orange (1 tasse)",
    "display_name_pt": "Suco de laranja (1 xícara)",
    "display_name_tr": "Portakal Suyu (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Orange",
        "name_es": "Naranja",
        "name_de": "Orange",
        "name_fr": "Orange",
        "name_pt": "Laranja",
        "name_tr": "Turuncu"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 5.0,
    "carbohydrates_g": 30.0,
    "fat_g": 5.0,
    "fiber_g": 1.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 25.0,
    "water_ml": 0.0,
    "display_name_en": "Pancakes (2 medium)",
    "display_name_es": "Panqueques (2 medianos)",
    "display_name_de": "Pfannkuchen (2 mittelgroß)",
    "display_name_fr": "Crêpes (2 moyennes)",
    "display_name_pt": "Panquecas (2 médias)",
    "display_name_tr": "Krep (2 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Baking powder",
        "name_es": "Polvo para hornear",
        "name_de": "Backpulver",
        "name_fr": "Levure chimique",
        "name_pt": "Fermento em pó",
        "name_tr": "Kabartma tozu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Syrup",
        "name_es": "Jarabe",
        "name_de": "Sirup",
        "name_fr": "Sirop",
        "name_pt": "Xarope",
        "name_tr": "Şurup"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 15.0,
    "protein_g": 0.5,
    "carbohydrates_g": 3.0,
    "fat_g": 0.0,
    "fiber_g": 1.0,
    "sodium_mg": 250.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pickled Radish (1/4 cup)",
    "display_name_es": "Rábano encurtido (1/4 taza)",
    "display_name_de": "Eingelegter Rettich (1/4 Tasse)",
    "display_name_fr": "Radis marinés (1/4 tasse)",
    "display_name_pt": "Rabanete em conserva (1/4 de xícara)",
    "display_name_tr": "Turşu Turp (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Radish",
        "name_es": "Rábano",
        "name_de": "Rettich",
        "name_fr": "Radis",
        "name_pt": "Rabanete",
        "name_tr": "Turp"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Protein",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 72.0,
    "protein_g": 6.3,
    "carbohydrates_g": 0.4,
    "fat_g": 4.8,
    "fiber_g": 0.0,
    "sodium_mg": 140.0,
    "cholesterol_mg": 185.0,
    "water_ml": 0.0,
    "display_name_en": "Poached Egg (1 large)",
    "display_name_es": "Huevo escalfado (1 grande)",
    "display_name_de": "Pochiertes Ei (1 großes)",
    "display_name_fr": "Œuf poché (1 gros)",
    "display_name_pt": "Ovo Poché (1 grande)",
    "display_name_tr": "Haşlanmış Yumurta (1 büyük)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar (for poaching)",
        "name_es": "Vinagre (para escalfar)",
        "name_de": "Essig (zum Pochieren)",
        "name_fr": "Vinaigre (pour le pochage)",
        "name_pt": "Vinagre (para caça furtiva)",
        "name_tr": "Sirke (haşlama için)"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 50.0,
    "protein_g": 4.0,
    "carbohydrates_g": 3.0,
    "fat_g": 2.0,
    "fiber_g": 0.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Pork Floss (1 tbsp)",
    "display_name_es": "Hilo de cerdo (1 cucharada)",
    "display_name_de": "Schweinefleischflocken (1 EL)",
    "display_name_fr": "Porc effiloché (1 cuillère à soupe)",
    "display_name_pt": "Fios de carne de porco (1 colher de sopa)",
    "display_name_tr": "Dana kıyma (1 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pork floss",
        "name_es": "Hilo de cerdo",
        "name_de": "Schweinefleischflocken",
        "name_fr": "Porc effiloché",
        "name_pt": "Fio de carne de porco",
        "name_tr": "Dana ipi"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 160.0,
    "protein_g": 3.0,
    "carbohydrates_g": 37.0,
    "fat_g": 0.5,
    "fiber_g": 0.5,
    "sodium_mg": 290.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Rice Krispies (1.5 cups)",
    "display_name_es": "Rice Krispies (1,5 tazas)",
    "display_name_de": "Rice Krispies (1,5 Tassen)",
    "display_name_fr": "Rice Krispies (1,5 tasse)",
    "display_name_pt": "Rice Krispies (1,5 xícaras)",
    "display_name_tr": "Pirinç Patlağı (1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Rice Krispies cereal",
        "name_es": "Cereal Rice Krispies",
        "name_de": "Rice Krispies Müsli",
        "name_fr": "céréales Rice Krispies",
        "name_pt": "Cereal Rice Krispies",
        "name_tr": "Rice Krispies gevreği"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 85.0,
    "protein_g": 5.0,
    "carbohydrates_g": 1.0,
    "fat_g": 7.0,
    "fiber_g": 0.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Sausage Link (1 cooked)",
    "display_name_es": "Salchicha (1 cocida)",
    "display_name_de": "Würstchen (1 gekocht)",
    "display_name_fr": "Saucisse (1 cuite)",
    "display_name_pt": "Linguiça (1 cozida)",
    "display_name_tr": "Sosis Bağlantısı (1 pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Breakfast sausage",
        "name_es": "Salchicha de desayuno",
        "name_de": "Frühstückswurst",
        "name_fr": "saucisse du petit-déjeuner",
        "name_pt": "linguiça de café da manhã",
        "name_tr": "Kahvaltılık sosis"
      }
    ]
  },
  {
    "category": "Protein/Dairy",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 12.0,
    "carbohydrates_g": 2.0,
    "fat_g": 14.0,
    "fiber_g": 0.0,
    "sodium_mg": 180.0,
    "cholesterol_mg": 370.0,
    "water_ml": 250.0,
    "display_name_en": "Scrambled Eggs (2 large)",
    "display_name_es": "Huevos revueltos (2 grandes)",
    "display_name_de": "Rührei (2 große)",
    "display_name_fr": "Œufs brouillés (2 gros)",
    "display_name_pt": "Ovos Mexidos (2 grandes)",
    "display_name_tr": "Çırpılmış Yumurta (2 büyük)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Chives (optional)",
        "name_es": "Cebollino (opcional)",
        "name_de": "Schnittlauch (optional)",
        "name_fr": "Ciboulette (facultatif)",
        "name_pt": "Cebolinha (opcional)",
        "name_tr": "Frenk soğanı (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Eggs",
        "name_es": "Huevos",
        "name_de": "Eier",
        "name_fr": "Œufs",
        "name_pt": "Ovos",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheese (optional)",
        "name_es": "Queso (opcional)",
        "name_de": "Käse (optional)",
        "name_fr": "Fromage (facultatif)",
        "name_pt": "Queijo (opcional)",
        "name_tr": "Peynir (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Beverage/Meal",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 280.0,
    "protein_g": 12.0,
    "carbohydrates_g": 55.0,
    "fat_g": 3.0,
    "fiber_g": 7.0,
    "sodium_mg": 70.0,
    "cholesterol_mg": 5.0,
    "water_ml": 250.0,
    "display_name_en": "Smoothie (Fruit & Yogurt)",
    "display_name_es": "Smoothie (Fruta y Yogur)",
    "display_name_de": "Smoothie (Obst & Joghurt)",
    "display_name_fr": "Smoothie (Fruits et Yaourt)",
    "display_name_pt": "Smoothie (Frutas e Iogurte)",
    "display_name_tr": "Smoothie (Meyve ve Yoğurt)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Banana",
        "name_es": "Plátano",
        "name_de": "Banane",
        "name_fr": "Banane",
        "name_pt": "Banana",
        "name_tr": "Muz"
      },
      {
        "category_en": "Produce",
        "name_en": "Berries",
        "name_es": "Bayas",
        "name_de": "Beeren",
        "name_fr": "Baies",
        "name_pt": "Frutas vermelhas",
        "name_tr": "Meyveler"
      },
      {
        "category_en": "Produce",
        "name_en": "Spinach (optional)",
        "name_es": "Espinacas (opcional)",
        "name_de": "Spinat (optional)",
        "name_fr": "Épinards (facultatif)",
        "name_pt": "Espinafre (opcional)",
        "name_tr": "Ispanak (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt",
        "name_es": "Yogur",
        "name_de": "Joghurt",
        "name_fr": "Yaourt",
        "name_pt": "Iogurte",
        "name_tr": "Yoğurt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk (optional)",
        "name_es": "Leche (opcional)",
        "name_de": "Milch (optional)",
        "name_fr": "Lait (facultatif)",
        "name_pt": "Leite (opcional)",
        "name_tr": "Süt (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Protein powder (optional)",
        "name_es": "Proteína en polvo (opcional)",
        "name_de": "Proteinpulver (optional)",
        "name_fr": "Poudre de protéines (facultatif)",
        "name_pt": "Proteína em pó (opcional)",
        "name_tr": "Protein tozu (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Honey",
        "name_es": "Miel",
        "name_de": "Honig",
        "name_fr": "Miel",
        "name_pt": "Mel",
        "name_tr": "Bal"
      }
    ]
  },
  {
    "category": "Beverage/Dairy-Alt",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 110.0,
    "protein_g": 8.0,
    "carbohydrates_g": 9.0,
    "fat_g": 4.5,
    "fiber_g": 2.0,
    "sodium_mg": 125.0,
    "cholesterol_mg": 0.0,
    "water_ml": 240.0,
    "display_name_en": "Soy Milk (Original 1 cup)",
    "display_name_es": "Leche de soja (original 1 taza)",
    "display_name_de": "Sojamilch (Original 1 Tasse)",
    "display_name_fr": "Lait de soja (Original 1 tasse)",
    "display_name_pt": "Leite de soja (Original 1 xícara)",
    "display_name_tr": "Soya Sütü (Orijinal 1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Soy milk",
        "name_es": "leche de soja",
        "name_de": "Sojamilch",
        "name_fr": "Lait de soja",
        "name_pt": "leite de soja",
        "name_tr": "Soya sütü"
      }
    ]
  },
  {
    "category": "Protein/Vegetarian",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 140.0,
    "protein_g": 10.0,
    "carbohydrates_g": 6.0,
    "fat_g": 9.0,
    "fiber_g": 3.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Soyrizo (2 oz)",
    "display_name_es": "Soyrizo (2 oz)",
    "display_name_de": "Soyrizo (2 oz)",
    "display_name_fr": "Soyrizo (57 g)",
    "display_name_pt": "Soja (2 oz)",
    "display_name_tr": "Soya peyniri (2 ons)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Soy chorizo",
        "name_es": "Chorizo ​​de soja",
        "name_de": "Soja-Chorizo",
        "name_fr": "Chorizo ​​de soja",
        "name_pt": "Chorizo ​​de soja",
        "name_tr": "Soya chorizo"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 2.0,
    "protein_g": 0.5,
    "carbohydrates_g": 0.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Tea (Green-1 cup)",
    "display_name_es": "Té (Verde-1 taza)",
    "display_name_de": "Tee (Grüntee - 1 Tasse)",
    "display_name_fr": "Thé (vert - 1 tasse)",
    "display_name_pt": "Chá (verde - 1 xícara)",
    "display_name_tr": "Çay (Yeşil-1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Green tea",
        "name_es": "Té verde",
        "name_de": "Grüner Tee",
        "name_fr": "Thé vert",
        "name_pt": "Chá verde",
        "name_tr": "Yeşil çay"
      }
    ]
  },
  {
    "category": "Meal/Vegetarian",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 250.0,
    "protein_g": 20.0,
    "carbohydrates_g": 8.0,
    "fat_g": 16.0,
    "fiber_g": 4.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Tofu Scramble",
    "display_name_es": "Tofu revuelto",
    "display_name_de": "Tofu-Rührei",
    "display_name_fr": "Tofu brouillé",
    "display_name_pt": "Tofu Mexido",
    "display_name_tr": "Tofu Karışımı",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Spinach",
        "name_es": "Espinacas",
        "name_de": "Spinat",
        "name_fr": "Épinards",
        "name_pt": "Espinafre",
        "name_tr": "Ispanak"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivron",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tofu",
        "name_es": "Tofu",
        "name_de": "Tofu",
        "name_fr": "Tofu",
        "name_pt": "Tofu",
        "name_tr": "Tofu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Turmeric",
        "name_es": "Cúrcuma",
        "name_de": "Kurkuma",
        "name_fr": "Curcuma",
        "name_pt": "Cúrcuma",
        "name_tr": "Zerdeçal"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 8.0,
    "protein_g": 0.3,
    "carbohydrates_g": 1.8,
    "fat_g": 0.1,
    "fiber_g": 0.5,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Tomato (1/4 cup side)",
    "display_name_es": "Tomate (1/4 taza de acompañamiento)",
    "display_name_de": "Tomate (1/4 Tasse Beilage)",
    "display_name_fr": "Tomate (1/4 tasse à côté)",
    "display_name_pt": "Tomate (1/4 de xícara como acompanhamento)",
    "display_name_tr": "Domates (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 70.0,
    "protein_g": 6.0,
    "carbohydrates_g": 1.0,
    "fat_g": 5.0,
    "fiber_g": 0.0,
    "sodium_mg": 360.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Turkey Bacon (2 slices)",
    "display_name_es": "Tocino de pavo (2 rebanadas)",
    "display_name_de": "Truthahnspeck (2 Scheiben)",
    "display_name_fr": "Bacon de dinde (2 tranches)",
    "display_name_pt": "Bacon de peru (2 fatias)",
    "display_name_tr": "Hindi Pastırması (2 dilim)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Turkey bacon",
        "name_es": "Tocino de pavo",
        "name_de": "Putenbacon",
        "name_fr": "bacon de dinde",
        "name_pt": "Bacon de peru",
        "name_tr": "Hindi pastırması"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 70.0,
    "protein_g": 9.0,
    "carbohydrates_g": 1.0,
    "fat_g": 4.0,
    "fiber_g": 0.0,
    "sodium_mg": 280.0,
    "cholesterol_mg": 35.0,
    "water_ml": 0.0,
    "display_name_en": "Turkey Sausage (1 patty)",
    "display_name_es": "Salchicha de pavo (1 hamburguesa)",
    "display_name_de": "Putenwurst (1 Stück)",
    "display_name_fr": "Saucisse de dinde (1 galette)",
    "display_name_pt": "Salsicha de peru (1 hambúrguer)",
    "display_name_tr": "Hindi Sosis (1 köfte)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Turkey sausage",
        "name_es": "salchicha de pavo",
        "name_de": "Putenwurst",
        "name_fr": "saucisse de dinde",
        "name_pt": "linguiça de peru",
        "name_tr": "Hindi sosisi"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 220.0,
    "protein_g": 6.0,
    "carbohydrates_g": 28.0,
    "fat_g": 9.0,
    "fiber_g": 1.5,
    "sodium_mg": 420.0,
    "cholesterol_mg": 45.0,
    "water_ml": 0.0,
    "display_name_en": "Waffles (2 homemade)",
    "display_name_es": "Waffles (2 caseros)",
    "display_name_de": "Waffeln (2 hausgemacht)",
    "display_name_fr": "Gaufres (2 faites maison)",
    "display_name_pt": "Waffles (2 caseiros)",
    "display_name_tr": "Waffle (2 ev yapımı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Berries (optional)",
        "name_es": "Bayas (opcional)",
        "name_de": "Beeren (optional)",
        "name_fr": "Baies (facultatif)",
        "name_pt": "Frutas vermelhas (opcional)",
        "name_tr": "Meyveler (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Baking powder",
        "name_es": "Polvo para hornear",
        "name_de": "Backpulver",
        "name_fr": "Levure chimique",
        "name_pt": "Fermento em pó",
        "name_tr": "Kabartma tozu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Syrup",
        "name_es": "Jarabe",
        "name_de": "Sirup",
        "name_fr": "Sirop",
        "name_pt": "Xarope",
        "name_tr": "Şurup"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 70.0,
    "protein_g": 2.0,
    "carbohydrates_g": 13.0,
    "fat_g": 1.0,
    "fiber_g": 0.6,
    "sodium_mg": 140.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "White Bread (1 slice)",
    "display_name_es": "Pan blanco (1 rebanada)",
    "display_name_de": "Weißbrot (1 Scheibe)",
    "display_name_fr": "Pain blanc (1 tranche)",
    "display_name_pt": "Pão branco (1 fatia)",
    "display_name_tr": "Beyaz Ekmek (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "White bread",
        "name_es": "Pan blanco",
        "name_de": "Weißbrot",
        "name_fr": "Pain blanc",
        "name_pt": "Pão branco",
        "name_tr": "Beyaz ekmek"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 80.0,
    "protein_g": 4.0,
    "carbohydrates_g": 14.0,
    "fat_g": 1.0,
    "fiber_g": 2.0,
    "sodium_mg": 140.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Whole Wheat Toast (1 slice)",
    "display_name_es": "Tostada de trigo integral (1 rebanada)",
    "display_name_de": "Vollkorntoast (1 Scheibe)",
    "display_name_fr": "Pain grillé au blé entier (1 tranche)",
    "display_name_pt": "Torrada integral (1 fatia)",
    "display_name_tr": "Tam Buğday Ekmeği (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Whole wheat bread",
        "name_es": "Pan de trigo entero",
        "name_de": "Vollkornbrot",
        "name_fr": "pain complet",
        "name_pt": "Pão integral",
        "name_tr": "Tam buğday ekmeği"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 200.0,
    "protein_g": 7.0,
    "carbohydrates_g": 42.0,
    "fat_g": 1.0,
    "fiber_g": 2.0,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Angel Hair Pasta (1 cup)",
    "display_name_es": "Pasta de cabello de ángel (1 taza)",
    "display_name_de": "Engelshaar-Pasta (1 Tasse)",
    "display_name_fr": "Pâtes cheveux d'ange (1 tasse)",
    "display_name_pt": "Massa cabelo de anjo (1 xícara)",
    "display_name_tr": "Melek Saçı Makarna (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato (optional)",
        "name_es": "Tomate (opcional)",
        "name_de": "Tomate (optional)",
        "name_fr": "Tomate (facultatif)",
        "name_pt": "Tomate (opcional)",
        "name_tr": "Domates (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese (optional)",
        "name_es": "Queso parmesano (opcional)",
        "name_de": "Parmesankäse (optional)",
        "name_fr": "Parmesan (facultatif)",
        "name_pt": "Queijo parmesão (opcional)",
        "name_tr": "Parmesan peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Angel hair pasta",
        "name_es": "Pasta de cabello de ángel",
        "name_de": "Engelshaar-Pasta",
        "name_fr": "Pâtes cheveux d'ange",
        "name_pt": "Massa cabelo de anjo",
        "name_tr": "Melek saçı makarna"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 60.0,
    "protein_g": 4.2,
    "carbohydrates_g": 13.4,
    "fat_g": 0.2,
    "fiber_g": 6.9,
    "sodium_mg": 112.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Artichoke (1 medium steamed)",
    "display_name_es": "Alcachofa (1 mediana al vapor)",
    "display_name_de": "Artischocke (1 mittelgroße, gedämpfte)",
    "display_name_fr": "Artichaut (1 moyen cuit à la vapeur)",
    "display_name_pt": "Alcachofra (1 média cozida no vapor)",
    "display_name_tr": "Enginar (1 orta boy buharda pişirilmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Artichoke",
        "name_es": "Alcachofa",
        "name_de": "Artischocke",
        "name_fr": "Artichaut",
        "name_pt": "Alcachofra",
        "name_tr": "Enginar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 40.0,
    "protein_g": 4.3,
    "carbohydrates_g": 7.4,
    "fat_g": 0.4,
    "fiber_g": 3.6,
    "sodium_mg": 4.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Asparagus (1 cup steamed)",
    "display_name_es": "Espárragos (1 taza al vapor)",
    "display_name_de": "Spargel (1 Tasse gedämpft)",
    "display_name_fr": "Asperges (1 tasse cuites à la vapeur)",
    "display_name_pt": "Espargos (1 xícara cozida no vapor)",
    "display_name_tr": "Kuşkonmaz (1 su bardağı buharda pişirilmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Asparagus",
        "name_es": "Espárragos",
        "name_de": "Spargel",
        "name_fr": "Asperge",
        "name_pt": "Espargos",
        "name_tr": "Kuşkonmaz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 40.0,
    "protein_g": 4.0,
    "carbohydrates_g": 4.0,
    "fat_g": 2.0,
    "fiber_g": 3.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Asparagus (6 spears roasted)",
    "display_name_es": "Espárragos (6 lanzas asadas)",
    "display_name_de": "Spargel (6 Stangen geröstet)",
    "display_name_fr": "Asperges (6 pointes rôties)",
    "display_name_pt": "Espargos (6 talos assados)",
    "display_name_tr": "Kuşkonmaz (6 adet kavrulmuş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Asparagus",
        "name_es": "Espárragos",
        "name_de": "Spargel",
        "name_fr": "Asperge",
        "name_pt": "Espargos",
        "name_tr": "Kuşkonmaz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 160.0,
    "protein_g": 4.3,
    "carbohydrates_g": 36.0,
    "fat_g": 0.2,
    "fiber_g": 3.8,
    "sodium_mg": 17.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Baked Potato (medium)",
    "display_name_es": "Papa al horno (mediana)",
    "display_name_de": "Ofenkartoffel (mittelgroß)",
    "display_name_fr": "Pomme de terre au four (moyenne)",
    "display_name_pt": "Batata assada (média)",
    "display_name_tr": "Fırında Patates (orta)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Patata",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Produce",
        "name_en": "Chives",
        "name_es": "Cebollino",
        "name_de": "Schnittlauch",
        "name_fr": "Ciboulette",
        "name_pt": "Cebolinha",
        "name_tr": "Frenk soğanı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Sour cream",
        "name_es": "Crema agria",
        "name_de": "Saure Sahne",
        "name_fr": "Crème fraîche",
        "name_pt": "Creme azedo",
        "name_tr": "Ekşi krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheese (optional)",
        "name_es": "Queso (opcional)",
        "name_de": "Käse (optional)",
        "name_fr": "Fromage (facultatif)",
        "name_pt": "Queijo (opcional)",
        "name_tr": "Peynir (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pepper",
        "name_es": "Pimienta",
        "name_de": "Pfeffer",
        "name_fr": "Poivre",
        "name_pt": "Pimenta",
        "name_tr": "Karabiber"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 8.0,
    "protein_g": 0.8,
    "carbohydrates_g": 1.5,
    "fat_g": 0.1,
    "fiber_g": 0.4,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Bean Sprouts (1/4 cup garnish)",
    "display_name_es": "Brotes de soja (1/4 taza de guarnición)",
    "display_name_de": "Sojasprossen (1/4 Tasse Garnierung)",
    "display_name_fr": "Germes de soja (garniture de 1/4 tasse)",
    "display_name_pt": "Brotos de feijão (1/4 de xícara para guarnição)",
    "display_name_tr": "Fasulye Filizi (1/4 su bardağı garnitür)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Bean sprouts",
        "name_es": "brotes de soja",
        "name_de": "Sojasprossen",
        "name_fr": "Germes de haricots",
        "name_pt": "Brotos de feijão",
        "name_tr": "Fasulye filizi"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 650.0,
    "protein_g": 30.0,
    "carbohydrates_g": 70.0,
    "fat_g": 28.0,
    "fiber_g": 10.0,
    "sodium_mg": 1400.0,
    "cholesterol_mg": 70.0,
    "water_ml": 500.0,
    "display_name_en": "Beef Burrito (large)",
    "display_name_es": "Burrito de carne (grande)",
    "display_name_de": "Rindfleisch-Burrito (groß)",
    "display_name_fr": "Burrito au bœuf (grand)",
    "display_name_pt": "Burrito de carne (grande)",
    "display_name_tr": "Dana Burrito (büyük)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese",
        "name_es": "Queso cheddar",
        "name_de": "Cheddar-Käse",
        "name_fr": "Fromage cheddar",
        "name_pt": "Queijo cheddar",
        "name_tr": "Çedar peyniri"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Sour cream",
        "name_es": "Crema agria",
        "name_de": "Saure Sahne",
        "name_fr": "Crème aigre",
        "name_pt": "Creme azedo",
        "name_tr": "Ekşi krema"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tortilla",
        "name_es": "Tortilla",
        "name_de": "Tortilla",
        "name_fr": "Tortilla",
        "name_pt": "Tortilha",
        "name_tr": "Tortilla"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground beef",
        "name_es": "Carne molida",
        "name_de": "Hackfleisch",
        "name_fr": "Bœuf haché",
        "name_pt": "Carne moída",
        "name_tr": "Kıyma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice",
        "name_es": "Arroz",
        "name_de": "Reis",
        "name_fr": "Riz",
        "name_pt": "Arroz",
        "name_tr": "Pirinç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beans",
        "name_es": "Frijoles",
        "name_de": "Bohnen",
        "name_fr": "Haricots",
        "name_pt": "Feijão",
        "name_tr": "Fasulye"
      }
    ]
  },
  {
    "category": "Meal/Soup",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 450.0,
    "protein_g": 30.0,
    "carbohydrates_g": 55.0,
    "fat_g": 12.0,
    "fiber_g": 4.0,
    "sodium_mg": 1500.0,
    "cholesterol_mg": 60.0,
    "water_ml": 500.0,
    "display_name_en": "Beef Pho (1 large bowl)",
    "display_name_es": "Pho de carne (1 tazón grande)",
    "display_name_de": "Rindfleisch-Pho (1 große Schüssel)",
    "display_name_fr": "Pho au bœuf (1 grand bol)",
    "display_name_pt": "Pho de carne (1 tigela grande)",
    "display_name_tr": "Dana Pho (1 büyük kase)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Bean sprouts",
        "name_es": "Brotes de soja",
        "name_de": "Sojasprossen",
        "name_fr": "Germes de soja",
        "name_pt": "Broto de feijão",
        "name_tr": "Fasulye filizi"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Cilantro",
        "name_es": "Cilantro",
        "name_de": "Koriander",
        "name_fr": "Coriandre",
        "name_pt": "Coentro",
        "name_tr": "Kişniş"
      },
      {
        "category_en": "Produce",
        "name_en": "Basil",
        "name_es": "Albahaca",
        "name_de": "Basilikum",
        "name_fr": "Basilic",
        "name_pt": "Manjericão",
        "name_tr": "Fesleğen"
      },
      {
        "category_en": "Produce",
        "name_en": "Jalapeno",
        "name_es": "Jalapeño",
        "name_de": "Jalapeño",
        "name_fr": "Jalapeno",
        "name_pt": "Jalapeño",
        "name_tr": "Jalapeno"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Beef bone broth",
        "name_es": "caldo de hueso de res",
        "name_de": "Rinderknochenbrühe",
        "name_fr": "bouillon d'os de bœuf",
        "name_pt": "caldo de osso de boi",
        "name_tr": "Sığır kemiği suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice noodles",
        "name_es": "Fideos de arroz",
        "name_de": "Reisnudeln",
        "name_fr": "Nouilles de riz",
        "name_pt": "Macarrão de arroz",
        "name_tr": "Pirinç eriştesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sliced beef",
        "name_es": "Carne de res en rodajas",
        "name_de": "Rindfleischscheiben",
        "name_fr": "Bœuf émincé",
        "name_pt": "Carne fatiada",
        "name_tr": "Dilimlenmiş dana eti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Fish sauce",
        "name_es": "Salsa de pescado",
        "name_de": "Fischsauce",
        "name_fr": "Sauce poisson",
        "name_pt": "Molho de peixe",
        "name_tr": "Balık sosu"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 270.0,
    "protein_g": 42.0,
    "carbohydrates_g": 0.0,
    "fat_g": 10.0,
    "fiber_g": 0.0,
    "sodium_mg": 90.0,
    "cholesterol_mg": 115.0,
    "water_ml": 250.0,
    "display_name_en": "Beef Steak (6oz sirloin)",
    "display_name_es": "Filete de res (solomillo de 6 oz)",
    "display_name_de": "Rindersteak (170g Rinderlende)",
    "display_name_fr": "Steak de bœuf (surlonge de 170 g)",
    "display_name_pt": "Bife de carne (contrafilé de 170g)",
    "display_name_tr": "Dana Biftek (6oz antrikot)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Herbs (e.g., rosemary)",
        "name_es": "Hierbas (por ejemplo, romero)",
        "name_de": "Kräuter (z. B. Rosmarin)",
        "name_fr": "Herbes (ex. : romarin)",
        "name_pt": "Ervas (ex.: alecrim)",
        "name_tr": "Otlar (örneğin biberiye)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (for searing)",
        "name_es": "Mantequilla (para sellar)",
        "name_de": "Butter (zum Anbraten)",
        "name_fr": "Beurre (pour saisir)",
        "name_pt": "Manteiga (para selar)",
        "name_tr": "Tereyağı (kızartmak için)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beef steak",
        "name_es": "Filete de ternera",
        "name_de": "Rindersteak",
        "name_fr": "Steak de bœuf",
        "name_pt": "Bife",
        "name_tr": "Dana biftek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pepper",
        "name_es": "Pimienta",
        "name_de": "Pfeffer",
        "name_fr": "Poivre",
        "name_pt": "Pimenta",
        "name_tr": "Karabiber"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 550.0,
    "protein_g": 30.0,
    "carbohydrates_g": 40.0,
    "fat_g": 28.0,
    "fiber_g": 4.0,
    "sodium_mg": 900.0,
    "cholesterol_mg": 100.0,
    "water_ml": 0.0,
    "display_name_en": "Beef Stroganoff (1.5 cups)",
    "display_name_es": "Stroganoff de res (1,5 tazas)",
    "display_name_de": "Rindfleisch Stroganoff (1,5 Tassen)",
    "display_name_fr": "Bœuf Stroganoff (1,5 tasse)",
    "display_name_pt": "Estrogonofe de carne (1,5 xícaras)",
    "display_name_tr": "Dana Stroganof (1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Mushroom",
        "name_es": "Champiñones",
        "name_de": "Pilze",
        "name_fr": "Champignons",
        "name_pt": "Cogumelo",
        "name_tr": "Mantar"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignons",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Sour cream",
        "name_es": "CCrea agria",
        "name_de": "Sauerrahm",
        "name_fr": "Crème aigre",
        "name_pt": "Nata",
        "name_tr": "Ekşi krema"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beef strips",
        "name_es": "Tiras de carne",
        "name_de": "Rindfleischstreifen",
        "name_fr": "Lanières de bœuf",
        "name_pt": "Tiras de carne",
        "name_tr": "Dana şeritleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Egg noodles",
        "name_es": "Fideos de huevo",
        "name_de": "Eiernudeln",
        "name_fr": "Nouilles aux œufs",
        "name_pt": "Macarrão de ovo",
        "name_tr": "Yumurta eriştesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beef broth",
        "name_es": "Caldo de res",
        "name_de": "Rinderbrühe",
        "name_fr": "Bouillon de bœuf",
        "name_pt": "Caldo de carne",
        "name_tr": "Dana suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 380.0,
    "protein_g": 18.0,
    "carbohydrates_g": 28.0,
    "fat_g": 22.0,
    "fiber_g": 5.0,
    "sodium_mg": 600.0,
    "cholesterol_mg": 50.0,
    "water_ml": 500.0,
    "display_name_en": "Beef Tacos (2 hard shell)",
    "display_name_es": "Tacos de carne (2 tortillas duras)",
    "display_name_de": "Rindfleisch-Tacos (2 harte Schalen)",
    "display_name_fr": "Tacos au bœuf (2 coques dures)",
    "display_name_pt": "Tacos de carne (2 cascas duras)",
    "display_name_tr": "Dana Taco (2 sert kabuklu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese",
        "name_es": "queso cheddar",
        "name_de": "Cheddar-Käse",
        "name_fr": "fromage cheddar",
        "name_pt": "Queijo cheddar",
        "name_tr": "Çedar peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Hard taco shells",
        "name_es": "Tortillas duras para tacos",
        "name_de": "Harte Taco-Schalen",
        "name_fr": "Coquilles à tacos croustillantes",
        "name_pt": "Cascas de taco crocantes",
        "name_tr": "Sert taco kabukları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground beef",
        "name_es": "Carne molida",
        "name_de": "Hackfleisch",
        "name_fr": "Bœuf haché",
        "name_pt": "Carne moída",
        "name_tr": "Kıyma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salsa",
        "name_es": "Salsa",
        "name_de": "Salsa",
        "name_fr": "Salsa",
        "name_pt": "Salsa",
        "name_tr": "Salsa"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 600.0,
    "protein_g": 30.0,
    "carbohydrates_g": 35.0,
    "fat_g": 38.0,
    "fiber_g": 4.0,
    "sodium_mg": 850.0,
    "cholesterol_mg": 100.0,
    "water_ml": 0.0,
    "display_name_en": "Beef Wellington (1 slice)",
    "display_name_es": "Ternera Wellington (1 rebanada)",
    "display_name_de": "Beef Wellington (1 Scheibe)",
    "display_name_fr": "Bœuf Wellington (1 tranche)",
    "display_name_pt": "Carne Wellington (1 fatia)",
    "display_name_tr": "Dana Wellington (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Mushrooms",
        "name_es": "Champiñones",
        "name_de": "Pilze",
        "name_fr": "Champignons",
        "name_pt": "Cogumelos",
        "name_tr": "Mantar"
      },
      {
        "category_en": "Produce",
        "name_en": "Spinach (optional)",
        "name_es": "Espinacas (opcional)",
        "name_de": "Spinat (optional)",
        "name_fr": "Épinards (facultatif)",
        "name_pt": "Espinafre (opcional)",
        "name_tr": "Ispanak (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg wash",
        "name_es": "Huevo batido",
        "name_de": "Eigelb",
        "name_fr": "Dorure à l'œuf",
        "name_pt": "Pincelada de ovo",
        "name_tr": "Yumurta yıkama"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beef tenderloin",
        "name_es": "Solomillo de ternera",
        "name_de": "Rinderfilet",
        "name_fr": "Filet de bœuf",
        "name_pt": "Filé mignon",
        "name_tr": "Dana bonfile"
      },
      {
        "category_en": "Pantry",
        "name_en": "Puff pastry",
        "name_es": "Hojaldre",
        "name_de": "Blätterteig",
        "name_fr": "Pâte feuilletée",
        "name_pt": "Massa folhada",
        "name_tr": "Milföy hamuru"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mustard",
        "name_es": "Mostaza",
        "name_de": "Senf",
        "name_fr": "Moutarde",
        "name_pt": "Mostarda",
        "name_tr": "Hardal"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 60.0,
    "protein_g": 1.5,
    "carbohydrates_g": 10.0,
    "fat_g": 2.0,
    "fiber_g": 3.0,
    "sodium_mg": 30.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Bell Peppers & Onions (sautéed)",
    "display_name_es": "Pimientos morrones y cebollas (salteados)",
    "display_name_de": "Paprika und Zwiebeln (sautiert)",
    "display_name_fr": "Poivrons et oignons (sautés)",
    "display_name_pt": "Pimentões e cebolas (refogado)",
    "display_name_tr": "Dolmalık Biber ve Soğan (sotelenmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Bell peppers",
        "name_es": "Pimientos morrones",
        "name_de": "Paprika",
        "name_fr": "Poivrons",
        "name_pt": "Pimentões",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Seasoning",
        "name_es": "Condimento",
        "name_de": "Gewürz",
        "name_fr": "Assaisonnement",
        "name_pt": "Tempero",
        "name_tr": "Baharat"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 520.0,
    "protein_g": 28.0,
    "carbohydrates_g": 60.0,
    "fat_g": 18.0,
    "fiber_g": 5.0,
    "sodium_mg": 900.0,
    "cholesterol_mg": 75.0,
    "water_ml": 0.0,
    "display_name_en": "Biryani (Chicken 1.5 cups)",
    "display_name_es": "Biryani (Pollo 1,5 tazas)",
    "display_name_de": "Biryani (Hühnchen 1,5 Tassen)",
    "display_name_fr": "Biryani (Poulet 1,5 tasse)",
    "display_name_pt": "Biryani (Frango 1,5 xícaras)",
    "display_name_tr": "Biryani (Tavuk 1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Cilantro",
        "name_es": "Cilantro",
        "name_de": "Koriander",
        "name_fr": "Coriandre",
        "name_pt": "Coentro",
        "name_tr": "Kişniş"
      },
      {
        "category_en": "Produce",
        "name_en": "Mint",
        "name_es": "Menta",
        "name_de": "Minze",
        "name_fr": "Menthe",
        "name_pt": "Hortelã",
        "name_tr": "Nane"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt",
        "name_es": "Yogur",
        "name_de": "Joghurt",
        "name_fr": "Yaourt",
        "name_pt": "Iogurte",
        "name_tr": "Yoğurt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Basmati rice",
        "name_es": "Arroz basmati",
        "name_de": "Basmatireis",
        "name_fr": "Riz basmati",
        "name_pt": "Arroz basmati",
        "name_tr": "Basmati pirinci"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken",
        "name_es": "Pollo",
        "name_de": "Hähnchen",
        "name_fr": "Poulet",
        "name_pt": "Frango",
        "name_tr": "Tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Biryani spices",
        "name_es": "Especias para biryani",
        "name_de": "Biryani-Gewürze",
        "name_fr": "Épices pour biryani",
        "name_pt": "Especiarias para biryani",
        "name_tr": "Biryani baharatları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ghee",
        "name_es": "Ghee",
        "name_de": "Ghee",
        "name_fr": "Ghee",
        "name_pt": "Ghee",
        "name_tr": "Ghee"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 450.0,
    "protein_g": 25.0,
    "carbohydrates_g": 30.0,
    "fat_g": 25.0,
    "fiber_g": 5.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 150.0,
    "water_ml": 0.0,
    "display_name_en": "Bobotie (1 serving)",
    "display_name_es": "Bobotie (1 porción)",
    "display_name_de": "Bobotie (1 Portion)",
    "display_name_fr": "Bobotie (1 portion)",
    "display_name_pt": "Bobotie (1 porção)",
    "display_name_tr": "Bobotie (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Apple (optional)",
        "name_es": "Manzana (opcional)",
        "name_de": "Apfel (optional)",
        "name_fr": "Pomme (facultatif)",
        "name_pt": "Maçã (opcional)",
        "name_tr": "Elma (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground beef",
        "name_es": "Carne molida",
        "name_de": "Hackfleisch",
        "name_fr": "Bœuf haché",
        "name_pt": "Carne moída",
        "name_tr": "Kıyma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bread",
        "name_es": "Pan",
        "name_de": "Brot",
        "name_fr": "Pain",
        "name_pt": "Pão",
        "name_tr": "Ekmek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Curry powder",
        "name_es": "Curry en polvo",
        "name_de": "Currypulver",
        "name_fr": "Poudre de curry",
        "name_pt": "Curry em pó",
        "name_tr": "Köri tozu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Raisins",
        "name_es": "Pasas",
        "name_de": "Rosinen",
        "name_fr": "Raisins secs",
        "name_pt": "Passas",
        "name_tr": "Kuru üzüm"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 10.0,
    "protein_g": 1.5,
    "carbohydrates_g": 2.0,
    "fat_g": 0.1,
    "fiber_g": 1.0,
    "sodium_mg": 40.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Bok Choy (1 cup steamed)",
    "display_name_es": "Bok Choy (1 taza al vapor)",
    "display_name_de": "Pak Choi (1 Tasse gedämpft)",
    "display_name_fr": "Bok choy (1 tasse cuite à la vapeur)",
    "display_name_pt": "Bok choy (1 xícara cozida no vapor)",
    "display_name_tr": "Bok Choy (1 su bardağı buharda pişirilmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Bok choy",
        "name_es": "Pak choi",
        "name_de": "Pak Choi",
        "name_fr": "Bok choy",
        "name_pt": "Bok choy",
        "name_tr": "Çin lahanası"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soy sauce",
        "name_es": "Salsa de soja",
        "name_de": "Sojasauce",
        "name_fr": "Sauce soja",
        "name_pt": "Molho de soja",
        "name_tr": "Soya sosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sesame oil",
        "name_es": "Aceite de sésamo",
        "name_de": "Sesamöl",
        "name_fr": "Huile de sésame",
        "name_pt": "Óleo de gergelim",
        "name_tr": "Susam yağı"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 160.0,
    "protein_g": 4.0,
    "carbohydrates_g": 28.0,
    "fat_g": 3.0,
    "fiber_g": 1.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Breadstick (1 large)",
    "display_name_es": "Palito de pan (1 grande)",
    "display_name_de": "Brotstange (1 groß)",
    "display_name_fr": "Gressin (1 grand)",
    "display_name_pt": "Palito de pão (1 grande)",
    "display_name_tr": "Ekmek çubuğu (1 büyük)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic (optional)",
        "name_es": "Ajo (opcional)",
        "name_de": "Knoblauch (optional)",
        "name_fr": "Ail (facultatif)",
        "name_pt": "Alho (opcional)",
        "name_tr": "Sarımsak (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese (optional)",
        "name_es": "Queso parmesano (opcional)",
        "name_de": "Parmesankäse (optional)",
        "name_fr": "Parmesan (facultatif)",
        "name_pt": "Queijo parmesão (opcional)",
        "name_tr": "Parmesan peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Breadstick dough",
        "name_es": "Masa de palitos de pan",
        "name_de": "Brotstangenteig",
        "name_fr": "Pâte à gressins",
        "name_pt": "Massa para palitos de pão",
        "name_tr": "Ekmek çubuğu hamuru"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 60.0,
    "protein_g": 1.0,
    "carbohydrates_g": 8.0,
    "fat_g": 3.0,
    "fiber_g": 2.0,
    "sodium_mg": 120.0,
    "cholesterol_mg": 5.0,
    "water_ml": 0.0,
    "display_name_en": "Cabbage Slaw (side)",
    "display_name_es": "Ensalada de col (acompañamiento)",
    "display_name_de": "Krautsalat (Beilage)",
    "display_name_fr": "Salade de chou (accompagnement)",
    "display_name_pt": "Salada de repolho (acompanhamento)",
    "display_name_tr": "Lahana Salatası (yan)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cabbage",
        "name_es": "Repollo",
        "name_de": "Kohl",
        "name_fr": "Chou",
        "name_pt": "Repolho",
        "name_tr": "Lahana"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Red onion",
        "name_es": "Cebolla roja",
        "name_de": "Rote Zwiebel",
        "name_fr": "Oignon rouge",
        "name_pt": "Cebola roxa",
        "name_tr": "Kırmızı soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mayonnaise (optional)",
        "name_es": "Mayonesa (opcional)",
        "name_de": "Mayonnaise (optional)",
        "name_fr": "Mayonnaise (facultatif)",
        "name_pt": "Maionese (opcional)",
        "name_tr": "Mayonez (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 500.0,
    "protein_g": 18.0,
    "carbohydrates_g": 65.0,
    "fat_g": 19.0,
    "fiber_g": 4.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 50.0,
    "water_ml": 0.0,
    "display_name_en": "Cacio e Pepe (1.5 cups)",
    "display_name_es": "Cacio e Pepe (1,5 tazas)",
    "display_name_de": "Cacio e Pepe (1,5 Tassen)",
    "display_name_fr": "Cacio e Pepe (1,5 tasse)",
    "display_name_pt": "Cacio e Pepe (1,5 xícaras)",
    "display_name_tr": "Cacio e Pepe (1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Pecorino cheese",
        "name_es": "queso pecorino",
        "name_de": "Pecorino-Käse",
        "name_fr": "fromage Pecorino",
        "name_pt": "Queijo Pecorino",
        "name_tr": "Pecorino peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spaghetti",
        "name_es": "Espaguetis",
        "name_de": "Spaghetti",
        "name_fr": "Spaghetti",
        "name_pt": "Espaguete",
        "name_tr": "Spagetti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Black pepper",
        "name_es": "Pimienta negra",
        "name_de": "Schwarzer Pfeffer",
        "name_fr": "Poivre noir",
        "name_pt": "Pimenta-do-reino",
        "name_tr": "Karabiber"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      }
    ]
  },
  {
    "category": "Meal/Seafood",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 150.0,
    "protein_g": 13.0,
    "carbohydrates_g": 8.0,
    "fat_g": 7.0,
    "fiber_g": 1.0,
    "sodium_mg": 600.0,
    "cholesterol_mg": 220.0,
    "water_ml": 0.0,
    "display_name_en": "Calamari (fried 3oz)",
    "display_name_es": "Calamares (fritos 3oz)",
    "display_name_de": "Calamari (frittiert, 85 g)",
    "display_name_fr": "Calamars frits (85g)",
    "display_name_pt": "Lula frita (85g)",
    "display_name_tr": "Kalamar (kızarmış 3oz)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon (wedge)",
        "name_es": "Limón (gajo)",
        "name_de": "Zitrone (Spalte)",
        "name_fr": "Citron (en quartier)",
        "name_pt": "Fatia de limão",
        "name_tr": "Limon (dilim)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Calamari",
        "name_es": "Calamares",
        "name_de": "Calamari",
        "name_fr": "Calamars",
        "name_pt": "Lula",
        "name_tr": "Kalamar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      },
      {
        "category_en": "Pantry",
        "name_en": "Seasoning",
        "name_es": "Condimento",
        "name_de": "Gewürze",
        "name_fr": "Assaisonnement",
        "name_pt": "Tempero",
        "name_tr": "Baharat"
      }
    ]
  },
  {
    "category": "Legume",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 105.0,
    "protein_g": 7.0,
    "carbohydrates_g": 20.0,
    "fat_g": 0.5,
    "fiber_g": 6.0,
    "sodium_mg": 230.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Cannellini Beans (1/2 cup in soup)",
    "display_name_es": "Frijoles cannellini (1/2 taza en sopa)",
    "display_name_de": "Cannellini-Bohnen (1/2 Tasse in der Suppe)",
    "display_name_fr": "Haricots cannellini (1/2 tasse dans la soupe)",
    "display_name_pt": "Feijão cannellini (1/2 xícara na sopa)",
    "display_name_tr": "Cannellini Fasulyesi (Çorbada 1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Kale (optional)",
        "name_es": "Col rizada (opcional)",
        "name_de": "Grünkohl (optional)",
        "name_fr": "Chou frisé (facultatif)",
        "name_pt": "Couve (opcional)",
        "name_tr": "Kara lahana (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cannellini beans",
        "name_es": "Frijoles cannellini",
        "name_de": "Cannellinibohnen",
        "name_fr": "Haricots cannellini",
        "name_pt": "Feijão cannellini",
        "name_tr": "Cannellini fasulyesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable broth",
        "name_es": "Caldo de verduras",
        "name_de": "Gemüsebrühe",
        "name_fr": "Bouillon de légumes",
        "name_pt": "Caldo de legumes",
        "name_tr": "Sebze suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 180.0,
    "protein_g": 2.0,
    "carbohydrates_g": 15.0,
    "fat_g": 14.0,
    "fiber_g": 5.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Caponata (1/2 cup)",
    "display_name_es": "Caponata (1/2 taza)",
    "display_name_de": "Caponata (1/2 Tasse)",
    "display_name_fr": "Caponata (1/2 tasse)",
    "display_name_pt": "Caponata (1/2 xícara)",
    "display_name_tr": "Kaponata (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Eggplant",
        "name_es": "Berenjena",
        "name_de": "Aubergine",
        "name_fr": "Aubergine",
        "name_pt": "Beringela",
        "name_tr": "Patlıcan"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Capers",
        "name_es": "Alcaparras",
        "name_de": "Kapern",
        "name_fr": "Câpres",
        "name_pt": "Alcaparras",
        "name_tr": "Kapari"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 650.0,
    "protein_g": 25.0,
    "carbohydrates_g": 60.0,
    "fat_g": 35.0,
    "fiber_g": 4.0,
    "sodium_mg": 900.0,
    "cholesterol_mg": 250.0,
    "water_ml": 0.0,
    "display_name_en": "Carbonara (1.5 cups)",
    "display_name_es": "Carbonara (1,5 tazas)",
    "display_name_de": "Carbonara (1,5 Tassen)",
    "display_name_fr": "Carbonara (1,5 tasse)",
    "display_name_pt": "Carbonara (1,5 xícaras)",
    "display_name_tr": "Karbonara (1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic (optional)",
        "name_es": "Ajo (opcional)",
        "name_de": "Knoblauch (optional)",
        "name_fr": "Ail (facultatif)",
        "name_pt": "Alho (opcional)",
        "name_tr": "Sarımsak (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Pecorino cheese",
        "name_es": "Queso pecorino",
        "name_de": "Pecorino-Käse",
        "name_fr": "Fromage Pecorino",
        "name_pt": "Queijo Pecorino",
        "name_tr": "Pecorino peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spaghetti",
        "name_es": "Espaguetis",
        "name_de": "Spaghetti",
        "name_fr": "Spaghettis",
        "name_pt": "Espaguete",
        "name_tr": "Spagetti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Guanciale",
        "name_es": "Guanciale",
        "name_de": "Guanciale",
        "name_fr": "Guanciale",
        "name_pt": "Guanciale",
        "name_tr": "Guanciale"
      },
      {
        "category_en": "Pantry",
        "name_en": "Black pepper",
        "name_es": "Pimienta negra",
        "name_de": "Schwarzer Pfeffer",
        "name_fr": "Poivre noir",
        "name_pt": "Pimenta preta",
        "name_tr": "Karabiber"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 10.0,
    "protein_g": 0.2,
    "carbohydrates_g": 2.4,
    "fat_g": 0.1,
    "fiber_g": 0.7,
    "sodium_mg": 17.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Carrot (1/4 minced in sauce)",
    "display_name_es": "Zanahoria (1/4 picada en salsa)",
    "display_name_de": "Karotte (1/4 fein gehackt in Soße)",
    "display_name_fr": "Carotte (1/4 hachée dans la sauce)",
    "display_name_pt": "Cenoura (1/4 picada no molho)",
    "display_name_tr": "Havuç (sos içinde 1/4 kıyılmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 2.0,
    "protein_g": 0.1,
    "carbohydrates_g": 0.4,
    "fat_g": 0.0,
    "fiber_g": 0.2,
    "sodium_mg": 12.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Celery (1/4 stalk minced)",
    "display_name_es": "Apio (1/4 de tallo picado)",
    "display_name_de": "Sellerie (1/4 Stange fein gehackt)",
    "display_name_fr": "Céleri (1/4 de branche hachée)",
    "display_name_pt": "Aipo (1/4 de talo picado)",
    "display_name_tr": "Kereviz (1/4 sap kıyılmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Salsão",
        "name_tr": "Kereviz"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 680.0,
    "protein_g": 35.0,
    "carbohydrates_g": 45.0,
    "fat_g": 38.0,
    "fiber_g": 4.0,
    "sodium_mg": 980.0,
    "cholesterol_mg": 120.0,
    "water_ml": 250.0,
    "display_name_en": "Chicken Alfredo (1.5 cups)",
    "display_name_es": "Pollo Alfredo (1,5 tazas)",
    "display_name_de": "Hähnchen Alfredo (1,5 Tassen)",
    "display_name_fr": "Poulet Alfredo (1,5 tasse)",
    "display_name_pt": "Frango Alfredo (1,5 xícaras)",
    "display_name_tr": "Tavuklu Alfredo (1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsa",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme de leite",
        "name_tr": "Krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "Queso parmesano",
        "name_de": "Parmesan",
        "name_fr": "Parmesan",
        "name_pt": "Queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken breast",
        "name_es": "Pechuga de pollo",
        "name_de": "Hähnchenbrust",
        "name_fr": "Blanc de poulet",
        "name_pt": "Peito de frango",
        "name_tr": "Tavuk göğsü"
      },
      {
        "category_en": "Pantry",
        "name_en": "Fettuccine",
        "name_es": "Fettuccine",
        "name_de": "Fettuccine",
        "name_fr": "Fettuccine",
        "name_pt": "Fettuccine",
        "name_tr": "Fettuccine"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 280.0,
    "protein_g": 30.0,
    "carbohydrates_g": 8.0,
    "fat_g": 14.0,
    "fiber_g": 3.0,
    "sodium_mg": 500.0,
    "cholesterol_mg": 85.0,
    "water_ml": 250.0,
    "display_name_en": "Chicken Kebab (2 skewers)",
    "display_name_es": "Kebab de pollo (2 brochetas)",
    "display_name_de": "Hähnchen-Kebab (2 Spieße)",
    "display_name_fr": "Brochettes de poulet (2 brochettes)",
    "display_name_pt": "Espetinho de frango (2 espetos)",
    "display_name_tr": "Tavuk Kebap (2 şiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivron",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt (for marinade)",
        "name_es": "Yogur (para marinar)",
        "name_de": "Joghurt (für die Marinade)",
        "name_fr": "Yaourt (pour la marinade)",
        "name_pt": "Iogurte (para marinar)",
        "name_tr": "Yoğurt (marine için)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken",
        "name_es": "Pollo",
        "name_de": "Hähnchen",
        "name_fr": "Poulet",
        "name_pt": "Frango",
        "name_tr": "Tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spices",
        "name_es": "Especias",
        "name_de": "Gewürze",
        "name_fr": "Épices",
        "name_pt": "Especiarias",
        "name_tr": "Baharatlar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Skewers",
        "name_es": "Brochetas",
        "name_de": "Spieße",
        "name_fr": "Brochettes",
        "name_pt": "Espetinhos",
        "name_tr": "Şişler"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 91.0,
    "protein_g": 13.6,
    "carbohydrates_g": 0.6,
    "fat_g": 3.6,
    "fiber_g": 0.0,
    "sodium_mg": 50.0,
    "cholesterol_mg": 320.0,
    "water_ml": 0.0,
    "display_name_en": "Chicken Liver (2 oz cooked)",
    "display_name_es": "Hígado de pollo (2 oz cocido)",
    "display_name_de": "Hühnerleber (2 oz gekocht)",
    "display_name_fr": "Foie de poulet (57 g cuit)",
    "display_name_pt": "Fígado de frango (57 g cozido)",
    "display_name_tr": "Tavuk Karaciğeri (2 ons pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Manteca",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken liver",
        "name_es": "Hígado de pollo",
        "name_de": "Hühnerleber",
        "name_fr": "Foie de poulet",
        "name_pt": "Fígado de galinha",
        "name_tr": "Tavuk ciğeri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 450.0,
    "protein_g": 35.0,
    "carbohydrates_g": 30.0,
    "fat_g": 22.0,
    "fiber_g": 3.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 100.0,
    "water_ml": 0.0,
    "display_name_en": "Chicken Milanesa (1 serving)",
    "display_name_es": "Milanesa de pollo (1 porción)",
    "display_name_de": "Hähnchen Milanesa (1 Portion)",
    "display_name_fr": "Poulet milanais (1 portion)",
    "display_name_pt": "Frango à milanesa (1 porção)",
    "display_name_tr": "Tavuk Milanesa (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon (wedge)",
        "name_es": "Limón (gajo)",
        "name_de": "Zitrone (Spalte)",
        "name_fr": "Citron (en quartier)",
        "name_pt": "Fatia de limão",
        "name_tr": "Limon (dilim)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken cutlet",
        "name_es": "Chuleta de pollo",
        "name_de": "Hähnchenschnitzel",
        "name_fr": "Escalope de poulet",
        "name_pt": "Filé de frango à milanesa",
        "name_tr": "Tavuk pirzola"
      },
      {
        "category_en": "Pantry",
        "name_en": "Breadcrumbs",
        "name_es": "Pan rallado",
        "name_de": "Paniermehl",
        "name_fr": "Chapelure",
        "name_pt": "Farinha de rosca",
        "name_tr": "Ekmek kırıntıları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha de trigo",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 350.0,
    "protein_g": 30.0,
    "carbohydrates_g": 10.0,
    "fat_g": 20.0,
    "fiber_g": 1.0,
    "sodium_mg": 600.0,
    "cholesterol_mg": 90.0,
    "water_ml": 250.0,
    "display_name_en": "Chicken Piccata (1 serving)",
    "display_name_es": "Pollo Piccata (1 porción)",
    "display_name_de": "Hähnchen Piccata (1 Portion)",
    "display_name_fr": "Piccata de poulet (1 portion)",
    "display_name_pt": "Frango Piccata (1 porção)",
    "display_name_tr": "Tavuk Piccata (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsa",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Manteca",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken breast",
        "name_es": "Pechuga de pollo",
        "name_de": "Hähnchenbrust",
        "name_fr": "Blanc de poulet",
        "name_pt": "Peito de frango",
        "name_tr": "Tavuk göğsü"
      },
      {
        "category_en": "Pantry",
        "name_en": "Capers",
        "name_es": "Alcaparras",
        "name_de": "Kapern",
        "name_fr": "Câpres",
        "name_pt": "Alcaparras",
        "name_tr": "Kapari"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken broth",
        "name_es": "Caldo de pollo",
        "name_de": "Hühnerbrühe",
        "name_fr": "Bouillon de poulet",
        "name_pt": "Caldo de galinha",
        "name_tr": "Tavuk suyu"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 210.0,
    "protein_g": 24.0,
    "carbohydrates_g": 0.0,
    "fat_g": 13.0,
    "fiber_g": 0.0,
    "sodium_mg": 90.0,
    "cholesterol_mg": 120.0,
    "water_ml": 0.0,
    "display_name_en": "Chicken Thigh (1 roasted)",
    "display_name_es": "Muslo de pollo (1 asado)",
    "display_name_de": "Hähnchenschenkel (1 gebraten)",
    "display_name_fr": "Cuisse de poulet (1 rôtie)",
    "display_name_pt": "Coxa de frango (1 assada)",
    "display_name_tr": "Tavuk But (1 adet kızarmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion (optional)",
        "name_es": "Cebolla (opcional)",
        "name_de": "Zwiebel (optional)",
        "name_fr": "Oignon (facultatif)",
        "name_pt": "Cebola (opcional)",
        "name_tr": "Soğan (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken thigh",
        "name_es": "Muslo de pollo",
        "name_de": "Hähnchenschenkel",
        "name_fr": "Cuisse de poulet",
        "name_pt": "Coxa de frango",
        "name_tr": "Tavuk budu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Herbs",
        "name_es": "Hierbas",
        "name_de": "Kräuter",
        "name_fr": "Herbes",
        "name_pt": "Ervas",
        "name_tr": "Otlar"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 480.0,
    "protein_g": 30.0,
    "carbohydrates_g": 20.0,
    "fat_g": 30.0,
    "fiber_g": 5.0,
    "sodium_mg": 900.0,
    "cholesterol_mg": 95.0,
    "water_ml": 250.0,
    "display_name_en": "Chicken Tikka Masala (1.5 cups)",
    "display_name_es": "Pollo Tikka Masala (1,5 tazas)",
    "display_name_de": "Chicken Tikka Masala (1,5 Tassen)",
    "display_name_fr": "Poulet Tikka Masala (1,5 tasse)",
    "display_name_pt": "Frango Tikka Masala (1,5 xícaras)",
    "display_name_tr": "Tavuk Tikka Masala (1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Ginger",
        "name_es": "Jengibre",
        "name_de": "Ingwer",
        "name_fr": "Gingembre",
        "name_pt": "Gengibre",
        "name_tr": "Zencefil"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt",
        "name_es": "Yogur",
        "name_de": "Joghurt",
        "name_fr": "Yaourt",
        "name_pt": "Iogurte",
        "name_tr": "Yoğurt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Nata",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme de leite",
        "name_tr": "Krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken",
        "name_es": "Pollo",
        "name_de": "Hähnchen",
        "name_fr": "Poulet",
        "name_pt": "Frango",
        "name_tr": "Tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tikka masala spices",
        "name_es": "Especias tikka masala",
        "name_de": "Tikka-Masala-Gewürze",
        "name_fr": "Épices Tikka Masala",
        "name_pt": "Especiarias Tikka Masala",
        "name_tr": "Tikka masala baharatları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tomato puree",
        "name_es": "Puré de tomate",
        "name_de": "Tomatenpüree",
        "name_fr": "Purée de tomates",
        "name_pt": "Purê de tomate",
        "name_tr": "Domates püresi"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 130.0,
    "protein_g": 6.0,
    "carbohydrates_g": 1.0,
    "fat_g": 11.0,
    "fiber_g": 0.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Chorizo (1 oz in paella)",
    "display_name_es": "Chorizo ​​(1 oz en paella)",
    "display_name_de": "Chorizo ​​(1 oz in Paella)",
    "display_name_fr": "Chorizo ​​(1 oz dans la paella)",
    "display_name_pt": "Chouriço (30 g na paella)",
    "display_name_tr": "Chorizo ​​(paella'da 1 ons)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomaten",
        "name_fr": "Tomates",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Peas",
        "name_es": "Guisantes",
        "name_de": "Erbsen",
        "name_fr": "Petits pois",
        "name_pt": "Ervilhas",
        "name_tr": "Bezelye"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivrons",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chorizo",
        "name_es": "Chorizo ​​",
        "name_de": "Chorizo ​​",
        "name_fr": "Chorizo ​​",
        "name_pt": "Chouriço",
        "name_tr": "Chorizo ​​"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice",
        "name_es": "Arroz",
        "name_de": "Reis",
        "name_fr": "Riz",
        "name_pt": "Arroz",
        "name_tr": "Pirinç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Saffron",
        "name_es": "Azafrán",
        "name_de": "Safran",
        "name_fr": "Safran",
        "name_pt": "Açafrão",
        "name_tr": "Safran"
      }
    ]
  },
  {
    "category": "Meal/Seafood",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 320.0,
    "protein_g": 10.0,
    "carbohydrates_g": 25.0,
    "fat_g": 20.0,
    "fiber_g": 3.0,
    "sodium_mg": 600.0,
    "cholesterol_mg": 80.0,
    "water_ml": 0.0,
    "display_name_en": "Coconut Shrimp (5 pcs)",
    "display_name_es": "Camarones al coco (5 piezas)",
    "display_name_de": "Kokosgarnelen (5 Stück)",
    "display_name_fr": "Crevettes à la noix de coco (5 pièces)",
    "display_name_pt": "Camarão ao Coco (5 unidades)",
    "display_name_tr": "Hindistan Cevizli Karides (5 adet)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lime (wedge)",
        "name_es": "Lima (gajo)",
        "name_de": "Limette (Spalte)",
        "name_fr": "Chaux (coin)",
        "name_pt": "Lima (cunha)",
        "name_tr": "Kireç (kama)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Shrimp",
        "name_es": "Camarones",
        "name_de": "Garnelen",
        "name_fr": "Crevettes",
        "name_pt": "Camarão",
        "name_tr": "Karides"
      },
      {
        "category_en": "Pantry",
        "name_en": "Shredded coconut",
        "name_es": "Coco rallado",
        "name_de": "Kokosraspeln",
        "name_fr": "Noix de coco râpée",
        "name_pt": "Coco ralado",
        "name_tr": "Hindistan cevizi rendesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Protein/Fish",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 95.0,
    "protein_g": 20.0,
    "carbohydrates_g": 0.0,
    "fat_g": 0.8,
    "fiber_g": 0.0,
    "sodium_mg": 95.0,
    "cholesterol_mg": 55.0,
    "water_ml": 250.0,
    "display_name_en": "Cod (4oz baked)",
    "display_name_es": "Bacalao (113 g al horno)",
    "display_name_de": "Kabeljau (113 g gebacken)",
    "display_name_fr": "Cabillaud (113 g cuit au four)",
    "display_name_pt": "Bacalhau (113 g assado)",
    "display_name_tr": "Morina (4oz fırınlanmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Produce",
        "name_en": "Herbs",
        "name_es": "Hierbas",
        "name_de": "Kräuter",
        "name_fr": "Herbes",
        "name_pt": "Ervas",
        "name_tr": "Otlar"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cod fillet",
        "name_es": "Filete de bacalao",
        "name_de": "Kabeljaufilet",
        "name_fr": "Filet de cabillaud",
        "name_pt": "Filé de bacalhau",
        "name_tr": "Morina filetosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 60.0,
    "protein_g": 5.0,
    "carbohydrates_g": 10.0,
    "fat_g": 1.0,
    "fiber_g": 7.0,
    "sodium_mg": 40.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Collard Greens (1 cup cooked)",
    "display_name_es": "Berza (1 taza cocida)",
    "display_name_de": "Grünkohl (1 Tasse gekocht)",
    "display_name_fr": "Chou vert (1 tasse cuite)",
    "display_name_pt": "Couve (1 xícara cozida)",
    "display_name_tr": "Kara Lahana (1 su bardağı pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Collard greens",
        "name_es": "Col rizada",
        "name_de": "Grünkohl",
        "name_fr": "Chou vert",
        "name_pt": "couve",
        "name_tr": "Kara lahana"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et suyu"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 10.0,
    "carbohydrates_g": 15.0,
    "fat_g": 9.0,
    "fiber_g": 8.0,
    "sodium_mg": 600.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Collard Greens (with ham hock)",
    "display_name_es": "Berza (con codillo de jamón)",
    "display_name_de": "Grünkohl (mit Schweinshaxe)",
    "display_name_fr": "Choux verts (avec jarret de porc)",
    "display_name_pt": "Couve-galega (com osso de presunto)",
    "display_name_tr": "Kara lahana (jambon budu ile)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Collard greens",
        "name_es": "Col rizada",
        "name_de": "Grünkohl",
        "name_fr": "Chou vert",
        "name_pt": "couve",
        "name_tr": "Kara lahana"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ham hock",
        "name_es": "Codillo de jamón",
        "name_de": "Schweinshaxe",
        "name_fr": "Jarret de jambon",
        "name_pt": "Pernil de porco",
        "name_tr": "Jambon budu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et suyu"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 125.0,
    "protein_g": 5.0,
    "carbohydrates_g": 29.0,
    "fat_g": 1.5,
    "fiber_g": 3.0,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Corn on the Cob (1 large)",
    "display_name_es": "Mazorca de maíz (1 grande)",
    "display_name_de": "Maiskolben (1 großer)",
    "display_name_fr": "Épi de maïs (1 gros)",
    "display_name_pt": "Milho na espiga (1 grande)",
    "display_name_tr": "Mısır Koçanı (1 büyük)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Corn on the cob",
        "name_es": "mazorca de maíz",
        "name_de": "Maiskolben",
        "name_fr": "Épis de maïs",
        "name_pt": "Milho na espiga",
        "name_tr": "Koçanda mısır"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Meal/Seafood",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 340.0,
    "protein_g": 20.0,
    "carbohydrates_g": 18.0,
    "fat_g": 20.0,
    "fiber_g": 1.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 120.0,
    "water_ml": 250.0,
    "display_name_en": "Crab Cakes (2 medium)",
    "display_name_es": "Tortitas de cangrejo (2 medianas)",
    "display_name_de": "Krabbenfrikadellen (2 mittelgroß)",
    "display_name_fr": "Galettes de crabe (2 moyennes)",
    "display_name_pt": "Bolinhos de caranguejo (2 médios)",
    "display_name_tr": "Yengeç Köftesi (2 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsa",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Produce",
        "name_en": "Green onion",
        "name_es": "Cebolla verde",
        "name_de": "Frühlingszwiebeln",
        "name_fr": "Oignon vert",
        "name_pt": "Cebolinha",
        "name_tr": "Yeşil soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mayonnaise",
        "name_es": "Mayonesa",
        "name_de": "Mayonnaise",
        "name_fr": "Mayonnaise",
        "name_pt": "Maionese",
        "name_tr": "Mayonez"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Crab meat",
        "name_es": "Carne de cangrejo",
        "name_de": "Krabbenfleisch",
        "name_fr": "Chair de crabe",
        "name_pt": "Carne de caranguejo",
        "name_tr": "Yengeç eti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Breadcrumbs",
        "name_es": "Pan rallado",
        "name_de": "Paniermehl",
        "name_fr": "Chapelure",
        "name_pt": "Farinha de rosca",
        "name_tr": "Ekmek kırıntıları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mustard",
        "name_es": "Mostaza",
        "name_de": "Senf",
        "name_fr": "Moutarde",
        "name_pt": "Mostarda",
        "name_tr": "Hardal"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 190.0,
    "protein_g": 5.0,
    "carbohydrates_g": 8.0,
    "fat_g": 16.0,
    "fiber_g": 3.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 50.0,
    "water_ml": 0.0,
    "display_name_en": "Creamed Spinach (1/2 cup)",
    "display_name_es": "Espinacas a la crema (1/2 taza)",
    "display_name_de": "Rahmspinat (1/2 Tasse)",
    "display_name_fr": "Épinards à la crème (1/2 tasse)",
    "display_name_pt": "Espinafre cremoso (1/2 xícara)",
    "display_name_tr": "Kremalı Ispanak (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Spinach",
        "name_es": "Espinaca",
        "name_de": "Spinat",
        "name_fr": "Épinard",
        "name_pt": "Espinafre",
        "name_tr": "Ispanak"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme de leite",
        "name_tr": "Krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "Queso parmesano",
        "name_de": "Parmesan",
        "name_fr": "Parmesan",
        "name_pt": "Queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 40.0,
    "protein_g": 1.0,
    "carbohydrates_g": 5.0,
    "fat_g": 2.0,
    "fiber_g": 1.0,
    "sodium_mg": 200.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Cucumber Salad (1/2 cup)",
    "display_name_es": "Ensalada de pepino (1/2 taza)",
    "display_name_de": "Gurkensalat (1/2 Tasse)",
    "display_name_fr": "Salade de concombre (1/2 tasse)",
    "display_name_pt": "Salada de pepino (1/2 xícara)",
    "display_name_tr": "Salatalık Salatası (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Dill",
        "name_es": "Eneldo",
        "name_de": "Dill",
        "name_fr": "Aneth",
        "name_pt": "Endro",
        "name_tr": "Dereotu"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt (optional)",
        "name_es": "Yogur (opcional)",
        "name_de": "Joghurt (optional)",
        "name_fr": "Yaourt (facultatif)",
        "name_pt": "Iogurte (opcional)",
        "name_tr": "Yoğurt (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 285.0,
    "protein_g": 16.0,
    "carbohydrates_g": 0.0,
    "fat_g": 24.0,
    "fiber_g": 0.0,
    "sodium_mg": 65.0,
    "cholesterol_mg": 72.0,
    "water_ml": 0.0,
    "display_name_en": "Duck (3oz roasted)",
    "display_name_es": "Pato (3 oz asado)",
    "display_name_de": "Ente (85g gebraten)",
    "display_name_fr": "Canard (85 g rôti)",
    "display_name_pt": "Pato (85g assado)",
    "display_name_tr": "Ördek (3oz kızarmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Orange (optional)",
        "name_es": "Naranja (opcional)",
        "name_de": "Orange (optional)",
        "name_fr": "Orange (facultatif)",
        "name_pt": "Laranja (opcional)",
        "name_tr": "Turuncu (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Duck breast",
        "name_es": "Pechuga de pato",
        "name_de": "Entenbrust",
        "name_fr": "Magret de canard",
        "name_pt": "Peito de pato",
        "name_tr": "Ördek göğsü"
      },
      {
        "category_en": "Pantry",
        "name_en": "Herbs",
        "name_es": "Hierbas",
        "name_de": "Kräuter",
        "name_fr": "Herbes",
        "name_pt": "Ervas",
        "name_tr": "Otlar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 65.0,
    "protein_g": 5.0,
    "carbohydrates_g": 6.0,
    "fat_g": 2.0,
    "fiber_g": 0.5,
    "sodium_mg": 780.0,
    "cholesterol_mg": 50.0,
    "water_ml": 0.0,
    "display_name_en": "Egg Drop Soup (1 cup)",
    "display_name_es": "Sopa de huevo (1 taza)",
    "display_name_de": "Eierflockensuppe (1 Tasse)",
    "display_name_fr": "Soupe aux œufs (1 tasse)",
    "display_name_pt": "Sopa de Ovos (1 xícara)",
    "display_name_tr": "Yumurta Çorbası (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Green onion",
        "name_es": "cebolla verde",
        "name_de": "Frühlingszwiebeln",
        "name_fr": "Oignon vert",
        "name_pt": "cebolinha",
        "name_tr": "Yeşil soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken broth",
        "name_es": "Caldo de pollo",
        "name_de": "Hühnerbrühe",
        "name_fr": "Bouillon de poulet",
        "name_pt": "Caldo de galinha",
        "name_tr": "Tavuk suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cornstarch",
        "name_es": "Maicena",
        "name_de": "Maisstärke",
        "name_fr": "Fécule de maïs",
        "name_pt": "Amido de milho",
        "name_tr": "Mısır nişastası"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soy sauce",
        "name_es": "Salsa de soja",
        "name_de": "Sojasauce",
        "name_fr": "Sauce soja",
        "name_pt": "Molho de soja",
        "name_tr": "Soya sosu"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 220.0,
    "protein_g": 8.0,
    "carbohydrates_g": 40.0,
    "fat_g": 3.0,
    "fiber_g": 2.0,
    "sodium_mg": 20.0,
    "cholesterol_mg": 50.0,
    "water_ml": 0.0,
    "display_name_en": "Egg Noodles (1 cup cooked)",
    "display_name_es": "Fideos de huevo (1 taza cocidos)",
    "display_name_de": "Eiernudeln (1 Tasse gekocht)",
    "display_name_fr": "Nouilles aux œufs (1 tasse cuites)",
    "display_name_pt": "Macarrão de ovo (1 xícara cozida)",
    "display_name_tr": "Yumurtalı Erişte (1 su bardağı pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Egg noodles",
        "name_es": "Fideos de huevo",
        "name_de": "Eiernudeln",
        "name_fr": "Nouilles aux œufs",
        "name_pt": "Macarrão de ovo",
        "name_tr": "Yumurta eriştesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 40.0,
    "protein_g": 0.5,
    "carbohydrates_g": 6.0,
    "fat_g": 2.0,
    "fiber_g": 2.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Eggplant (1/2 cup in caponata)",
    "display_name_es": "Berenjena (1/2 taza en caponata)",
    "display_name_de": "Aubergine (1/2 Tasse in Caponata)",
    "display_name_fr": "Aubergine (1/2 tasse en caponata)",
    "display_name_pt": "Berinjela (1/2 xícara em caponata)",
    "display_name_tr": "Patlıcan (caponata'da 1/2 bardak)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Eggplant",
        "name_es": "Berenjena",
        "name_de": "Aubergine",
        "name_fr": "Aubergine",
        "name_pt": "Beringela",
        "name_tr": "Patlıcan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 230.0,
    "protein_g": 24.0,
    "carbohydrates_g": 0.0,
    "fat_g": 15.0,
    "fiber_g": 0.0,
    "sodium_mg": 60.0,
    "cholesterol_mg": 75.0,
    "water_ml": 0.0,
    "display_name_en": "Fiorentina Steak (3oz portion)",
    "display_name_es": "Filete Fiorentina (porción de 3 oz)",
    "display_name_de": "Fiorentina-Steak (3-Unzen-Portion)",
    "display_name_fr": "Steak Fiorentina (portion de 85 g)",
    "display_name_pt": "Bife à Fiorentina (porção de 85g)",
    "display_name_tr": "Fiorentina Biftek (3oz porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Rosemary",
        "name_es": "Romero",
        "name_de": "Rosmarin",
        "name_fr": "Romarin",
        "name_pt": "Alecrim",
        "name_tr": "Biberiye"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beef T-bone steak",
        "name_es": "Chuletón de ternera",
        "name_de": "Rinder-T-Bone-Steak",
        "name_fr": "Steak T-bone de bœuf",
        "name_pt": "Bife T-bone de carne bovina",
        "name_tr": "Dana T-bone biftek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Meal/Fish",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 420.0,
    "protein_g": 25.0,
    "carbohydrates_g": 40.0,
    "fat_g": 18.0,
    "fiber_g": 6.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 60.0,
    "water_ml": 500.0,
    "display_name_en": "Fish Tacos (2 tacos)",
    "display_name_es": "Tacos de pescado (2 tacos)",
    "display_name_de": "Fisch-Tacos (2 Tacos)",
    "display_name_fr": "Tacos au poisson (2 tacos)",
    "display_name_pt": "Tacos de peixe (2 tacos)",
    "display_name_tr": "Balık Taco'ları (2 taco)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cabbage",
        "name_es": "Repollo",
        "name_de": "Kohl",
        "name_fr": "Chou",
        "name_pt": "Repolho",
        "name_tr": "Lahana"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Cilantro",
        "name_es": "Cilantro",
        "name_de": "Koriander",
        "name_fr": "Coriandre",
        "name_pt": "Coentro",
        "name_tr": "Kişniş"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Sour cream",
        "name_es": "CCrea agria",
        "name_de": "Sauerrahm",
        "name_fr": "Crème aigre",
        "name_pt": "Nata",
        "name_tr": "Ekşi krema"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tortillas",
        "name_es": "Tortillas",
        "name_de": "Tortillas",
        "name_fr": "Tortillas",
        "name_pt": "Tortilhas",
        "name_tr": "Tortillalar"
      },
      {
        "category_en": "Pantry",
        "name_en": "White fish",
        "name_es": "Pescado blanco",
        "name_de": "Weißfisch",
        "name_fr": "Poisson blanc",
        "name_pt": "Peixe branco",
        "name_tr": "Beyaz balık"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salsa",
        "name_es": "Salsa",
        "name_de": "Salsa",
        "name_fr": "Salsa",
        "name_pt": "Salsa",
        "name_tr": "Salsa"
      }
    ]
  },
  {
    "category": "Vegetable/Processed",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 200.0,
    "protein_g": 2.0,
    "carbohydrates_g": 25.0,
    "fat_g": 10.0,
    "fiber_g": 2.0,
    "sodium_mg": 130.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "French Fries (as side)",
    "display_name_es": "Papas fritas (como acompañamiento)",
    "display_name_de": "Pommes frites (als Beilage)",
    "display_name_fr": "Frites (en accompagnement)",
    "display_name_pt": "Batatas fritas (como acompanhamento)",
    "display_name_tr": "Patates kızartması (yanında)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable oil",
        "name_es": "Aceite vegetal",
        "name_de": "Pflanzenöl",
        "name_fr": "Huile végétale",
        "name_pt": "Óleo vegetal",
        "name_tr": "Bitkisel yağ"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Vegetable/Processed",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 340.0,
    "protein_g": 4.0,
    "carbohydrates_g": 44.0,
    "fat_g": 17.0,
    "fiber_g": 4.0,
    "sodium_mg": 230.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "French Fries (medium)",
    "display_name_es": "Papas fritas (medianas)",
    "display_name_de": "Pommes frites (mittel)",
    "display_name_fr": "Frites (moyennes)",
    "display_name_pt": "Batatas fritas (médias)",
    "display_name_tr": "Patates Kızartması (orta)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable oil",
        "name_es": "Aceite vegetal",
        "name_de": "Pflanzenöl",
        "name_fr": "Huile végétale",
        "name_pt": "Óleo vegetal",
        "name_tr": "Bitkisel yağ"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 72.0,
    "protein_g": 5.0,
    "carbohydrates_g": 0.8,
    "fat_g": 5.0,
    "fiber_g": 0.0,
    "sodium_mg": 138.0,
    "cholesterol_mg": 22.0,
    "water_ml": 0.0,
    "display_name_en": "Fresh Mozzarella (1 oz)",
    "display_name_es": "Mozzarella fresca (1 oz)",
    "display_name_de": "Frischer Mozzarella (1 oz)",
    "display_name_fr": "Mozzarella fraîche (1 oz)",
    "display_name_pt": "Mussarela fresca (28 g)",
    "display_name_tr": "Taze Mozzarella (1 oz)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Fresh mozzarella",
        "name_es": "Mozzarella fresca",
        "name_de": "Frischer Mozzarella",
        "name_fr": "mozzarella fraîche",
        "name_pt": "mussarela fresca",
        "name_tr": "Taze mozzarella"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 220.0,
    "protein_g": 4.0,
    "carbohydrates_g": 25.0,
    "fat_g": 12.0,
    "fiber_g": 5.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Fried Okra (1 cup)",
    "display_name_es": "Quimbombó frito (1 taza)",
    "display_name_de": "Gebratene Okraschoten (1 Tasse)",
    "display_name_fr": "Gombo frit (1 tasse)",
    "display_name_pt": "Quiabo frito (1 xícara)",
    "display_name_tr": "Kızarmış Bamya (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Okra",
        "name_es": "Okra",
        "name_de": "Okra",
        "name_fr": "Gombo",
        "name_pt": "Quiabo",
        "name_tr": "Bamya"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cornmeal",
        "name_es": "Harina de maíz",
        "name_de": "Maismehl",
        "name_fr": "Semoule de maïs",
        "name_pt": "Farinha de milho",
        "name_tr": "Mısır unu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Maisstärke",
        "name_fr": "Farine",
        "name_pt": "Farinha de trigo",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Maisöl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 210.0,
    "protein_g": 4.5,
    "carbohydrates_g": 45.0,
    "fat_g": 1.5,
    "fiber_g": 3.0,
    "sodium_mg": 480.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Gnocchi (1 cup)",
    "display_name_es": "Ñoquis (1 taza)",
    "display_name_de": "Gnocchi (1 Tasse)",
    "display_name_fr": "Gnocchis (1 tasse)",
    "display_name_pt": "Nhoque (1 xícara)",
    "display_name_tr": "Gnocchi (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese (optional)",
        "name_es": "Queso parmesano (opcional)",
        "name_de": "Parmesankäse (optional)",
        "name_fr": "Parmesan (facultatif)",
        "name_pt": "Queijo parmesão (opcional)",
        "name_tr": "Parmesan peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Potato gnocchi",
        "name_es": "Ñoquis de patata",
        "name_de": "Kartoffelgnocchi",
        "name_fr": "Gnocchis de pommes de terre",
        "name_pt": "Nhoque de batata",
        "name_tr": "Patates gnocchi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 450.0,
    "protein_g": 15.0,
    "carbohydrates_g": 60.0,
    "fat_g": 18.0,
    "fiber_g": 6.0,
    "sodium_mg": 800.0,
    "cholesterol_mg": 40.0,
    "water_ml": 0.0,
    "display_name_en": "Gnocchi alla Sorrentina (1.5 cups)",
    "display_name_es": "Ñoquis a la sorrentina (1,5 tazas)",
    "display_name_de": "Gnocchi alla Sorrentina (1,5 Tassen)",
    "display_name_fr": "Gnocchis à la Sorrentine (1,5 tasse)",
    "display_name_pt": "Nhoque à Sorrentina (1,5 xícara)",
    "display_name_tr": "Gnocchi alla Sorrentina (1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Basil",
        "name_es": "Albahaca",
        "name_de": "Basilikum",
        "name_fr": "Basilic",
        "name_pt": "Manjericão",
        "name_tr": "Fesleğen"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella",
        "name_es": "Mozzarella",
        "name_de": "Mozzarella",
        "name_fr": "Mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "Queso parmesano",
        "name_de": "Parmesan",
        "name_fr": "Parmesan",
        "name_pt": "Queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Gnocchi",
        "name_es": "Ñoquis",
        "name_de": "Gnocchi",
        "name_fr": "Gnocchis",
        "name_pt": "Nhoque",
        "name_tr": "Gnocchi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 100.0,
    "protein_g": 6.0,
    "carbohydrates_g": 0.7,
    "fat_g": 8.0,
    "fiber_g": 0.0,
    "sodium_mg": 325.0,
    "cholesterol_mg": 21.0,
    "water_ml": 0.0,
    "display_name_en": "Gorgonzola Cheese (1 oz)",
    "display_name_es": "Queso Gorgonzola (1 oz)",
    "display_name_de": "Gorgonzola-Käse (1 oz)",
    "display_name_fr": "Fromage Gorgonzola (1 oz)",
    "display_name_pt": "Queijo Gorgonzola (28 g)",
    "display_name_tr": "Gorgonzola Peyniri (1 ons)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Gorgonzola cheese",
        "name_es": "queso gorgonzola",
        "name_de": "Gorgonzola-Käse",
        "name_fr": "fromage Gorgonzola",
        "name_pt": "Queijo Gorgonzola",
        "name_tr": "Gorgonzola peyniri"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 31.0,
    "protein_g": 1.8,
    "carbohydrates_g": 7.0,
    "fat_g": 0.2,
    "fiber_g": 2.7,
    "sodium_mg": 6.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Green Beans (1 cup)",
    "display_name_es": "Judías verdes (1 taza)",
    "display_name_de": "Grüne Bohnen (1 Tasse)",
    "display_name_fr": "Haricots verts (1 tasse)",
    "display_name_pt": "Vagem (1 xícara)",
    "display_name_tr": "Yeşil Fasulye (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Green beans",
        "name_es": "Judías verdes",
        "name_de": "Grüne Bohnen",
        "name_fr": "haricots verts",
        "name_pt": "Vagens",
        "name_tr": "Taze fasulye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 15.0,
    "protein_g": 0.9,
    "carbohydrates_g": 3.5,
    "fat_g": 0.1,
    "fiber_g": 1.3,
    "sodium_mg": 3.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Green Beans (1/2 cup w/ pasta)",
    "display_name_es": "Judías verdes (1/2 taza con pasta)",
    "display_name_de": "Grüne Bohnen (1/2 Tasse mit Nudeln)",
    "display_name_fr": "Haricots verts (1/2 tasse avec des pâtes)",
    "display_name_pt": "Feijão verde (1/2 xícara com massa)",
    "display_name_tr": "Yeşil Fasulye (1/2 su bardağı makarna ile)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Green beans",
        "name_es": "Judías verdes",
        "name_de": "Grüne Bohnen",
        "name_fr": "haricots verts",
        "name_pt": "Vagens",
        "name_tr": "Taze fasulye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pasta",
        "name_es": "Pasta",
        "name_de": "Pasta",
        "name_fr": "Pâtes",
        "name_pt": "Massa",
        "name_tr": "Makarna"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      }
    ]
  },
  {
    "category": "Legume",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 62.0,
    "protein_g": 4.1,
    "carbohydrates_g": 11.1,
    "fat_g": 0.2,
    "fiber_g": 4.4,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Green Peas (1/2 cup)",
    "display_name_es": "Guisantes verdes (1/2 taza)",
    "display_name_de": "Grüne Erbsen (1/2 Tasse)",
    "display_name_fr": "Petits pois (1/2 tasse)",
    "display_name_pt": "Ervilhas verdes (1/2 xícara)",
    "display_name_tr": "Yeşil Bezelye (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Green peas",
        "name_es": "Guisantes",
        "name_de": "Grüne Erbsen",
        "name_fr": "petits pois",
        "name_pt": "Ervilhas verdes",
        "name_tr": "Yeşil bezelye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter",
        "name_es": "Manteca",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 140.0,
    "protein_g": 11.0,
    "carbohydrates_g": 0.0,
    "fat_g": 10.0,
    "fiber_g": 0.0,
    "sodium_mg": 40.0,
    "cholesterol_mg": 35.0,
    "water_ml": 0.0,
    "display_name_en": "Ground Beef (2 oz in sauce)",
    "display_name_es": "Carne molida (2 oz en salsa)",
    "display_name_de": "Rinderhackfleisch (57 g in Soße)",
    "display_name_fr": "Bœuf haché (57 g en sauce)",
    "display_name_pt": "Carne moída (57 g com molho)",
    "display_name_tr": "Kıyma (2 oz soslu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese (optional)",
        "name_es": "Queso parmesano (opcional)",
        "name_de": "Parmesankäse (optional)",
        "name_fr": "Parmesan (facultatif)",
        "name_pt": "Queijo parmesão (opcional)",
        "name_tr": "Parmesan peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground beef",
        "name_es": "Carne molida",
        "name_de": "Rinderhackfleisch",
        "name_fr": "Bœuf haché",
        "name_pt": "Carne moída",
        "name_tr": "Kıyma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tomato sauce",
        "name_es": "Salsa de tomate",
        "name_de": "Tomatensoße",
        "name_fr": "Sauce tomate",
        "name_pt": "Molho de tomate",
        "name_tr": "Domates sosu"
      }
    ]
  },
  {
    "category": "Vegetable/Condiment",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 90.0,
    "protein_g": 1.0,
    "carbohydrates_g": 4.0,
    "fat_g": 8.0,
    "fiber_g": 3.0,
    "sodium_mg": 120.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Guacamole (1/4 cup)",
    "display_name_es": "Guacamole (1/4 taza)",
    "display_name_de": "Guacamole (1/4 Tasse)",
    "display_name_fr": "Guacamole (1/4 tasse)",
    "display_name_pt": "Guacamole (1/4 de xícara)",
    "display_name_tr": "Guacamole (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Avocado",
        "name_es": "Aguacate",
        "name_de": "Avocado",
        "name_fr": "Avocat",
        "name_pt": "Abacate",
        "name_tr": "Avokado"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Cilantro",
        "name_es": "Cilantro",
        "name_de": "Koriander",
        "name_fr": "Coriandre",
        "name_pt": "Coentro",
        "name_tr": "Kişniş"
      },
      {
        "category_en": "Produce",
        "name_en": "Lime",
        "name_es": "Lima",
        "name_de": "Limette",
        "name_fr": "Citron vert",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 170.0,
    "protein_g": 3.0,
    "carbohydrates_g": 0.0,
    "fat_g": 18.0,
    "fiber_g": 0.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 35.0,
    "water_ml": 0.0,
    "display_name_en": "Guanciale (1 oz)",
    "display_name_es": "Guanciale (1 onza)",
    "display_name_de": "Guanciale (1 oz)",
    "display_name_fr": "Guanciale (1 oz)",
    "display_name_pt": "Guanciale (1 oz)",
    "display_name_tr": "Guanciale (1 ons)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic (optional)",
        "name_es": "Ajo (opcional)",
        "name_de": "Knoblauch (optional)",
        "name_fr": "Ail (facultatif)",
        "name_pt": "Alho (opcional)",
        "name_tr": "Sarımsak (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Guanciale",
        "name_es": "Guanciale",
        "name_de": "Guanciale",
        "name_fr": "Guanciale",
        "name_pt": "Guanciale",
        "name_tr": "Guanciale"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 600.0,
    "protein_g": 25.0,
    "carbohydrates_g": 55.0,
    "fat_g": 30.0,
    "fiber_g": 5.0,
    "sodium_mg": 1200.0,
    "cholesterol_mg": 80.0,
    "water_ml": 250.0,
    "display_name_en": "Gyro (1 sandwich)",
    "display_name_es": "Gyro (1 sándwich)",
    "display_name_de": "Gyros (1 Sandwich)",
    "display_name_fr": "Gyros (1 sandwich)",
    "display_name_pt": "Gyro (1 sanduíche)",
    "display_name_tr": "Gyro (1 sandviç)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomaten",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt (tzatziki)",
        "name_es": "Yogur (tzatziki)",
        "name_de": "Joghurt (Tzatziki)",
        "name_fr": "Yaourt (tzatziki)",
        "name_pt": "Iogurte (tzatziki)",
        "name_tr": "Yoğurt (tzatziki)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pita bread",
        "name_es": "Pan de pita",
        "name_de": "Pitabrot",
        "name_fr": "Pain pita",
        "name_pt": "Pão pita",
        "name_tr": "Pide ekmeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Gyro meat",
        "name_es": "Carne de gyro",
        "name_de": "Gyrosfleisch",
        "name_fr": "Viande de gyro",
        "name_pt": "Carne de giroscópio",
        "name_tr": "Döner eti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spices",
        "name_es": "Especias",
        "name_de": "Gewürze",
        "name_fr": "Épices",
        "name_pt": "Especiarias",
        "name_tr": "Baharatlar"
      }
    ]
  },
  {
    "category": "Protein/Fish",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 125.0,
    "protein_g": 24.0,
    "carbohydrates_g": 0.0,
    "fat_g": 2.5,
    "fiber_g": 0.0,
    "sodium_mg": 60.0,
    "cholesterol_mg": 40.0,
    "water_ml": 250.0,
    "display_name_en": "Halibut (4oz baked)",
    "display_name_es": "Halibut (113 g horneado)",
    "display_name_de": "Heilbutt (113 g gebacken)",
    "display_name_fr": "Flétan (113 g cuit au four)",
    "display_name_pt": "Halibute (113 g assado)",
    "display_name_tr": "Halibut (4oz pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Produce",
        "name_en": "Herbs",
        "name_es": "Hierbas",
        "name_de": "Kräuter",
        "name_fr": "Herbes",
        "name_pt": "Ervas",
        "name_tr": "Otlar"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Halibut fillet",
        "name_es": "Filete de fletán",
        "name_de": "Heilbuttfilet",
        "name_fr": "Filet de flétan",
        "name_pt": "Filé de alabote",
        "name_tr": "Pisi balığı filetosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 200.0,
    "protein_g": 12.0,
    "carbohydrates_g": 3.0,
    "fat_g": 16.0,
    "fiber_g": 0.0,
    "sodium_mg": 550.0,
    "cholesterol_mg": 50.0,
    "water_ml": 0.0,
    "display_name_en": "Italian Sausage (1 link)",
    "display_name_es": "Salchicha italiana (1 enlace)",
    "display_name_de": "Italienische Wurst (1 Stück)",
    "display_name_fr": "Saucisse italienne (1 saucisse)",
    "display_name_pt": "Linguiça italiana (1 unidade)",
    "display_name_tr": "İtalyan Sosis (1 bağlantı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Italian sausage",
        "name_es": "salchicha italiana",
        "name_de": "Italienische Wurst",
        "name_fr": "saucisse italienne",
        "name_pt": "linguiça italiana",
        "name_tr": "İtalyan sosisi"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 4.0,
    "protein_g": 0.1,
    "carbohydrates_g": 0.8,
    "fat_g": 0.1,
    "fiber_g": 0.4,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Jalapeno (1 tbsp sliced)",
    "display_name_es": "Jalapeño (1 cucharada en rodajas)",
    "display_name_de": "Jalapeno (1 EL in Scheiben geschnitten)",
    "display_name_fr": "Jalapeno (1 cuillère à soupe tranchée)",
    "display_name_pt": "Jalapeño (1 colher de sopa fatiada)",
    "display_name_tr": "Jalapeno (1 yemek kaşığı dilimlenmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Jalapeno",
        "name_es": "Jalapeño",
        "name_de": "Jalapeno",
        "name_fr": "Jalapeno",
        "name_pt": "Jalapeño",
        "name_tr": "Jalapeno"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 205.0,
    "protein_g": 4.3,
    "carbohydrates_g": 45.0,
    "fat_g": 0.4,
    "fiber_g": 0.6,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Jasmine Rice (1 cup cooked)",
    "display_name_es": "Arroz jazmín (1 taza cocido)",
    "display_name_de": "Jasminreis (1 Tasse gekocht)",
    "display_name_fr": "Riz au jasmin (1 tasse cuite)",
    "display_name_pt": "Arroz de jasmim (1 xícara cozida)",
    "display_name_tr": "Yasemin Pirinci (1 su bardağı pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Jasmine rice",
        "name_es": "arroz jazmín",
        "name_de": "Jasminreis",
        "name_fr": "riz au jasmin",
        "name_pt": "Arroz de jasmim",
        "name_tr": "Yasmin pirinci"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 33.0,
    "protein_g": 2.9,
    "carbohydrates_g": 6.0,
    "fat_g": 0.6,
    "fiber_g": 2.0,
    "sodium_mg": 29.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Kale (1 cup in soup)",
    "display_name_es": "Col rizada (1 taza en sopa)",
    "display_name_de": "Grünkohl (1 Tasse in der Suppe)",
    "display_name_fr": "Chou frisé (1 tasse dans la soupe)",
    "display_name_pt": "Couve (1 xícara na sopa)",
    "display_name_tr": "Kale (çorbada 1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Kale",
        "name_es": "Col rizada",
        "name_de": "Grünkohl",
        "name_fr": "Chou frisé",
        "name_pt": "Couve",
        "name_tr": "Kale"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable broth",
        "name_es": "Caldo de verduras",
        "name_de": "Gemüsebrühe",
        "name_fr": "Bouillon de légumes",
        "name_pt": "Caldo de legumes",
        "name_tr": "Sebze suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beans (optional)",
        "name_es": "Frijoles (opcional)",
        "name_de": "Bohnen (optional)",
        "name_fr": "Haricots (facultatif)",
        "name_pt": "Feijão (opcional)",
        "name_tr": "Fasulye (isteğe bağlı)"
      }
    ]
  },
  {
    "category": "Meal/Soup",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 350.0,
    "protein_g": 15.0,
    "carbohydrates_g": 20.0,
    "fat_g": 22.0,
    "fiber_g": 5.0,
    "sodium_mg": 1200.0,
    "cholesterol_mg": 30.0,
    "water_ml": 500.0,
    "display_name_en": "Kimchi Jjigae (1 bowl)",
    "display_name_es": "Kimchi Jjigae (1 tazón)",
    "display_name_de": "Kimchi Jjigae (1 Schüssel)",
    "display_name_fr": "Kimchi Jjigae (1 bol)",
    "display_name_pt": "Kimchi Jjigae (1 tigela)",
    "display_name_tr": "Kimchi Jjigae (1 kase)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Kimchi",
        "name_es": "Kimchi",
        "name_de": "Kimchi",
        "name_fr": "Kimchi",
        "name_pt": "Kimchi",
        "name_tr": "Kimchi"
      },
      {
        "category_en": "Produce",
        "name_en": "Green onion",
        "name_es": "Cebolla verde",
        "name_de": "Frühlingszwiebeln",
        "name_fr": "Oignon vert",
        "name_pt": "Cebolinha",
        "name_tr": "Yeşil soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Tofu (optional)",
        "name_es": "Tofu (opcional)",
        "name_de": "Tofu (optional)",
        "name_fr": "Tofu (facultatif)",
        "name_pt": "Tofu (opcional)",
        "name_tr": "Tofu (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pork (optional)",
        "name_es": "Cerdo (opcional)",
        "name_de": "Schweinefleisch (optional)",
        "name_fr": "Porc (facultatif)",
        "name_pt": "Carne de porco (opcional)",
        "name_tr": "Dana eti (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Gochujang",
        "name_es": "Gochujang",
        "name_de": "Gochujang",
        "name_fr": "Gochujang",
        "name_pt": "Gochujang",
        "name_tr": "Goçujang"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "et suyu"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 350.0,
    "protein_g": 20.0,
    "carbohydrates_g": 30.0,
    "fat_g": 17.0,
    "fiber_g": 4.0,
    "sodium_mg": 850.0,
    "cholesterol_mg": 55.0,
    "water_ml": 250.0,
    "display_name_en": "Lasagna (1 serving meat)",
    "display_name_es": "Lasaña (1 porción de carne)",
    "display_name_de": "Lasagne (1 Portion Fleisch)",
    "display_name_fr": "Lasagnes (1 portion de viande)",
    "display_name_pt": "Lasanha (1 porção de carne)",
    "display_name_tr": "Lazanya (1 porsiyon et)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomaten",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Spinach (optional)",
        "name_es": "Espinacas (opcional)",
        "name_de": "Spinat (optional)",
        "name_fr": "Épinards (facultatif)",
        "name_pt": "Espinafre (opcional)",
        "name_tr": "Ispanak (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Ricotta",
        "name_es": "Ricota",
        "name_de": "Ricotta",
        "name_fr": "Ricotta",
        "name_pt": "Ricota",
        "name_tr": "Ricotta"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella",
        "name_es": "mozzarella",
        "name_de": "Mozzarella",
        "name_fr": "Mozzarella",
        "name_pt": "Mussarela",
        "name_tr": "Mozarella"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan",
        "name_es": "parmesano",
        "name_de": "Parmesan",
        "name_fr": "Parmesan",
        "name_pt": "parmesão",
        "name_tr": "Parmesan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lasagna noodles",
        "name_es": "Fideos de lasaña",
        "name_de": "Lasagneplatten",
        "name_fr": "Pâtes à lasagnes",
        "name_pt": "Massa para lasanha",
        "name_tr": "Lazanya eriştesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground beef",
        "name_es": "Carne molida",
        "name_de": "Hackfleisch",
        "name_fr": "Bœuf haché",
        "name_pt": "Carne moída",
        "name_tr": "Kıyma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tomato sauce",
        "name_es": "Salsa de tomate",
        "name_de": "Tomatensoße",
        "name_fr": "Sauce tomate",
        "name_pt": "Molho de tomate",
        "name_tr": "Domates sosu"
      }
    ]
  },
  {
    "category": "Protein/Seafood",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 76.0,
    "protein_g": 16.0,
    "carbohydrates_g": 0.0,
    "fat_g": 0.7,
    "fiber_g": 0.0,
    "sodium_mg": 250.0,
    "cholesterol_mg": 125.0,
    "water_ml": 250.0,
    "display_name_en": "Lobster (3oz steamed)",
    "display_name_es": "Langosta (3 oz al vapor)",
    "display_name_de": "Hummer (85g gedämpft)",
    "display_name_fr": "Homard (85 g cuit à la vapeur)",
    "display_name_pt": "Lagosta (85g cozida no vapor)",
    "display_name_tr": "Istakoz (3oz buharda pişirilmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lobster",
        "name_es": "Langosta",
        "name_de": "Hummer",
        "name_fr": "Homard",
        "name_pt": "Lagosta",
        "name_tr": "Istakoz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 500.0,
    "protein_g": 35.0,
    "carbohydrates_g": 45.0,
    "fat_g": 22.0,
    "fiber_g": 5.0,
    "sodium_mg": 1100.0,
    "cholesterol_mg": 90.0,
    "water_ml": 0.0,
    "display_name_en": "Lomo Saltado (1.5 cups)",
    "display_name_es": "Lomo Saltado (1.5 tazas)",
    "display_name_de": "Lomo Saltado (1,5 Tassen)",
    "display_name_fr": "Lomo Saltado (1,5 tasse)",
    "display_name_pt": "Lomo Saltado (1,5 xícaras)",
    "display_name_tr": "Lomo Saltado (1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomaten",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "French fries",
        "name_es": "Papas fritas",
        "name_de": "Pommes frites",
        "name_fr": "Frites",
        "name_pt": "Batata frita",
        "name_tr": "Patates kızartması"
      },
      {
        "category_en": "Produce",
        "name_en": "Cilantro",
        "name_es": "Cilantro",
        "name_de": "Koriander",
        "name_fr": "Coriandre",
        "name_pt": "Coentro",
        "name_tr": "Kişniş"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beef strips",
        "name_es": "Tiras de ternera",
        "name_de": "Rindfleischstreifen",
        "name_fr": "Lanières de bœuf",
        "name_pt": "Tiras de carne",
        "name_tr": "Sığır eti şeritleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soy sauce",
        "name_es": "Salsa de soja",
        "name_de": "Sojasauce",
        "name_fr": "Sauce soja",
        "name_pt": "Molho de soja",
        "name_tr": "Soya sosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      }
    ]
  },
  {
    "category": "Protein/Fish",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 175.0,
    "protein_g": 16.0,
    "carbohydrates_g": 0.0,
    "fat_g": 12.0,
    "fiber_g": 0.0,
    "sodium_mg": 75.0,
    "cholesterol_mg": 65.0,
    "water_ml": 0.0,
    "display_name_en": "Mackerel (3oz cooked)",
    "display_name_es": "Caballa (3 oz cocida)",
    "display_name_de": "Makrele (3 oz gekocht)",
    "display_name_fr": "Maquereau (85 g cuit)",
    "display_name_pt": "Cavala (85g cozida)",
    "display_name_tr": "Uskumru (3oz pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mackerel fillet",
        "name_es": "Filete de caballa",
        "name_de": "Makrelenfilet",
        "name_fr": "Filet de maquereau",
        "name_pt": "Filé de cavala",
        "name_tr": "Uskumru filetosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 380.0,
    "protein_g": 20.0,
    "carbohydrates_g": 35.0,
    "fat_g": 18.0,
    "fiber_g": 4.0,
    "sodium_mg": 650.0,
    "cholesterol_mg": 60.0,
    "water_ml": 0.0,
    "display_name_en": "Manicotti (2 shells cheese)",
    "display_name_es": "Manicotti (2 conchas de queso)",
    "display_name_de": "Manicotti (2 Muscheln mit Käse)",
    "display_name_fr": "Manicotti (2 coquilles au fromage)",
    "display_name_pt": "Manicotti (2 conchas de queijo)",
    "display_name_tr": "Manicotti (2 kabuklu peynir)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Spinach (optional)",
        "name_es": "Espinacas (opcional)",
        "name_de": "Spinat (optional)",
        "name_fr": "Épinards (facultatif)",
        "name_pt": "Espinafre (opcional)",
        "name_tr": "Ispanak (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Ricotta",
        "name_es": "Ricota",
        "name_de": "Ricotta",
        "name_fr": "Ricotta",
        "name_pt": "Ricota",
        "name_tr": "Ricotta"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella",
        "name_es": "mozzarella",
        "name_de": "Mozzarella",
        "name_fr": "Mozzarella",
        "name_pt": "Mussarela",
        "name_tr": "Mozarella"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan",
        "name_es": "parmesano",
        "name_de": "Parmesan",
        "name_fr": "Parmesan",
        "name_pt": "parmesão",
        "name_tr": "Parmesan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Manicotti pasta",
        "name_es": "Pasta manicotti",
        "name_de": "Manicotti-Nudeln",
        "name_fr": "Pâtes manicotti",
        "name_pt": "Macarrão Manicotti",
        "name_tr": "Manicotti makarnası"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tomato sauce",
        "name_es": "salsa de tomate",
        "name_de": "Tomatensauce",
        "name_fr": "Sauce tomate",
        "name_pt": "Molho de tomate",
        "name_tr": "Domates sosu"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 140.0,
    "protein_g": 5.0,
    "carbohydrates_g": 12.0,
    "fat_g": 8.0,
    "fiber_g": 5.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 25.0,
    "water_ml": 0.0,
    "display_name_en": "Mashed Cauliflower (1 cup)",
    "display_name_es": "Puré de coliflor (1 taza)",
    "display_name_de": "Blumenkohlpüree (1 Tasse)",
    "display_name_fr": "Purée de chou-fleur (1 tasse)",
    "display_name_pt": "Purê de couve-flor (1 xícara)",
    "display_name_tr": "Püre haline getirilmiş karnabahar (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cauliflower",
        "name_es": "Coliflor",
        "name_de": "Blumenkohl",
        "name_fr": "Chou-fleur",
        "name_pt": "Couve-flor",
        "name_tr": "Karnabahar"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme de leite",
        "name_tr": "Krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "Queso parmesano",
        "name_de": "Parmesan",
        "name_fr": "Parmesan",
        "name_pt": "Queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pepper",
        "name_es": "Pimienta",
        "name_de": "Pfeffer",
        "name_fr": "Poivre",
        "name_pt": "Pimenta",
        "name_tr": "Karabiber"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 230.0,
    "protein_g": 4.0,
    "carbohydrates_g": 35.0,
    "fat_g": 8.0,
    "fiber_g": 3.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 15.0,
    "water_ml": 0.0,
    "display_name_en": "Mashed Potatoes (1 cup)",
    "display_name_es": "Puré de papas (1 taza)",
    "display_name_de": "Kartoffelpüree (1 Tasse)",
    "display_name_fr": "Purée de pommes de terre (1 tasse)",
    "display_name_pt": "Purê de batatas (1 xícara)",
    "display_name_tr": "Patates Püresi (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Nata",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme",
        "name_tr": "Krema"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pepper",
        "name_es": "Pimienta",
        "name_de": "Pfeffer",
        "name_fr": "Poivre",
        "name_pt": "Pimenta",
        "name_tr": "Karabiber"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 150.0,
    "protein_g": 3.0,
    "carbohydrates_g": 25.0,
    "fat_g": 4.0,
    "fiber_g": 2.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Mashed Potatoes (side)",
    "display_name_es": "Puré de papas (acompañamiento)",
    "display_name_de": "Kartoffelpüree (Beilage)",
    "display_name_fr": "Purée de pommes de terre (accompagnement)",
    "display_name_pt": "Purê de batatas (acompanhamento)",
    "display_name_tr": "Patates Püresi (yanında)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pepper",
        "name_es": "Pimienta",
        "name_de": "Pfeffer",
        "name_fr": "Poivre",
        "name_pt": "Pimenta",
        "name_tr": "Karabiber"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 80.0,
    "protein_g": 6.0,
    "carbohydrates_g": 1.0,
    "fat_g": 6.0,
    "fiber_g": 0.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Mozzarella (1 oz melted)",
    "display_name_es": "Mozzarella (1 oz derretida)",
    "display_name_de": "Mozzarella (1 oz geschmolzen)",
    "display_name_fr": "Mozzarella (1 oz fondue)",
    "display_name_pt": "Mussarela (30 g derretida)",
    "display_name_tr": "Mozzarella (1 ons eritilmiş)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella",
        "name_es": "queso Mozzarella",
        "name_de": "Mozzarella",
        "name_fr": "Mozzarella",
        "name_pt": "Mozzarella",
        "name_tr": "Mozzarella"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 15.0,
    "protein_g": 2.2,
    "carbohydrates_g": 2.3,
    "fat_g": 0.2,
    "fiber_g": 0.7,
    "sodium_mg": 4.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Mushroom (White 1 cup sliced)",
    "display_name_es": "Champiñones (blancos 1 taza en rodajas)",
    "display_name_de": "Champignons (weiß, 1 Tasse in Scheiben geschnitten)",
    "display_name_fr": "Champignons (blancs, 1 tasse tranchée)",
    "display_name_pt": "Cogumelos (brancos, 1 xícara fatiada)",
    "display_name_tr": "Mantar (Beyaz 1 su bardağı dilimlenmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Mushroom",
        "name_es": "Champiñón",
        "name_de": "Pilz",
        "name_fr": "Champignon",
        "name_pt": "Cogumelo",
        "name_tr": "Mantar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      }
    ]
  },
  {
    "category": "Protein/Seafood",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 146.0,
    "protein_g": 20.0,
    "carbohydrates_g": 6.0,
    "fat_g": 4.0,
    "fiber_g": 0.0,
    "sodium_mg": 310.0,
    "cholesterol_mg": 48.0,
    "water_ml": 0.0,
    "display_name_en": "Mussels (3oz steamed)",
    "display_name_es": "Mejillones (3 oz al vapor)",
    "display_name_de": "Miesmuscheln (3 oz gedämpft)",
    "display_name_fr": "Moules (85 g cuites à la vapeur)",
    "display_name_pt": "Mexilhões (85g cozidos no vapor)",
    "display_name_tr": "Midye (3oz buharda pişirilmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato (optional)",
        "name_es": "Tomate (opcional)",
        "name_de": "Tomate (optional)",
        "name_fr": "Tomate (facultatif)",
        "name_pt": "Tomate (opcional)",
        "name_tr": "Domates (isteğe bağlı)"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsinha",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mussels",
        "name_es": "Mejillones",
        "name_de": "Miesmuscheln",
        "name_fr": "Moules",
        "name_pt": "Mexilhões",
        "name_tr": "Midye"
      },
      {
        "category_en": "Pantry",
        "name_en": "White wine",
        "name_es": "Vino blanco",
        "name_de": "Weißwein",
        "name_fr": "Vin blanc",
        "name_pt": "Vinho branco",
        "name_tr": "Beyaz şarap"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 260.0,
    "protein_g": 8.0,
    "carbohydrates_g": 45.0,
    "fat_g": 5.0,
    "fiber_g": 2.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Naan Bread (1 piece)",
    "display_name_es": "Pan Naan (1 pieza)",
    "display_name_de": "Naan-Brot (1 Stück)",
    "display_name_fr": "Pain naan (1 pièce)",
    "display_name_pt": "Pão Naan (1 unidade)",
    "display_name_tr": "Naan Ekmeği (1 adet)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic (optional)",
        "name_es": "Ajo (opcional)",
        "name_de": "Knoblauch (optional)",
        "name_fr": "Ail (facultatif)",
        "name_pt": "Alho (opcional)",
        "name_tr": "Sarımsak (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt",
        "name_es": "Yogur",
        "name_de": "Joghurt",
        "name_fr": "Yaourt",
        "name_pt": "Iogurte",
        "name_tr": "Yoğurt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Naan bread dough",
        "name_es": "Masa de pan naan",
        "name_de": "Naan-Teig",
        "name_fr": "Pâte à pain naan",
        "name_pt": "Massa de pão naan",
        "name_tr": "Naan ekmeği hamuru"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Yeast",
        "name_es": "Levadura",
        "name_de": "Hefe",
        "name_fr": "Levure",
        "name_pt": "Fermento",
        "name_tr": "Maya"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 5.0,
    "protein_g": 0.1,
    "carbohydrates_g": 1.2,
    "fat_g": 0.0,
    "fiber_g": 0.2,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Onion (1/8 minced in sauce)",
    "display_name_es": "Cebolla (1/8 picada en salsa)",
    "display_name_de": "Zwiebel (1/8 fein gehackt in Soße)",
    "display_name_fr": "Oignon (1/8 haché dans la sauce)",
    "display_name_pt": "Cebola (1/8 picada no molho)",
    "display_name_tr": "Soğan (sos içinde 1/8 kıyılmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 550.0,
    "protein_g": 45.0,
    "carbohydrates_g": 15.0,
    "fat_g": 30.0,
    "fiber_g": 4.0,
    "sodium_mg": 900.0,
    "cholesterol_mg": 150.0,
    "water_ml": 0.0,
    "display_name_en": "Osso Buco (1 serving)",
    "display_name_es": "Osso Buco (1 ración)",
    "display_name_de": "Osso Buco (1 Portion)",
    "display_name_fr": "Osso Buco (1 portion)",
    "display_name_pt": "Osso Buco (1 porção)",
    "display_name_tr": "Osso Buco (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Gremolata (parsley",
        "name_es": "Gremolata (perejil",
        "name_de": "Gremolata (Petersilie",
        "name_fr": "Gremolata (persil",
        "name_pt": "Gremolata (salsa",
        "name_tr": "Gremolata (maydanoz"
      },
      {
        "category_en": "Produce",
        "name_en": "lemon zest",
        "name_es": "ralladura de limón",
        "name_de": "Zitronenschale",
        "name_fr": "zeste de citron",
        "name_pt": "raspas de limão",
        "name_tr": "limon kabuğu rendesi"
      },
      {
        "category_en": "Produce",
        "name_en": "garlic)",
        "name_es": "ajo)",
        "name_de": "Knoblauch)",
        "name_fr": "ail)",
        "name_pt": "alho)",
        "name_tr": "sarımsak)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Veal shank",
        "name_es": "Jarrete de ternera",
        "name_de": "Kalbshaxe",
        "name_fr": "Jarret de veau",
        "name_pt": "Ossobuco de vitela",
        "name_tr": "Dana incik"
      },
      {
        "category_en": "Pantry",
        "name_en": "White wine",
        "name_es": "Vino blanco",
        "name_de": "Weißwein",
        "name_fr": "Vin blanc",
        "name_pt": "Vinho branco",
        "name_tr": "Beyaz şarap"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et suyu"
      }
    ]
  },
  {
    "category": "Protein/Seafood",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 8.0,
    "protein_g": 1.0,
    "carbohydrates_g": 0.5,
    "fat_g": 0.2,
    "fiber_g": 0.0,
    "sodium_mg": 50.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Oyster (1 medium raw)",
    "display_name_es": "Ostra (1 mediana cruda)",
    "display_name_de": "Auster (1 mittelgroße rohe Auster)",
    "display_name_fr": "Huître (1 moyenne crue)",
    "display_name_pt": "Ostra (1 média crua)",
    "display_name_tr": "İstiridye (1 orta boy çiğ)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oyster",
        "name_es": "Ostra",
        "name_de": "Auster",
        "name_fr": "huître",
        "name_pt": "Ostra",
        "name_tr": "istiridye"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 550.0,
    "protein_g": 25.0,
    "carbohydrates_g": 60.0,
    "fat_g": 22.0,
    "fiber_g": 5.0,
    "sodium_mg": 950.0,
    "cholesterol_mg": 70.0,
    "water_ml": 500.0,
    "display_name_en": "Pad Thai (Chicken 1.5 cups)",
    "display_name_es": "Pad Thai (Pollo 1,5 tazas)",
    "display_name_de": "Pad Thai (Hühnchen 1,5 Tassen)",
    "display_name_fr": "Pad Thaï (Poulet 1,5 tasse)",
    "display_name_pt": "Pad Thai (Frango 1,5 xícaras)",
    "display_name_tr": "Pad Thai (Tavuk 1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Bean sprouts",
        "name_es": "Brotes de soja",
        "name_de": "Sojasprossen",
        "name_fr": "Germes de soja",
        "name_pt": "Brotos de feijão",
        "name_tr": "Fasulye filizi"
      },
      {
        "category_en": "Produce",
        "name_en": "Green onion",
        "name_es": "Cebolleta",
        "name_de": "Frühlingszwiebeln",
        "name_fr": "Oignon vert",
        "name_pt": "Cebolinha",
        "name_tr": "Yeşil soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Lime",
        "name_es": "Lima",
        "name_de": "Limette",
        "name_fr": "Citron vert",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice noodles",
        "name_es": "Fideos de arroz",
        "name_de": "Reisnudeln",
        "name_fr": "Nouilles de riz",
        "name_pt": "Macarrão de arroz",
        "name_tr": "Pirinç eriştesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken",
        "name_es": "Pollo",
        "name_de": "Hühnchen",
        "name_fr": "Poulet",
        "name_pt": "Frango",
        "name_tr": "Tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Peanuts",
        "name_es": "Cacahuetes",
        "name_de": "Erdnüsse",
        "name_fr": "Cacahuètes",
        "name_pt": "Amendoim",
        "name_tr": "Yer fıstığı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tamarind sauce",
        "name_es": "Salsa de tamarindo",
        "name_de": "Tamarindensauce",
        "name_fr": "Sauce tamarin",
        "name_pt": "Molho de tamarindo",
        "name_tr": "Demirhindi sosu"
      }
    ]
  },
  {
    "category": "Meal/Rice",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 550.0,
    "protein_g": 30.0,
    "carbohydrates_g": 70.0,
    "fat_g": 18.0,
    "fiber_g": 6.0,
    "sodium_mg": 1200.0,
    "cholesterol_mg": 110.0,
    "water_ml": 0.0,
    "display_name_en": "Paella (1.5 cups seafood)",
    "display_name_es": "Paella (1,5 tazas de mariscos)",
    "display_name_de": "Paella (1,5 Tassen Meeresfrüchte)",
    "display_name_fr": "Paella (1,5 tasse de fruits de mer)",
    "display_name_pt": "Paella (1,5 xícaras de frutos do mar)",
    "display_name_tr": "Paella (1,5 su bardağı deniz ürünü)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomaten",
        "name_fr": "Tomates",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Peas",
        "name_es": "Guisantes",
        "name_de": "Erbsen",
        "name_fr": "Petits pois",
        "name_pt": "Ervilhas",
        "name_tr": "Bezelye"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivrons",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice",
        "name_es": "Arroz",
        "name_de": "Reis",
        "name_fr": "Riz",
        "name_pt": "Arroz",
        "name_tr": "Pirinç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Shrimp",
        "name_es": "Camarones",
        "name_de": "Garnelen",
        "name_fr": "Crevettes",
        "name_pt": "Camarão",
        "name_tr": "Karides"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mussels",
        "name_es": "Mejillones",
        "name_de": "Muscheln",
        "name_fr": "Moules",
        "name_pt": "Mexilhões",
        "name_tr": "Midye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Squid",
        "name_es": "Calamares",
        "name_de": "Tintenfisch",
        "name_fr": "Calamars",
        "name_pt": "Lula",
        "name_tr": "Kalamar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Saffron",
        "name_es": "Azafrán",
        "name_de": "Safran",
        "name_fr": "Safran",
        "name_pt": "Açafrão",
        "name_tr": "Safran"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 45.0,
    "protein_g": 1.5,
    "carbohydrates_g": 0.0,
    "fat_g": 4.5,
    "fiber_g": 0.0,
    "sodium_mg": 160.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Pancetta (0.5 oz in sauce)",
    "display_name_es": "Panceta (0,5 oz en salsa)",
    "display_name_de": "Pancetta (0,5 oz in Sauce)",
    "display_name_fr": "Pancetta (14 g en sauce)",
    "display_name_pt": "Pancetta (14 g em molho)",
    "display_name_tr": "Pancetta (sos içinde 0,5 oz)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic (optional)",
        "name_es": "Ajo (opcional)",
        "name_de": "Knoblauch (optional)",
        "name_fr": "Ail (facultatif)",
        "name_pt": "Alho (opcional)",
        "name_tr": "Sarımsak (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pancetta",
        "name_es": "Panceta",
        "name_de": "Pancetta",
        "name_fr": "Pancetta",
        "name_pt": "Pancetta",
        "name_tr": "Pancetta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 22.0,
    "protein_g": 2.0,
    "carbohydrates_g": 0.2,
    "fat_g": 1.5,
    "fiber_g": 0.0,
    "sodium_mg": 95.0,
    "cholesterol_mg": 4.0,
    "water_ml": 0.0,
    "display_name_en": "Parmigiano-Reggiano (1 tbsp)",
    "display_name_es": "Parmigiano-Reggiano (1 cucharada)",
    "display_name_de": "Parmigiano-Reggiano (1 EL)",
    "display_name_fr": "Parmigiano-Reggiano (1 cuillère à soupe)",
    "display_name_pt": "Parmigiano-Reggiano (1 colher de sopa)",
    "display_name_tr": "Parmigiano-Reggiano (1 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmigiano-Reggiano",
        "name_es": "Parmesano-Reggiano",
        "name_de": "Parmigiano-Reggiano",
        "name_fr": "Parmigiano-Reggiano",
        "name_pt": "Parmigiano-Reggiano",
        "name_tr": "Parmigiano-Reggiano"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 25.0,
    "protein_g": 1.5,
    "carbohydrates_g": 0.1,
    "fat_g": 2.0,
    "fiber_g": 0.0,
    "sodium_mg": 110.0,
    "cholesterol_mg": 6.0,
    "water_ml": 0.0,
    "display_name_en": "Pecorino Cheese (1 tbsp)",
    "display_name_es": "Queso pecorino (1 cucharada)",
    "display_name_de": "Pecorino-Käse (1 EL)",
    "display_name_fr": "Fromage Pecorino (1 cuillère à soupe)",
    "display_name_pt": "Queijo Pecorino (1 colher de sopa)",
    "display_name_tr": "Pecorino Peyniri (1 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Pecorino cheese",
        "name_es": "queso pecorino",
        "name_de": "Pecorino-Käse",
        "name_fr": "fromage Pecorino",
        "name_pt": "Queijo Pecorino",
        "name_tr": "Pecorino peyniri"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 110.0,
    "protein_g": 7.5,
    "carbohydrates_g": 1.0,
    "fat_g": 8.5,
    "fiber_g": 0.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 25.0,
    "water_ml": 0.0,
    "display_name_en": "Pecorino Romano (1/4 cup)",
    "display_name_es": "Pecorino Romano (1/4 taza)",
    "display_name_de": "Pecorino Romano (1/4 Tasse)",
    "display_name_fr": "Pecorino Romano (1/4 tasse)",
    "display_name_pt": "Pecorino Romano (1/4 de xícara)",
    "display_name_tr": "Pecorino Romano (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Pecorino Romano",
        "name_es": "Pecorino Romano",
        "name_de": "Pecorino Romano",
        "name_fr": "Pecorino Romano",
        "name_pt": "Pecorino Romano",
        "name_tr": "Pecorino Romano"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 10.0,
    "protein_g": 0.5,
    "carbohydrates_g": 2.0,
    "fat_g": 0.0,
    "fiber_g": 1.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pickled Cucumber (1/4 cup)",
    "display_name_es": "Pepino encurtido (1/4 taza)",
    "display_name_de": "Eingelegte Gurke (1/4 Tasse)",
    "display_name_fr": "Concombre mariné (1/4 tasse)",
    "display_name_pt": "Pepino em conserva (1/4 de xícara)",
    "display_name_tr": "Turşu Salatalık (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 95.0,
    "protein_g": 2.0,
    "carbohydrates_g": 2.0,
    "fat_g": 10.0,
    "fiber_g": 0.5,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pine Nuts (1 tbsp in pesto)",
    "display_name_es": "Piñones (1 cucharada en pesto)",
    "display_name_de": "Pinienkerne (1 EL im Pesto)",
    "display_name_fr": "Pignons de pin (1 cuillère à soupe dans le pesto)",
    "display_name_pt": "Pinhões (1 colher de sopa no pesto)",
    "display_name_tr": "Çam Fıstığı (pesto sosunda 1 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Basil",
        "name_es": "Albahaca",
        "name_de": "Basilikum",
        "name_fr": "Basilic",
        "name_pt": "Manjericão",
        "name_tr": "Fesleğen"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "queso parmesano",
        "name_de": "Parmesankäse",
        "name_fr": "parmesan",
        "name_pt": "queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pine nuts",
        "name_es": "Piñones",
        "name_de": "Pinienkerne",
        "name_fr": "Pignons de pin",
        "name_pt": "Pinhões",
        "name_tr": "Çam fıstığı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 95.0,
    "protein_g": 2.0,
    "carbohydrates_g": 2.0,
    "fat_g": 10.0,
    "fiber_g": 0.5,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pine Nuts (1 tbsp)",
    "display_name_es": "Piñones (1 cucharada)",
    "display_name_de": "Pinienkerne (1 EL)",
    "display_name_fr": "Pignons de pin (1 cuillère à soupe)",
    "display_name_pt": "Pinhões (1 colher de sopa)",
    "display_name_tr": "Çam Fıstığı (1 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pine nuts",
        "name_es": "piñones",
        "name_de": "Pinienkerne",
        "name_fr": "pignons de pin",
        "name_pt": "pinhões",
        "name_tr": "Çam fıstığı"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 48.0,
    "protein_g": 1.0,
    "carbohydrates_g": 1.0,
    "fat_g": 5.0,
    "fiber_g": 0.2,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pine Nuts (1/2 tbsp)",
    "display_name_es": "Piñones (1/2 cucharada)",
    "display_name_de": "Pinienkerne (1/2 EL)",
    "display_name_fr": "Pignons de pin (1/2 cuillère à soupe)",
    "display_name_pt": "Pinhões (1/2 colher de sopa)",
    "display_name_tr": "Çam Fıstığı (1/2 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pine nuts",
        "name_es": "piñones",
        "name_de": "Pinienkerne",
        "name_fr": "pignons de pin",
        "name_pt": "pinhões",
        "name_tr": "Çam fıstığı"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 220.0,
    "protein_g": 7.0,
    "carbohydrates_g": 45.0,
    "fat_g": 2.0,
    "fiber_g": 2.0,
    "sodium_mg": 440.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pita Bread (White 1 large)",
    "display_name_es": "Pan Pita (Blanco 1 grande)",
    "display_name_de": "Pitabrot (Weißbrot, 1 großes)",
    "display_name_fr": "Pain pita (blanc, 1 grand)",
    "display_name_pt": "Pão pita (branco, 1 grande)",
    "display_name_tr": "Pide Ekmeği (Beyaz 1 büyük)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pita bread",
        "name_es": "Pan de pita",
        "name_de": "Pitabrot",
        "name_fr": "Pain pita",
        "name_pt": "Pão pita",
        "name_tr": "Pide ekmeği"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 290.0,
    "protein_g": 12.0,
    "carbohydrates_g": 34.0,
    "fat_g": 12.0,
    "fiber_g": 2.0,
    "sodium_mg": 720.0,
    "cholesterol_mg": 35.0,
    "water_ml": 250.0,
    "display_name_en": "Pizza (1 slice pepperoni)",
    "display_name_es": "Pizza (1 rebanada de pepperoni)",
    "display_name_de": "Pizza (1 Stück Peperoni)",
    "display_name_fr": "Pizza (1 part de pepperoni)",
    "display_name_pt": "Pizza (1 fatia de pepperoni)",
    "display_name_tr": "Pizza (1 dilim pepperoni)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato sauce",
        "name_es": "salsa de tomate",
        "name_de": "Tomatensoße",
        "name_fr": "Sauce tomate",
        "name_pt": "Molho de tomate",
        "name_tr": "Domates sosu"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "queso mozzarella",
        "name_de": "Mozzarella-Käse",
        "name_fr": "fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pizza crust",
        "name_es": "Masa de pizza",
        "name_de": "Pizzaboden",
        "name_fr": "Croûte à pizza",
        "name_pt": "Massa de pizza",
        "name_tr": "Pizza hamuru"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pepperoni",
        "name_es": "Pepperoni",
        "name_de": "Peperoni",
        "name_fr": "Pepperoni",
        "name_pt": "Calabresa",
        "name_tr": "Pepperoni"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 250.0,
    "protein_g": 12.0,
    "carbohydrates_g": 30.0,
    "fat_g": 10.0,
    "fiber_g": 3.0,
    "sodium_mg": 600.0,
    "cholesterol_mg": 25.0,
    "water_ml": 250.0,
    "display_name_en": "Pizza (Margherita 1 slice)",
    "display_name_es": "Pizza (Margarita 1 porción)",
    "display_name_de": "Pizza (Margherita, 1 Stück)",
    "display_name_fr": "Pizza (Margherita 1 part)",
    "display_name_pt": "Pizza (Margherita 1 fatia)",
    "display_name_tr": "Pizza (Margarita 1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Basil",
        "name_es": "Albahaca",
        "name_de": "Basilikum",
        "name_fr": "Basilic",
        "name_pt": "Manjericão",
        "name_tr": "Fesleğen"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "queso mozzarella",
        "name_de": "Mozzarella-Käse",
        "name_fr": "fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pizza crust",
        "name_es": "Masa de pizza",
        "name_de": "Pizzaboden",
        "name_fr": "Pâte à pizza",
        "name_pt": "Massa de pizza",
        "name_tr": "Pizza hamuru"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 150.0,
    "protein_g": 3.0,
    "carbohydrates_g": 32.0,
    "fat_g": 1.0,
    "fiber_g": 3.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 5.0,
    "water_ml": 0.0,
    "display_name_en": "Polenta (1 cup creamy)",
    "display_name_es": "Polenta (1 taza cremosa)",
    "display_name_de": "Polenta (1 Tasse cremig)",
    "display_name_fr": "Polenta (1 tasse crémeuse)",
    "display_name_pt": "Polenta (1 xícara cremosa)",
    "display_name_tr": "Polenta (1 su bardağı kremalı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "Queso parmesano",
        "name_de": "Parmesan",
        "name_fr": "Parmesan",
        "name_pt": "Queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Polenta",
        "name_es": "Polenta",
        "name_de": "Polenta",
        "name_fr": "Polenta",
        "name_pt": "Polenta",
        "name_tr": "Polenta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable broth",
        "name_es": "Caldo de verduras",
        "name_de": "Gemüsebrühe",
        "name_fr": "Bouillon de légumes",
        "name_pt": "Caldo de legumes",
        "name_tr": "Sebze suyu"
      }
    ]
  },
  {
    "category": "Meal/Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 120.0,
    "protein_g": 2.5,
    "carbohydrates_g": 25.0,
    "fat_g": 1.0,
    "fiber_g": 2.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Polenta (grilled 1 slice)",
    "display_name_es": "Polenta (a la parrilla 1 rebanada)",
    "display_name_de": "Polenta (gegrillt, 1 Scheibe)",
    "display_name_fr": "Polenta (1 tranche grillée)",
    "display_name_pt": "Polenta (1 fatia grelhada)",
    "display_name_tr": "Polenta (ızgara 1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Polenta",
        "name_es": "Polenta",
        "name_de": "Polenta",
        "name_fr": "Polenta",
        "name_pt": "Polenta",
        "name_tr": "Polenta"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 145.0,
    "protein_g": 3.0,
    "carbohydrates_g": 0.0,
    "fat_g": 15.0,
    "fiber_g": 0.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Pork Belly (1 oz in soup)",
    "display_name_es": "Panceta de cerdo (1 oz en sopa)",
    "display_name_de": "Schweinebauch (1 oz in Suppe)",
    "display_name_fr": "Poitrine de porc (1 oz dans la soupe)",
    "display_name_pt": "Barriga de porco (30 g na sopa)",
    "display_name_tr": "Dana Göbeği (çorbada 1 ons)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Green onion",
        "name_es": "cebolla verde",
        "name_de": "Frühlingszwiebeln",
        "name_fr": "Oignon vert",
        "name_pt": "cebolinha",
        "name_tr": "Yeşil soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pork belly",
        "name_es": "Panceta de cerdo",
        "name_de": "Schweinebauch",
        "name_fr": "Poitrine de porc",
        "name_pt": "Barriga de porco",
        "name_tr": "Dana göbeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soy sauce",
        "name_es": "Salsa de soja",
        "name_de": "Sojasauce",
        "name_fr": "Sauce soja",
        "name_pt": "Molho de soja",
        "name_tr": "Soya sosu"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 220.0,
    "protein_g": 30.0,
    "carbohydrates_g": 0.0,
    "fat_g": 10.0,
    "fiber_g": 0.0,
    "sodium_mg": 70.0,
    "cholesterol_mg": 85.0,
    "water_ml": 250.0,
    "display_name_en": "Pork Chop (4oz grilled)",
    "display_name_es": "Chuleta de cerdo (113 g a la parrilla)",
    "display_name_de": "Schweinekotelett (113 g gegrillt)",
    "display_name_fr": "Côte de porc (113 g grillée)",
    "display_name_pt": "Costeleta de porco (113 g grelhada)",
    "display_name_tr": "Dana Pirzolası (4oz ızgara)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Rosemary",
        "name_es": "Romero",
        "name_de": "Rosmarin",
        "name_fr": "Romarin",
        "name_pt": "Alecrim",
        "name_tr": "Biberiye"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pork chop",
        "name_es": "Chuleta de cerdo",
        "name_de": "Schweinekotelett",
        "name_fr": "Côte de porc",
        "name_pt": "Costeleta de porco",
        "name_tr": "Dana pirzolası"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pepper",
        "name_es": "Pimienta",
        "name_de": "Pfeffer",
        "name_fr": "Poivre",
        "name_pt": "Pimenta",
        "name_tr": "Karabiber"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 65.0,
    "protein_g": 1.0,
    "carbohydrates_g": 15.0,
    "fat_g": 0.1,
    "fiber_g": 1.0,
    "sodium_mg": 3.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Potato (1/2 w/ pasta)",
    "display_name_es": "Papa (1/2 con pasta)",
    "display_name_de": "Kartoffel (1/2 mit Nudeln)",
    "display_name_fr": "Pomme de terre (1/2 avec pâtes)",
    "display_name_pt": "Batata (1/2 com massa)",
    "display_name_tr": "Patates (1/2 makarna ile)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pasta",
        "name_es": "Pasta",
        "name_de": "Pasta",
        "name_fr": "Pâtes",
        "name_pt": "Massa",
        "name_tr": "Makarna"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 35.0,
    "protein_g": 4.0,
    "carbohydrates_g": 0.0,
    "fat_g": 2.5,
    "fiber_g": 0.0,
    "sodium_mg": 280.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Prosciutto (1 slice)",
    "display_name_es": "Prosciutto (1 rebanada)",
    "display_name_de": "Prosciutto (1 Scheibe)",
    "display_name_fr": "Prosciutto (1 tranche)",
    "display_name_pt": "Presunto (1 fatia)",
    "display_name_tr": "Prosciutto (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Melon (optional)",
        "name_es": "Melón (opcional)",
        "name_de": "Melone (optional)",
        "name_fr": "Melon (facultatif)",
        "name_pt": "Melão (opcional)",
        "name_tr": "Kavun (isteğe bağlı)"
      },
      {
        "category_en": "Produce",
        "name_en": "Arugula (optional)",
        "name_es": "Rúcula (opcional)",
        "name_de": "Rucola (optional)",
        "name_fr": "Roquette (facultatif)",
        "name_pt": "Rúcula (opcional)",
        "name_tr": "Roka (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Prosciutto",
        "name_es": "Jamón",
        "name_de": "Prosciutto",
        "name_fr": "Prosciutto",
        "name_pt": "Presunto",
        "name_tr": "Jambon"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 100.0,
    "protein_g": 7.0,
    "carbohydrates_g": 1.0,
    "fat_g": 8.0,
    "fiber_g": 0.0,
    "sodium_mg": 250.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Provoleta (1 oz grilled cheese)",
    "display_name_es": "Provoleta (1 oz de queso a la parrilla)",
    "display_name_de": "Provoleta (1 oz gegrillter Käse)",
    "display_name_fr": "Provoleta (1 oz de fromage grillé)",
    "display_name_pt": "Provoleta (sanduíche de queijo grelhado de 30g)",
    "display_name_tr": "Provoleta (1 ons ızgara peynir)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Oregano",
        "name_es": "Orégano",
        "name_de": "Oregano",
        "name_fr": "Origan",
        "name_pt": "Orégano",
        "name_tr": "Kekik"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Provolone cheese",
        "name_es": "queso provolone",
        "name_de": "Provolone-Käse",
        "name_fr": "fromage provolone",
        "name_pt": "queijo Provolone",
        "name_tr": "Provolone peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 115.0,
    "protein_g": 1.5,
    "carbohydrates_g": 9.0,
    "fat_g": 8.0,
    "fiber_g": 0.5,
    "sodium_mg": 100.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Puff Pastry (1 oz wrapper)",
    "display_name_es": "Hojaldre (envoltorio de 1 oz)",
    "display_name_de": "Blätterteig (1-Unzen-Teigblatt)",
    "display_name_fr": "Pâte feuilletée (feuille de 28 g)",
    "display_name_pt": "Massa folhada (invólucro de 28 g)",
    "display_name_tr": "Milföy Hamuru (1 onsluk ambalaj)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Puff pastry",
        "name_es": "Hojaldre",
        "name_de": "Blätterteig",
        "name_fr": "Pâte feuilletée",
        "name_pt": "Massa folhada",
        "name_tr": "Puf böreği"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 222.0,
    "protein_g": 8.0,
    "carbohydrates_g": 39.0,
    "fat_g": 3.6,
    "fiber_g": 5.0,
    "sodium_mg": 13.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Quinoa (1 cup cooked)",
    "display_name_es": "Quinua (1 taza cocida)",
    "display_name_de": "Quinoa (1 Tasse gekocht)",
    "display_name_fr": "Quinoa (1 tasse cuite)",
    "display_name_pt": "Quinoa (1 xícara cozida)",
    "display_name_tr": "Kinoa (1 su bardağı pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Vegetable mix (optional: bell pepper",
        "name_es": "Mezcla de verduras (opcional: pimiento morrón",
        "name_de": "Gemüsemischung (optional: Paprika",
        "name_fr": "Mélange de légumes (facultatif : poivron",
        "name_pt": "Mix de vegetais (opcional: pimentão",
        "name_tr": "Sebze karışımı (isteğe bağlı: dolmalık biber"
      },
      {
        "category_en": "Produce",
        "name_en": "onion",
        "name_es": "cebolla",
        "name_de": "Zwiebel",
        "name_fr": "oignon",
        "name_pt": "cebola",
        "name_tr": "soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "spinach)",
        "name_es": "espinacas)",
        "name_de": "Spinat)",
        "name_fr": "épinards)",
        "name_pt": "espinafre)",
        "name_tr": "ıspanak)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Quinoa",
        "name_es": "Quinoa",
        "name_de": "Quinoa",
        "name_fr": "Quinoa",
        "name_pt": "Quinoa",
        "name_tr": "Kinoa"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 27.0,
    "protein_g": 0.3,
    "carbohydrates_g": 7.0,
    "fat_g": 0.0,
    "fiber_g": 0.3,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Raisins (1 tbsp)",
    "display_name_es": "Pasas (1 cucharada)",
    "display_name_de": "Rosinen (1 EL)",
    "display_name_fr": "Raisins secs (1 cuillère à soupe)",
    "display_name_pt": "Uvas-passas (1 colher de sopa)",
    "display_name_tr": "Kuru üzüm (1 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Raisins",
        "name_es": "Pasas",
        "name_de": "Rosinen",
        "name_fr": "Raisins",
        "name_pt": "Uvas passas",
        "name_tr": "Kuru üzüm"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 22.0,
    "protein_g": 1.1,
    "carbohydrates_g": 5.2,
    "fat_g": 0.1,
    "fiber_g": 1.6,
    "sodium_mg": 8.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Red Cabbage (1 cup raw)",
    "display_name_es": "Repollo morado (1 taza crudo)",
    "display_name_de": "Rotkohl (1 Tasse roh)",
    "display_name_fr": "Chou rouge (1 tasse cru)",
    "display_name_pt": "Repolho roxo (1 xícara cru)",
    "display_name_tr": "Kırmızı Lahana (1 su bardağı çiğ)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Red cabbage",
        "name_es": "Col lombarda",
        "name_de": "Rotkohl",
        "name_fr": "chou rouge",
        "name_pt": "repolho roxo",
        "name_tr": "Kırmızı lahana"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Legume",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 115.0,
    "protein_g": 7.0,
    "carbohydrates_g": 19.0,
    "fat_g": 1.0,
    "fiber_g": 6.0,
    "sodium_mg": 480.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Refried Beans (1/2 cup)",
    "display_name_es": "Frijoles Refritos (1/2 taza)",
    "display_name_de": "Refried Beans (1/2 Tasse)",
    "display_name_fr": "Haricots frits (1/2 tasse)",
    "display_name_pt": "Feijão refogado (1/2 xícara)",
    "display_name_tr": "Kızarmış Fasulye (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion (optional)",
        "name_es": "Cebolla (opcional)",
        "name_de": "Zwiebel (optional)",
        "name_fr": "Oignon (facultatif)",
        "name_pt": "Cebola (opcional)",
        "name_tr": "Soğan (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheese (optional)",
        "name_es": "Queso (opcional)",
        "name_de": "Käse (optional)",
        "name_fr": "Fromage (facultatif)",
        "name_pt": "Queijo (opcional)",
        "name_tr": "Peynir (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Refried beans",
        "name_es": "Frijoles refritos",
        "name_de": "Refried Beans",
        "name_fr": "Haricots frits",
        "name_pt": "Feijão refogado",
        "name_tr": "Kızarmış fasulye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lard or oil",
        "name_es": "Manteca o aceite",
        "name_de": "Schmalz oder Öl",
        "name_fr": "Saindoux ou huile",
        "name_pt": "Banha ou óleo",
        "name_tr": "Dana yağı veya sıvı yağ"
      }
    ]
  },
  {
    "category": "Meal/Soup",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 350.0,
    "protein_g": 15.0,
    "carbohydrates_g": 55.0,
    "fat_g": 8.0,
    "fiber_g": 14.0,
    "sodium_mg": 900.0,
    "cholesterol_mg": 5.0,
    "water_ml": 500.0,
    "display_name_en": "Ribollita (1.5 cups soup)",
    "display_name_es": "Ribollita (1,5 tazas de sopa)",
    "display_name_de": "Ribollita (1,5 Tassen Suppe)",
    "display_name_fr": "Ribollita (1,5 tasse de soupe)",
    "display_name_pt": "Ribollita (1,5 xícaras de sopa)",
    "display_name_tr": "Ribollita (1,5 su bardağı çorba)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Kale",
        "name_es": "Col rizada",
        "name_de": "Grünkohl",
        "name_fr": "Chou frisé",
        "name_pt": "Couve",
        "name_tr": "Kale"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Cabbage",
        "name_es": "Repollo",
        "name_de": "Kohl",
        "name_fr": "Chou",
        "name_pt": "Repolho",
        "name_tr": "Lahana"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese (optional)",
        "name_es": "Queso parmesano (opcional)",
        "name_de": "Parmesankäse (optional)",
        "name_fr": "Parmesan (facultatif)",
        "name_pt": "Queijo parmesão (opcional)",
        "name_tr": "Parmesan peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cannellini beans",
        "name_es": "Frijoles cannellini",
        "name_de": "Cannellinibohnen",
        "name_fr": "Haricots cannellini",
        "name_pt": "Feijão branco",
        "name_tr": "Cannellini fasulyesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Stale bread",
        "name_es": "Pan duro",
        "name_de": "Altes Brot",
        "name_fr": "Pain rassis",
        "name_pt": "Pão amanhecido",
        "name_tr": "Bayat ekmek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et suyu"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 85.0,
    "protein_g": 5.5,
    "carbohydrates_g": 2.5,
    "fat_g": 6.0,
    "fiber_g": 0.0,
    "sodium_mg": 50.0,
    "cholesterol_mg": 24.0,
    "water_ml": 0.0,
    "display_name_en": "Ricotta Cheese (1/4 cup)",
    "display_name_es": "Queso ricotta (1/4 taza)",
    "display_name_de": "Ricotta-Käse (1/4 Tasse)",
    "display_name_fr": "Fromage ricotta (1/4 tasse)",
    "display_name_pt": "Queijo Ricota (1/4 de xícara)",
    "display_name_tr": "Ricotta Peyniri (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Ricotta cheese",
        "name_es": "Queso ricotta",
        "name_de": "Ricotta-Käse",
        "name_fr": "fromage ricotta",
        "name_pt": "Queijo Ricota",
        "name_tr": "Ricotta peyniri"
      }
    ]
  },
  {
    "category": "Meal/Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 250.0,
    "protein_g": 7.0,
    "carbohydrates_g": 35.0,
    "fat_g": 9.0,
    "fiber_g": 3.0,
    "sodium_mg": 600.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Risotto (Mushroom 1 cup)",
    "display_name_es": "Risotto (Champiñones 1 taza)",
    "display_name_de": "Risotto (Pilze, 1 Tasse)",
    "display_name_fr": "Risotto (Champignons 1 tasse)",
    "display_name_pt": "Risoto (1 xícara de cogumelos)",
    "display_name_tr": "Risotto (Mantar 1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Mushroom",
        "name_es": "Champiñones",
        "name_de": "Pilze",
        "name_fr": "Champignons",
        "name_pt": "Cogumelo",
        "name_tr": "Mantar"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignons",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "Queso parmesano",
        "name_de": "Parmesan",
        "name_fr": "Parmesan",
        "name_pt": "Queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Arborio rice",
        "name_es": "Arroz Arborio",
        "name_de": "Arborio-Reis",
        "name_fr": "Riz Arborio",
        "name_pt": "Arroz arbóreo",
        "name_tr": "Arborio pirinci"
      },
      {
        "category_en": "Pantry",
        "name_en": "White wine",
        "name_es": "Vino blanco",
        "name_de": "Weißwein",
        "name_fr": "Vin blanc",
        "name_pt": "Vinho branco",
        "name_tr": "Beyaz şarap"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et suyu"
      }
    ]
  },
  {
    "category": "Meal/Rice",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 350.0,
    "protein_g": 10.0,
    "carbohydrates_g": 50.0,
    "fat_g": 12.0,
    "fiber_g": 3.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Risotto alla Milanese (1 cup)",
    "display_name_es": "Risotto a la milanesa (1 taza)",
    "display_name_de": "Risotto alla Milanese (1 Tasse)",
    "display_name_fr": "Risotto alla Milanese (1 tasse)",
    "display_name_pt": "Risoto à milanesa (1 xícara)",
    "display_name_tr": "Risotto alla Milanese (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "Queso parmesano",
        "name_de": "Parmesan",
        "name_fr": "Parmesan",
        "name_pt": "Queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Arborio rice",
        "name_es": "Arroz Arborio",
        "name_de": "Arborio-Reis",
        "name_fr": "Riz Arborio",
        "name_pt": "Arroz arbóreo",
        "name_tr": "Arborio pirinci"
      },
      {
        "category_en": "Pantry",
        "name_en": "Saffron",
        "name_es": "Azafrán",
        "name_de": "Safran",
        "name_fr": "Safran",
        "name_pt": "Açafrão",
        "name_tr": "Safran"
      },
      {
        "category_en": "Pantry",
        "name_en": "White wine",
        "name_es": "Vino blanco",
        "name_de": "Weißwein",
        "name_fr": "Vin blanc",
        "name_pt": "Vinho branco",
        "name_tr": "Beyaz şarap"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et suyu"
      }
    ]
  },
  {
    "category": "Protein/Fish",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 230.0,
    "protein_g": 25.0,
    "carbohydrates_g": 0.0,
    "fat_g": 14.0,
    "fiber_g": 0.0,
    "sodium_mg": 60.0,
    "cholesterol_mg": 60.0,
    "water_ml": 250.0,
    "display_name_en": "Salmon (4oz grilled)",
    "display_name_es": "Salmón (113 g a la parrilla)",
    "display_name_de": "Lachs (113 g gegrillt)",
    "display_name_fr": "Saumon (113 g grillé)",
    "display_name_pt": "Salmão (113g grelhado)",
    "display_name_tr": "Somon (4oz ızgara)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Produce",
        "name_en": "Dill (optional)",
        "name_es": "Eneldo (opcional)",
        "name_de": "Dill (optional)",
        "name_fr": "Aneth (facultatif)",
        "name_pt": "Endro (opcional)",
        "name_tr": "Dereotu (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salmon fillet",
        "name_es": "Filete de salmón",
        "name_de": "Lachsfilet",
        "name_fr": "Filet de saumon",
        "name_pt": "Filé de salmão",
        "name_tr": "Somon fileto"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 380.0,
    "protein_g": 38.0,
    "carbohydrates_g": 5.0,
    "fat_g": 22.0,
    "fiber_g": 0.5,
    "sodium_mg": 850.0,
    "cholesterol_mg": 120.0,
    "water_ml": 0.0,
    "display_name_en": "Saltimbocca (1 serving)",
    "display_name_es": "Saltimbocca (1 porción)",
    "display_name_de": "Saltimbocca (1 Portion)",
    "display_name_fr": "Saltimbocca (1 portion)",
    "display_name_pt": "Saltimbocca (1 porção)",
    "display_name_tr": "Saltimbocca (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Sage",
        "name_es": "Sabio",
        "name_de": "Salbei",
        "name_fr": "Sage",
        "name_pt": "Sábio",
        "name_tr": "Adaçayı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Veal",
        "name_es": "Ternera",
        "name_de": "Kalbfleisch",
        "name_fr": "Veau",
        "name_pt": "Vitela",
        "name_tr": "Dana eti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Prosciutto",
        "name_es": "Jamón crudo",
        "name_de": "Prosciutto",
        "name_fr": "Jambon de Paris",
        "name_pt": "Presunto",
        "name_tr": "Prosciutto"
      },
      {
        "category_en": "Pantry",
        "name_en": "White wine",
        "name_es": "Vino blanco",
        "name_de": "Weißwein",
        "name_fr": "Vin blanc",
        "name_pt": "Vinho branco",
        "name_tr": "Beyaz şarap"
      }
    ]
  },
  {
    "category": "Protein/Seafood",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 95.0,
    "protein_g": 17.0,
    "carbohydrates_g": 5.0,
    "fat_g": 1.0,
    "fiber_g": 0.0,
    "sodium_mg": 180.0,
    "cholesterol_mg": 35.0,
    "water_ml": 0.0,
    "display_name_en": "Scallops (3oz seared)",
    "display_name_es": "Vieiras (3 oz selladas)",
    "display_name_de": "Jakobsmuscheln (3 oz, angebraten)",
    "display_name_fr": "Coquilles Saint-Jacques (85 g poêlées)",
    "display_name_pt": "Vieiras (85g grelhadas)",
    "display_name_tr": "Deniz tarağı (3oz, kızartılmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Produce",
        "name_en": "Herbs",
        "name_es": "Hierbas",
        "name_de": "Kräuter",
        "name_fr": "Herbes",
        "name_pt": "Ervas",
        "name_tr": "Otlar"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Manteca",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Scallops",
        "name_es": "Vieiras",
        "name_de": "Jakobsmuscheln",
        "name_fr": "Coquilles Saint-Jacques",
        "name_pt": "Vieiras",
        "name_tr": "Deniz Tarağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Protein/Vegetarian",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 90.0,
    "protein_g": 18.0,
    "carbohydrates_g": 4.0,
    "fat_g": 1.0,
    "fiber_g": 1.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Seitan (3oz)",
    "display_name_es": "Seitán (3 oz)",
    "display_name_de": "Seitan (85g)",
    "display_name_fr": "Seitan (3 oz)",
    "display_name_pt": "Seitan (85g)",
    "display_name_tr": "Seitan (3oz)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Seitan",
        "name_es": "Seitán",
        "name_de": "Seitan",
        "name_fr": "Seitan",
        "name_pt": "Seitan",
        "name_tr": "Seytan"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 400.0,
    "protein_g": 20.0,
    "carbohydrates_g": 35.0,
    "fat_g": 20.0,
    "fiber_g": 6.0,
    "sodium_mg": 850.0,
    "cholesterol_mg": 55.0,
    "water_ml": 250.0,
    "display_name_en": "Shepherd's Pie (1 serving)",
    "display_name_es": "Pastel de pastor (1 porción)",
    "display_name_de": "Shepherd's Pie (1 Portion)",
    "display_name_fr": "Hachis Parmentier (1 portion)",
    "display_name_pt": "Torta de carneiro (1 porção)",
    "display_name_tr": "Çoban Böreği (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotten",
        "name_fr": "Carottes",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Peas",
        "name_es": "Guisantes",
        "name_de": "Erbsen",
        "name_fr": "Petits pois",
        "name_pt": "Ervilha",
        "name_tr": "Bezelye"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignons",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Corn",
        "name_es": "Maíz",
        "name_de": "Mais",
        "name_fr": "Maïs",
        "name_pt": "Milho",
        "name_tr": "Mısır"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheese (optional)",
        "name_es": "Queso (opcional)",
        "name_de": "Käse (optional)",
        "name_fr": "Fromage (facultatif)",
        "name_pt": "Queijo (opcional)",
        "name_tr": "Peynir (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground lamb or beef",
        "name_es": "Carne molida de cordero o ternera",
        "name_de": "Hackfleisch vom Lamm oder Rind",
        "name_fr": "Agneau ou bœuf haché",
        "name_pt": "Carne moída de cordeiro ou bovina",
        "name_tr": "Kıyma kuzu veya dana eti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Potatoes",
        "name_es": "Papas",
        "name_de": "Kartoffeln",
        "name_fr": "Pommes de terre",
        "name_pt": "Batatas",
        "name_tr": "Patates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et suyu"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 300.0,
    "protein_g": 35.0,
    "carbohydrates_g": 5.0,
    "fat_g": 16.0,
    "fiber_g": 1.0,
    "sodium_mg": 600.0,
    "cholesterol_mg": 100.0,
    "water_ml": 0.0,
    "display_name_en": "Shish Tawook (2 skewers)",
    "display_name_es": "Shish Tawook (2 brochetas)",
    "display_name_de": "Schaschlik (2 Spieße)",
    "display_name_fr": "Brochettes Shish Tawook (2 brochettes)",
    "display_name_pt": "Shish Tawook (2 espetos)",
    "display_name_tr": "Şiş Tavook (2 şiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivron",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt (for marinade)",
        "name_es": "Yogur (para marinar)",
        "name_de": "Joghurt (für die Marinade)",
        "name_fr": "Yaourt (pour la marinade)",
        "name_pt": "Iogurte (para marinar)",
        "name_tr": "Yoğurt (marine için)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken",
        "name_es": "Pollo",
        "name_de": "Hähnchen",
        "name_fr": "Poulet",
        "name_pt": "Frango",
        "name_tr": "Tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spices",
        "name_es": "Especias",
        "name_de": "Gewürze",
        "name_fr": "Épices",
        "name_pt": "Especiarias",
        "name_tr": "Baharatlar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 115.0,
    "protein_g": 7.0,
    "carbohydrates_g": 1.0,
    "fat_g": 9.5,
    "fiber_g": 0.0,
    "sodium_mg": 180.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Shredded Cheese (Cheddar 1/4 cup)",
    "display_name_es": "Queso rallado (Cheddar 1/4 taza)",
    "display_name_de": "Geriebener Käse (Cheddar 1/4 Tasse)",
    "display_name_fr": "Fromage râpé (cheddar 1/4 tasse)",
    "display_name_pt": "Queijo ralado (1/4 de xícara de cheddar)",
    "display_name_tr": "Rendelenmiş Peynir (Çedar 1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese",
        "name_es": "queso cheddar",
        "name_de": "Cheddar-Käse",
        "name_fr": "fromage cheddar",
        "name_pt": "Queijo cheddar",
        "name_tr": "Çedar peyniri"
      }
    ]
  },
  {
    "category": "Protein/Fish",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 84.0,
    "protein_g": 20.0,
    "carbohydrates_g": 0.2,
    "fat_g": 0.2,
    "fiber_g": 0.0,
    "sodium_mg": 100.0,
    "cholesterol_mg": 161.0,
    "water_ml": 250.0,
    "display_name_en": "Shrimp (3oz steamed)",
    "display_name_es": "Camarones (3 oz al vapor)",
    "display_name_de": "Garnelen (3 oz gedämpft)",
    "display_name_fr": "Crevettes (85 g cuites à la vapeur)",
    "display_name_pt": "Camarão (85g cozido no vapor)",
    "display_name_tr": "Karides (3oz buharda pişirilmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Pantry",
        "name_en": "Shrimp",
        "name_es": "Camarón",
        "name_de": "Garnele",
        "name_fr": "Crevette",
        "name_pt": "Camarão",
        "name_tr": "Karides"
      }
    ]
  },
  {
    "category": "Meal/Seafood",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 380.0,
    "protein_g": 22.0,
    "carbohydrates_g": 40.0,
    "fat_g": 15.0,
    "fiber_g": 3.0,
    "sodium_mg": 750.0,
    "cholesterol_mg": 140.0,
    "water_ml": 0.0,
    "display_name_en": "Shrimp Scampi (1 cup)",
    "display_name_es": "Camarones al ajillo (1 taza)",
    "display_name_de": "Garnelen-Scampi (1 Tasse)",
    "display_name_fr": "Scampis aux crevettes (1 tasse)",
    "display_name_pt": "Camarão ao alho e óleo (1 xícara)",
    "display_name_tr": "Karides Scampi (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsa",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Manteca",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Shrimp",
        "name_es": "Camarones",
        "name_de": "Garnelen",
        "name_fr": "Crevettes",
        "name_pt": "Camarão",
        "name_tr": "Karides"
      },
      {
        "category_en": "Pantry",
        "name_en": "White wine",
        "name_es": "Vino blanco",
        "name_de": "Weißwein",
        "name_fr": "Vin blanc",
        "name_pt": "Vinho branco",
        "name_tr": "Beyaz şarap"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pasta",
        "name_es": "Pasta",
        "name_de": "Pasta",
        "name_fr": "Pâtes",
        "name_pt": "Massa",
        "name_tr": "Makarna"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 70.0,
    "protein_g": 2.0,
    "carbohydrates_g": 8.0,
    "fat_g": 4.0,
    "fiber_g": 3.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Side Salad (light dressing)",
    "display_name_es": "Ensalada de acompañamiento (aderezo ligero)",
    "display_name_de": "Beilagensalat (leichtes Dressing)",
    "display_name_fr": "Salade d'accompagnement (vinaigrette légère)",
    "display_name_pt": "Salada acompanhamento (molho leve)",
    "display_name_tr": "Yan Salata (hafif soslu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Feta cheese (optional)",
        "name_es": "Queso feta (opcional)",
        "name_de": "Feta-Käse (optional)",
        "name_fr": "Fromage feta (facultatif)",
        "name_pt": "Queijo feta (opcional)",
        "name_tr": "Feta peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      }
    ]
  },
  {
    "category": "Protein/Vegetarian",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 45.0,
    "protein_g": 5.0,
    "carbohydrates_g": 2.0,
    "fat_g": 2.5,
    "fiber_g": 0.5,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Silken Tofu (3oz in soup)",
    "display_name_es": "Tofu sedoso (3 oz en sopa)",
    "display_name_de": "Seidentofu (85 g in Suppe)",
    "display_name_fr": "Tofu soyeux (85 g dans la soupe)",
    "display_name_pt": "Tofu sedoso (85g na sopa)",
    "display_name_tr": "İpek Tofu (çorbada 3oz)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Green onion",
        "name_es": "cebolla verde",
        "name_de": "Frühlingszwiebeln",
        "name_fr": "Oignon vert",
        "name_pt": "cebolinha",
        "name_tr": "Yeşil soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Silken tofu",
        "name_es": "Tofu sedoso",
        "name_de": "Seidentofu",
        "name_fr": "Tofu soyeux",
        "name_pt": "Tofu sedoso",
        "name_tr": "İpeksi tofu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soy sauce",
        "name_es": "Salsa de soja",
        "name_de": "Sojasauce",
        "name_fr": "Sauce soja",
        "name_pt": "Molho de soja",
        "name_tr": "Soya sosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et suyu"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 240.0,
    "protein_g": 26.0,
    "carbohydrates_g": 0.0,
    "fat_g": 15.0,
    "fiber_g": 0.0,
    "sodium_mg": 70.0,
    "cholesterol_mg": 80.0,
    "water_ml": 0.0,
    "display_name_en": "Skirt Steak (4oz grilled)",
    "display_name_es": "Filete de falda (113 g a la parrilla)",
    "display_name_de": "Flanksteak (113 g gegrillt)",
    "display_name_fr": "Bavette (113 g grillée)",
    "display_name_pt": "Bife de fraldinha (113g grelhado)",
    "display_name_tr": "Etek Biftek (4oz ızgara)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion (optional)",
        "name_es": "Cebolla (opcional)",
        "name_de": "Zwiebel (optional)",
        "name_fr": "Oignon (facultatif)",
        "name_pt": "Cebola (opcional)",
        "name_tr": "Soğan (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Skirt steak",
        "name_es": "Chuletón de falda",
        "name_de": "Flanksteak",
        "name_fr": "Bavette",
        "name_pt": "Bife de fraldinha",
        "name_tr": "Etek biftek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spices",
        "name_es": "Especias",
        "name_de": "Gewürze",
        "name_fr": "Épices",
        "name_pt": "Especiarias",
        "name_tr": "Baharatlar"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 100.0,
    "protein_g": 3.5,
    "carbohydrates_g": 21.0,
    "fat_g": 0.5,
    "fiber_g": 1.0,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Spaghetti (side)",
    "display_name_es": "Espaguetis (acompañamiento)",
    "display_name_de": "Spaghetti (Beilage)",
    "display_name_fr": "Spaghetti (accompagnement)",
    "display_name_pt": "Espaguete (acompanhamento)",
    "display_name_tr": "Spagetti (yan)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic (optional)",
        "name_es": "Ajo (opcional)",
        "name_de": "Knoblauch (optional)",
        "name_fr": "Ail (facultatif)",
        "name_pt": "Alho (opcional)",
        "name_tr": "Sarımsak (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese (optional)",
        "name_es": "Queso parmesano (opcional)",
        "name_de": "Parmesankäse (optional)",
        "name_fr": "Parmesan (facultatif)",
        "name_pt": "Queijo parmesão (opcional)",
        "name_tr": "Parmesan peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spaghetti",
        "name_es": "Espaguetis",
        "name_de": "Spaghetti",
        "name_fr": "Spaghetti",
        "name_pt": "Espaguete",
        "name_tr": "Spagetti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tomato sauce (optional)",
        "name_es": "Salsa de tomate (opcional)",
        "name_de": "Tomatensoße (optional)",
        "name_fr": "Sauce tomate (facultatif)",
        "name_pt": "Molho de tomate (opcional)",
        "name_tr": "Domates sosu (isteğe bağlı)"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 460.0,
    "protein_g": 20.0,
    "carbohydrates_g": 55.0,
    "fat_g": 18.0,
    "fiber_g": 6.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 50.0,
    "water_ml": 250.0,
    "display_name_en": "Spaghetti Bolognese",
    "display_name_es": "Espaguetis a la boloñesa",
    "display_name_de": "Spaghetti Bolognese",
    "display_name_fr": "Spaghetti bolognaise",
    "display_name_pt": "Espaguete à Bolonhesa",
    "display_name_tr": "Spagetti Bolonez",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "queso parmesano",
        "name_de": "Parmesankäse",
        "name_fr": "parmesan",
        "name_pt": "queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spaghetti",
        "name_es": "Espaguetis",
        "name_de": "Spaghetti",
        "name_fr": "Spaghetti",
        "name_pt": "Espaguete",
        "name_tr": "Spagetti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground beef",
        "name_es": "Carne molida",
        "name_de": "Hackfleisch",
        "name_fr": "Bœuf haché",
        "name_pt": "Carne moída",
        "name_tr": "Kıyma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tomato sauce",
        "name_es": "Salsa de tomate",
        "name_de": "Tomatensoße",
        "name_fr": "Sauce tomate",
        "name_pt": "Molho de tomate",
        "name_tr": "Domates sosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 180.0,
    "protein_g": 4.0,
    "carbohydrates_g": 25.0,
    "fat_g": 7.0,
    "fiber_g": 3.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Spring Roll (Veg 2 rolls)",
    "display_name_es": "Rollito de primavera (2 rollitos de verduras)",
    "display_name_de": "Frühlingsrolle (vegetarisch, 2 Rollen)",
    "display_name_fr": "Rouleau de printemps (2 rouleaux végétariens)",
    "display_name_pt": "Rolinho Primavera (Vegetariano, 2 rolinhos)",
    "display_name_tr": "Spring Roll (Sebzeli 2 rulo)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cabbage",
        "name_es": "Repollo",
        "name_de": "Kohl",
        "name_fr": "Chou",
        "name_pt": "Repolho",
        "name_tr": "Lahana"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotten",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Bean sprouts",
        "name_es": "Brotes de soja",
        "name_de": "Sojasprossen",
        "name_fr": "Germes de soja",
        "name_pt": "Broto de feijão",
        "name_tr": "Fasulye filizi"
      },
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice paper",
        "name_es": "Papel de arroz",
        "name_de": "Reispapier",
        "name_fr": "Papier de riz",
        "name_pt": "Papel de arroz",
        "name_tr": "Pirinç kağıdı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soy sauce",
        "name_es": "Salsa de soja",
        "name_de": "Sojasauce",
        "name_fr": "Sauce soja",
        "name_pt": "Molho de soja",
        "name_tr": "Soya sosu"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 80.0,
    "protein_g": 3.0,
    "carbohydrates_g": 15.0,
    "fat_g": 1.0,
    "fiber_g": 1.0,
    "sodium_mg": 160.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Stale Bread (1/2 cup in soup)",
    "display_name_es": "Pan duro (1/2 taza en sopa)",
    "display_name_de": "Altes Brot (1/2 Tasse in die Suppe)",
    "display_name_fr": "Pain rassis (1/2 tasse dans la soupe)",
    "display_name_pt": "Pão amanhecido (1/2 xícara na sopa)",
    "display_name_tr": "Bayat Ekmek (Çorbada 1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Stale bread",
        "name_es": "pan duro",
        "name_de": "Altes Brot",
        "name_fr": "Pain rassis",
        "name_pt": "Pão amanhecido",
        "name_tr": "Bayat ekmek"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 55.0,
    "protein_g": 3.7,
    "carbohydrates_g": 11.2,
    "fat_g": 0.6,
    "fiber_g": 5.1,
    "sodium_mg": 40.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Steamed Broccoli (1 cup)",
    "display_name_es": "Brócoli al vapor (1 taza)",
    "display_name_de": "Gedämpfter Brokkoli (1 Tasse)",
    "display_name_fr": "Brocoli cuit à la vapeur (1 tasse)",
    "display_name_pt": "Brócolis cozido no vapor (1 xícara)",
    "display_name_tr": "Buharda Pişmiş Brokoli (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Broccoli",
        "name_es": "Brócoli",
        "name_de": "Brokkoli",
        "name_fr": "Brocoli",
        "name_pt": "Brócolis",
        "name_tr": "Brokoli"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil (optional)",
        "name_es": "Aceite de oliva (opcional)",
        "name_de": "Olivenöl (optional)",
        "name_fr": "Huile d'olive (facultatif)",
        "name_pt": "Azeite (opcional)",
        "name_tr": "Zeytinyağı (isteğe bağlı)"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 380.0,
    "protein_g": 18.0,
    "carbohydrates_g": 45.0,
    "fat_g": 15.0,
    "fiber_g": 3.0,
    "sodium_mg": 750.0,
    "cholesterol_mg": 50.0,
    "water_ml": 0.0,
    "display_name_en": "Sweet & Sour Chicken (1 cup)",
    "display_name_es": "Pollo agridulce (1 taza)",
    "display_name_de": "Süß-saures Hähnchen (1 Tasse)",
    "display_name_fr": "Poulet aigre-doux (1 tasse)",
    "display_name_pt": "Frango Agridoce (1 xícara)",
    "display_name_tr": "Tatlı Ekşi Tavuk (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivron",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Produce",
        "name_en": "Pineapple",
        "name_es": "Piña",
        "name_de": "Ananas",
        "name_fr": "Ananas",
        "name_pt": "Abacaxi",
        "name_tr": "Ananas"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken",
        "name_es": "Pollo",
        "name_de": "Hähnchen",
        "name_fr": "Poulet",
        "name_pt": "Frango",
        "name_tr": "Tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sweet and sour sauce",
        "name_es": "Salsa agridulce",
        "name_de": "Süß-saure Soße",
        "name_fr": "Sauce aigre-douce",
        "name_pt": "Molho agridoce",
        "name_tr": "Tatlı ekşi sos"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice (optional)",
        "name_es": "Arroz (opcional)",
        "name_de": "Reis (optional)",
        "name_fr": "Riz (facultatif)",
        "name_pt": "Arroz (opcional)",
        "name_tr": "Pirinç (isteğe bağlı)"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 103.0,
    "protein_g": 2.3,
    "carbohydrates_g": 23.6,
    "fat_g": 0.2,
    "fiber_g": 3.8,
    "sodium_mg": 41.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Sweet Potato (1 medium baked)",
    "display_name_es": "Boniato (1 mediano horneado)",
    "display_name_de": "Süßkartoffel (1 mittelgroße, gebackene)",
    "display_name_fr": "Patate douce (1 moyenne cuite au four)",
    "display_name_pt": "Batata-doce (1 média assada)",
    "display_name_tr": "Tatlı Patates (1 orta boy fırınlanmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Sweet potato",
        "name_es": "Batata",
        "name_de": "Süßkartoffel",
        "name_fr": "Patate douce",
        "name_pt": "Batata doce",
        "name_tr": "Tatlı patates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cinnamon (optional)",
        "name_es": "Canela (opcional)",
        "name_de": "Zimt (optional)",
        "name_fr": "Cannelle (facultatif)",
        "name_pt": "Canela (opcional)",
        "name_tr": "Tarçın (isteğe bağlı)"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 460.0,
    "protein_g": 38.0,
    "carbohydrates_g": 0.0,
    "fat_g": 33.0,
    "fiber_g": 0.0,
    "sodium_mg": 110.0,
    "cholesterol_mg": 105.0,
    "water_ml": 0.0,
    "display_name_en": "T-Bone Steak (6oz)",
    "display_name_es": "Filete T-Bone (6 oz)",
    "display_name_de": "T-Bone-Steak (170 g)",
    "display_name_fr": "Steak T-Bone (170 g)",
    "display_name_pt": "Bife T-Bone (170g)",
    "display_name_tr": "T-Bone Biftek (6oz)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Herbs",
        "name_es": "Hierbas",
        "name_de": "Kräuter",
        "name_fr": "Herbes",
        "name_pt": "Ervas",
        "name_tr": "Otlar"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "T-bone steak",
        "name_es": "Chuletón",
        "name_de": "T-Bone-Steak",
        "name_fr": "Steak T-bone",
        "name_pt": "Bife T-bone",
        "name_tr": "T-bone biftek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pepper",
        "name_es": "Pimienta",
        "name_de": "Pfeffer",
        "name_fr": "Poivre",
        "name_pt": "Pimenta",
        "name_tr": "Karabiber"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 550.0,
    "protein_g": 28.0,
    "carbohydrates_g": 65.0,
    "fat_g": 20.0,
    "fiber_g": 7.0,
    "sodium_mg": 850.0,
    "cholesterol_mg": 70.0,
    "water_ml": 500.0,
    "display_name_en": "Tagliatelle al Ragù (Bolognese)",
    "display_name_es": "Tagliatelle al Ragù (boloñesa)",
    "display_name_de": "Tagliatelle al Ragù (Bolognese)",
    "display_name_fr": "Tagliatelles au Ragù (bolognaise)",
    "display_name_pt": "Tagliatelle al Ragù (à bolonhesa)",
    "display_name_tr": "Tagliatelle al Ragù (Bolognese)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "queso parmesano",
        "name_de": "Parmesankäse",
        "name_fr": "parmesan",
        "name_pt": "queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tagliatelle",
        "name_es": "Tagliatelle",
        "name_de": "Tagliatelle",
        "name_fr": "Tagliatelles",
        "name_pt": "Tagliatelle",
        "name_tr": "Tagliatelle"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground beef",
        "name_es": "Carne molida",
        "name_de": "Rinderhackfleisch",
        "name_fr": "Bœuf haché",
        "name_pt": "Carne moída",
        "name_tr": "Kıyma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tomato sauce",
        "name_es": "Salsa de tomate",
        "name_de": "Tomatensauce",
        "name_fr": "Sauce tomate",
        "name_pt": "Molho de tomate",
        "name_tr": "Domates sosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Protein/Fish",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 110.0,
    "protein_g": 22.0,
    "carbohydrates_g": 0.0,
    "fat_g": 2.5,
    "fiber_g": 0.0,
    "sodium_mg": 50.0,
    "cholesterol_mg": 50.0,
    "water_ml": 0.0,
    "display_name_en": "Tilapia (4oz baked)",
    "display_name_es": "Tilapia (113 g al horno)",
    "display_name_de": "Tilapia (113 g gebacken)",
    "display_name_fr": "Tilapia (113 g cuit au four)",
    "display_name_pt": "Tilápia (113 g assada)",
    "display_name_tr": "Tilapia (4oz fırınlanmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Produce",
        "name_en": "Herbs",
        "name_es": "Hierbas",
        "name_de": "Kräuter",
        "name_fr": "Herbes",
        "name_pt": "Ervas",
        "name_tr": "Otlar"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tilapia fillet",
        "name_es": "Filete de tilapia",
        "name_de": "Tilapiafilet",
        "name_fr": "Filet de tilapia",
        "name_pt": "Filé de tilápia",
        "name_tr": "Tilapia filetosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      }
    ]
  },
  {
    "category": "Protein/Fish",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 110.0,
    "protein_g": 22.0,
    "carbohydrates_g": 0.0,
    "fat_g": 2.5,
    "fiber_g": 0.0,
    "sodium_mg": 50.0,
    "cholesterol_mg": 50.0,
    "water_ml": 0.0,
    "display_name_en": "Tilapia (4oz baked)",
    "display_name_es": "Tilapia (113 g al horno)",
    "display_name_de": "Tilapia (113 g gebacken)",
    "display_name_fr": "Tilapia (113 g cuit au four)",
    "display_name_pt": "Tilápia (113 g assada)",
    "display_name_tr": "Tilapia (4oz fırınlanmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Produce",
        "name_en": "Herbs",
        "name_es": "Hierbas",
        "name_de": "Kräuter",
        "name_fr": "Herbes",
        "name_pt": "Ervas",
        "name_tr": "Otlar"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tilapia fillet",
        "name_es": "Filete de tilapia",
        "name_de": "Tilapiafilet",
        "name_fr": "Filet de tilapia",
        "name_pt": "Filé de tilápia",
        "name_tr": "Tilapia filetosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      }
    ]
  },
  {
    "category": "Meal/Vegetarian",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 400.0,
    "protein_g": 18.0,
    "carbohydrates_g": 30.0,
    "fat_g": 22.0,
    "fiber_g": 7.0,
    "sodium_mg": 500.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Tofu Stir-fry",
    "display_name_es": "Tofu salteado",
    "display_name_de": "Tofu-Pfannengericht",
    "display_name_fr": "Sauté de tofu",
    "display_name_pt": "Tofu salteado",
    "display_name_tr": "Tofu Sote",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Broccoli",
        "name_es": "Brócoli",
        "name_de": "Brokkoli",
        "name_fr": "Brocoli",
        "name_pt": "Brócolis",
        "name_tr": "Brokoli"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivron",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Snow peas",
        "name_es": "Guisantes",
        "name_de": "Zuckerschoten",
        "name_fr": "Pois mange-tout",
        "name_pt": "Ervilha-torta",
        "name_tr": "Bezelye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tofu",
        "name_es": "Tofu",
        "name_de": "Tofu",
        "name_fr": "Tofu",
        "name_pt": "Tofu",
        "name_tr": "Tofu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soy sauce",
        "name_es": "Salsa de soja",
        "name_de": "Sojasauce",
        "name_fr": "Sauce soja",
        "name_pt": "Molho de soja",
        "name_tr": "Soya sosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sesame oil",
        "name_es": "Aceite de sésamo",
        "name_de": "Sesamöl",
        "name_fr": "Huile de sésame",
        "name_pt": "Óleo de gergelim",
        "name_tr": "Susam yağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ginger",
        "name_es": "Jengibre",
        "name_de": "Ingwer",
        "name_fr": "Gingembre",
        "name_pt": "Gengibre",
        "name_tr": "Zencefil"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 210.0,
    "protein_g": 7.0,
    "carbohydrates_g": 43.0,
    "fat_g": 1.0,
    "fiber_g": 2.0,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Trofie Pasta (1 cup cooked)",
    "display_name_es": "Pasta Trofie (1 taza cocida)",
    "display_name_de": "Trofie-Nudeln (1 Tasse gekocht)",
    "display_name_fr": "Pâtes Trofie (1 tasse cuites)",
    "display_name_pt": "Massa Trofie (1 xícara cozida)",
    "display_name_tr": "Trofie Makarna (1 su bardağı pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cherry tomatoes",
        "name_es": "Tomates cherry",
        "name_de": "Kirschtomaten",
        "name_fr": "Tomates cerises",
        "name_pt": "Tomates-cereja",
        "name_tr": "Kiraz domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Basil",
        "name_es": "Albahaca",
        "name_de": "Basilikum",
        "name_fr": "Basilic",
        "name_pt": "Manjericão",
        "name_tr": "Fesleğen"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "queso parmesano",
        "name_de": "Parmesankäse",
        "name_fr": "parmesan",
        "name_pt": "queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Trofie pasta",
        "name_es": "Pasta Trofie",
        "name_de": "Trofie-Pasta",
        "name_fr": "Pâtes Trofie",
        "name_pt": "Massa Trofie",
        "name_tr": "Trofie makarna"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 250.0,
    "protein_g": 22.0,
    "carbohydrates_g": 25.0,
    "fat_g": 7.0,
    "fiber_g": 8.0,
    "sodium_mg": 750.0,
    "cholesterol_mg": 50.0,
    "water_ml": 250.0,
    "display_name_en": "Turkey Chili (1 cup)",
    "display_name_es": "Chile de pavo (1 taza)",
    "display_name_de": "Truthahn-Chili (1 Tasse)",
    "display_name_fr": "Chili de dinde (1 tasse)",
    "display_name_pt": "Chili de peru (1 xícara)",
    "display_name_tr": "Hindi Çili (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivron",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese (optional)",
        "name_es": "Queso cheddar (opcional)",
        "name_de": "Cheddar-Käse (optional)",
        "name_fr": "Fromage cheddar (facultatif)",
        "name_pt": "Queijo cheddar (opcional)",
        "name_tr": "Çedar peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground turkey",
        "name_es": "Pavo molido",
        "name_de": "Putenhackfleisch",
        "name_fr": "Dinde hachée",
        "name_pt": "Carne moída de peru",
        "name_tr": "Kıyma hindi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beans",
        "name_es": "Frijoles",
        "name_de": "Bohnen",
        "name_fr": "Haricots",
        "name_pt": "Feijão",
        "name_tr": "Fasulye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chili spices",
        "name_es": "Especias de chile",
        "name_de": "Chiligewürz",
        "name_fr": "Épices pour chili",
        "name_pt": "Especiarias para chili",
        "name_tr": "Acılı baharatlar"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 550.0,
    "protein_g": 40.0,
    "carbohydrates_g": 30.0,
    "fat_g": 30.0,
    "fiber_g": 4.0,
    "sodium_mg": 1100.0,
    "cholesterol_mg": 130.0,
    "water_ml": 250.0,
    "display_name_en": "Veal Parmesan (1 serving)",
    "display_name_es": "Ternera a la parmesana (1 ración)",
    "display_name_de": "Kalbsschnitzel Parmesan (1 Portion)",
    "display_name_fr": "Escalope de veau parmesan (1 portion)",
    "display_name_pt": "Vitela à Parmegiana (1 porção)",
    "display_name_tr": "Dana Parmesan (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato sauce",
        "name_es": "salsa de tomate",
        "name_de": "Tomatensoße",
        "name_fr": "Sauce tomate",
        "name_pt": "Molho de tomate",
        "name_tr": "Domates sosu"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "Queso mozzarella",
        "name_de": "Mozzarella",
        "name_fr": "Fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "Queso parmesano",
        "name_de": "Parmesan",
        "name_fr": "Fromage parmesan",
        "name_pt": "Queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Veal cutlet",
        "name_es": "Chuleta de ternera",
        "name_de": "Kalbsschnitzel",
        "name_fr": "Escalope de veau",
        "name_pt": "Escalope de vitela",
        "name_tr": "Dana pirzola"
      },
      {
        "category_en": "Pantry",
        "name_en": "Breadcrumbs",
        "name_es": "Rebozado",
        "name_de": "Paniermehl",
        "name_fr": "Chapelure",
        "name_pt": "Farinha de rosca",
        "name_tr": "Ekmek kırıntıları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Marinara sauce",
        "name_es": "Salsa marinara",
        "name_de": "Marinara-Sauce",
        "name_fr": "Sauce marinara",
        "name_pt": "Molho marinara",
        "name_tr": "Marinara sosu"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 15.0,
    "protein_g": 1.0,
    "carbohydrates_g": 3.0,
    "fat_g": 0.0,
    "fiber_g": 1.0,
    "sodium_mg": 550.0,
    "cholesterol_mg": 0.0,
    "water_ml": 240.0,
    "display_name_en": "Vegetable Broth (1 cup)",
    "display_name_es": "Caldo de verduras (1 taza)",
    "display_name_de": "Gemüsebrühe (1 Tasse)",
    "display_name_fr": "Bouillon de légumes (1 tasse)",
    "display_name_pt": "Caldo de legumes (1 xícara)",
    "display_name_tr": "Sebze Suyu (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable broth base",
        "name_es": "Base de caldo de verduras",
        "name_de": "Gemüsebrühe als Basis",
        "name_fr": "base de bouillon de légumes",
        "name_pt": "base de caldo de legumes",
        "name_tr": "Sebze suyu tabanı"
      }
    ]
  },
  {
    "category": "Legume",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 150.0,
    "protein_g": 8.0,
    "carbohydrates_g": 20.0,
    "fat_g": 4.0,
    "fiber_g": 7.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "White Beans (Tuscan style 1/2 cup)",
    "display_name_es": "Frijoles blancos (estilo toscano 1/2 taza)",
    "display_name_de": "Weiße Bohnen (toskanische Art, 1/2 Tasse)",
    "display_name_fr": "Haricots blancs (à la toscane, 1/2 tasse)",
    "display_name_pt": "Feijão branco (estilo toscano, 1/2 xícara)",
    "display_name_tr": "Beyaz Fasulye (Toskana usulü 1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomaten",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Kale (optional)",
        "name_es": "Col rizada (opcional)",
        "name_de": "Grünkohl (optional)",
        "name_fr": "Chou frisé (facultatif)",
        "name_pt": "Couve (opcional)",
        "name_tr": "Kara lahana (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "White beans",
        "name_es": "Judías blancas",
        "name_de": "Weiße Bohnen",
        "name_fr": "Haricots blancs",
        "name_pt": "Feijão branco",
        "name_tr": "Beyaz fasulye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Herbs",
        "name_es": "Hierbas",
        "name_de": "Kräuter",
        "name_fr": "Herbes",
        "name_pt": "Ervas",
        "name_tr": "Otlar"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 204.0,
    "protein_g": 4.2,
    "carbohydrates_g": 44.5,
    "fat_g": 0.4,
    "fiber_g": 0.6,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "White Rice (1 cup cooked)",
    "display_name_es": "Arroz blanco (1 taza cocido)",
    "display_name_de": "Weißer Reis (1 Tasse gekocht)",
    "display_name_fr": "Riz blanc (1 tasse cuite)",
    "display_name_pt": "Arroz branco (1 xícara cozida)",
    "display_name_tr": "Beyaz Pirinç (1 su bardağı pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "White rice",
        "name_es": "arroz blanco",
        "name_de": "Weißer Reis",
        "name_fr": "riz blanc",
        "name_pt": "Arroz branco",
        "name_tr": "Beyaz pirinç"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 166.0,
    "protein_g": 6.5,
    "carbohydrates_g": 35.0,
    "fat_g": 0.6,
    "fiber_g": 3.0,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Wild Rice (1 cup cooked)",
    "display_name_es": "Arroz salvaje (1 taza cocido)",
    "display_name_de": "Wildreis (1 Tasse gekocht)",
    "display_name_fr": "Riz sauvage (1 tasse cuite)",
    "display_name_pt": "Arroz selvagem (1 xícara cozida)",
    "display_name_tr": "Yabani Pirinç (1 su bardağı pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Wild rice",
        "name_es": "Arroz salvaje",
        "name_de": "Wildreis",
        "name_fr": "riz sauvage",
        "name_pt": "Arroz selvagem",
        "name_tr": "Yabani pirinç"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Dinner",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 230.0,
    "protein_g": 4.0,
    "carbohydrates_g": 50.0,
    "fat_g": 1.0,
    "fiber_g": 2.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Yellow Rice (1 cup)",
    "display_name_es": "Arroz amarillo (1 taza)",
    "display_name_de": "Gelber Reis (1 Tasse)",
    "display_name_fr": "Riz jaune (1 tasse)",
    "display_name_pt": "Arroz amarelo (1 xícara)",
    "display_name_tr": "Sarı Pirinç (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Rice",
        "name_es": "Arroz",
        "name_de": "Reis",
        "name_fr": "Riz",
        "name_pt": "Arroz",
        "name_tr": "Pirinç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Turmeric",
        "name_es": "Cúrcuma",
        "name_de": "Kurkuma",
        "name_fr": "Curcuma",
        "name_pt": "Açafrão",
        "name_tr": "Zerdeçal"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken broth",
        "name_es": "Caldo de pollo",
        "name_de": "Hühnerbrühe",
        "name_fr": "Bouillon de poulet",
        "name_pt": "Caldo de galinha",
        "name_tr": "Tavuk suyu"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 10.0,
    "protein_g": 1.0,
    "carbohydrates_g": 0.8,
    "fat_g": 0.2,
    "fiber_g": 0.4,
    "sodium_mg": 6.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Arugula (2 cups)",
    "display_name_es": "Rúcula (2 tazas)",
    "display_name_de": "Rucola (2 Tassen)",
    "display_name_fr": "Roquette (2 tasses)",
    "display_name_pt": "Rúcula (2 xícaras)",
    "display_name_tr": "Roka (2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Arugula",
        "name_es": "Rúcula",
        "name_de": "Rucola",
        "name_fr": "Roquette",
        "name_pt": "Rúcula",
        "name_tr": "Roka"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 70.0,
    "protein_g": 2.5,
    "carbohydrates_g": 14.0,
    "fat_g": 0.5,
    "fiber_g": 0.6,
    "sodium_mg": 150.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Baguette (slice)",
    "display_name_es": "Baguette (rebanada)",
    "display_name_de": "Baguette (Scheibe)",
    "display_name_fr": "Baguette (tranche)",
    "display_name_pt": "Baguete (fatia)",
    "display_name_tr": "Baget (dilim)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Baguette",
        "name_es": "Junquillo",
        "name_de": "Baguette",
        "name_fr": "Baguette",
        "name_pt": "Baguete",
        "name_tr": "Baget"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 30.0,
    "protein_g": 0.8,
    "carbohydrates_g": 6.8,
    "fat_g": 0.1,
    "fiber_g": 1.4,
    "sodium_mg": 50.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Beets (1/2 cup roasted)",
    "display_name_es": "Remolachas (1/2 taza asadas)",
    "display_name_de": "Rote Beete (1/2 Tasse geröstet)",
    "display_name_fr": "Betteraves (1/2 tasse rôtie)",
    "display_name_pt": "Beterrabas (1/2 xícara assadas)",
    "display_name_tr": "Pancar (1/2 su bardağı kavrulmuş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Beets",
        "name_es": "Remolachas",
        "name_de": "Rote Beete",
        "name_fr": "Betteraves",
        "name_pt": "Beterrabas",
        "name_tr": "Pancar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 31.0,
    "protein_g": 1.2,
    "carbohydrates_g": 6.0,
    "fat_g": 0.3,
    "fiber_g": 2.1,
    "sodium_mg": 4.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Bell Pepper (1 medium red)",
    "display_name_es": "Pimiento morrón (1 rojo mediano)",
    "display_name_de": "Paprika (1 mittelgroße rote)",
    "display_name_fr": "Poivron (1 rouge moyen)",
    "display_name_pt": "Pimentão (1 vermelho médio)",
    "display_name_tr": "Dolmalık Biber (1 orta boy kırmızı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Red bell pepper",
        "name_es": "pimiento rojo",
        "name_de": "rote Paprika",
        "name_fr": "Poivron rouge",
        "name_pt": "pimentão vermelho",
        "name_tr": "Kırmızı dolmalık biber"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 150.0,
    "protein_g": 22.0,
    "carbohydrates_g": 0.0,
    "fat_g": 7.0,
    "fiber_g": 0.0,
    "sodium_mg": 65.0,
    "cholesterol_mg": 70.0,
    "water_ml": 250.0,
    "display_name_en": "Bison Burger (1 patty)",
    "display_name_es": "Hamburguesa de bisonte (1 hamburguesa)",
    "display_name_de": "Bisonburger (1 Patty)",
    "display_name_fr": "Burger de bison (1 steak haché)",
    "display_name_pt": "Hambúrguer de bisão (1 hambúrguer)",
    "display_name_tr": "Bizon Burger (1 köfte)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese (optional)",
        "name_es": "Queso cheddar (opcional)",
        "name_de": "Cheddar-Käse (optional)",
        "name_fr": "Fromage cheddar (facultatif)",
        "name_pt": "Queijo cheddar (opcional)",
        "name_tr": "Çedar peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bison patty",
        "name_es": "Hamburguesa de bisonte",
        "name_de": "Bisonfleisch-Patty",
        "name_fr": "Steak haché de bison",
        "name_pt": "Hambúrguer de bisão",
        "name_tr": "Bizon köftesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Burger bun",
        "name_es": "Pan de hamburguesa",
        "name_de": "Burgerbrötchen",
        "name_fr": "Pain à hamburger",
        "name_pt": "Pão de hambúrguer",
        "name_tr": "Burger ekmeği"
      }
    ]
  },
  {
    "category": "Legume",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 114.0,
    "protein_g": 7.6,
    "carbohydrates_g": 20.4,
    "fat_g": 0.5,
    "fiber_g": 7.5,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Black Beans (1/2 cup)",
    "display_name_es": "Frijoles negros (1/2 taza)",
    "display_name_de": "Schwarze Bohnen (1/2 Tasse)",
    "display_name_fr": "Haricots noirs (1/2 tasse)",
    "display_name_pt": "Feijão preto (1/2 xícara)",
    "display_name_tr": "Siyah Fasulye (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper (optional)",
        "name_es": "Pimiento morrón (opcional)",
        "name_de": "Paprika (optional)",
        "name_fr": "Poivron (facultatif)",
        "name_pt": "Pimentão (opcional)",
        "name_tr": "Dolmalık biber (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Black beans",
        "name_es": "frijoles negros",
        "name_de": "Schwarze Bohnen",
        "name_fr": "haricots noirs",
        "name_pt": "feijão preto",
        "name_tr": "Siyah fasulye"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 200.0,
    "protein_g": 6.0,
    "carbohydrates_g": 38.0,
    "fat_g": 2.0,
    "fiber_g": 2.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Bread Roll (hoagie)",
    "display_name_es": "Panecillo (hoagie)",
    "display_name_de": "Brötchen (Hoagie)",
    "display_name_fr": "Petit pain (hoagie)",
    "display_name_pt": "Pãozinho (tipo hoagie)",
    "display_name_tr": "Ekmek Rulosu (hoagie)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Hoagie roll",
        "name_es": "Panecillo hoagie",
        "name_de": "Hoagie-Brötchen",
        "name_fr": "pain hoagie",
        "name_pt": "Pãozinho de cachorro-quente",
        "name_tr": "Hoagie rulosu"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 215.0,
    "protein_g": 5.0,
    "carbohydrates_g": 45.0,
    "fat_g": 1.8,
    "fiber_g": 3.5,
    "sodium_mg": 10.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Brown Rice (1 cup cooked)",
    "display_name_es": "Arroz integral (1 taza cocido)",
    "display_name_de": "Brauner Reis (1 Tasse gekocht)",
    "display_name_fr": "Riz brun (1 tasse cuite)",
    "display_name_pt": "Arroz integral (1 xícara cozida)",
    "display_name_tr": "Esmer Pirinç (1 su bardağı pişmiş)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Brown rice",
        "name_es": "arroz integral",
        "name_de": "Brauner Reis",
        "name_fr": "riz brun",
        "name_pt": "Arroz integral",
        "name_tr": "Kahverengi pirinç"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 151.0,
    "protein_g": 6.0,
    "carbohydrates_g": 34.0,
    "fat_g": 0.0,
    "fiber_g": 8.0,
    "sodium_mg": 20.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Mediterranean Bulgur Salad",
    "display_name_es": "Ensalada mediterránea de bulgur",
    "display_name_de": "Mediterraner Bulgursalat",
    "display_name_fr": "Salade de boulgour méditerranéenne",
    "display_name_pt": "Salada Mediterrânea de Bulgur",
    "display_name_tr": "Akdeniz Bulgur Salatası",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsa",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Produce",
        "name_en": "Red onion",
        "name_es": "Cebolla roja",
        "name_de": "Rote Zwiebel",
        "name_fr": "Oignon rouge",
        "name_pt": "Cebola roxa",
        "name_tr": "Kırmızı soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Feta cheese (optional)",
        "name_es": "Queso feta (opcional)",
        "name_de": "Feta-Käse (optional)",
        "name_fr": "Fromage feta (facultatif)",
        "name_pt": "Queijo feta (opcional)",
        "name_tr": "Feta peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bulgur",
        "name_es": "Bulgur",
        "name_de": "Bulgur",
        "name_fr": "Boulgour",
        "name_pt": "Bulgur",
        "name_tr": "Bulgur"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 76.0,
    "protein_g": 2.7,
    "carbohydrates_g": 16.8,
    "fat_g": 0.2,
    "fiber_g": 4.1,
    "sodium_mg": 4.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Bulgur (1/4 cup in tabouli)",
    "display_name_es": "Bulgur (1/4 taza en tabulé)",
    "display_name_de": "Bulgur (1/4 Tasse in Taboulé)",
    "display_name_fr": "Boulgour (1/4 de tasse dans le taboulé)",
    "display_name_pt": "Bulgur (1/4 de xícara no tabule)",
    "display_name_tr": "Bulgur (tabouli'de 1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsa",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Produce",
        "name_en": "Mint",
        "name_es": "Menta",
        "name_de": "Minze",
        "name_fr": "Menthe",
        "name_pt": "Hortelã",
        "name_tr": "Nane"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bulgur",
        "name_es": "Bulgur",
        "name_de": "Bulgur",
        "name_fr": "Boulgour",
        "name_pt": "Bulgur",
        "name_tr": "Bulgur"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 550.0,
    "protein_g": 30.0,
    "carbohydrates_g": 40.0,
    "fat_g": 30.0,
    "fiber_g": 3.0,
    "sodium_mg": 1100.0,
    "cholesterol_mg": 90.0,
    "water_ml": 500.0,
    "display_name_en": "Burger (cheeseburger)",
    "display_name_es": "Hamburguesa (hamburguesa con queso)",
    "display_name_de": "Burger (Cheeseburger)",
    "display_name_fr": "Burger (cheeseburger)",
    "display_name_pt": "Hambúrguer (cheeseburger)",
    "display_name_tr": "Burger (çizburger)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese",
        "name_es": "queso cheddar",
        "name_de": "Cheddar-Käse",
        "name_fr": "fromage cheddar",
        "name_pt": "Queijo cheddar",
        "name_tr": "Çedar peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground beef patty",
        "name_es": "Hamburguesa de carne molida",
        "name_de": "Rinderhackfleisch-Patty",
        "name_fr": "Steak haché",
        "name_pt": "Hambúrguer de carne moída",
        "name_tr": "Kıyma köftesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Burger bun",
        "name_es": "Pan de hamburguesa",
        "name_de": "Burgerbrötchen",
        "name_fr": "Pain à hamburger",
        "name_pt": "Pão de hambúrguer",
        "name_tr": "Burger ekmeği"
      }
    ]
  },
  {
    "category": "Meal/Protein",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 470.0,
    "protein_g": 30.0,
    "carbohydrates_g": 15.0,
    "fat_g": 30.0,
    "fiber_g": 3.0,
    "sodium_mg": 890.0,
    "cholesterol_mg": 75.0,
    "water_ml": 250.0,
    "display_name_en": "Caesar Salad (with chicken)",
    "display_name_es": "Ensalada César (con pollo)",
    "display_name_de": "Caesar Salad (mit Hähnchen)",
    "display_name_fr": "Salade César (au poulet)",
    "display_name_pt": "Salada Caesar (com frango)",
    "display_name_tr": "Sezar Salatası (tavuklu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Romaine lettuce",
        "name_es": "Lechuga romana",
        "name_de": "Römersalat",
        "name_fr": "Laitue romaine",
        "name_pt": "Alface romana",
        "name_tr": "Romaine marulu"
      },
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "queso parmesano",
        "name_de": "Parmesankäse",
        "name_fr": "parmesan",
        "name_pt": "queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken breast",
        "name_es": "Pechuga de pollo",
        "name_de": "Hähnchenbrust",
        "name_fr": "Blanc de poulet",
        "name_pt": "Peito de frango",
        "name_tr": "Tavuk göğsü"
      },
      {
        "category_en": "Pantry",
        "name_en": "Croutons",
        "name_es": "Crutones",
        "name_de": "Croutons",
        "name_fr": "Croûtons",
        "name_pt": "Croutons",
        "name_tr": "Kruton"
      },
      {
        "category_en": "Pantry",
        "name_en": "Caesar dressing",
        "name_es": "Aderezo César",
        "name_de": "Caesar-Dressing",
        "name_fr": "Sauce César",
        "name_pt": "Molho Caesar",
        "name_tr": "Sezar sosu"
      }
    ]
  },
  {
    "category": "Meal/Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 240.0,
    "protein_g": 10.0,
    "carbohydrates_g": 8.0,
    "fat_g": 18.0,
    "fiber_g": 2.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 40.0,
    "water_ml": 250.0,
    "display_name_en": "Caprese Salad",
    "display_name_es": "Ensalada Caprese",
    "display_name_de": "Caprese-Salat",
    "display_name_fr": "Salade Caprese",
    "display_name_pt": "Salada Caprese",
    "display_name_tr": "Caprese Salatası",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Basil",
        "name_es": "Albahaca",
        "name_de": "Basilikum",
        "name_fr": "Basilic",
        "name_pt": "Manjericão",
        "name_tr": "Fesleğen"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "queso mozzarella",
        "name_de": "Mozzarella-Käse",
        "name_fr": "fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Balsamic vinegar",
        "name_es": "Vinagre balsámico",
        "name_de": "Balsamico-Essig",
        "name_fr": "Vinaigre balsamique",
        "name_pt": "Vinagre balsâmico",
        "name_tr": "Balzamik sirke"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 6.0,
    "protein_g": 0.3,
    "carbohydrates_g": 1.2,
    "fat_g": 0.1,
    "fiber_g": 0.6,
    "sodium_mg": 32.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Celery (1 stalk)",
    "display_name_es": "Apio (1 tallo)",
    "display_name_de": "Sellerie (1 Stange)",
    "display_name_fr": "Céleri (1 branche)",
    "display_name_pt": "Aipo (1 talo)",
    "display_name_tr": "Kereviz (1 sap)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Salsão",
        "name_tr": "Kereviz"
      }
    ]
  },
  {
    "category": "Meal/Fish",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 25.0,
    "carbohydrates_g": 15.0,
    "fat_g": 2.0,
    "fiber_g": 3.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 45.0,
    "water_ml": 0.0,
    "display_name_en": "Ceviche (1 cup fish)",
    "display_name_es": "Ceviche (1 taza de pescado)",
    "display_name_de": "Ceviche (1 Tasse Fisch)",
    "display_name_fr": "Ceviche (1 tasse de poisson)",
    "display_name_pt": "Ceviche (1 xícara de peixe)",
    "display_name_tr": "Ceviche (1 su bardağı balık)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Cilantro",
        "name_es": "Cilantro",
        "name_de": "Koriander",
        "name_fr": "Coriandre",
        "name_pt": "Coentro",
        "name_tr": "Kişniş"
      },
      {
        "category_en": "Produce",
        "name_en": "Chili pepper",
        "name_es": "Chile picante",
        "name_de": "Chilischote",
        "name_fr": "Piment",
        "name_pt": "Pimenta",
        "name_tr": "Acı biber"
      },
      {
        "category_en": "Pantry",
        "name_en": "White fish",
        "name_es": "Pescado blanco",
        "name_de": "Weißfisch",
        "name_fr": "Poisson blanc",
        "name_pt": "Peixe branco",
        "name_tr": "Beyaz balık"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lime juice",
        "name_es": "Jugo de lima",
        "name_de": "Limettensaft",
        "name_fr": "Jus de citron vert",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 130.0,
    "protein_g": 7.0,
    "carbohydrates_g": 18.0,
    "fat_g": 3.0,
    "fiber_g": 2.0,
    "sodium_mg": 850.0,
    "cholesterol_mg": 15.0,
    "water_ml": 250.0,
    "display_name_en": "Chicken & Rice Soup (1 can)",
    "display_name_es": "Sopa de pollo y arroz (1 lata)",
    "display_name_de": "Hühner-Reis-Suppe (1 Dose)",
    "display_name_fr": "Soupe poulet et riz (1 boîte)",
    "display_name_pt": "Sopa de Frango com Arroz (1 lata)",
    "display_name_tr": "Tavuk ve Pirinç Çorbası (1 kutu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken",
        "name_es": "Pollo",
        "name_de": "Huhn",
        "name_fr": "Poulet",
        "name_pt": "Frango",
        "name_tr": "Tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice",
        "name_es": "Arroz",
        "name_de": "Reis",
        "name_fr": "Riz",
        "name_pt": "Arroz",
        "name_tr": "Pirinç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken broth",
        "name_es": "Caldo de pollo",
        "name_de": "Hühnerbrühe",
        "name_fr": "Bouillon de poulet",
        "name_pt": "Caldo de frango",
        "name_tr": "Tavuk suyu"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 185.0,
    "protein_g": 35.0,
    "carbohydrates_g": 0.0,
    "fat_g": 4.0,
    "fiber_g": 0.0,
    "sodium_mg": 80.0,
    "cholesterol_mg": 95.0,
    "water_ml": 500.0,
    "display_name_en": "Chicken Breast (4oz roasted)",
    "display_name_es": "Pechuga de pollo (4 oz asada)",
    "display_name_de": "Hähnchenbrust (113 g gebraten)",
    "display_name_fr": "Poitrine de poulet (113 g rôtie)",
    "display_name_pt": "Peito de frango (113g assado)",
    "display_name_tr": "Tavuk Göğsü (4oz kızarmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic (optional)",
        "name_es": "Ajo (opcional)",
        "name_de": "Knoblauch (optional)",
        "name_fr": "Ail (facultatif)",
        "name_pt": "Alho (opcional)",
        "name_tr": "Sarımsak (isteğe bağlı)"
      },
      {
        "category_en": "Produce",
        "name_en": "Herbs (optional)",
        "name_es": "Hierbas (opcional)",
        "name_de": "Kräuter (optional)",
        "name_fr": "Herbes (facultatif)",
        "name_pt": "Ervas (opcional)",
        "name_tr": "Otlar (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken breast",
        "name_es": "Pechuga de pollo",
        "name_de": "Hähnchenbrust",
        "name_fr": "Blanc de poulet",
        "name_pt": "Peito de frango",
        "name_tr": "Tavuk göğsü"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 270.0,
    "protein_g": 15.0,
    "carbohydrates_g": 16.0,
    "fat_g": 16.0,
    "fiber_g": 1.0,
    "sodium_mg": 500.0,
    "cholesterol_mg": 40.0,
    "water_ml": 0.0,
    "display_name_en": "Chicken McNuggets (6 pcs)",
    "display_name_es": "McNuggets de pollo (6 piezas)",
    "display_name_de": "Chicken McNuggets (6 Stück)",
    "display_name_fr": "Chicken McNuggets (6 pièces)",
    "display_name_pt": "Chicken McNuggets (6 unidades)",
    "display_name_tr": "Tavuk McNuggets (6 adet)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Chicken nuggets",
        "name_es": "Nuggets de pollo",
        "name_de": "Chicken Nuggets",
        "name_fr": "Nuggets de poulet",
        "name_pt": "Nuggets de frango",
        "name_tr": "Tavuk nugget"
      },
      {
        "category_en": "Pantry",
        "name_en": "Breading",
        "name_es": "Empanizado",
        "name_de": "Panade",
        "name_fr": "Panure",
        "name_pt": "Empanado",
        "name_tr": "Ekmek kırıntısı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 150.0,
    "protein_g": 7.0,
    "carbohydrates_g": 18.0,
    "fat_g": 5.0,
    "fiber_g": 2.0,
    "sodium_mg": 890.0,
    "cholesterol_mg": 15.0,
    "water_ml": 250.0,
    "display_name_en": "Chicken Noodle Soup (1 can)",
    "display_name_es": "Sopa de pollo con fideos (1 lata)",
    "display_name_de": "Hühnernudelsuppe (1 Dose)",
    "display_name_fr": "Soupe de nouilles au poulet (1 boîte)",
    "display_name_pt": "Sopa de galinha com macarrão (1 lata)",
    "display_name_tr": "Tavuk Erişte Çorbası (1 kutu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken",
        "name_es": "Pollo",
        "name_de": "Hühnchen",
        "name_fr": "Poulet",
        "name_pt": "Frango",
        "name_tr": "Tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Egg noodles",
        "name_es": "Fideos de huevo",
        "name_de": "Eiernudeln",
        "name_fr": "Nouilles aux œufs",
        "name_pt": "Macarrão de ovo",
        "name_tr": "Yumurta eriştesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken broth",
        "name_es": "Caldo de pollo",
        "name_de": "Hühnerbrühe",
        "name_fr": "Bouillon de poulet",
        "name_pt": "Caldo de frango",
        "name_tr": "Tavuk suyu"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 650.0,
    "protein_g": 40.0,
    "carbohydrates_g": 55.0,
    "fat_g": 30.0,
    "fiber_g": 6.0,
    "sodium_mg": 1400.0,
    "cholesterol_mg": 100.0,
    "water_ml": 500.0,
    "display_name_en": "Chicken Parm Sandwich",
    "display_name_es": "Sándwich de pollo a la parmesana",
    "display_name_de": "Hähnchen-Parmesan-Sandwich",
    "display_name_fr": "Sandwich au poulet parmesan",
    "display_name_pt": "Sanduíche de Frango à Parmegiana",
    "display_name_tr": "Tavuk Parm Sandviç",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato sauce",
        "name_es": "salsa de tomate",
        "name_de": "Tomatensoße",
        "name_fr": "Sauce tomate",
        "name_pt": "Molho de tomate",
        "name_tr": "Domates sosu"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "queso mozzarella",
        "name_de": "Mozzarella-Käse",
        "name_fr": "fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Breaded chicken cutlet",
        "name_es": "Chuleta de pollo empanizada",
        "name_de": "Paniertes Hähnchenschnitzel",
        "name_fr": "Escalope de poulet panée",
        "name_pt": "Filé de frango à milanesa",
        "name_tr": "Ekmekli tavuk pirzola"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sandwich roll",
        "name_es": "Panecillo tipo sándwich",
        "name_de": "Sandwichbrötchen",
        "name_fr": "Sandwich roulé",
        "name_pt": "Pãozinho para sanduíche",
        "name_tr": "Sandviç rulo"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 420.0,
    "protein_g": 20.0,
    "carbohydrates_g": 35.0,
    "fat_g": 20.0,
    "fiber_g": 3.0,
    "sodium_mg": 850.0,
    "cholesterol_mg": 60.0,
    "water_ml": 250.0,
    "display_name_en": "Chicken Salad Sandwich",
    "display_name_es": "Sándwich de ensalada de pollo",
    "display_name_de": "Hähnchensalat-Sandwich",
    "display_name_fr": "Sandwich à la salade de poulet",
    "display_name_pt": "Sanduíche de salada de frango",
    "display_name_tr": "Tavuk Salatası Sandviç",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cooked chicken",
        "name_es": "Pollo cocido",
        "name_de": "Gekochtes Hähnchen",
        "name_fr": "Poulet cuit",
        "name_pt": "Frango cozido",
        "name_tr": "Pişmiş tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mayonnaise",
        "name_es": "Mayonesa",
        "name_de": "Mayonnaise",
        "name_fr": "Mayonnaise",
        "name_pt": "Maionese",
        "name_tr": "Mayonez"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sandwich bread",
        "name_es": "Pan de sándwich",
        "name_de": "Sandwichbrot",
        "name_fr": "Pain de mie",
        "name_pt": "Pão de sanduíche",
        "name_tr": "Sandviç ekmeği"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 410.0,
    "protein_g": 25.0,
    "carbohydrates_g": 38.0,
    "fat_g": 17.0,
    "fiber_g": 5.0,
    "sodium_mg": 780.0,
    "cholesterol_mg": 60.0,
    "water_ml": 250.0,
    "display_name_en": "Chicken Wrap (with tortilla)",
    "display_name_es": "Wrap de pollo (con tortilla)",
    "display_name_de": "Hähnchen-Wrap (mit Tortilla)",
    "display_name_fr": "Wrap au poulet (avec tortilla)",
    "display_name_pt": "Wrap de frango (com tortilla)",
    "display_name_tr": "Tavuk Dürüm (tortilla ile)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese (optional)",
        "name_es": "Queso cheddar (opcional)",
        "name_de": "Cheddar-Käse (optional)",
        "name_fr": "Fromage cheddar (facultatif)",
        "name_pt": "Queijo cheddar (opcional)",
        "name_tr": "Çedar peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Grilled chicken",
        "name_es": "Pollo a la parrilla",
        "name_de": "Gegrilltes Hähnchen",
        "name_fr": "Poulet grillé",
        "name_pt": "Frango grelhado",
        "name_tr": "Izgara tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tortilla",
        "name_es": "Tortilla",
        "name_de": "Tortilla",
        "name_fr": "Tortilla",
        "name_pt": "Tortilha",
        "name_tr": "Tortilla"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sauce",
        "name_es": "Salsa",
        "name_de": "Sauce",
        "name_fr": "Sauce",
        "name_pt": "Molho",
        "name_tr": "Sos"
      }
    ]
  },
  {
    "category": "Legume",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 135.0,
    "protein_g": 7.0,
    "carbohydrates_g": 22.0,
    "fat_g": 2.0,
    "fiber_g": 6.0,
    "sodium_mg": 250.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Chickpeas (1/2 cup canned)",
    "display_name_es": "Garbanzos (1/2 taza enlatados)",
    "display_name_de": "Kichererbsen (1/2 Tasse aus der Dose)",
    "display_name_fr": "Pois chiches (1/2 tasse en conserve)",
    "display_name_pt": "Grão-de-bico (1/2 xícara em lata)",
    "display_name_tr": "Nohut (1/2 su bardağı konserve)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Chickpeas",
        "name_es": "garbanzos",
        "name_de": "Kichererbsen",
        "name_fr": "pois chiches",
        "name_pt": "Grão-de-bico",
        "name_tr": "Nohut"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 550.0,
    "protein_g": 20.0,
    "carbohydrates_g": 40.0,
    "fat_g": 35.0,
    "fiber_g": 3.0,
    "sodium_mg": 1100.0,
    "cholesterol_mg": 80.0,
    "water_ml": 250.0,
    "display_name_en": "Choripan (1 sandwich)",
    "display_name_es": "Choripán (1 sándwich)",
    "display_name_de": "Choripan (1 Sandwich)",
    "display_name_fr": "Choripan (1 sandwich)",
    "display_name_pt": "Choripan (1 sanduíche)",
    "display_name_tr": "Choripan (1 sandviç)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Chimichurri herbs",
        "name_es": "Hierbas chimichurri",
        "name_de": "Chimichurri-Kräuter",
        "name_fr": "Herbes pour chimichurri",
        "name_pt": "Ervas para chimichurri",
        "name_tr": "Chimichurri otları"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion (optional)",
        "name_es": "Cebolla (opcional)",
        "name_de": "Zwiebel (optional)",
        "name_fr": "Oignon (facultatif)",
        "name_pt": "Cebola (opcional)",
        "name_tr": "Soğan (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chorizo sausage",
        "name_es": "Chorizo ​​",
        "name_de": "Chorizo-Wurst",
        "name_fr": "Saucisse chorizo ​​",
        "name_pt": "Linguiça de chorizo ​​",
        "name_tr": "Chorizo ​​sosis"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bread roll",
        "name_es": "Panecillo",
        "name_de": "Brötchen",
        "name_fr": "Petit pain",
        "name_pt": "Pãozinho",
        "name_tr": "Ekmek rulosu"
      }
    ]
  },
  {
    "category": "Meal/Seafood",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 200.0,
    "protein_g": 10.0,
    "carbohydrates_g": 18.0,
    "fat_g": 9.0,
    "fiber_g": 1.0,
    "sodium_mg": 870.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Clam Chowder (1 cup)",
    "display_name_es": "Sopa de almejas (1 taza)",
    "display_name_de": "Muschelsuppe (1 Tasse)",
    "display_name_fr": "Chaudrée de palourdes (1 tasse)",
    "display_name_pt": "Sopa de mariscos (1 xícara)",
    "display_name_tr": "Midye Çorbası (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme",
        "name_tr": "Krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Clams",
        "name_es": "Almejas",
        "name_de": "Muscheln",
        "name_fr": "Palourdes",
        "name_pt": "Amêijoas",
        "name_tr": "Midye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et Suyu"
      }
    ]
  },
  {
    "category": "Meal/Seafood",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 200.0,
    "protein_g": 10.0,
    "carbohydrates_g": 18.0,
    "fat_g": 9.0,
    "fiber_g": 1.0,
    "sodium_mg": 870.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Clam Chowder (1 cup)",
    "display_name_es": "Sopa de almejas (1 taza)",
    "display_name_de": "Muschelsuppe (1 Tasse)",
    "display_name_fr": "Chaudrée de palourdes (1 tasse)",
    "display_name_pt": "Sopa de mariscos (1 xícara)",
    "display_name_tr": "Midye Çorbası (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme",
        "name_tr": "Krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Clams",
        "name_es": "Almejas",
        "name_de": "Muscheln",
        "name_fr": "Palourdes",
        "name_pt": "Amêijoas",
        "name_tr": "Midye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "Caldo",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et Suyu"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 580.0,
    "protein_g": 35.0,
    "carbohydrates_g": 40.0,
    "fat_g": 30.0,
    "fiber_g": 5.0,
    "sodium_mg": 1300.0,
    "cholesterol_mg": 95.0,
    "water_ml": 500.0,
    "display_name_en": "Club Sandwich",
    "display_name_es": "Sándwich club",
    "display_name_de": "Club-Sandwich",
    "display_name_fr": "Club sandwich",
    "display_name_pt": "Sanduíche Club",
    "display_name_tr": "Kulüp sandviç",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Turkey",
        "name_es": "Pavo",
        "name_de": "Pute",
        "name_fr": "Dinde",
        "name_pt": "Peru",
        "name_tr": "Hindi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bacon",
        "name_es": "Tocino",
        "name_de": "Speck",
        "name_fr": "Bacon",
        "name_pt": "Bacon",
        "name_tr": "Pastırma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sandwich bread",
        "name_es": "Pan de sándwich",
        "name_de": "Sandwichbrot",
        "name_fr": "Pain de mie",
        "name_pt": "Pão de sanduíche",
        "name_tr": "Sandviç ekmeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mayonnaise",
        "name_es": "Mayonesa",
        "name_de": "Mayonnaise",
        "name_fr": "Mayonnaise",
        "name_pt": "Maionese",
        "name_tr": "Mayonez"
      }
    ]
  },
  {
    "category": "Meal/Protein",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 510.0,
    "protein_g": 30.0,
    "carbohydrates_g": 12.0,
    "fat_g": 38.0,
    "fiber_g": 7.0,
    "sodium_mg": 800.0,
    "cholesterol_mg": 210.0,
    "water_ml": 500.0,
    "display_name_en": "Cobb Salad",
    "display_name_es": "Ensalada Cobb",
    "display_name_de": "Cobb-Salat",
    "display_name_fr": "Salade Cobb",
    "display_name_pt": "Salada Cobb",
    "display_name_tr": "Cobb Salatası",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Romaine lettuce",
        "name_es": "Lechuga romana",
        "name_de": "Römersalat",
        "name_fr": "Laitue romaine",
        "name_pt": "Alface romana",
        "name_tr": "Romaine marulu"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Avocado",
        "name_es": "Aguacate",
        "name_de": "Avocado",
        "name_fr": "Avocat",
        "name_pt": "Abacate",
        "name_tr": "Avokado"
      },
      {
        "category_en": "Produce",
        "name_en": "Red onion",
        "name_es": "Cebolla roja",
        "name_de": "Rote Zwiebel",
        "name_fr": "Oignon rouge",
        "name_pt": "Cebola roxa",
        "name_tr": "Kırmızı soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Blue cheese",
        "name_es": "Queso azul",
        "name_de": "Blauschimmelkäse",
        "name_fr": "Fromage bleu",
        "name_pt": "Queijo azul",
        "name_tr": "Mavi peynir"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Hard-boiled egg",
        "name_es": "Huevo duro",
        "name_de": "Hartgekochtes Ei",
        "name_fr": "Œuf dur",
        "name_pt": "Ovo cozido",
        "name_tr": "Haşlanmış yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bacon",
        "name_es": "Tocino",
        "name_de": "Speck",
        "name_fr": "Bacon",
        "name_pt": "Bacon",
        "name_tr": "Pastırma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken",
        "name_es": "Pollo",
        "name_de": "Hähnchen",
        "name_fr": "Poulet",
        "name_pt": "Frango",
        "name_tr": "Tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinaigrette",
        "name_es": "Vinagreta",
        "name_de": "Vinaigrette",
        "name_fr": "Vinaigrette",
        "name_pt": "Vinagrete",
        "name_tr": "Vinaigrette"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 160.0,
    "protein_g": 28.0,
    "carbohydrates_g": 6.0,
    "fat_g": 2.5,
    "fiber_g": 0.0,
    "sodium_mg": 820.0,
    "cholesterol_mg": 10.0,
    "water_ml": 250.0,
    "display_name_en": "Cottage Cheese (1 cup low fat)",
    "display_name_es": "Requesón (1 taza bajo en grasa)",
    "display_name_de": "Hüttenkäse (1 Tasse fettarm)",
    "display_name_fr": "Fromage cottage (1 tasse faible en gras)",
    "display_name_pt": "Queijo cottage (1 xícara com baixo teor de gordura)",
    "display_name_tr": "Süzme Peynir (1 su bardağı az yağlı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cottage cheese",
        "name_es": "Requesón",
        "name_de": "Hüttenkäse",
        "name_fr": "Fromage blanc",
        "name_pt": "Queijo tipo cottage",
        "name_tr": "Süzme peynir"
      }
    ]
  },
  {
    "category": "Grain/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 90.0,
    "protein_g": 2.0,
    "carbohydrates_g": 14.0,
    "fat_g": 3.0,
    "fiber_g": 2.0,
    "sodium_mg": 180.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Crackers (5 whole wheat)",
    "display_name_es": "Galletas (5 integrales)",
    "display_name_de": "Cracker (5 Vollkorn)",
    "display_name_fr": "Craquelins (5 au blé entier)",
    "display_name_pt": "Bolachas (5 de trigo integral)",
    "display_name_tr": "Kraker (5 tam buğday)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Whole wheat crackers",
        "name_es": "Galletas de trigo integral",
        "name_de": "Vollkorncracker",
        "name_fr": "craquelins de blé entier",
        "name_pt": "biscoitos de trigo integral",
        "name_tr": "Tam buğday krakerleri"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 50.0,
    "protein_g": 1.5,
    "carbohydrates_g": 7.0,
    "fat_g": 2.0,
    "fiber_g": 0.5,
    "sodium_mg": 140.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Croutons (1/4 cup)",
    "display_name_es": "Crutones (1/4 taza)",
    "display_name_de": "Croutons (1/4 Tasse)",
    "display_name_fr": "Croûtons (1/4 tasse)",
    "display_name_pt": "Croutons (1/4 de xícara)",
    "display_name_tr": "Kruton (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic (optional)",
        "name_es": "Ajo (opcional)",
        "name_de": "Knoblauch (optional)",
        "name_fr": "Ail (facultatif)",
        "name_pt": "Alho (opcional)",
        "name_tr": "Sarımsak (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bread cubes",
        "name_es": "Cubitos de pan",
        "name_de": "Brotwürfel",
        "name_fr": "Croûtons",
        "name_pt": "Cubos de pão",
        "name_tr": "Ekmek küpleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 50.0,
    "protein_g": 1.5,
    "carbohydrates_g": 7.0,
    "fat_g": 2.0,
    "fiber_g": 0.5,
    "sodium_mg": 140.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Croutons (Garlic 1/4 cup)",
    "display_name_es": "Crutones (Ajo 1/4 taza)",
    "display_name_de": "Croutons (1/4 Tasse Knoblauch)",
    "display_name_fr": "Croûtons (ail 1/4 tasse)",
    "display_name_pt": "Croutons (1/4 de xícara de alho)",
    "display_name_tr": "Kruton (Sarımsaklı 1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bread cubes",
        "name_es": "Cubitos de pan",
        "name_de": "Brotwürfel",
        "name_fr": "Croûtons",
        "name_pt": "Cubos de pão",
        "name_tr": "Ekmek küpleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 12.0,
    "carbohydrates_g": 10.0,
    "fat_g": 10.0,
    "fiber_g": 2.0,
    "sodium_mg": 550.0,
    "cholesterol_mg": 60.0,
    "water_ml": 0.0,
    "display_name_en": "Dim Sum (Siu Mai 3 pcs)",
    "display_name_es": "Dim Sum (Siu Mai 3 piezas)",
    "display_name_de": "Dim Sum (Siu Mai 3 Stück)",
    "display_name_fr": "Dim Sum (Siu Mai 3 pièces)",
    "display_name_pt": "Dim Sum (Siu Mai 3 unidades)",
    "display_name_tr": "Dim Sum (Siu Mai 3 adet)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Green onion",
        "name_es": "Cebolla verde",
        "name_de": "Frühlingszwiebeln",
        "name_fr": "Oignon vert",
        "name_pt": "Cebolinha",
        "name_tr": "Yeşil soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Ginger",
        "name_es": "Jengibre",
        "name_de": "Ingwer",
        "name_fr": "Gingembre",
        "name_pt": "Gengibre",
        "name_tr": "Zencefil"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pork",
        "name_es": "Cerdo",
        "name_de": "Schweinefleisch",
        "name_fr": "Porc",
        "name_pt": "Carne de porco",
        "name_tr": "Dana eti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Shrimp",
        "name_es": "Camarones",
        "name_de": "Garnelen",
        "name_fr": "Crevettes",
        "name_pt": "Camarão",
        "name_tr": "Karides"
      },
      {
        "category_en": "Pantry",
        "name_en": "Wonton wrapper",
        "name_es": "Envoltura de wonton",
        "name_de": "Wonton-Teig",
        "name_fr": "Pâte à wonton",
        "name_pt": "Massa de wonton",
        "name_tr": "Wonton ambalajı"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 290.0,
    "protein_g": 10.0,
    "carbohydrates_g": 28.0,
    "fat_g": 16.0,
    "fiber_g": 3.0,
    "sodium_mg": 550.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Empanada (Beef 1 medium)",
    "display_name_es": "Empanada (Carne 1 mediana)",
    "display_name_de": "Empanada (Rindfleisch 1 mittelgroß)",
    "display_name_fr": "Empanada (Bœuf 1 moyenne)",
    "display_name_pt": "Empanada (Carne 1 média)",
    "display_name_tr": "Empanada (1 orta boy dana eti)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivron",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground beef",
        "name_es": "Carne molida",
        "name_de": "Hackfleisch",
        "name_fr": "Bœuf haché",
        "name_pt": "Carne moída",
        "name_tr": "Kıyma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Empanada dough",
        "name_es": "Masa para empanada",
        "name_de": "Empanada-Teig",
        "name_fr": "Pâte à empanadas",
        "name_pt": "Massa para empanada",
        "name_tr": "Empanada hamuru"
      }
    ]
  },
  {
    "category": "Meal/Vegetarian",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 180.0,
    "protein_g": 6.0,
    "carbohydrates_g": 18.0,
    "fat_g": 9.0,
    "fiber_g": 4.0,
    "sodium_mg": 320.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Falafel (3 pieces)",
    "display_name_es": "Falafel (3 piezas)",
    "display_name_de": "Falafel (3 Stück)",
    "display_name_fr": "Falafel (3 pièces)",
    "display_name_pt": "Falafel (3 unidades)",
    "display_name_tr": "Falafel (3 adet)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Chickpeas",
        "name_es": "Garbanzos",
        "name_de": "Kichererbsen",
        "name_fr": "Pois chiches",
        "name_pt": "Grão-de-bico",
        "name_tr": "Nohut"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsinha",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spices",
        "name_es": "Especias",
        "name_de": "Gewürze",
        "name_fr": "Épices",
        "name_pt": "Especiarias",
        "name_tr": "Baharatlar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Meal/Vegetarian",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 250.0,
    "protein_g": 5.0,
    "carbohydrates_g": 25.0,
    "fat_g": 15.0,
    "fiber_g": 6.0,
    "sodium_mg": 500.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Fattoush Salad (1.5 cups)",
    "display_name_es": "Ensalada Fattoush (1,5 tazas)",
    "display_name_de": "Fattoush-Salat (1,5 Tassen)",
    "display_name_fr": "Salade Fattouche (1,5 tasse)",
    "display_name_pt": "Salada Fattoush (1,5 xícaras)",
    "display_name_tr": "Fatuş Salatası (1,5 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Kopfsalat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Radish",
        "name_es": "Rábano",
        "name_de": "Radieschen",
        "name_fr": "Radis",
        "name_pt": "Rabanete",
        "name_tr": "Turp"
      },
      {
        "category_en": "Produce",
        "name_en": "Mint",
        "name_es": "Menta",
        "name_de": "Minze",
        "name_fr": "Menthe",
        "name_pt": "Hortelã",
        "name_tr": "Nane"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsa",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Toasted pita",
        "name_es": "Pita tostada",
        "name_de": "Geröstetes Pitabrot",
        "name_fr": "Pain pita grillé",
        "name_pt": "Pão pita torrado",
        "name_tr": "Kızarmış pide"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 75.0,
    "protein_g": 4.0,
    "carbohydrates_g": 1.2,
    "fat_g": 6.1,
    "fiber_g": 0.0,
    "sodium_mg": 316.0,
    "cholesterol_mg": 25.0,
    "water_ml": 0.0,
    "display_name_en": "Feta Cheese (1 oz)",
    "display_name_es": "Queso feta (1 oz)",
    "display_name_de": "Feta-Käse (1 oz)",
    "display_name_fr": "Fromage feta (1 oz)",
    "display_name_pt": "Queijo Feta (28 g)",
    "display_name_tr": "Feta Peyniri (1 oz)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Feta cheese",
        "name_es": "queso feta",
        "name_de": "Feta-Käse",
        "name_fr": "fromage feta",
        "name_pt": "Queijo feta",
        "name_tr": "Feta peyniri"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 250.0,
    "protein_g": 8.0,
    "carbohydrates_g": 40.0,
    "fat_g": 7.0,
    "fiber_g": 2.0,
    "sodium_mg": 500.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Focaccia (1 square)",
    "display_name_es": "Focaccia (1 cuadrado)",
    "display_name_de": "Focaccia (1 Stück)",
    "display_name_fr": "Focaccia (1 carré)",
    "display_name_pt": "Focaccia (1 quadrado)",
    "display_name_tr": "Focaccia (1 kare)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Rosemary",
        "name_es": "Romero",
        "name_de": "Rosmarin",
        "name_fr": "Romarin",
        "name_pt": "Alecrim",
        "name_tr": "Biberiye"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato (optional)",
        "name_es": "Tomate (opcional)",
        "name_de": "Tomate (optional)",
        "name_fr": "Tomate (facultatif)",
        "name_pt": "Tomate (opcional)",
        "name_tr": "Domates (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Focaccia bread",
        "name_es": "Pan focaccia",
        "name_de": "Focaccia-Brot",
        "name_fr": "Pain focaccia",
        "name_pt": "Pão focaccia",
        "name_tr": "Focaccia ekmeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 150.0,
    "protein_g": 6.0,
    "carbohydrates_g": 15.0,
    "fat_g": 7.0,
    "fiber_g": 2.0,
    "sodium_mg": 800.0,
    "cholesterol_mg": 20.0,
    "water_ml": 250.0,
    "display_name_en": "French Onion Soup (1 cup)",
    "display_name_es": "Sopa de cebolla francesa (1 taza)",
    "display_name_de": "Französische Zwiebelsuppe (1 Tasse)",
    "display_name_fr": "Soupe à l'oignon française (1 tasse)",
    "display_name_pt": "Sopa de cebola francesa (1 xícara)",
    "display_name_tr": "Fransız Soğan Çorbası (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Manteca",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beef broth",
        "name_es": "Caldo de res",
        "name_de": "Rinderbrühe",
        "name_fr": "Bouillon de bœuf",
        "name_pt": "Caldo de carne",
        "name_tr": "Dana suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bread",
        "name_es": "Pan",
        "name_de": "Brot",
        "name_fr": "Pain",
        "name_pt": "Pão",
        "name_tr": "Ekmek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cheese",
        "name_es": "Queso",
        "name_de": "Käse",
        "name_fr": "Fromage",
        "name_pt": "Queijo",
        "name_tr": "Peynir"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 80.0,
    "protein_g": 2.0,
    "carbohydrates_g": 12.0,
    "fat_g": 3.0,
    "fiber_g": 1.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Fried Pita (1/2 pita in salad)",
    "display_name_es": "Pita frita (1/2 pita en ensalada)",
    "display_name_de": "Frittiertes Pita (1/2 Pita im Salat)",
    "display_name_fr": "Pita frite (1/2 pita dans la salade)",
    "display_name_pt": "Pita frita (1/2 pita na salada)",
    "display_name_tr": "Kızarmış Pide (Salata'da 1/2 pide)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pita bread",
        "name_es": "Pan pita",
        "name_de": "Pitabrot",
        "name_fr": "Pain pita",
        "name_pt": "Pão pita",
        "name_tr": "Pide ekmeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Azeite",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Meal/Soup",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 90.0,
    "protein_g": 2.0,
    "carbohydrates_g": 12.0,
    "fat_g": 4.0,
    "fiber_g": 3.0,
    "sodium_mg": 600.0,
    "cholesterol_mg": 0.0,
    "water_ml": 240.0,
    "display_name_en": "Gazpacho (1 cup)",
    "display_name_es": "Gazpacho (1 taza)",
    "display_name_de": "Gazpacho (1 Tasse)",
    "display_name_fr": "Gaspacho (1 tasse)",
    "display_name_pt": "Gazpacho (1 xícara)",
    "display_name_tr": "Gazpacho (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivron",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 390.0,
    "protein_g": 15.0,
    "carbohydrates_g": 32.0,
    "fat_g": 22.0,
    "fiber_g": 3.0,
    "sodium_mg": 800.0,
    "cholesterol_mg": 60.0,
    "water_ml": 0.0,
    "display_name_en": "Grilled Cheese Sandwich",
    "display_name_es": "Sándwich de queso a la parrilla",
    "display_name_de": "Gegrilltes Käsesandwich",
    "display_name_fr": "Sandwich au fromage grillé",
    "display_name_pt": "Sanduíche de queijo grelhado",
    "display_name_tr": "Izgara Peynirli Sandviç",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato (optional)",
        "name_es": "Tomate (opcional)",
        "name_de": "Tomate (optional)",
        "name_fr": "Tomate (facultatif)",
        "name_pt": "Tomate (opcional)",
        "name_tr": "Domates (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese",
        "name_es": "queso cheddar",
        "name_de": "Cheddar-Käse",
        "name_fr": "fromage cheddar",
        "name_pt": "Queijo cheddar",
        "name_tr": "Çedar peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sandwich bread",
        "name_es": "Pan de sándwich",
        "name_de": "Sandwichbrot",
        "name_fr": "Pain de mie",
        "name_pt": "Pão de sanduíche",
        "name_tr": "Sandviç ekmeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      }
    ]
  },
  {
    "category": "Meal/Protein",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 1,
    "calories_kcal": 350.0,
    "protein_g": 30.0,
    "carbohydrates_g": 10.0,
    "fat_g": 20.0,
    "fiber_g": 5.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 80.0,
    "water_ml": 500.0,
    "display_name_en": "Grilled Chicken Salad",
    "display_name_es": "Ensalada de pollo a la parrilla",
    "display_name_de": "Gegrillter Hähnchensalat",
    "display_name_fr": "Salade de poulet grillé",
    "display_name_pt": "Salada de Frango Grelhado",
    "display_name_tr": "Izgara Tavuk Salatası",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Red onion",
        "name_es": "Cebolla roja",
        "name_de": "Rote Zwiebel",
        "name_fr": "Oignon rouge",
        "name_pt": "Cebola roxa",
        "name_tr": "Kırmızı soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Feta cheese (optional)",
        "name_es": "Queso feta (opcional)",
        "name_de": "Feta-Käse (optional)",
        "name_fr": "Fromage feta (facultatif)",
        "name_pt": "Queijo feta (opcional)",
        "name_tr": "Feta peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Grilled chicken",
        "name_es": "Pollo a la parrilla",
        "name_de": "Gegrilltes Hähnchen",
        "name_fr": "Poulet grillé",
        "name_pt": "Frango grelhado",
        "name_tr": "Izgara tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinaigrette",
        "name_es": "Vinagreta",
        "name_de": "Vinaigrette",
        "name_fr": "Vinaigrette",
        "name_pt": "Vinagrete",
        "name_tr": "Vinaigrette"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 110.0,
    "protein_g": 16.0,
    "carbohydrates_g": 2.0,
    "fat_g": 4.0,
    "fiber_g": 0.0,
    "sodium_mg": 950.0,
    "cholesterol_mg": 45.0,
    "water_ml": 0.0,
    "display_name_en": "Ham (3oz deli sliced)",
    "display_name_es": "Jamón (3 oz cortado en lonchas)",
    "display_name_de": "Schinken (85g in Scheiben geschnitten)",
    "display_name_fr": "Jambon (85 g, tranché)",
    "display_name_pt": "Presunto (85g fatiado)",
    "display_name_tr": "Jambon (3oz dilimlenmiş şarküteri)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Ham",
        "name_es": "Jamón",
        "name_de": "Schinken",
        "name_fr": "Jambon",
        "name_pt": "Presunto",
        "name_tr": "Jambon"
      }
    ]
  },
  {
    "category": "Legume",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 130.0,
    "protein_g": 5.0,
    "carbohydrates_g": 10.0,
    "fat_g": 8.0,
    "fiber_g": 4.0,
    "sodium_mg": 250.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Hummus (1/4 cup)",
    "display_name_es": "Hummus (1/4 taza)",
    "display_name_de": "Hummus (1/4 Tasse)",
    "display_name_fr": "Houmous (1/4 tasse)",
    "display_name_pt": "Hummus (1/4 de xícara)",
    "display_name_tr": "Humus (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chickpeas",
        "name_es": "Garbanzos",
        "name_de": "Kichererbsen",
        "name_fr": "Pois chiches",
        "name_pt": "Grão-de-bico",
        "name_tr": "Nohut"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tahini",
        "name_es": "Tahini",
        "name_de": "Tahini",
        "name_fr": "Tahini",
        "name_pt": "Tahine",
        "name_tr": "Tahin"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Vegetarian",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 450.0,
    "protein_g": 15.0,
    "carbohydrates_g": 60.0,
    "fat_g": 18.0,
    "fiber_g": 12.0,
    "sodium_mg": 800.0,
    "cholesterol_mg": 0.0,
    "water_ml": 500.0,
    "display_name_en": "Hummus Wrap (large)",
    "display_name_es": "Wrap de hummus (grande)",
    "display_name_de": "Hummus-Wrap (groß)",
    "display_name_fr": "Wrap au houmous (grand format)",
    "display_name_pt": "Wrap de húmus (grande)",
    "display_name_tr": "Humus Dürüm (büyük)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Pantry",
        "name_en": "Hummus",
        "name_es": "Hummus",
        "name_de": "Hummus",
        "name_fr": "Houmous",
        "name_pt": "Hummus",
        "name_tr": "Humus"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tortilla",
        "name_es": "Tortilla",
        "name_de": "Tortilla",
        "name_fr": "Tortilla",
        "name_pt": "Tortilha",
        "name_tr": "Tortilla"
      }
    ]
  },
  {
    "category": "Meal/Legume",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 230.0,
    "protein_g": 15.0,
    "carbohydrates_g": 35.0,
    "fat_g": 3.0,
    "fiber_g": 12.0,
    "sodium_mg": 650.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Lentil Soup (1 can)",
    "display_name_es": "Sopa de lentejas (1 lata)",
    "display_name_de": "Linsensuppe (1 Dose)",
    "display_name_fr": "Soupe aux lentilles (1 boîte)",
    "display_name_pt": "Sopa de lentilha (1 lata)",
    "display_name_tr": "Mercimek Çorbası (1 kutu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lentils",
        "name_es": "Lentejas",
        "name_de": "Linsen",
        "name_fr": "Lentilles",
        "name_pt": "Lentilhas",
        "name_tr": "Mercimek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable broth",
        "name_es": "Caldo de verduras",
        "name_de": "Gemüsebrühe",
        "name_fr": "Bouillon de légumes",
        "name_pt": "Caldo de legumes",
        "name_tr": "Sebze suyu"
      }
    ]
  },
  {
    "category": "Meal/Legume",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 200.0,
    "protein_g": 10.0,
    "carbohydrates_g": 30.0,
    "fat_g": 5.0,
    "fiber_g": 10.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Lentil Soup (1 cup Middle Eastern)",
    "display_name_es": "Sopa de lentejas (1 taza de Medio Oriente)",
    "display_name_de": "Linsensuppe (1 Tasse, orientalisch)",
    "display_name_fr": "Soupe de lentilles (1 tasse, style moyen-oriental)",
    "display_name_pt": "Sopa de lentilha (1 xícara, estilo Oriente Médio)",
    "display_name_tr": "Mercimek Çorbası (1 su bardağı Orta Doğu usulü)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Pantry",
        "name_en": "Red lentils",
        "name_es": "Lentejas rojas",
        "name_de": "Rote Linsen",
        "name_fr": "Lentilles rouges",
        "name_pt": "Lentilhas vermelhas",
        "name_tr": "Kırmızı mercimek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cumin",
        "name_es": "Comino",
        "name_de": "Kreuzkümmel",
        "name_fr": "Cumin",
        "name_pt": "Cominho",
        "name_tr": "Kimyon"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 16.0,
    "protein_g": 1.0,
    "carbohydrates_g": 3.0,
    "fat_g": 0.3,
    "fiber_g": 2.0,
    "sodium_mg": 10.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Lettuce (Romaine 2 cups)",
    "display_name_es": "Lechuga (Romana 2 tazas)",
    "display_name_de": "Salat (Römersalat 2 Tassen)",
    "display_name_fr": "Laitue (Romaine 2 tasses)",
    "display_name_pt": "Alface (2 xícaras de alface romana)",
    "display_name_tr": "Marul (Romaine 2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Romaine lettuce",
        "name_es": "Lechuga romana",
        "name_de": "Römersalat",
        "name_fr": "Laitue romaine",
        "name_pt": "Alface",
        "name_tr": "Marul"
      }
    ]
  },
  {
    "category": "Meal/Seafood",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 250.0,
    "protein_g": 8.0,
    "carbohydrates_g": 12.0,
    "fat_g": 18.0,
    "fiber_g": 1.0,
    "sodium_mg": 850.0,
    "cholesterol_mg": 50.0,
    "water_ml": 250.0,
    "display_name_en": "Lobster Bisque (1 cup)",
    "display_name_es": "Bisque de langosta (1 taza)",
    "display_name_de": "Hummersuppe (1 Tasse)",
    "display_name_fr": "Bisque de homard (1 tasse)",
    "display_name_pt": "Sopa cremosa de lagosta (1 xícara)",
    "display_name_tr": "Istakoz Çorbası (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme",
        "name_tr": "Krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lobster",
        "name_es": "Caldo de langosta",
        "name_de": "Hummer",
        "name_fr": "Homard",
        "name_pt": "Lagosta",
        "name_tr": "Istakoz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Broth",
        "name_es": "",
        "name_de": "Brühe",
        "name_fr": "Bouillon",
        "name_pt": "Caldo",
        "name_tr": "Et Suyu"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 350.0,
    "protein_g": 10.0,
    "carbohydrates_g": 40.0,
    "fat_g": 17.0,
    "fiber_g": 2.0,
    "sodium_mg": 750.0,
    "cholesterol_mg": 40.0,
    "water_ml": 250.0,
    "display_name_en": "Macaroni & Cheese (1 cup)",
    "display_name_es": "Macarrones con queso (1 taza)",
    "display_name_de": "Makkaroni mit Käse (1 Tasse)",
    "display_name_fr": "Macaronis au fromage (1 tasse)",
    "display_name_pt": "Macarrão com queijo (1 xícara)",
    "display_name_tr": "Makarna ve Peynir (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese",
        "name_es": "Queso cheddar",
        "name_de": "Cheddar-Käse",
        "name_fr": "Fromage cheddar",
        "name_pt": "Queijo cheddar",
        "name_tr": "Çedar peyniri"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Macaroni",
        "name_es": "Macarrones",
        "name_de": "Makkaroni",
        "name_fr": "Macaronis",
        "name_pt": "Macarrão",
        "name_tr": "Makarna"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 380.0,
    "protein_g": 8.0,
    "carbohydrates_g": 30.0,
    "fat_g": 25.0,
    "fiber_g": 3.0,
    "sodium_mg": 750.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Macaroni Salad (1 cup)",
    "display_name_es": "Ensalada de macarrones (1 taza)",
    "display_name_de": "Makkaronisalat (1 Tasse)",
    "display_name_fr": "Salade de macaronis (1 tasse)",
    "display_name_pt": "Salada de Macarrão (1 xícara)",
    "display_name_tr": "Makarna Salatası (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Peas (optional)",
        "name_es": "Guisantes (opcional)",
        "name_de": "Erbsen (optional)",
        "name_fr": "Petits pois (facultatif)",
        "name_pt": "Ervilhas (opcional)",
        "name_tr": "Bezelye (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Macaroni",
        "name_es": "Macarrones",
        "name_de": "Makkaroni",
        "name_fr": "Macaronis",
        "name_pt": "Macarrão",
        "name_tr": "Makarna"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mayonnaise",
        "name_es": "Mayonesa",
        "name_de": "Mayonnaise",
        "name_fr": "Mayonnaise",
        "name_pt": "Maionese",
        "name_tr": "Mayonez"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 580.0,
    "protein_g": 28.0,
    "carbohydrates_g": 55.0,
    "fat_g": 27.0,
    "fiber_g": 6.0,
    "sodium_mg": 1200.0,
    "cholesterol_mg": 70.0,
    "water_ml": 500.0,
    "display_name_en": "Meatball Sub (6 inch)",
    "display_name_es": "Submarino de albóndigas (6 pulgadas)",
    "display_name_de": "Fleischbällchen-Sub (15 cm)",
    "display_name_fr": "Sandwich aux boulettes de viande (15 cm)",
    "display_name_pt": "Sub de Almôndegas (15 cm)",
    "display_name_tr": "Köfteli Sandviç (6 inç)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion (in sauce)",
        "name_es": "Cebolla (en salsa)",
        "name_de": "Zwiebeln (in Soße)",
        "name_fr": "Oignon (en sauce)",
        "name_pt": "Cebola (em molho)",
        "name_tr": "Soğan (soslu)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "queso mozzarella",
        "name_de": "Mozzarella-Käse",
        "name_fr": "fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Meatballs",
        "name_es": "Albóndigas",
        "name_de": "Fleischbällchen",
        "name_fr": "Boulettes de viande",
        "name_pt": "Almôndegas",
        "name_tr": "Köfte"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sub roll",
        "name_es": "Rollito submarino",
        "name_de": "Brötchen",
        "name_fr": "Pain sous-marin",
        "name_pt": "Pão para sanduíche",
        "name_tr": "Sandviç ekmeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Marinara sauce",
        "name_es": "Salsa marinara",
        "name_de": "Marinara-Sauce",
        "name_fr": "Sauce marinara",
        "name_pt": "Molho marinara",
        "name_tr": "Marinara sosu"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 80.0,
    "protein_g": 6.0,
    "carbohydrates_g": 1.0,
    "fat_g": 6.0,
    "fiber_g": 0.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Mozzarella (1 slice)",
    "display_name_es": "Mozzarella (1 rebanada)",
    "display_name_de": "Mozzarella (1 Scheibe)",
    "display_name_fr": "Mozzarella (1 tranche)",
    "display_name_pt": "Muçarela (1 fatia)",
    "display_name_tr": "Mozzarella (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "queso mozzarella",
        "name_de": "Mozzarella-Käse",
        "name_fr": "fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 35.0,
    "protein_g": 0.2,
    "carbohydrates_g": 1.0,
    "fat_g": 3.5,
    "fiber_g": 0.5,
    "sodium_mg": 210.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Olives (Kalamata 5 large)",
    "display_name_es": "Aceitunas (Kalamata 5 grandes)",
    "display_name_de": "Oliven (Kalamata, 5 große)",
    "display_name_fr": "Olives (Kalamata 5 grosses)",
    "display_name_pt": "Azeitonas (Kalamata 5 grandes)",
    "display_name_tr": "Zeytin (Kalamata 5 büyük)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Kalamata olives",
        "name_es": "Aceitunas de Kalamata",
        "name_de": "Kalamata-Oliven",
        "name_fr": "olives de Kalamata",
        "name_pt": "Azeitonas Kalamata",
        "name_tr": "Kalamata zeytinleri"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 5.0,
    "protein_g": 0.3,
    "carbohydrates_g": 1.0,
    "fat_g": 0.1,
    "fiber_g": 0.5,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Parsley (1/4 cup in tabouli)",
    "display_name_es": "Perejil (1/4 taza en tabulé)",
    "display_name_de": "Petersilie (1/4 Tasse im Taboulé)",
    "display_name_fr": "Persil (1/4 de tasse dans le taboulé)",
    "display_name_pt": "Salsa (1/4 de xícara no tabule)",
    "display_name_tr": "Maydanoz (tabouli'de 1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsinha",
        "name_tr": "Maydanoz"
      }
    ]
  },
  {
    "category": "Meal/Pasta",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 280.0,
    "protein_g": 8.0,
    "carbohydrates_g": 30.0,
    "fat_g": 14.0,
    "fiber_g": 4.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Pasta Salad (1 cup)",
    "display_name_es": "Ensalada de pasta (1 taza)",
    "display_name_de": "Nudelsalat (1 Tasse)",
    "display_name_fr": "Salade de pâtes (1 tasse)",
    "display_name_pt": "Salada de massa (1 xícara)",
    "display_name_tr": "Makarna Salatası (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivron",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Feta cheese (optional)",
        "name_es": "Queso feta (opcional)",
        "name_de": "Feta-Käse (optional)",
        "name_fr": "Fromage feta (facultatif)",
        "name_pt": "Queijo feta (opcional)",
        "name_tr": "Feta peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pasta",
        "name_es": "Pasta",
        "name_de": "Pasta",
        "name_fr": "Pâtes",
        "name_pt": "Massa",
        "name_tr": "Makarna"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 390.0,
    "protein_g": 12.0,
    "carbohydrates_g": 50.0,
    "fat_g": 17.0,
    "fiber_g": 5.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Peanut Butter & Jelly Sandwich",
    "display_name_es": "Sándwich de mantequilla de maní y mermelada",
    "display_name_de": "Erdnussbutter- und Marmeladen-Sandwich",
    "display_name_fr": "Sandwich au beurre de cacahuète et à la confiture",
    "display_name_pt": "Sanduíche de manteiga de amendoim e geleia",
    "display_name_tr": "Fıstık Ezmesi ve Jöle Sandviç",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Peanut butter",
        "name_es": "Mantequilla de maní",
        "name_de": "Erdnussbutter",
        "name_fr": "Beurre de cacahuète",
        "name_pt": "Manteiga de amendoim",
        "name_tr": "Fıstık ezmesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Jam",
        "name_es": "Mermelada",
        "name_de": "Marmelade",
        "name_fr": "Confiture",
        "name_pt": "Geleia",
        "name_tr": "Reçel"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sandwich bread",
        "name_es": "Pan de sándwich",
        "name_de": "Sandwichbrot",
        "name_fr": "Pain de mie",
        "name_pt": "Pão de forma",
        "name_tr": "Sandviç ekmeği"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 10.0,
    "protein_g": 0.5,
    "carbohydrates_g": 2.0,
    "fat_g": 0.0,
    "fiber_g": 1.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pepperoncini (2 peppers)",
    "display_name_es": "Pepperoncini (2 pimientos)",
    "display_name_de": "Pepperoncini (2 Paprikaschoten)",
    "display_name_fr": "Pepperoncini (2 piments)",
    "display_name_pt": "Pimentas peperoncini (2 pimentas)",
    "display_name_tr": "Pepperoncini (2 biber)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Pepperoncini peppers",
        "name_es": "Pimientos pepperoncini",
        "name_de": "Peperoni",
        "name_fr": "poivrons Pepperoncini",
        "name_pt": "pimentas peperoncini",
        "name_tr": "Pepperoncini biberleri"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 500.0,
    "protein_g": 25.0,
    "carbohydrates_g": 40.0,
    "fat_g": 28.0,
    "fiber_g": 3.0,
    "sodium_mg": 1100.0,
    "cholesterol_mg": 70.0,
    "water_ml": 500.0,
    "display_name_en": "Philly Cheesesteak (6 inch)",
    "display_name_es": "Filete de queso Philly (6 pulgadas)",
    "display_name_de": "Philly Cheesesteak (15 cm)",
    "display_name_fr": "Philly Cheesesteak (15 cm)",
    "display_name_pt": "Philly Cheesesteak (15 cm)",
    "display_name_tr": "Philly Cheesesteak (6 inç)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Bell pepper",
        "name_es": "Pimiento morrón",
        "name_de": "Paprika",
        "name_fr": "Poivron",
        "name_pt": "Pimentão",
        "name_tr": "Dolmalık biber"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Provolone cheese",
        "name_es": "queso provolone",
        "name_de": "Provolone-Käse",
        "name_fr": "fromage provolone",
        "name_pt": "queijo Provolone",
        "name_tr": "Provolone peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Beef steak",
        "name_es": "Filete de res",
        "name_de": "Rindersteak",
        "name_fr": "Steak de bœuf",
        "name_pt": "Bife",
        "name_tr": "Dana biftek"
      },
      {
        "category_en": "Pantry",
        "name_en": "Hoagie roll",
        "name_es": "Panecillo hoagie",
        "name_de": "Hoagie-Brötchen",
        "name_fr": "Pain hoagie",
        "name_pt": "Pão tipo hoagie",
        "name_tr": "Hoagie rulosu"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 5.0,
    "protein_g": 0.2,
    "carbohydrates_g": 1.0,
    "fat_g": 0.1,
    "fiber_g": 0.3,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pickle (1 spear dill)",
    "display_name_es": "Encurtido (1 lanza de eneldo)",
    "display_name_de": "Essiggurke (1 Dillgurke)",
    "display_name_fr": "Cornichon (1 brin d'aneth)",
    "display_name_pt": "Picles (1 ramo de endro)",
    "display_name_tr": "Turşu (1 dal dereotu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      },
      {
        "category_en": "Pantry",
        "name_en": "Dill",
        "name_es": "Eneldo",
        "name_de": "Dill",
        "name_fr": "Aneth",
        "name_pt": "Endro",
        "name_tr": "Dereotu"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 10.0,
    "protein_g": 0.2,
    "carbohydrates_g": 2.0,
    "fat_g": 0.0,
    "fiber_g": 0.5,
    "sodium_mg": 200.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pickled Turnips (2 tbsp)",
    "display_name_es": "Nabos encurtidos (2 cucharadas)",
    "display_name_de": "Eingelegte Rüben (2 EL)",
    "display_name_fr": "Navets marinés (2 cuillères à soupe)",
    "display_name_pt": "Nabo em conserva (2 colheres de sopa)",
    "display_name_tr": "Turşu Şalgam (2 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Turnips",
        "name_es": "Nabos",
        "name_de": "Rüben",
        "name_fr": "Navets",
        "name_pt": "Nabo",
        "name_tr": "Şalgam"
      },
      {
        "category_en": "Produce",
        "name_en": "Beet (for color)",
        "name_es": "Remolacha (para dar color)",
        "name_de": "Rote Bete (für die Farbe)",
        "name_fr": "Betteraves (pour la couleur)",
        "name_pt": "Beterraba (para dar cor)",
        "name_tr": "Pancar (renklendirmek için)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vinegar",
        "name_es": "Vinagre",
        "name_de": "Essig",
        "name_fr": "Vinaigre",
        "name_pt": "Vinagre",
        "name_tr": "Sirke"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 130.0,
    "protein_g": 3.0,
    "carbohydrates_g": 18.0,
    "fat_g": 5.0,
    "fiber_g": 2.0,
    "sodium_mg": 240.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pita Crisps (1 oz)",
    "display_name_es": "Papas fritas de pita (1 oz)",
    "display_name_de": "Pita-Chips (1 oz)",
    "display_name_fr": "Chips de pita (1 oz)",
    "display_name_pt": "Pita Chips (1 oz)",
    "display_name_tr": "Pita Cipsleri (1 oz)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pita bread",
        "name_es": "Pan pita",
        "name_de": "Pitabrot",
        "name_fr": "Pain pita",
        "name_pt": "Pão pita",
        "name_tr": "Pide ekmeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 220.0,
    "protein_g": 8.0,
    "carbohydrates_g": 30.0,
    "fat_g": 8.0,
    "fiber_g": 2.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Pork Bun (1 steamed)",
    "display_name_es": "Bollo de cerdo (1 al vapor)",
    "display_name_de": "Schweinefleischbrötchen (1 gedämpft)",
    "display_name_fr": "Brioche au porc (1 cuite à la vapeur)",
    "display_name_pt": "Pãozinho de porco (1 cozido no vapor)",
    "display_name_tr": "Dana Çöreği (1 buharda pişirilmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Green onion (optional)",
        "name_es": "Cebolla verde (opcional)",
        "name_de": "Frühlingszwiebeln (optional)",
        "name_fr": "Oignon vert (facultatif)",
        "name_pt": "Cebolinha verde (opcional)",
        "name_tr": "Yeşil soğan (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pork filling",
        "name_es": "Relleno de cerdo",
        "name_de": "Schweinefleischfüllung",
        "name_fr": "Garniture de porc",
        "name_pt": "Recheio de porco",
        "name_tr": "Dana eti dolgusu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Steamed bun dough",
        "name_es": "Masa de pan al vapor",
        "name_de": "Gedämpfter Brötchenteig",
        "name_fr": "Pâte à brioche cuite à la vapeur",
        "name_pt": "Massa de pão cozida no vapor",
        "name_tr": "Buharda pişirilmiş çörek hamuru"
      }
    ]
  },
  {
    "category": "Meal/Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 4.0,
    "carbohydrates_g": 25.0,
    "fat_g": 7.0,
    "fiber_g": 3.0,
    "sodium_mg": 650.0,
    "cholesterol_mg": 15.0,
    "water_ml": 250.0,
    "display_name_en": "Potato Leek Soup (1 cup)",
    "display_name_es": "Sopa de papa y puerro (1 taza)",
    "display_name_de": "Kartoffel-Lauch-Suppe (1 Tasse)",
    "display_name_fr": "Soupe poireaux-pommes de terre (1 tasse)",
    "display_name_pt": "Sopa de batata com alho-poró (1 xícara)",
    "display_name_tr": "Patates Pırasa Çorbası (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Patata",
        "name_de": "Kartoffeln",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Produce",
        "name_en": "Leek",
        "name_es": "Puerro",
        "name_de": "Lauch",
        "name_fr": "Poireau",
        "name_pt": "Alho-poró",
        "name_tr": "Pırasa"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme",
        "name_tr": "Krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable broth",
        "name_es": "caldo de verduras",
        "name_de": "Gemüsebrühe",
        "name_fr": "bouillon de légumes",
        "name_pt": "Caldo de legumes",
        "name_tr": "Sebze suyu"
      }
    ]
  },
  {
    "category": "Meal/Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 2.0,
    "carbohydrates_g": 19.0,
    "fat_g": 11.0,
    "fiber_g": 2.0,
    "sodium_mg": 500.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Potato Salad (1/2 cup)",
    "display_name_es": "Ensalada de papa (1/2 taza)",
    "display_name_de": "Kartoffelsalat (1/2 Tasse)",
    "display_name_fr": "Salade de pommes de terre (1/2 tasse)",
    "display_name_pt": "Salada de batata (1/2 xícara)",
    "display_name_tr": "Patates Salatası (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg (optional)",
        "name_es": "Huevo (opcional)",
        "name_de": "Ei (optional)",
        "name_fr": "Œuf (facultatif)",
        "name_pt": "Ovo (opcional)",
        "name_tr": "Yumurta (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mayonnaise",
        "name_es": "Mayonesa",
        "name_de": "Mayonnaise",
        "name_fr": "Mayonnaise",
        "name_pt": "Maionese",
        "name_tr": "Mayonez"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mustard",
        "name_es": "Mostaza",
        "name_de": "Senf",
        "name_fr": "Moutarde",
        "name_pt": "Mostarda",
        "name_tr": "Hardal"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 230.0,
    "protein_g": 8.0,
    "carbohydrates_g": 45.0,
    "fat_g": 2.0,
    "fiber_g": 2.0,
    "sodium_mg": 550.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pretzel Bun (1 medium)",
    "display_name_es": "Pan de pretzel (1 mediano)",
    "display_name_de": "Brezelbrötchen (1 mittelgroß)",
    "display_name_fr": "Petit pain bretzel (1 moyen)",
    "display_name_pt": "Pãozinho de pretzel (1 médio)",
    "display_name_tr": "Simit Çörek (1 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pretzel bun",
        "name_es": "pan de pretzel",
        "name_de": "Brezelbrötchen",
        "name_fr": "pain bretzel",
        "name_pt": "Pão de pretzel",
        "name_tr": "Simit çöreği"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 480.0,
    "protein_g": 25.0,
    "carbohydrates_g": 48.0,
    "fat_g": 20.0,
    "fiber_g": 3.0,
    "sodium_mg": 900.0,
    "cholesterol_mg": 75.0,
    "water_ml": 250.0,
    "display_name_en": "Pulled Pork Sandwich",
    "display_name_es": "Sándwich de cerdo desmenuzado",
    "display_name_de": "Pulled Pork Sandwich",
    "display_name_fr": "Sandwich au porc effiloché",
    "display_name_pt": "Sanduíche de carne de porco desfiada",
    "display_name_tr": "Çekilmiş Dana Eti Sandviçi",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Coleslaw cabbage (optional)",
        "name_es": "Ensalada de col (opcional)",
        "name_de": "Krautsalat (optional)",
        "name_fr": "Salade de chou (facultatif)",
        "name_pt": "Repolho para salada coleslaw (opcional)",
        "name_tr": "Coleslaw lahana (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pulled pork",
        "name_es": "Cerdo desmenuzado",
        "name_de": "Pulled Pork",
        "name_fr": "Porc effiloché",
        "name_pt": "Carne de porco desfiada",
        "name_tr": "Çekilmiş Dana eti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Barbecue sauce",
        "name_es": "Salsa barbacoa",
        "name_de": "Barbecue-Sauce",
        "name_fr": "Sauce barbecue",
        "name_pt": "Molho barbecue",
        "name_tr": "Barbekü sosu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sandwich bun",
        "name_es": "Pan de sándwich",
        "name_de": "Sandwichbrötchen",
        "name_fr": "Pain à sandwich",
        "name_pt": "Pão de sanduíche",
        "name_tr": "Sandviç ekmeği"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 400.0,
    "protein_g": 18.0,
    "carbohydrates_g": 35.0,
    "fat_g": 22.0,
    "fiber_g": 3.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 50.0,
    "water_ml": 250.0,
    "display_name_en": "Quesadilla (Cheese 1 medium)",
    "display_name_es": "Quesadilla (Queso 1 mediano)",
    "display_name_de": "Quesadilla (Käse 1 mittelgroß)",
    "display_name_fr": "Quesadilla (Fromage 1 moyen)",
    "display_name_pt": "Quesadilla (Queijo 1 média)",
    "display_name_tr": "Quesadilla (Peynir 1 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Jalapeno (optional)",
        "name_es": "Jalapeño (opcional)",
        "name_de": "Jalapeno (optional)",
        "name_fr": "Jalapeno (facultatif)",
        "name_pt": "Jalapeño (opcional)",
        "name_tr": "Jalapeno (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese",
        "name_es": "Queso cheddar",
        "name_de": "Cheddar-Käse",
        "name_fr": "Fromage cheddar",
        "name_pt": "Queijo cheddar",
        "name_tr": "Cheddar peyniri"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Monterey Jack cheese",
        "name_es": "Queso Monterey Jack",
        "name_de": "Monterey-Jack-Käse",
        "name_fr": "Fromage Monterey Jack",
        "name_pt": "Queijo Monterey Jack",
        "name_tr": "Monterey Jack peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour tortilla",
        "name_es": "Tortilla de harina",
        "name_de": "Mehltortilla",
        "name_fr": "Tortilla à la farine",
        "name_pt": "Tortilha de farinha",
        "name_tr": "Un tortilla"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Meal/Vegetarian",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 260.0,
    "protein_g": 9.0,
    "carbohydrates_g": 32.0,
    "fat_g": 12.0,
    "fiber_g": 6.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Quinoa Salad (1 cup)",
    "display_name_es": "Ensalada de quinoa (1 taza)",
    "display_name_de": "Quinoa-Salat (1 Tasse)",
    "display_name_fr": "Salade de quinoa (1 tasse)",
    "display_name_pt": "Salada de Quinoa (1 xícara)",
    "display_name_tr": "Kinoa Salatası (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsinha",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Produce",
        "name_en": "Red onion",
        "name_es": "Cebolla roja",
        "name_de": "Rote Zwiebel",
        "name_fr": "Oignon rouge",
        "name_pt": "Cebola roxa",
        "name_tr": "Kırmızı soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Feta cheese (optional)",
        "name_es": "Queso feta (opcional)",
        "name_de": "Feta-Käse (optional)",
        "name_fr": "Fromage feta (facultatif)",
        "name_pt": "Queijo feta (opcional)",
        "name_tr": "Feta peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Quinoa",
        "name_es": "Quinoa",
        "name_de": "Quinoa",
        "name_fr": "Quinoa",
        "name_pt": "Quinoa",
        "name_tr": "Kinoa"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 380.0,
    "protein_g": 9.0,
    "carbohydrates_g": 53.0,
    "fat_g": 14.0,
    "fiber_g": 2.0,
    "sodium_mg": 1580.0,
    "cholesterol_mg": 0.0,
    "water_ml": 500.0,
    "display_name_en": "Ramen (Instant 1 pack)",
    "display_name_es": "Ramen (paquete instantáneo de 1)",
    "display_name_de": "Ramen (Instant, 1 Packung)",
    "display_name_fr": "Ramen (Instantané, 1 sachet)",
    "display_name_pt": "Ramen (Instantâneo, 1 pacote)",
    "display_name_tr": "Ramen (Hazır 1 paket)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Green onion (optional)",
        "name_es": "Cebolla verde (opcional)",
        "name_de": "Frühlingszwiebeln (optional)",
        "name_fr": "Oignon vert (facultatif)",
        "name_pt": "Cebolinha verde (opcional)",
        "name_tr": "Yeşil soğan (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg (optional)",
        "name_es": "Huevo (opcional)",
        "name_de": "Ei (optional)",
        "name_fr": "Œuf (facultatif)",
        "name_pt": "Ovo (opcional)",
        "name_tr": "Yumurta (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Instant ramen noodles",
        "name_es": "Fideos ramen instantáneos",
        "name_de": "Instant-Ramen-Nudeln",
        "name_fr": "Nouilles ramen instantanées",
        "name_pt": "Macarrão instantâneo ramen",
        "name_tr": "Hazır ramen eriştesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Seasoning packet",
        "name_es": "Paquete de condimentos",
        "name_de": "Gewürztüte",
        "name_fr": "Sachet d'assaisonnement",
        "name_pt": "Pacote de tempero",
        "name_tr": "Baharat paketi"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 650.0,
    "protein_g": 28.0,
    "carbohydrates_g": 35.0,
    "fat_g": 40.0,
    "fiber_g": 5.0,
    "sodium_mg": 1500.0,
    "cholesterol_mg": 100.0,
    "water_ml": 500.0,
    "display_name_en": "Reuben Sandwich",
    "display_name_es": "Sándwich Reuben",
    "display_name_de": "Reuben-Sandwich",
    "display_name_fr": "Sandwich Reuben",
    "display_name_pt": "Sanduíche Reuben",
    "display_name_tr": "Reuben Sandviç",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Sauerkraut",
        "name_es": "Chucrut",
        "name_de": "Sauerkraut",
        "name_fr": "Choucroute",
        "name_pt": "Chucrute",
        "name_tr": "Lahana turşusu"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Swiss cheese",
        "name_es": "queso suizo",
        "name_de": "Schweizer Käse",
        "name_fr": "fromage suisse",
        "name_pt": "queijo suíço",
        "name_tr": "İsviçre peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Corned beef",
        "name_es": "Carne en conserva",
        "name_de": "Corned Beef",
        "name_fr": "Bœuf salé",
        "name_pt": "Carne enlatada",
        "name_tr": "Konserve sığır eti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rye bread",
        "name_es": "Pan de centeno",
        "name_de": "Roggenbrot",
        "name_fr": "Pain de seigle",
        "name_pt": "Pão de centeio",
        "name_tr": "Çavdar ekmeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Russian dressing",
        "name_es": "Aderezo ruso",
        "name_de": "Russisches Dressing",
        "name_fr": "Sauce russe",
        "name_pt": "Molho russo",
        "name_tr": "Rus sosu"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 83.0,
    "protein_g": 2.7,
    "carbohydrates_g": 15.5,
    "fat_g": 1.1,
    "fiber_g": 1.9,
    "sodium_mg": 170.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Rye Bread (1 slice)",
    "display_name_es": "Pan de centeno (1 rebanada)",
    "display_name_de": "Roggenbrot (1 Scheibe)",
    "display_name_fr": "Pain de seigle (1 tranche)",
    "display_name_pt": "Pão de centeio (1 fatia)",
    "display_name_tr": "Çavdar Ekmeği (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Rye bread",
        "name_es": "Pan de centeno",
        "name_de": "Roggenbrot",
        "name_fr": "Pain de seigle",
        "name_pt": "Pão de centeio",
        "name_tr": "Çavdar ekmeği"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 70.0,
    "protein_g": 2.0,
    "carbohydrates_g": 14.0,
    "fat_g": 0.5,
    "fiber_g": 3.0,
    "sodium_mg": 120.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Rye Crispbread (2 slices)",
    "display_name_es": "Pan crujiente de centeno (2 rebanadas)",
    "display_name_de": "Roggenknäckebrot (2 Scheiben)",
    "display_name_fr": "Pain croustillant de seigle (2 tranches)",
    "display_name_pt": "Pão crocante de centeio (2 fatias)",
    "display_name_tr": "Çavdarlı Çıtır Ekmek (2 dilim)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Rye crispbread",
        "name_es": "Pan crujiente de centeno",
        "name_de": "Roggenknäckebrot",
        "name_fr": "pain croustillant de seigle",
        "name_pt": "pão crocante de centeio",
        "name_tr": "Çavdarlı çıtır ekmek"
      }
    ]
  },
  {
    "category": "Protein/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 110.0,
    "protein_g": 6.0,
    "carbohydrates_g": 1.0,
    "fat_g": 9.0,
    "fiber_g": 0.0,
    "sodium_mg": 500.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Salami (3 slices)",
    "display_name_es": "Salami (3 rebanadas)",
    "display_name_de": "Salami (3 Scheiben)",
    "display_name_fr": "Salami (3 tranches)",
    "display_name_pt": "Salame (3 fatias)",
    "display_name_tr": "Salam (3 dilim)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Salami",
        "name_es": "Salami",
        "name_de": "Salami",
        "name_fr": "Salami",
        "name_pt": "Salame",
        "name_tr": "Salam"
      }
    ]
  },
  {
    "category": "Grain/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 60.0,
    "protein_g": 1.0,
    "carbohydrates_g": 10.0,
    "fat_g": 1.5,
    "fiber_g": 0.5,
    "sodium_mg": 140.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Saltine Crackers (5 crackers)",
    "display_name_es": "Galletas saladas (5 galletas)",
    "display_name_de": "Salzcracker (5 Cracker)",
    "display_name_fr": "Biscuits salés (5 biscuits)",
    "display_name_pt": "Biscoitos salgados (5 biscoitos)",
    "display_name_tr": "Tuzlu Kraker (5 kraker)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Saltine crackers",
        "name_es": "Galletas saladas",
        "name_de": "Salzcracker",
        "name_fr": "crackers salés",
        "name_pt": "biscoitos salgados",
        "name_tr": "Tuzlu krakerler"
      }
    ]
  },
  {
    "category": "Protein/Fish",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 120.0,
    "protein_g": 18.0,
    "carbohydrates_g": 0.0,
    "fat_g": 5.0,
    "fiber_g": 0.0,
    "sodium_mg": 45.0,
    "cholesterol_mg": 40.0,
    "water_ml": 0.0,
    "display_name_en": "Sashimi (Salmon 3 pcs)",
    "display_name_es": "Sashimi (Salmón 3 piezas)",
    "display_name_de": "Sashimi (Lachs, 3 Stück)",
    "display_name_fr": "Sashimi (Saumon 3 pièces)",
    "display_name_pt": "Sashimi (Salmão - 3 unidades)",
    "display_name_tr": "Sashimi (Somon 3 adet)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Salmon",
        "name_es": "Salmón",
        "name_de": "Lachs",
        "name_fr": "Saumon",
        "name_pt": "Salmão",
        "name_tr": "Somon"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 14.0,
    "protein_g": 0.7,
    "carbohydrates_g": 3.1,
    "fat_g": 0.1,
    "fiber_g": 2.0,
    "sodium_mg": 468.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Sauerkraut (1/2 cup)",
    "display_name_es": "Chucrut (1/2 taza)",
    "display_name_de": "Sauerkraut (1/2 Tasse)",
    "display_name_fr": "Choucroute (1/2 tasse)",
    "display_name_pt": "Chucrute (1/2 xícara)",
    "display_name_tr": "Lahana turşusu (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cabbage",
        "name_es": "Repollo",
        "name_de": "Kohl",
        "name_fr": "Chou",
        "name_pt": "Repolho",
        "name_tr": "Lahana"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 7.0,
    "protein_g": 0.3,
    "carbohydrates_g": 1.5,
    "fat_g": 0.0,
    "fiber_g": 1.0,
    "sodium_mg": 234.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Sauerkraut (1/4 cup side)",
    "display_name_es": "Chucrut (1/4 taza de acompañamiento)",
    "display_name_de": "Sauerkraut (1/4 Tasse Beilage)",
    "display_name_fr": "Choucroute (1/4 tasse à part)",
    "display_name_pt": "Chucrute (1/4 de xícara como acompanhamento)",
    "display_name_tr": "Lahana turşusu (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cabbage",
        "name_es": "Repollo",
        "name_de": "Kohl",
        "name_fr": "Chou",
        "name_pt": "Repolho",
        "name_tr": "Lahana"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 60.0,
    "protein_g": 2.0,
    "carbohydrates_g": 8.0,
    "fat_g": 3.0,
    "fiber_g": 2.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Seaweed Salad (1/2 cup)",
    "display_name_es": "Ensalada de algas (1/2 taza)",
    "display_name_de": "Seetangsalat (1/2 Tasse)",
    "display_name_fr": "Salade d'algues (1/2 tasse)",
    "display_name_pt": "Salada de Algas Marinhas (1/2 xícara)",
    "display_name_tr": "Deniz Yosunu Salatası (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Seaweed",
        "name_es": "Algas",
        "name_de": "Algen",
        "name_fr": "Algues",
        "name_pt": "Algas marinhas",
        "name_tr": "Deniz Yosunu"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sesame oil",
        "name_es": "Aceite de sésamo",
        "name_de": "Sesamöl",
        "name_fr": "Huile de sésame",
        "name_pt": "Óleo de gergelim",
        "name_tr": "Susam yağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soy sauce",
        "name_es": "Salsa de soja",
        "name_de": "Sojasauce",
        "name_fr": "Sauce soja",
        "name_pt": "Molho de soja",
        "name_tr": "Soya sosu"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 550.0,
    "protein_g": 30.0,
    "carbohydrates_g": 50.0,
    "fat_g": 25.0,
    "fiber_g": 6.0,
    "sodium_mg": 1100.0,
    "cholesterol_mg": 80.0,
    "water_ml": 250.0,
    "display_name_en": "Shawarma (Chicken 1 wrap)",
    "display_name_es": "Shawarma (1 wrap de pollo)",
    "display_name_de": "Shawarma (Hähnchen-Wrap)",
    "display_name_fr": "Shawarma (1 wrap au poulet)",
    "display_name_pt": "Shawarma (1 wrap de frango)",
    "display_name_tr": "Şavurma (Tavuk 1 dürüm)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomaten",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Pickles",
        "name_es": "Pepinillos",
        "name_de": "Essiggurken",
        "name_fr": "Cornichons",
        "name_pt": "Picles",
        "name_tr": "Turşu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chicken",
        "name_es": "Pollo",
        "name_de": "Hähnchen",
        "name_fr": "Poulet",
        "name_pt": "Frango",
        "name_tr": "Tavuk"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pita bread",
        "name_es": "Pan pita",
        "name_de": "Pitabrot",
        "name_fr": "Pain pita",
        "name_pt": "Pão pita",
        "name_tr": "Pide ekmeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic sauce",
        "name_es": "Salsa de ajo",
        "name_de": "Knoblauchsauce",
        "name_fr": "Sauce à l'ail",
        "name_pt": "Molho de alho",
        "name_tr": "Sarımsak sosu"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 7.0,
    "protein_g": 0.9,
    "carbohydrates_g": 1.1,
    "fat_g": 0.1,
    "fiber_g": 0.7,
    "sodium_mg": 24.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Spinach (1 cup-raw)",
    "display_name_es": "Espinacas (1 taza cruda)",
    "display_name_de": "Spinat (1 Tasse - roh)",
    "display_name_fr": "Épinards (1 tasse crue)",
    "display_name_pt": "Espinafre (1 xícara - cru)",
    "display_name_tr": "Ispanak (1 su bardağı-çiğ)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Spinach",
        "name_es": "Espinaca",
        "name_de": "Spinat",
        "name_fr": "Épinard",
        "name_pt": "Espinafre",
        "name_tr": "Ispanak"
      }
    ]
  },
  {
    "category": "Meal/Legume",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 11.0,
    "carbohydrates_g": 30.0,
    "fat_g": 2.0,
    "fiber_g": 10.0,
    "sodium_mg": 700.0,
    "cholesterol_mg": 5.0,
    "water_ml": 250.0,
    "display_name_en": "Split Pea Soup (1 cup)",
    "display_name_es": "Sopa de guisantes partidos (1 taza)",
    "display_name_de": "Erbsensuppe (1 Tasse)",
    "display_name_fr": "Soupe aux pois cassés (1 tasse)",
    "display_name_pt": "Sopa de ervilha partida (1 xícara)",
    "display_name_tr": "Bezelye Çorbası (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Split peas",
        "name_es": "Guisantes partidos",
        "name_de": "Erbsen",
        "name_fr": "Pois cassés",
        "name_pt": "Ervilhas partidas",
        "name_tr": "Bezelye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable broth",
        "name_es": "Caldo de verduras",
        "name_de": "Gemüsebrühe",
        "name_fr": "Bouillon de légumes",
        "name_pt": "Caldo de legumes",
        "name_tr": "Sebze suyu"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 106.0,
    "protein_g": 7.6,
    "carbohydrates_g": 1.0,
    "fat_g": 8.0,
    "fiber_g": 0.0,
    "sodium_mg": 54.0,
    "cholesterol_mg": 26.0,
    "water_ml": 0.0,
    "display_name_en": "Swiss Cheese (1 slice)",
    "display_name_es": "Queso suizo (1 rebanada)",
    "display_name_de": "Schweizer Käse (1 Scheibe)",
    "display_name_fr": "Fromage suisse (1 tranche)",
    "display_name_pt": "Queijo suíço (1 fatia)",
    "display_name_tr": "İsviçre Peyniri (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Swiss cheese",
        "name_es": "queso suizo",
        "name_de": "Schweizer Käse",
        "name_fr": "fromage suisse",
        "name_pt": "queijo suíço",
        "name_tr": "İsviçre peyniri"
      }
    ]
  },
  {
    "category": "Meal/Vegetarian",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 120.0,
    "protein_g": 3.0,
    "carbohydrates_g": 15.0,
    "fat_g": 6.0,
    "fiber_g": 4.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Tabouli (1/2 cup)",
    "display_name_es": "Tabulé (1/2 taza)",
    "display_name_de": "Taboulé (1/2 Tasse)",
    "display_name_fr": "Taboulé (1/2 tasse)",
    "display_name_pt": "Tabule (1/2 xícara)",
    "display_name_tr": "Tabuli (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsa",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      },
      {
        "category_en": "Produce",
        "name_en": "Green onion",
        "name_es": "Cebolleta",
        "name_de": "Frühlingszwiebel",
        "name_fr": "Oignon vert",
        "name_pt": "Cebolinha",
        "name_tr": "Yeşil soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Mint",
        "name_es": "Menta",
        "name_de": "Minze",
        "name_fr": "Menthe",
        "name_pt": "Hortelã",
        "name_tr": "Nane"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bulgur",
        "name_es": "Bulgur",
        "name_de": "Bulgur",
        "name_fr": "Boulgour",
        "name_pt": "Bulgur",
        "name_tr": "Bulgur"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      }
    ]
  },
  {
    "category": "Protein/Vegetarian",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 160.0,
    "protein_g": 16.0,
    "carbohydrates_g": 8.0,
    "fat_g": 9.0,
    "fiber_g": 5.0,
    "sodium_mg": 10.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Tempeh (3oz)",
    "display_name_es": "Tempeh (3 oz)",
    "display_name_de": "Tempeh (3 oz)",
    "display_name_fr": "Tempeh (3 oz)",
    "display_name_pt": "Tempeh (85g)",
    "display_name_tr": "Tempeh (3oz)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Tempeh",
        "name_es": "Tempeh",
        "name_de": "Tempeh",
        "name_fr": "Tempeh",
        "name_pt": "Tempeh",
        "name_tr": "Tempeh"
      }
    ]
  },
  {
    "category": "Protein/Vegetarian",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 90.0,
    "protein_g": 10.0,
    "carbohydrates_g": 3.0,
    "fat_g": 5.0,
    "fiber_g": 2.0,
    "sodium_mg": 10.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Tofu (4oz firm)",
    "display_name_es": "Tofu (4 oz firme)",
    "display_name_de": "Tofu (113 g fest)",
    "display_name_fr": "Tofu (113 g ferme)",
    "display_name_pt": "Tofu (113 g firme)",
    "display_name_tr": "Tofu (4oz sert)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Firm tofu",
        "name_es": "Tofu firme",
        "name_de": "Fester Tofu",
        "name_fr": "Tofu ferme",
        "name_pt": "Tofu firme",
        "name_tr": "Sert tofu"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 22.0,
    "protein_g": 1.1,
    "carbohydrates_g": 4.8,
    "fat_g": 0.2,
    "fiber_g": 1.5,
    "sodium_mg": 6.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Tomato (1 medium sliced)",
    "display_name_es": "Tomate (1 mediano en rodajas)",
    "display_name_de": "Tomate (1 mittelgroße, in Scheiben geschnittene)",
    "display_name_fr": "Tomate (1 moyenne tranchée)",
    "display_name_pt": "Tomate (1 médio fatiado)",
    "display_name_tr": "Domates (1 orta boy dilimlenmiş)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      }
    ]
  },
  {
    "category": "Meal/Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 170.0,
    "protein_g": 4.0,
    "carbohydrates_g": 25.0,
    "fat_g": 6.0,
    "fiber_g": 4.0,
    "sodium_mg": 900.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Tomato Soup (1 can)",
    "display_name_es": "Sopa de tomate (1 lata)",
    "display_name_de": "Tomatensuppe (1 Dose)",
    "display_name_fr": "Soupe à la tomate (1 boîte)",
    "display_name_pt": "Sopa de tomate (1 lata)",
    "display_name_tr": "Domates Çorbası (1 kutu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream (optional)",
        "name_es": "Crema (opcional)",
        "name_de": "Sahne (optional)",
        "name_fr": "Crème (facultatif)",
        "name_pt": "Creme (opcional)",
        "name_tr": "Krema (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable broth",
        "name_es": "caldo de verduras",
        "name_de": "Gemüsebrühe",
        "name_fr": "bouillon de légumes",
        "name_pt": "Caldo de legumes",
        "name_tr": "Sebze suyu"
      }
    ]
  },
  {
    "category": "Protein/Fish",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 90.0,
    "protein_g": 20.0,
    "carbohydrates_g": 0.0,
    "fat_g": 1.0,
    "fiber_g": 0.0,
    "sodium_mg": 250.0,
    "cholesterol_mg": 35.0,
    "water_ml": 0.0,
    "display_name_en": "Tuna (Canned 3oz in water)",
    "display_name_es": "Atún (enlatado 3 oz en agua)",
    "display_name_de": "Thunfisch (3 oz in Wasser, Dose)",
    "display_name_fr": "Thon (en conserve, 85 g au naturel)",
    "display_name_pt": "Atum (enlatado de 85g em água)",
    "display_name_tr": "Ton Balığı (3oz suda konserve)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Canned tuna",
        "name_es": "Atún enlatado",
        "name_de": "Thunfisch aus der Dose",
        "name_fr": "Thon en conserve",
        "name_pt": "atum enlatado",
        "name_tr": "Konserve ton balığı"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 450.0,
    "protein_g": 25.0,
    "carbohydrates_g": 32.0,
    "fat_g": 25.0,
    "fiber_g": 3.0,
    "sodium_mg": 900.0,
    "cholesterol_mg": 50.0,
    "water_ml": 250.0,
    "display_name_en": "Tuna Melt",
    "display_name_es": "Atún fundido",
    "display_name_de": "Thunfisch-Melt",
    "display_name_fr": "Fondant au thon",
    "display_name_pt": "Atum derretido",
    "display_name_tr": "Ton Balığı Erimiş",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato (optional)",
        "name_es": "Tomate (opcional)",
        "name_de": "Tomate (optional)",
        "name_fr": "Tomate (facultatif)",
        "name_pt": "Tomate (opcional)",
        "name_tr": "Domates (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese",
        "name_es": "queso cheddar",
        "name_de": "Cheddar-Käse",
        "name_fr": "fromage cheddar",
        "name_pt": "Queijo cheddar",
        "name_tr": "Çedar peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Canned tuna",
        "name_es": "Atún enlatado",
        "name_de": "Thunfisch aus der Dose",
        "name_fr": "Thon en conserve",
        "name_pt": "Atum em lata",
        "name_tr": "Konserve ton balığı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mayonnaise",
        "name_es": "Mayonesa",
        "name_de": "Mayonnaise",
        "name_fr": "Mayonnaise",
        "name_pt": "Maionese",
        "name_tr": "Mayonez"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sandwich bread",
        "name_es": "Pan de sándwich",
        "name_de": "Sandwichbrot",
        "name_fr": "Pain de mie",
        "name_pt": "Pão de forma",
        "name_tr": "Sandviç ekmeği"
      }
    ]
  },
  {
    "category": "Meal/Fish",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 190.0,
    "protein_g": 19.0,
    "carbohydrates_g": 2.0,
    "fat_g": 12.0,
    "fiber_g": 1.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 30.0,
    "water_ml": 500.0,
    "display_name_en": "Tuna Salad (1/2 cup)",
    "display_name_es": "Ensalada de atún (1/2 taza)",
    "display_name_de": "Thunfischsalat (1/2 Tasse)",
    "display_name_fr": "Salade de thon (1/2 tasse)",
    "display_name_pt": "Salada de atum (1/2 xícara)",
    "display_name_tr": "Ton Balıklı Salata (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Pickle (optional)",
        "name_es": "Pepinillo (opcional)",
        "name_de": "Gewürzgurke (optional)",
        "name_fr": "Cornichon (facultatif)",
        "name_pt": "Picles (opcional)",
        "name_tr": "Turşu (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Canned tuna",
        "name_es": "Atún enlatado",
        "name_de": "Thunfisch aus der Dose",
        "name_fr": "Thon en conserve",
        "name_pt": "Atum em lata",
        "name_tr": "Konserve ton balığı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mayonnaise",
        "name_es": "Mayonesa",
        "name_de": "Mayonnaise",
        "name_fr": "Mayonnaise",
        "name_pt": "Maionese",
        "name_tr": "Mayonez"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 160.0,
    "protein_g": 22.0,
    "carbohydrates_g": 2.0,
    "fat_g": 8.0,
    "fiber_g": 0.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 70.0,
    "water_ml": 250.0,
    "display_name_en": "Turkey Burger (1 patty)",
    "display_name_es": "Hamburguesa de pavo (1 hamburguesa)",
    "display_name_de": "Truthahnburger (1 Patty)",
    "display_name_fr": "Burger de dinde (1 galette)",
    "display_name_pt": "Hambúrguer de peru (1 hambúrguer)",
    "display_name_tr": "Hindi Burger (1 köfte)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese (optional)",
        "name_es": "Queso cheddar (opcional)",
        "name_de": "Cheddar-Käse (optional)",
        "name_fr": "Fromage cheddar (facultatif)",
        "name_pt": "Queijo cheddar (opcional)",
        "name_tr": "Çedar peyniri (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Turkey patty",
        "name_es": "Hamburguesa de pavo",
        "name_de": "Putenfrikadelle",
        "name_fr": "Steak haché de dinde",
        "name_pt": "Hambúrguer de peru",
        "name_tr": "Hindi köftesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Burger bun",
        "name_es": "Pan de hamburguesa",
        "name_de": "Burgerbrötchen",
        "name_fr": "Pain à hamburger",
        "name_pt": "Pão de hambúrguer",
        "name_tr": "Burger ekmeği"
      }
    ]
  },
  {
    "category": "Meal/Processed",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 340.0,
    "protein_g": 22.0,
    "carbohydrates_g": 34.0,
    "fat_g": 12.0,
    "fiber_g": 5.0,
    "sodium_mg": 850.0,
    "cholesterol_mg": 50.0,
    "water_ml": 500.0,
    "display_name_en": "Turkey Sandwich (on wheat)",
    "display_name_es": "Sándwich de pavo (en trigo)",
    "display_name_de": "Truthahnsandwich (auf Weizenbrot)",
    "display_name_fr": "Sandwich à la dinde (sur pain de blé)",
    "display_name_pt": "Sanduíche de peru (no pão integral)",
    "display_name_tr": "Hindi Sandviç (buğday ekmeğinde)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Turkey slices",
        "name_es": "Rebanadas de pavo",
        "name_de": "Putenbrustscheiben",
        "name_fr": "Tranches de dinde",
        "name_pt": "Fatias de peru",
        "name_tr": "Hindi dilimleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Whole wheat bread",
        "name_es": "Pan integral",
        "name_de": "Vollkornbrot",
        "name_fr": "Pain complet",
        "name_pt": "Pão integral",
        "name_tr": "Tam buğday ekmeği"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mayonnaise",
        "name_es": "Mayonesa",
        "name_de": "Mayonnaise",
        "name_fr": "Mayonnaise",
        "name_pt": "Maionese",
        "name_tr": "Mayonez"
      }
    ]
  },
  {
    "category": "Meal/Vegetable",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 140.0,
    "protein_g": 4.0,
    "carbohydrates_g": 22.0,
    "fat_g": 4.0,
    "fiber_g": 6.0,
    "sodium_mg": 780.0,
    "cholesterol_mg": 5.0,
    "water_ml": 250.0,
    "display_name_en": "Vegetable Soup (1 can)",
    "display_name_es": "Sopa de verduras (1 lata)",
    "display_name_de": "Gemüsesuppe (1 Dose)",
    "display_name_fr": "Soupe aux légumes (1 boîte)",
    "display_name_pt": "Sopa de legumes (1 lata)",
    "display_name_tr": "Sebze Çorbası (1 kutu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotten",
        "name_fr": "Carottes",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      },
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomaten",
        "name_fr": "Tomates",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Green beans",
        "name_es": "Judías verdes",
        "name_de": "Grüne Bohnen",
        "name_fr": "Haricots verts",
        "name_pt": "Vagem",
        "name_tr": "Yeşil fasulye"
      },
      {
        "category_en": "Produce",
        "name_en": "Peas",
        "name_es": "Guisantes",
        "name_de": "Erbsen",
        "name_fr": "Petits pois",
        "name_pt": "Ervilha",
        "name_tr": "Bezelye"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vegetable broth",
        "name_es": "Caldo de verduras",
        "name_de": "Gemüsebrühe",
        "name_fr": "Bouillon de légumes",
        "name_pt": "Caldo de legumes",
        "name_tr": "Sebze suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pasta (optional)",
        "name_es": "Pasta (opcional)",
        "name_de": "Nudeln (optional)",
        "name_fr": "Pâtes (facultatif)",
        "name_pt": "Massa (opcional)",
        "name_tr": "Makarna (isteğe bağlı)"
      }
    ]
  },
  {
    "category": "Protein/Vegetarian",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 120.0,
    "protein_g": 11.0,
    "carbohydrates_g": 10.0,
    "fat_g": 4.0,
    "fiber_g": 5.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Veggie Burger (1 patty)",
    "display_name_es": "Hamburguesa vegetariana (1 hamburguesa)",
    "display_name_de": "Veggie-Burger (1 Patty)",
    "display_name_fr": "Burger végétarien (1 galette)",
    "display_name_pt": "Hambúrguer vegetariano (1 hambúrguer)",
    "display_name_tr": "Vejetaryen Burger (1 köfte)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lettuce",
        "name_es": "Lechuga",
        "name_de": "Salat",
        "name_fr": "Laitue",
        "name_pt": "Alface",
        "name_tr": "Marul"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomate",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Veggie burger patty",
        "name_es": "Hamburguesa vegetariana",
        "name_de": "Veggie-Burger-Patty",
        "name_fr": "Galette végétarienne pour burger",
        "name_pt": "Hambúrguer vegetariano",
        "name_tr": "Vejetaryen burger köftesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Burger bun",
        "name_es": "Pan de hamburguesa",
        "name_de": "Burgerbrötchen",
        "name_fr": "Pain à burger",
        "name_pt": "Pão de hambúrguer",
        "name_tr": "Burger ekmeği"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 380.0,
    "protein_g": 35.0,
    "carbohydrates_g": 3.0,
    "fat_g": 25.0,
    "fiber_g": 0.5,
    "sodium_mg": 600.0,
    "cholesterol_mg": 110.0,
    "water_ml": 0.0,
    "display_name_en": "Vitello Tonnato (1 serving)",
    "display_name_es": "Vitello Tonnato (1 porción)",
    "display_name_de": "Vitello Tonnato (1 Portion)",
    "display_name_fr": "Vitello Tonnato (1 portion)",
    "display_name_pt": "Vitello Tonnato (1 porção)",
    "display_name_tr": "Vitello Tonnato (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Produce",
        "name_en": "Capers",
        "name_es": "Alcaparras",
        "name_de": "Kapern",
        "name_fr": "Câpres",
        "name_pt": "Alcaparras",
        "name_tr": "Kapari"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsa",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg yolk (in sauce)",
        "name_es": "Yema de huevo (en salsa)",
        "name_de": "Eigelb (in Soße)",
        "name_fr": "Jaune d'œuf (en sauce)",
        "name_pt": "Gema de ovo (em molho)",
        "name_tr": "Yumurta sarısı (sos içinde)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Veal",
        "name_es": "Ternera",
        "name_de": "Kalbfleisch",
        "name_fr": "Veau",
        "name_pt": "Vitela",
        "name_tr": "Dana eti"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tuna",
        "name_es": "Atún",
        "name_de": "Thunfisch",
        "name_fr": "Thon",
        "name_pt": "Atum",
        "name_tr": "Ton balığı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Lunch",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 46.0,
    "protein_g": 1.1,
    "carbohydrates_g": 1.0,
    "fat_g": 4.6,
    "fiber_g": 0.5,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Walnuts (1 tbsp chopped)",
    "display_name_es": "Nueces (1 cucharada picadas)",
    "display_name_de": "Walnüsse (1 EL gehackt)",
    "display_name_fr": "Noix (1 cuillère à soupe hachée)",
    "display_name_pt": "Nozes (1 colher de sopa picada)",
    "display_name_tr": "Ceviz (1 yemek kaşığı doğranmış)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Walnuts",
        "name_es": "Nueces",
        "name_de": "Walnüsse",
        "name_fr": "Noix",
        "name_pt": "Nozes",
        "name_tr": "Cevizler"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Side",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 22.0,
    "protein_g": 1.7,
    "carbohydrates_g": 4.0,
    "fat_g": 0.4,
    "fiber_g": 2.4,
    "sodium_mg": 750.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Kimchi (1/2 cup)",
    "display_name_es": "Kimchi (1/2 taza)",
    "display_name_de": "Kimchi (1/2 Tasse)",
    "display_name_fr": "Kimchi (1/2 tasse)",
    "display_name_pt": "Kimchi (1/2 xícara)",
    "display_name_tr": "Kimçi (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cabbage",
        "name_es": "Repollo",
        "name_de": "Kohl",
        "name_fr": "Chou",
        "name_pt": "Repolho",
        "name_tr": "Lahana"
      },
      {
        "category_en": "Produce",
        "name_en": "Green onion",
        "name_es": "Cebolleta",
        "name_de": "Frühlingszwiebeln",
        "name_fr": "Oignon vert",
        "name_pt": "Cebolinha",
        "name_tr": "Yeşil soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Radish",
        "name_es": "Rábano",
        "name_de": "Radieschen",
        "name_fr": "Radis",
        "name_pt": "Rabanete",
        "name_tr": "Turp"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chili flakes",
        "name_es": "Hojuelas de chile",
        "name_de": "Chiliflocken",
        "name_fr": "Flocons de piment",
        "name_pt": "Flocos de pimenta",
        "name_tr": "Pul biber"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ginger",
        "name_es": "Jengibre",
        "name_de": "Ingwer",
        "name_fr": "Gingembre",
        "name_pt": "Gengibre",
        "name_tr": "Zencefil"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 2.0,
    "carbohydrates_g": 22.0,
    "fat_g": 10.0,
    "fiber_g": 1.0,
    "sodium_mg": 60.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Alfajores (1 cookie)",
    "display_name_es": "Alfajores (1 galleta)",
    "display_name_de": "Alfajores (1 Keks)",
    "display_name_fr": "Alfajores (1 biscuit)",
    "display_name_pt": "Alfajores (1 biscoito)",
    "display_name_tr": "Alfajores (1 kurabiye)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Alfajores cookie",
        "name_es": "Galleta de alfajores",
        "name_de": "Alfajores-Keks",
        "name_fr": "Biscuit Alfajores",
        "name_pt": "Biscoito Alfajores",
        "name_tr": "Alfajores kurabiyesi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Dulce de leche",
        "name_es": "dulce de leche",
        "name_de": "Dulce de Leche",
        "name_fr": "Dulce de lait",
        "name_pt": "Doce de leite",
        "name_tr": "Dulce de leche"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 164.0,
    "protein_g": 6.0,
    "carbohydrates_g": 6.0,
    "fat_g": 14.0,
    "fiber_g": 3.5,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Almonds (1 oz)",
    "display_name_es": "Almendras (1 oz)",
    "display_name_de": "Mandeln (1 oz)",
    "display_name_fr": "Amandes (1 oz)",
    "display_name_pt": "Amêndoas (28 g)",
    "display_name_tr": "Badem (1 ons)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Almonds",
        "name_es": "Almendras",
        "name_de": "Mandeln",
        "name_fr": "Amandes",
        "name_pt": "Amêndoas",
        "name_tr": "Badem"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 90.0,
    "protein_g": 2.0,
    "carbohydrates_g": 12.0,
    "fat_g": 4.0,
    "fiber_g": 1.0,
    "sodium_mg": 10.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Amaretti Cookie (2 cookies)",
    "display_name_es": "Galleta Amaretti (2 galletas)",
    "display_name_de": "Amaretti-Keks (2 Kekse)",
    "display_name_fr": "Biscuits amaretti (2 biscuits)",
    "display_name_pt": "Biscoito Amaretti (2 biscoitos)",
    "display_name_tr": "Amaretti Kurabiyesi (2 kurabiye)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Amaretti cookies",
        "name_es": "Galletas Amaretti",
        "name_de": "Amaretti-Kekse",
        "name_fr": "biscuits amaretti",
        "name_pt": "Biscoitos Amaretti",
        "name_tr": "Amaretti kurabiyeleri"
      }
    ]
  },
  {
    "category": "Snack",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 180.0,
    "protein_g": 6.0,
    "carbohydrates_g": 12.0,
    "fat_g": 12.0,
    "fiber_g": 3.0,
    "sodium_mg": 120.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Ants on a Log (4 pcs)",
    "display_name_es": "Hormigas en un tronco (4 piezas)",
    "display_name_de": "Ameisen auf einem Baumstamm (4 Stück)",
    "display_name_fr": "Fourmis sur une bûche (4 pièces)",
    "display_name_pt": "Formigas em um tronco (4 unidades)",
    "display_name_tr": "Kütükteki Karıncalar (4 adet)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Aipo",
        "name_tr": "Kereviz"
      },
      {
        "category_en": "Produce",
        "name_en": "Raisins",
        "name_es": "Pasas",
        "name_de": "Rosinen",
        "name_fr": "Raisins secs",
        "name_pt": "Uvas-passas",
        "name_tr": "Kuru üzüm"
      },
      {
        "category_en": "Pantry",
        "name_en": "Peanut butter",
        "name_es": "Manteca de cacahuete",
        "name_de": "Erdnussbutter",
        "name_fr": "beurre de cacahuète",
        "name_pt": "Manteiga de amendoim",
        "name_tr": "Fıstık ezmesi"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 0.0,
    "carbohydrates_g": 20.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 10.0,
    "cholesterol_mg": 0.0,
    "water_ml": 150.0,
    "display_name_en": "Aperol Spritz (1 drink)",
    "display_name_es": "Aperol Spritz (1 bebida)",
    "display_name_de": "Aperol Spritz (1 Getränk)",
    "display_name_fr": "Aperol Spritz (1 verre)",
    "display_name_pt": "Aperol Spritz (1 dose)",
    "display_name_tr": "Aperol Spritz (1 içecek)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Orange slice",
        "name_es": "rodaja de naranja",
        "name_de": "Orangenscheibe",
        "name_fr": "tranche d'orange",
        "name_pt": "fatia de laranja",
        "name_tr": "Portakal dilimi"
      },
      {
        "category_en": "Pantry",
        "name_en": "Aperol",
        "name_es": "Aperol",
        "name_de": "Aperol",
        "name_fr": "Aperol",
        "name_pt": "Aperol",
        "name_tr": "Aperol"
      },
      {
        "category_en": "Pantry",
        "name_en": "Prosecco",
        "name_es": "Prosecco",
        "name_de": "Prosecco",
        "name_fr": "Prosecco",
        "name_pt": "Prosecco",
        "name_tr": "Prosecco"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soda water",
        "name_es": "Agua con gas",
        "name_de": "Sodawasser",
        "name_fr": "Eau gazeuse",
        "name_pt": "Água com gás",
        "name_tr": "Soda"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 95.0,
    "protein_g": 0.5,
    "carbohydrates_g": 25.0,
    "fat_g": 0.3,
    "fiber_g": 4.4,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Apple",
    "display_name_es": "Manzana",
    "display_name_de": "Apfel",
    "display_name_fr": "Pomme",
    "display_name_pt": "Maçã",
    "display_name_tr": "Elma",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Apple",
        "name_es": "Manzana",
        "name_de": "Apfel",
        "name_fr": "Pomme",
        "name_pt": "Maçã",
        "name_tr": "Elma"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 410.0,
    "protein_g": 3.0,
    "carbohydrates_g": 58.0,
    "fat_g": 19.0,
    "fiber_g": 3.0,
    "sodium_mg": 320.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Apple Pie (1 slice)",
    "display_name_es": "Pastel de manzana (1 rebanada)",
    "display_name_de": "Apfelkuchen (1 Stück)",
    "display_name_fr": "Tarte aux pommes (1 part)",
    "display_name_pt": "Torta de maçã (1 fatia)",
    "display_name_tr": "Elmalı Turta (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Apple",
        "name_es": "Manzana",
        "name_de": "Apfel",
        "name_fr": "Pomme",
        "name_pt": "Maçã",
        "name_tr": "Elma"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Manteca",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pie crust",
        "name_es": "Masa de tarta",
        "name_de": "Kuchenteig",
        "name_fr": "Pâte à tarte",
        "name_pt": "Massa de torta",
        "name_tr": "Turta kabuğu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cinnamon",
        "name_es": "Canela",
        "name_de": "Zimt",
        "name_fr": "Cannelle",
        "name_pt": "Canela",
        "name_tr": "Tarçın"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 250.0,
    "protein_g": 9.0,
    "carbohydrates_g": 30.0,
    "fat_g": 10.0,
    "fiber_g": 3.0,
    "sodium_mg": 500.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Arancini (1 large ball)",
    "display_name_es": "Arancini (1 bola grande)",
    "display_name_de": "Arancini (1 große Kugel)",
    "display_name_fr": "Arancini (1 grosse boule)",
    "display_name_pt": "Arancini (1 bola grande)",
    "display_name_tr": "Arancini (1 büyük top)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Peas (optional)",
        "name_es": "Guisantes (opcional)",
        "name_de": "Erbsen (optional)",
        "name_fr": "Petits pois (facultatif)",
        "name_pt": "Ervilhas (opcional)",
        "name_tr": "Bezelye (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "queso mozzarella",
        "name_de": "Mozzarella-Käse",
        "name_fr": "fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice",
        "name_es": "Arroz",
        "name_de": "Reis",
        "name_fr": "Riz",
        "name_pt": "Arroz",
        "name_tr": "Pirinç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Breadcrumbs",
        "name_es": "Pan rallado",
        "name_de": "Paniermehl",
        "name_fr": "Chapelure",
        "name_pt": "Farinha de rosca",
        "name_tr": "Ekmek kırıntıları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Meal/Vegetable",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 100.0,
    "protein_g": 2.0,
    "carbohydrates_g": 8.0,
    "fat_g": 7.0,
    "fiber_g": 4.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Baba Ganoush (1/4 cup)",
    "display_name_es": "Baba Ganoush (1/4 taza)",
    "display_name_de": "Baba Ganoush (1/4 Tasse)",
    "display_name_fr": "Baba Ganoush (1/4 de tasse)",
    "display_name_pt": "Baba Ganoush (1/4 de xícara)",
    "display_name_tr": "Baba Ganuş (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Eggplant",
        "name_es": "Berenjena",
        "name_de": "Aubergine",
        "name_fr": "Aubergine",
        "name_pt": "Beringela",
        "name_tr": "Patlıcan"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tahini",
        "name_es": "Tahini",
        "name_de": "Tahini",
        "name_fr": "Tahini",
        "name_pt": "Tahine",
        "name_tr": "Tahin"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 280.0,
    "protein_g": 3.0,
    "carbohydrates_g": 30.0,
    "fat_g": 18.0,
    "fiber_g": 2.0,
    "sodium_mg": 80.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Baklava (1 piece)",
    "display_name_es": "Baklava (1 pieza)",
    "display_name_de": "Baklava (1 Stück)",
    "display_name_fr": "Baklava (1 pièce)",
    "display_name_pt": "Baklava (1 unidade)",
    "display_name_tr": "Baklava (1 adet)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Baklava",
        "name_es": "Baklava",
        "name_de": "Baklava",
        "name_fr": "Baklava",
        "name_pt": "Baklava",
        "name_tr": "Baklava"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 116.0,
    "protein_g": 9.4,
    "carbohydrates_g": 3.1,
    "fat_g": 7.2,
    "fiber_g": 0.5,
    "sodium_mg": 590.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Beef Jerky (1 oz)",
    "display_name_es": "Carne seca (1 oz)",
    "display_name_de": "Beef Jerky (1 oz)",
    "display_name_fr": "Viande séchée (1 oz)",
    "display_name_pt": "Carne seca (28 g)",
    "display_name_tr": "Sığır Eti Kurutulmuş Eti (1 oz)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Beef jerky",
        "name_es": "Carne seca",
        "name_de": "Beef Jerky",
        "name_fr": "Bœuf séché",
        "name_pt": "carne seca",
        "name_tr": "Sığır eti kurusu"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 110.0,
    "protein_g": 2.0,
    "carbohydrates_g": 18.0,
    "fat_g": 4.0,
    "fiber_g": 1.0,
    "sodium_mg": 50.0,
    "cholesterol_mg": 15.0,
    "water_ml": 0.0,
    "display_name_en": "Biscotti (1 cookie)",
    "display_name_es": "Biscotti (1 galleta)",
    "display_name_de": "Biscotti (1 Keks)",
    "display_name_fr": "Biscotti (1 biscuit)",
    "display_name_pt": "Biscotti (1 biscoito)",
    "display_name_tr": "Biscotti (1 kurabiye)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Almonds (optional)",
        "name_es": "Almendras (opcional)",
        "name_de": "Mandeln (optional)",
        "name_fr": "Amandes (facultatif)",
        "name_pt": "Amêndoas (opcional)",
        "name_tr": "Badem (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 62.0,
    "protein_g": 2.0,
    "carbohydrates_g": 13.8,
    "fat_g": 0.7,
    "fiber_g": 7.6,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Blackberries (1 cup)",
    "display_name_es": "Moras (1 taza)",
    "display_name_de": "Brombeeren (1 Tasse)",
    "display_name_fr": "Mûres (1 tasse)",
    "display_name_pt": "Amoras (1 xícara)",
    "display_name_tr": "Böğürtlen (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Blackberries",
        "name_es": "Moras",
        "name_de": "Brombeeren",
        "name_fr": "mûres",
        "name_pt": "amoras",
        "name_tr": "Böğürtlen"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 100.0,
    "protein_g": 6.0,
    "carbohydrates_g": 0.7,
    "fat_g": 8.0,
    "fiber_g": 0.0,
    "sodium_mg": 325.0,
    "cholesterol_mg": 21.0,
    "water_ml": 0.0,
    "display_name_en": "Blue Cheese (1 oz)",
    "display_name_es": "Queso azul (1 oz)",
    "display_name_de": "Blauschimmelkäse (1 oz)",
    "display_name_fr": "Fromage bleu (1 oz)",
    "display_name_pt": "Queijo Azul (28 g)",
    "display_name_tr": "Mavi Peynir (1 ons)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Blue cheese",
        "name_es": "queso azul",
        "name_de": "Blauschimmelkäse",
        "name_fr": "Fromage bleu",
        "name_pt": "Queijo azul",
        "name_tr": "Mavi peynir"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 95.0,
    "protein_g": 6.0,
    "carbohydrates_g": 0.1,
    "fat_g": 7.9,
    "fiber_g": 0.0,
    "sodium_mg": 178.0,
    "cholesterol_mg": 28.0,
    "water_ml": 0.0,
    "display_name_en": "Brie Cheese (1 oz)",
    "display_name_es": "Queso Brie (1 oz)",
    "display_name_de": "Brie-Käse (1 oz)",
    "display_name_fr": "Fromage Brie (1 oz)",
    "display_name_pt": "Queijo Brie (28 g)",
    "display_name_tr": "Brie Peyniri (1 ons)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Brie cheese",
        "name_es": "queso brie",
        "name_de": "Brie-Käse",
        "name_fr": "fromage Brie",
        "name_pt": "Queijo Brie",
        "name_tr": "Brie peyniri"
      }
    ]
  },
  {
    "category": "Snack/Appetizer",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 180.0,
    "protein_g": 4.0,
    "carbohydrates_g": 25.0,
    "fat_g": 7.0,
    "fiber_g": 3.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Bruschetta (2 pcs)",
    "display_name_es": "Bruschetta (2 piezas)",
    "display_name_de": "Bruschetta (2 Stück)",
    "display_name_fr": "Bruschetta (2 pièces)",
    "display_name_pt": "Bruschetta (2 unidades)",
    "display_name_tr": "Bruschetta (2 adet)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomaten",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Basil",
        "name_es": "Albahaca",
        "name_de": "Basilikum",
        "name_fr": "Basilic",
        "name_pt": "Manjericão",
        "name_tr": "Fesleğen"
      },
      {
        "category_en": "Pantry",
        "name_en": "Baguette slices",
        "name_es": "Rebanadas de baguette",
        "name_de": "Baguettescheiben",
        "name_fr": "Tranches de baguette",
        "name_pt": "Fatias de baguete",
        "name_tr": "Baget dilimleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 320.0,
    "protein_g": 2.0,
    "carbohydrates_g": 70.0,
    "fat_g": 4.0,
    "fiber_g": 1.0,
    "sodium_mg": 100.0,
    "cholesterol_mg": 10.0,
    "water_ml": 473.0,
    "display_name_en": "Bubble Tea (16 oz milk tea)",
    "display_name_es": "Té de burbujas (té con leche de 16 oz)",
    "display_name_de": "Bubble Tea (16 oz Milchtee)",
    "display_name_fr": "Bubble Tea (thé au lait de 473 ml)",
    "display_name_pt": "Chá de bolhas (chá com leite de 473 ml)",
    "display_name_tr": "Bubble Tea (16 oz sütlü çay)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tapioca pearls",
        "name_es": "Perlas de tapioca",
        "name_de": "Tapiokaperlen",
        "name_fr": "perles de tapioca",
        "name_pt": "Pérolas de tapioca",
        "name_tr": "Tapioka incileri"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tea",
        "name_es": "Té",
        "name_de": "Tee",
        "name_fr": "Thé",
        "name_pt": "Chá",
        "name_tr": "Çay"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar syrup",
        "name_es": "Jarabe de azúcar",
        "name_de": "Zuckersirup",
        "name_fr": "Sirop de sucre",
        "name_pt": "Xarope de açúcar",
        "name_tr": "Şeker şurubu"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 85.0,
    "protein_g": 0.0,
    "carbohydrates_g": 10.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 25.0,
    "cholesterol_mg": 0.0,
    "water_ml": 150.0,
    "display_name_en": "Campari & Soda (1 drink)",
    "display_name_es": "Campari & Soda (1 bebida)",
    "display_name_de": "Campari & Soda (1 Getränk)",
    "display_name_fr": "Campari & Soda (1 boisson)",
    "display_name_pt": "Campari e refrigerante (1 bebida)",
    "display_name_tr": "Campari & Soda (1 içecek)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Orange slice (optional)",
        "name_es": "Rodaja de naranja (opcional)",
        "name_de": "Orangenscheibe (optional)",
        "name_fr": "Tranche d'orange (facultatif)",
        "name_pt": "Fatia de laranja (opcional)",
        "name_tr": "Portakal dilimi (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Campari",
        "name_es": "Campari",
        "name_de": "Campari",
        "name_fr": "Campari",
        "name_pt": "Campari",
        "name_tr": "Campari"
      },
      {
        "category_en": "Pantry",
        "name_en": "Soda water",
        "name_es": "Agua con gas",
        "name_de": "Sodawasser",
        "name_fr": "Eau gazeuse",
        "name_pt": "Água com gás",
        "name_tr": "Soda suyu"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 30.0,
    "protein_g": 0.0,
    "carbohydrates_g": 8.0,
    "fat_g": 0.0,
    "fiber_g": 0.5,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Candied Fruit (1 tbsp)",
    "display_name_es": "Fruta confitada (1 cucharada)",
    "display_name_de": "Kandierte Früchte (1 EL)",
    "display_name_fr": "Fruits confits (1 cuillère à soupe)",
    "display_name_pt": "Frutas cristalizadas (1 colher de sopa)",
    "display_name_tr": "Şekerlenmiş Meyve (1 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Mixed fruit",
        "name_es": "Frutas mixtas",
        "name_de": "Gemischte Früchte",
        "name_fr": "Fruits mélangés",
        "name_pt": "Frutas mistas",
        "name_tr": "Karışık meyve"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar syrup",
        "name_es": "jarabe de azúcar",
        "name_de": "Zuckersirup",
        "name_fr": "sirop de sucre",
        "name_pt": "Xarope de açúcar",
        "name_tr": "Şeker şurubu"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 240.0,
    "protein_g": 5.0,
    "carbohydrates_g": 25.0,
    "fat_g": 13.0,
    "fiber_g": 1.0,
    "sodium_mg": 100.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Cannoli (1 medium)",
    "display_name_es": "Cannoli (1 mediano)",
    "display_name_de": "Cannoli (1 mittelgroß)",
    "display_name_fr": "Cannoli (1 moyen)",
    "display_name_pt": "Cannoli (1 médio)",
    "display_name_tr": "Cannoli (1 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Orange zest",
        "name_es": "ralladura de naranja",
        "name_de": "Orangenschale",
        "name_fr": "zeste d'orange",
        "name_pt": "raspas de laranja",
        "name_tr": "Portakal kabuğu rendesi"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Ricotta cheese",
        "name_es": "Queso ricotta",
        "name_de": "Ricotta-Käse",
        "name_fr": "fromage ricotta",
        "name_pt": "Queijo Ricota",
        "name_tr": "Ricotta peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cannoli shell",
        "name_es": "Concha de cannoli",
        "name_de": "Cannoli-Hülle",
        "name_fr": "Coquille de cannoli",
        "name_pt": "Casquinha de cannoli",
        "name_tr": "Cannoli kabuğu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 52.0,
    "protein_g": 1.2,
    "carbohydrates_g": 12.3,
    "fat_g": 0.3,
    "fiber_g": 3.6,
    "sodium_mg": 88.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Carrot Sticks (1 cup)",
    "display_name_es": "Palitos de zanahoria (1 taza)",
    "display_name_de": "Karottenstifte (1 Tasse)",
    "display_name_fr": "Bâtonnets de carottes (1 tasse)",
    "display_name_pt": "Palitos de cenoura (1 xícara)",
    "display_name_tr": "Havuç Çubukları (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Carrot",
        "name_es": "Zanahoria",
        "name_de": "Karotte",
        "name_fr": "Carotte",
        "name_pt": "Cenoura",
        "name_tr": "Havuç"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 163.0,
    "protein_g": 4.3,
    "carbohydrates_g": 9.2,
    "fat_g": 13.1,
    "fiber_g": 0.9,
    "sodium_mg": 140.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Cashews (1 oz roasted)",
    "display_name_es": "Anacardos (1 oz tostados)",
    "display_name_de": "Cashewnüsse (1 oz geröstet)",
    "display_name_fr": "Noix de cajou (1 oz grillées)",
    "display_name_pt": "Castanhas de caju (30 g torradas)",
    "display_name_tr": "Kaju fıstığı (28 gr kavrulmuş)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Cashews",
        "name_es": "Anacardos",
        "name_de": "Cashewnüsse",
        "name_fr": "noix de cajou",
        "name_pt": "Castanhas de caju",
        "name_tr": "Kaju fıstığı"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 14.0,
    "protein_g": 0.6,
    "carbohydrates_g": 3.0,
    "fat_g": 0.2,
    "fiber_g": 1.4,
    "sodium_mg": 77.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Celery Sticks (1 cup)",
    "display_name_es": "Palitos de apio (1 taza)",
    "display_name_de": "Selleriestangen (1 Tasse)",
    "display_name_fr": "Bâtonnets de céleri (1 tasse)",
    "display_name_pt": "Talos de aipo (1 xícara)",
    "display_name_tr": "Kereviz Sapları (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Celery",
        "name_es": "Apio",
        "name_de": "Sellerie",
        "name_fr": "Céleri",
        "name_pt": "Salsão",
        "name_tr": "Kereviz"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 190.0,
    "protein_g": 7.0,
    "carbohydrates_g": 32.0,
    "fat_g": 4.0,
    "fiber_g": 1.0,
    "sodium_mg": 105.0,
    "cholesterol_mg": 15.0,
    "water_ml": 355.0,
    "display_name_en": "Chai Latte (12 oz)",
    "display_name_es": "Chai Latte (355 ml)",
    "display_name_de": "Chai Latte (355 ml)",
    "display_name_fr": "Chai Latte (35 cl)",
    "display_name_pt": "Chai Latte (355 ml)",
    "display_name_tr": "Chai Latte (12 oz)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Black tea",
        "name_es": "Té negro",
        "name_de": "Schwarzer Tee",
        "name_fr": "Thé noir",
        "name_pt": "Chá preto",
        "name_tr": "Siyah çay"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chai spices",
        "name_es": "Especias chai",
        "name_de": "Chai-Gewürze",
        "name_fr": "Épices chai",
        "name_pt": "Especiarias chai",
        "name_tr": "Chai baharatları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 115.0,
    "protein_g": 7.0,
    "carbohydrates_g": 1.0,
    "fat_g": 9.5,
    "fiber_g": 0.0,
    "sodium_mg": 180.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Cheddar Cheese (1 oz)",
    "display_name_es": "Queso cheddar (1 oz)",
    "display_name_de": "Cheddar-Käse (1 oz)",
    "display_name_fr": "Fromage cheddar (1 oz)",
    "display_name_pt": "Queijo Cheddar (28 g)",
    "display_name_tr": "Çedar Peyniri (1 oz)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cheddar cheese",
        "name_es": "queso cheddar",
        "name_de": "Cheddar-Käse",
        "name_fr": "fromage cheddar",
        "name_pt": "Queijo cheddar",
        "name_tr": "Çedar peyniri"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 320.0,
    "protein_g": 5.0,
    "carbohydrates_g": 28.0,
    "fat_g": 21.0,
    "fiber_g": 1.0,
    "sodium_mg": 280.0,
    "cholesterol_mg": 65.0,
    "water_ml": 250.0,
    "display_name_en": "Cheesecake (1 slice)",
    "display_name_es": "Tarta de queso (1 rebanada)",
    "display_name_de": "Käsekuchen (1 Stück)",
    "display_name_fr": "Gâteau au fromage (1 part)",
    "display_name_pt": "Cheesecake (1 fatia)",
    "display_name_tr": "Cheesecake (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon zest (optional)",
        "name_es": "Ralladura de limón (opcional)",
        "name_de": "Zitronenschale (optional)",
        "name_fr": "zeste de citron (facultatif)",
        "name_pt": "Raspas de limão (opcional)",
        "name_tr": "Limon kabuğu rendesi (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream cheese",
        "name_es": "Queso crema",
        "name_de": "Frischkäse",
        "name_fr": "Fromage à la crème",
        "name_pt": "Queijo cremoso",
        "name_tr": "Krema peyniri"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Sour cream",
        "name_es": "Crema agria",
        "name_de": "Saure Sahne",
        "name_fr": "Crème fraîche",
        "name_pt": "Creme de leite",
        "name_tr": "Ekşi krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Graham cracker crust",
        "name_es": "Base de galleta Graham",
        "name_de": "Graham-Cracker-Boden",
        "name_fr": "Croûte de biscuits Graham",
        "name_pt": "Crosta de biscoito Graham",
        "name_tr": "Graham kraker kabuğu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 77.0,
    "protein_g": 1.6,
    "carbohydrates_g": 19.0,
    "fat_g": 0.5,
    "fiber_g": 2.5,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Cherries (1 cup)",
    "display_name_es": "Cerezas (1 taza)",
    "display_name_de": "Kirschen (1 Tasse)",
    "display_name_fr": "Cerises (1 tasse)",
    "display_name_pt": "Cerejas (1 xícara)",
    "display_name_tr": "Kiraz (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cherries",
        "name_es": "Guindas",
        "name_de": "Kirschen",
        "name_fr": "Cerises",
        "name_pt": "Cerejas",
        "name_tr": "Kirazlar"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 25.0,
    "protein_g": 0.3,
    "carbohydrates_g": 3.0,
    "fat_g": 1.5,
    "fiber_g": 0.2,
    "sodium_mg": 4.0,
    "cholesterol_mg": 1.0,
    "water_ml": 0.0,
    "display_name_en": "Chocolate (Hershey's bar 1 segment)",
    "display_name_es": "Chocolate (barra Hershey's 1 segmento)",
    "display_name_de": "Schokolade (Hershey's Riegel, 1 Segment)",
    "display_name_fr": "Chocolat (barre Hershey's, 1 segment)",
    "display_name_pt": "Chocolate (1 segmento de barra Hershey's)",
    "display_name_tr": "Çikolata (Hershey's bar 1 segment)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Milk chocolate",
        "name_es": "Chocolate con leche",
        "name_de": "Vollmilchschokolade",
        "name_fr": "Chocolat au lait",
        "name_pt": "Chocolate ao leite",
        "name_tr": "Sütlü çikolata"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 220.0,
    "protein_g": 2.5,
    "carbohydrates_g": 30.0,
    "fat_g": 11.0,
    "fiber_g": 1.5,
    "sodium_mg": 160.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Chocolate Chip Cookie (1 large)",
    "display_name_es": "Galleta con chispas de chocolate (1 grande)",
    "display_name_de": "Schokoladenkekse (1 großer)",
    "display_name_fr": "Cookie aux pépites de chocolat (1 grand)",
    "display_name_pt": "Cookie com gotas de chocolate (1 grande)",
    "display_name_tr": "Çikolatalı Kurabiye (1 büyük)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chocolate chips",
        "name_es": "Chispas de chocolate",
        "name_de": "Schokoladenstückchen",
        "name_fr": "Pépites de chocolat",
        "name_pt": "Gotas de chocolate",
        "name_tr": "Çikolata parçaları"
      }
    ]
  },
  {
    "category": "Beverage/Dairy",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 200.0,
    "protein_g": 8.0,
    "carbohydrates_g": 26.0,
    "fat_g": 8.0,
    "fiber_g": 1.0,
    "sodium_mg": 160.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Chocolate Milk (1 cup)",
    "display_name_es": "Leche con chocolate (1 taza)",
    "display_name_de": "Schokoladenmilch (1 Tasse)",
    "display_name_fr": "Lait chocolaté (1 tasse)",
    "display_name_pt": "Leite com chocolate (1 xícara)",
    "display_name_tr": "Çikolatalı Süt (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cocoa powder",
        "name_es": "Cacao en polvo",
        "name_de": "Kakaopulver",
        "name_fr": "Cacao en poudre",
        "name_pt": "Cacau em pó",
        "name_tr": "Kakao tozu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 150.0,
    "protein_g": 2.0,
    "carbohydrates_g": 28.0,
    "fat_g": 4.0,
    "fiber_g": 2.0,
    "sodium_mg": 130.0,
    "cholesterol_mg": 2.0,
    "water_ml": 0.0,
    "display_name_en": "Chocolate Pudding (1/2 cup)",
    "display_name_es": "Pudín de chocolate (1/2 taza)",
    "display_name_de": "Schokoladenpudding (1/2 Tasse)",
    "display_name_fr": "Pouding au chocolat (1/2 tasse)",
    "display_name_pt": "Pudim de chocolate (1/2 xícara)",
    "display_name_tr": "Çikolatalı Puding (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cocoa powder",
        "name_es": "Cacao en polvo",
        "name_de": "Kakaopulver",
        "name_fr": "Cacao en poudre",
        "name_pt": "Cacau em pó",
        "name_tr": "Kakao tozu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cornstarch",
        "name_es": "Maicena",
        "name_de": "Maisstärke",
        "name_fr": "Fécule de maïs",
        "name_pt": "Amido de milho",
        "name_tr": "Mısır nişastası"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 240.0,
    "protein_g": 3.0,
    "carbohydrates_g": 30.0,
    "fat_g": 12.0,
    "fiber_g": 1.5,
    "sodium_mg": 200.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Churros (2 sticks)",
    "display_name_es": "Churros (2 palitos)",
    "display_name_de": "Churros (2 Stück)",
    "display_name_fr": "Churros (2 bâtonnets)",
    "display_name_pt": "Churros (2 palitos)",
    "display_name_tr": "Churros (2 çubuk)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 110.0,
    "protein_g": 1.0,
    "carbohydrates_g": 4.5,
    "fat_g": 10.5,
    "fiber_g": 2.0,
    "sodium_mg": 3.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Coconut (shredded 1/4 cup)",
    "display_name_es": "Coco (rallado 1/4 taza)",
    "display_name_de": "Kokosraspeln (1/4 Tasse)",
    "display_name_fr": "Noix de coco (râpée, 1/4 de tasse)",
    "display_name_pt": "Coco ralado (1/4 de xícara)",
    "display_name_tr": "Hindistan cevizi (rendelenmiş 1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Coconut",
        "name_es": "Coco",
        "name_de": "Kokosnuss",
        "name_fr": "Noix de coco",
        "name_pt": "Coco",
        "name_tr": "Hindistan cevizi"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 10.0,
    "protein_g": 0.1,
    "carbohydrates_g": 0.5,
    "fat_g": 1.0,
    "fiber_g": 0.2,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Coconut (shredded garnish)",
    "display_name_es": "Coco (guarnición rallada)",
    "display_name_de": "Kokosraspeln (zum Garnieren)",
    "display_name_fr": "Noix de coco (garniture râpée)",
    "display_name_pt": "Coco ralado (para decorar)",
    "display_name_tr": "Hindistan cevizi (rendelenmiş garnitür)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Coconut",
        "name_es": "Coco",
        "name_de": "Kokosnuss",
        "name_fr": "Noix de coco",
        "name_pt": "Coco",
        "name_tr": "Hindistan cevizi"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 132.0,
    "protein_g": 4.7,
    "carbohydrates_g": 30.0,
    "fat_g": 1.8,
    "fiber_g": 3.6,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Corn (1 cup)",
    "display_name_es": "Maíz (1 taza)",
    "display_name_de": "Mais (1 Tasse)",
    "display_name_fr": "Maïs (1 tasse)",
    "display_name_pt": "Milho (1 xícara)",
    "display_name_tr": "Mısır (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Corn kernels",
        "name_es": "Granos de maíz",
        "name_de": "Maiskörner",
        "name_fr": "grains de maïs",
        "name_pt": "grãos de milho",
        "name_tr": "Mısır taneleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Butter (optional)",
        "name_es": "Mantequilla (opcional)",
        "name_de": "Butter (optional)",
        "name_fr": "Beurre (facultatif)",
        "name_pt": "Manteiga (opcional)",
        "name_tr": "Tereyağı (isteğe bağlı)"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 130.0,
    "protein_g": 2.0,
    "carbohydrates_g": 23.0,
    "fat_g": 4.0,
    "fiber_g": 2.0,
    "sodium_mg": 180.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Corn Nuts (1 oz)",
    "display_name_es": "Nueces de maíz (1 oz)",
    "display_name_de": "Maiskörner (1 oz)",
    "display_name_fr": "Noix de maïs (1 oz)",
    "display_name_pt": "Corn Nuts (28 g)",
    "display_name_tr": "Mısır Fıstığı (1 ons)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Corn kernels",
        "name_es": "Granos de maíz",
        "name_de": "Maiskörner",
        "name_fr": "grains de maïs",
        "name_pt": "grãos de milho",
        "name_tr": "Mısır taneleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 90.0,
    "protein_g": 12.0,
    "carbohydrates_g": 5.0,
    "fat_g": 3.0,
    "fiber_g": 0.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Cottage Cheese (1/2 cup)",
    "display_name_es": "Requesón (1/2 taza)",
    "display_name_de": "Hüttenkäse (1/2 Tasse)",
    "display_name_fr": "Fromage cottage (1/2 tasse)",
    "display_name_pt": "Queijo cottage (1/2 xícara)",
    "display_name_tr": "Süzme Peynir (1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cottage cheese",
        "name_es": "Requesón",
        "name_de": "Hüttenkäse",
        "name_fr": "Fromage blanc",
        "name_pt": "Queijo tipo cottage",
        "name_tr": "Süzme peynir"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 16.0,
    "protein_g": 0.7,
    "carbohydrates_g": 3.6,
    "fat_g": 0.1,
    "fiber_g": 0.5,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Cucumber Slices (1 cup)",
    "display_name_es": "Rodajas de pepino (1 taza)",
    "display_name_de": "Gurkenscheiben (1 Tasse)",
    "display_name_fr": "Tranches de concombre (1 tasse)",
    "display_name_pt": "Fatias de pepino (1 xícara)",
    "display_name_tr": "Salatalık Dilimleri (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cucumber",
        "name_es": "Pepino",
        "name_de": "Gurke",
        "name_fr": "Concombre",
        "name_pt": "Pepino",
        "name_tr": "Salatalık"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 240.0,
    "protein_g": 2.0,
    "carbohydrates_g": 35.0,
    "fat_g": 11.0,
    "fiber_g": 1.0,
    "sodium_mg": 200.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Cupcake (Vanilla 1 medium)",
    "display_name_es": "Magdalena (Vainilla 1 mediana)",
    "display_name_de": "Cupcake (Vanille, 1 mittelgroß)",
    "display_name_fr": "Cupcake (Vanille 1 moyen)",
    "display_name_pt": "Cupcake (Baunilha 1 médio)",
    "display_name_tr": "Cupcake (Vanilya 1 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vanilla",
        "name_es": "Vainilla",
        "name_de": "Vanille",
        "name_fr": "Vanille",
        "name_pt": "Baunilha",
        "name_tr": "Vanilya"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 170.0,
    "protein_g": 2.2,
    "carbohydrates_g": 13.0,
    "fat_g": 12.0,
    "fiber_g": 3.0,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Dark Chocolate (1 oz 70%)",
    "display_name_es": "Chocolate negro (1 oz 70%)",
    "display_name_de": "Dunkle Schokolade (1 oz 70%)",
    "display_name_fr": "Chocolat noir (1 oz 70 %)",
    "display_name_pt": "Chocolate amargo (28 g, 70%)",
    "display_name_tr": "Bitter Çikolata (1 oz %70)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Dark chocolate",
        "name_es": "Chocolate oscuro",
        "name_de": "Dunkle Schokolade",
        "name_fr": "chocolat noir",
        "name_pt": "Chocolate escuro",
        "name_tr": "Bitter çikolata"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 133.0,
    "protein_g": 0.8,
    "carbohydrates_g": 36.0,
    "fat_g": 0.1,
    "fiber_g": 3.2,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Dates (2 medium Medjool)",
    "display_name_es": "Dátiles (2 Medjool medianos)",
    "display_name_de": "Datteln (2 mittelgroße Medjool)",
    "display_name_fr": "Dattes (2 Medjool moyennes)",
    "display_name_pt": "Tâmaras (2 Medjool médias)",
    "display_name_tr": "Hurma (2 orta boy Medjool)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Dates",
        "name_es": "Fechas",
        "name_de": "Termine",
        "name_fr": "Dates",
        "name_pt": "Datas",
        "name_tr": "Tarihler"
      }
    ]
  },
  {
    "category": "Legume",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 120.0,
    "protein_g": 11.0,
    "carbohydrates_g": 9.0,
    "fat_g": 5.0,
    "fiber_g": 5.0,
    "sodium_mg": 9.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Edamame (in pod 1 cup)",
    "display_name_es": "Edamame (en vaina 1 taza)",
    "display_name_de": "Edamame (in der Schote, 1 Tasse)",
    "display_name_fr": "Edamame (en gousse, 1 tasse)",
    "display_name_pt": "Edamame (1 xícara na vagem)",
    "display_name_tr": "Edamame (kabukta 1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Edamame pods",
        "name_es": "Vainas de edamame",
        "name_de": "Edamame-Schoten",
        "name_fr": "gousses d'edamame",
        "name_pt": "Vagens de edamame",
        "name_tr": "Edamame baklaları"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 3.0,
    "protein_g": 0.3,
    "carbohydrates_g": 0.0,
    "fat_g": 0.1,
    "fiber_g": 0.0,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Espresso (1 oz in drink)",
    "display_name_es": "Espresso (1 oz en bebida)",
    "display_name_de": "Espresso (30 ml im Getränk)",
    "display_name_fr": "Espresso (3 cl dans la boisson)",
    "display_name_pt": "Espresso (30 ml na bebida)",
    "display_name_tr": "Espresso (1 ons içecek)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Espresso coffee",
        "name_es": "Café expreso",
        "name_de": "Espresso",
        "name_fr": "Café expresso",
        "name_pt": "Café expresso",
        "name_tr": "Espresso kahve"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 5.0,
    "protein_g": 0.5,
    "carbohydrates_g": 0.0,
    "fat_g": 0.1,
    "fiber_g": 0.0,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 60.0,
    "display_name_en": "Espresso (double shot)",
    "display_name_es": "Espresso (doble dosis)",
    "display_name_de": "Espresso (doppelter Espresso)",
    "display_name_fr": "Espresso (double dose)",
    "display_name_pt": "Espresso (dose dupla)",
    "display_name_tr": "Espresso (çift shot)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Espresso coffee",
        "name_es": "Café expreso",
        "name_de": "Espresso",
        "name_fr": "Café expresso",
        "name_pt": "Café expresso",
        "name_tr": "Espresso kahve"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 2.0,
    "protein_g": 0.2,
    "carbohydrates_g": 0.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 30.0,
    "display_name_en": "Espresso (for dipping)",
    "display_name_es": "Espresso (para mojar)",
    "display_name_de": "Espresso (zum Dippen)",
    "display_name_fr": "Expresso (pour tremper)",
    "display_name_pt": "Espresso (para mergulhar)",
    "display_name_tr": "Espresso (bandırmak için)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Espresso coffee",
        "name_es": "Café expreso",
        "name_de": "Espresso",
        "name_fr": "Café expresso",
        "name_pt": "Café expresso",
        "name_tr": "Espresso kahve"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 74.0,
    "protein_g": 0.6,
    "carbohydrates_g": 19.2,
    "fat_g": 0.3,
    "fiber_g": 2.9,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Figs (2 medium)",
    "display_name_es": "Higos (2 medianos)",
    "display_name_de": "Feigen (2 mittelgroß)",
    "display_name_fr": "Figues (2 moyennes)",
    "display_name_pt": "Figos (2 médios)",
    "display_name_tr": "İncir (2 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Figs",
        "name_es": "Higos",
        "name_de": "Feigen",
        "name_fr": "figues",
        "name_pt": "Figos",
        "name_tr": "İncirler"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 220.0,
    "protein_g": 6.0,
    "carbohydrates_g": 35.0,
    "fat_g": 7.0,
    "fiber_g": 0.0,
    "sodium_mg": 80.0,
    "cholesterol_mg": 90.0,
    "water_ml": 0.0,
    "display_name_en": "Flan (1 slice)",
    "display_name_es": "Flan (1 rebanada)",
    "display_name_de": "Flan (1 Stück)",
    "display_name_fr": "Flan (1 tranche)",
    "display_name_pt": "Flan (1 fatia)",
    "display_name_tr": "Flan (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Eggs",
        "name_es": "Huevos",
        "name_de": "Eier",
        "name_fr": "Œufs",
        "name_pt": "Ovos",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Caramel",
        "name_es": "Caramelo",
        "name_de": "Karamell",
        "name_fr": "Caramel",
        "name_pt": "Caramelo",
        "name_tr": "Karamel"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 110.0,
    "protein_g": 1.0,
    "carbohydrates_g": 28.0,
    "fat_g": 0.0,
    "fiber_g": 2.0,
    "sodium_mg": 10.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Fruit Cocktail (canned 1 cup)",
    "display_name_es": "Cóctel de frutas (enlatado 1 taza)",
    "display_name_de": "Fruchtcocktail (Dose, 1 Tasse)",
    "display_name_fr": "Cocktail de fruits (1 tasse en conserve)",
    "display_name_pt": "Coquetel de frutas (1 xícara em lata)",
    "display_name_tr": "Meyve Kokteyli (konserve 1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Peach",
        "name_es": "Melocotón",
        "name_de": "Pfirsich",
        "name_fr": "Pêche",
        "name_pt": "Pêssego",
        "name_tr": "Şeftali"
      },
      {
        "category_en": "Produce",
        "name_en": "Pear",
        "name_es": "Pera",
        "name_de": "Birne",
        "name_fr": "Poire",
        "name_pt": "Pera",
        "name_tr": "Armut"
      },
      {
        "category_en": "Produce",
        "name_en": "Grapes",
        "name_es": "Uvas",
        "name_de": "Weintrauben",
        "name_fr": "Raisins",
        "name_pt": "Uvas",
        "name_tr": "Üzüm"
      },
      {
        "category_en": "Produce",
        "name_en": "Cherries",
        "name_es": "Cerezas",
        "name_de": "Kirschen",
        "name_fr": "Cerises",
        "name_pt": "Cerejas",
        "name_tr": "Kiraz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Syrup",
        "name_es": "Jarabe",
        "name_de": "Sirup",
        "name_fr": "Sirop",
        "name_pt": "Xarope",
        "name_tr": "Şurup"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 220.0,
    "protein_g": 5.0,
    "carbohydrates_g": 24.0,
    "fat_g": 12.0,
    "fiber_g": 2.0,
    "sodium_mg": 60.0,
    "cholesterol_mg": 40.0,
    "water_ml": 0.0,
    "display_name_en": "Gelato (Pistachio 1/2 cup)",
    "display_name_es": "Gelato (Pistacho 1/2 taza)",
    "display_name_de": "Gelato (Pistazie 1/2 Tasse)",
    "display_name_fr": "Gelato (Pistache 1/2 tasse)",
    "display_name_pt": "Gelato (1/2 xícara de pistache)",
    "display_name_tr": "Dondurma (Antep Fıstığı 1/2 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme",
        "name_tr": "Krema"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pistachio flavor",
        "name_es": "Sabor a pistacho",
        "name_de": "Pistaziengeschmack",
        "name_fr": "Arôme pistache",
        "name_pt": "Sabor pistache",
        "name_tr": "Antep fıstığı aromalı"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 124.0,
    "protein_g": 0.0,
    "carbohydrates_g": 32.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 40.0,
    "cholesterol_mg": 0.0,
    "water_ml": 355.0,
    "display_name_en": "Ginger Ale (1 can)",
    "display_name_es": "Ginger Ale (1 lata)",
    "display_name_de": "Ingwerlimonade (1 Dose)",
    "display_name_fr": "Ginger Ale (1 canette)",
    "display_name_pt": "Refrigerante de gengibre (1 lata)",
    "display_name_tr": "Zencefilli Gazoz (1 kutu)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Ginger ale soda",
        "name_es": "Refresco de ginger ale",
        "name_de": "Ingwerlimonade",
        "name_fr": "soda au gingembre",
        "name_pt": "refrigerante de gengibre",
        "name_tr": "Zencefilli gazoz"
      }
    ]
  },
  {
    "category": "Grain/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 60.0,
    "protein_g": 1.0,
    "carbohydrates_g": 11.0,
    "fat_g": 1.5,
    "fiber_g": 0.5,
    "sodium_mg": 70.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Graham Cracker (1 large rectangle)",
    "display_name_es": "Galleta Graham (1 rectángulo grande)",
    "display_name_de": "Graham Cracker (1 großes Rechteck)",
    "display_name_fr": "Biscuit Graham (1 grand rectangle)",
    "display_name_pt": "Biscoito Graham (1 retângulo grande)",
    "display_name_tr": "Graham Kraker (1 büyük dikdörtgen)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Graham cracker",
        "name_es": "Galleta Graham",
        "name_de": "Graham-Cracker",
        "name_fr": "biscuit Graham",
        "name_pt": "Biscoito Graham",
        "name_tr": "Graham krakeri"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 104.0,
    "protein_g": 1.1,
    "carbohydrates_g": 27.0,
    "fat_g": 0.2,
    "fiber_g": 1.4,
    "sodium_mg": 3.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Grapes (1 cup)",
    "display_name_es": "Uvas (1 taza)",
    "display_name_de": "Trauben (1 Tasse)",
    "display_name_fr": "Raisins (1 tasse)",
    "display_name_pt": "Uvas (1 xícara)",
    "display_name_tr": "Üzüm (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Grapes",
        "name_es": "Uvas",
        "name_de": "Trauben",
        "name_fr": "Raisins",
        "name_pt": "Uvas",
        "name_tr": "Üzümler"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 1,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 150.0,
    "protein_g": 25.0,
    "carbohydrates_g": 8.0,
    "fat_g": 3.0,
    "fiber_g": 0.0,
    "sodium_mg": 85.0,
    "cholesterol_mg": 10.0,
    "water_ml": 250.0,
    "display_name_en": "Greek Yogurt (plain 1 cup)",
    "display_name_es": "Yogur griego (natural 1 taza)",
    "display_name_de": "Griechischer Joghurt (natur, 1 Tasse)",
    "display_name_fr": "Yaourt grec (nature, 1 tasse)",
    "display_name_pt": "Iogurte grego (natural, 1 xícara)",
    "display_name_tr": "Yunan Yoğurdu (sade 1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Greek yogurt",
        "name_es": "yogur griego",
        "name_de": "Griechischer Joghurt",
        "name_fr": "yaourt grec",
        "name_pt": "Iogurte grego",
        "name_tr": "Yunan yoğurdu"
      }
    ]
  },
  {
    "category": "Protein/Meat",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 80.0,
    "protein_g": 5.5,
    "carbohydrates_g": 0.0,
    "fat_g": 6.0,
    "fiber_g": 0.0,
    "sodium_mg": 20.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Ground Lamb (1 oz filling)",
    "display_name_es": "Cordero molido (relleno de 1 oz)",
    "display_name_de": "Lammhackfleisch (1 oz Füllung)",
    "display_name_fr": "Agneau haché (garniture de 28 g)",
    "display_name_pt": "Carne de cordeiro moída (recheio de 28 g)",
    "display_name_tr": "Kıyma Kuzu (28 gr iç harç)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Parsley",
        "name_es": "Perejil",
        "name_de": "Petersilie",
        "name_fr": "Persil",
        "name_pt": "Salsa",
        "name_tr": "Maydanoz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground lamb",
        "name_es": "Cordero molido",
        "name_de": "Lammhackfleisch",
        "name_fr": "Agneau haché",
        "name_pt": "Carne de cordeiro moída",
        "name_tr": "Kıyma kuzu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spices",
        "name_es": "Especias",
        "name_de": "Gewürze",
        "name_fr": "Épices",
        "name_pt": "Especiarias",
        "name_tr": "Baharatlar"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 68.0,
    "protein_g": 2.6,
    "carbohydrates_g": 14.3,
    "fat_g": 0.9,
    "fiber_g": 5.4,
    "sodium_mg": 3.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Guava",
    "display_name_es": "Guayaba",
    "display_name_de": "Guave",
    "display_name_fr": "Goyave",
    "display_name_pt": "Goiaba",
    "display_name_tr": "Guava",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Guava",
        "name_es": "Guayaba",
        "name_de": "Guave",
        "name_fr": "Goyave",
        "name_pt": "Goiaba",
        "name_tr": "Guava"
      }
    ]
  },
  {
    "category": "Protein",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 78.0,
    "protein_g": 6.3,
    "carbohydrates_g": 0.6,
    "fat_g": 5.3,
    "fiber_g": 0.0,
    "sodium_mg": 62.0,
    "cholesterol_mg": 187.0,
    "water_ml": 0.0,
    "display_name_en": "Hard-Boiled Egg (1 large)",
    "display_name_es": "Huevo duro (1 grande)",
    "display_name_de": "Hartgekochtes Ei (1 großes)",
    "display_name_fr": "Œuf dur (1 gros)",
    "display_name_pt": "Ovo cozido (1 grande)",
    "display_name_tr": "Haşlanmış Yumurta (1 büyük)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg",
        "name_es": "Huevo",
        "name_de": "Ei",
        "name_fr": "Œuf",
        "name_pt": "Ovo",
        "name_tr": "Yumurta"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 140.0,
    "protein_g": 2.0,
    "carbohydrates_g": 25.0,
    "fat_g": 3.0,
    "fiber_g": 1.0,
    "sodium_mg": 30.0,
    "cholesterol_mg": 5.0,
    "water_ml": 240.0,
    "display_name_en": "Horchata (1 cup)",
    "display_name_es": "Horchata (1 taza)",
    "display_name_de": "Horchata (1 Tasse)",
    "display_name_fr": "Horchata (1 tasse)",
    "display_name_pt": "Horchata (1 xícara)",
    "display_name_tr": "Horchata (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cinnamon",
        "name_es": "Canela",
        "name_de": "Zimt",
        "name_fr": "Cannelle",
        "name_pt": "Canela",
        "name_tr": "Tarçın"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk (optional)",
        "name_es": "Leche (opcional)",
        "name_de": "Milch (optional)",
        "name_fr": "Lait (facultatif)",
        "name_pt": "Leite (opcional)",
        "name_tr": "Süt (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice",
        "name_es": "Arroz",
        "name_de": "Reis",
        "name_fr": "Riz",
        "name_pt": "Arroz",
        "name_tr": "Pirinç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 200.0,
    "protein_g": 3.0,
    "carbohydrates_g": 30.0,
    "fat_g": 8.0,
    "fiber_g": 2.0,
    "sodium_mg": 160.0,
    "cholesterol_mg": 10.0,
    "water_ml": 240.0,
    "display_name_en": "Hot Chocolate (1 cup)",
    "display_name_es": "Chocolate caliente (1 taza)",
    "display_name_de": "Heiße Schokolade (1 Tasse)",
    "display_name_fr": "Chocolat chaud (1 tasse)",
    "display_name_pt": "Chocolate quente (1 xícara)",
    "display_name_tr": "Sıcak Çikolata (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cocoa powder",
        "name_es": "Cacao en polvo",
        "name_de": "Kakaopulver",
        "name_fr": "Cacao en poudre",
        "name_pt": "Cacau em pó",
        "name_tr": "Kakao tozu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Legume",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 70.0,
    "protein_g": 2.0,
    "carbohydrates_g": 4.0,
    "fat_g": 5.0,
    "fiber_g": 2.0,
    "sodium_mg": 130.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Hummus (2 tbsp)",
    "display_name_es": "Hummus (2 cucharadas)",
    "display_name_de": "Hummus (2 EL)",
    "display_name_fr": "Houmous (2 cuillères à soupe)",
    "display_name_pt": "Hummus (2 colheres de sopa)",
    "display_name_tr": "Humus (2 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      },
      {
        "category_en": "Produce",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chickpeas",
        "name_es": "Garbanzos",
        "name_de": "Kichererbsen",
        "name_fr": "Pois chiches",
        "name_pt": "Grão-de-bico",
        "name_tr": "Nohut"
      },
      {
        "category_en": "Pantry",
        "name_en": "Tahini",
        "name_es": "Tahini",
        "name_de": "Tahini",
        "name_fr": "Tahini",
        "name_pt": "Tahine",
        "name_tr": "Tahin"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite de oliva",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Dairy/Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 145.0,
    "protein_g": 2.5,
    "carbohydrates_g": 17.0,
    "fat_g": 7.5,
    "fiber_g": 0.5,
    "sodium_mg": 55.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Ice Cream (1/2 cup vanilla)",
    "display_name_es": "Helado (1/2 taza de vainilla)",
    "display_name_de": "Eiscreme (1/2 Tasse Vanille)",
    "display_name_fr": "Crème glacée (1/2 tasse de vanille)",
    "display_name_pt": "Sorvete (1/2 xícara de baunilha)",
    "display_name_tr": "Dondurma (1/2 su bardağı vanilya)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme",
        "name_tr": "Krema"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Vanilla",
        "name_es": "Vainilla",
        "name_de": "Vanille",
        "name_fr": "Vanille",
        "name_pt": "Baunilha",
        "name_tr": "Vanilya"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 0.0,
    "carbohydrates_g": 46.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 15.0,
    "cholesterol_mg": 0.0,
    "water_ml": 500.0,
    "display_name_en": "Iced Tea (Sweetened 16oz)",
    "display_name_es": "Té helado (endulzado, 16 oz)",
    "display_name_de": "Eistee (gesüßt, 16 oz)",
    "display_name_fr": "Thé glacé (sucré 473 ml)",
    "display_name_pt": "Chá gelado (adoçado, 473 ml)",
    "display_name_tr": "Buzlu Çay (Tatlandırılmış 16oz)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon (optional)",
        "name_es": "Limón (opcional)",
        "name_de": "Zitrone (optional)",
        "name_fr": "Citron (facultatif)",
        "name_pt": "Limão (opcional)",
        "name_tr": "Limon (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Black tea",
        "name_es": "Té negro",
        "name_de": "Schwarzer Tee",
        "name_fr": "Thé noir",
        "name_pt": "Chá preto",
        "name_tr": "Siyah çay"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Vegetable",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 46.0,
    "protein_g": 0.9,
    "carbohydrates_g": 10.6,
    "fat_g": 0.1,
    "fiber_g": 5.8,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Jicama (1 cup sticks)",
    "display_name_es": "Jícama (1 taza de palitos)",
    "display_name_de": "Jicama (1 Tasse Stifte)",
    "display_name_fr": "Jicama (1 tasse de bâtonnets)",
    "display_name_pt": "Jicama (1 xícara de palitos)",
    "display_name_tr": "Jicama (1 su bardağı çubuk)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Jicama",
        "name_es": "Jícama",
        "name_de": "Jicama",
        "name_fr": "Jicama",
        "name_pt": "Jicama",
        "name_tr": "Meksika turpu"
      }
    ]
  },
  {
    "category": "Meal/Meat",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 230.0,
    "protein_g": 9.0,
    "carbohydrates_g": 20.0,
    "fat_g": 13.0,
    "fiber_g": 3.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Kibbeh (1 piece fried)",
    "display_name_es": "Kibbeh (1 pieza frita)",
    "display_name_de": "Kibbeh (1 Stück frittiert)",
    "display_name_fr": "Kibbeh (1 morceau frit)",
    "display_name_pt": "Kibbeh (1 unidade frita)",
    "display_name_tr": "Kibbeh (1 adet kızarmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Mint (optional)",
        "name_es": "Menta (opcional)",
        "name_de": "Minze (optional)",
        "name_fr": "Menthe (facultatif)",
        "name_pt": "Hortelã (opcional)",
        "name_tr": "Nane (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ground lamb",
        "name_es": "Carne molida de cordero",
        "name_de": "Lammhackfleisch",
        "name_fr": "Agneau haché",
        "name_pt": "Carne de cordeiro moída",
        "name_tr": "Kıyma"
      },
      {
        "category_en": "Pantry",
        "name_en": "Bulgur",
        "name_es": "Bulgur",
        "name_de": "Bulgur",
        "name_fr": "Boulgour",
        "name_pt": "Bulgur",
        "name_tr": "Bulgur"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spices",
        "name_es": "Especias",
        "name_de": "Gewürze",
        "name_fr": "Épices",
        "name_pt": "Especiarias",
        "name_tr": "Baharatlar"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 46.0,
    "protein_g": 0.9,
    "carbohydrates_g": 11.1,
    "fat_g": 0.4,
    "fiber_g": 2.3,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Kiwifruit (1 medium)",
    "display_name_es": "Kiwi (1 mediano)",
    "display_name_de": "Kiwi (1 mittelgroß)",
    "display_name_fr": "Kiwi (1 moyen)",
    "display_name_pt": "Kiwi (1 médio)",
    "display_name_tr": "Kivi (1 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Kiwi",
        "name_es": "Kiwi",
        "name_de": "Kiwi",
        "name_fr": "Kiwi",
        "name_pt": "Kiwi",
        "name_tr": "Kivi"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 30.0,
    "protein_g": 0.0,
    "carbohydrates_g": 7.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 10.0,
    "cholesterol_mg": 0.0,
    "water_ml": 240.0,
    "display_name_en": "Kombucha (1 cup)",
    "display_name_es": "Kombucha (1 taza)",
    "display_name_de": "Kombucha (1 Tasse)",
    "display_name_fr": "Kombucha (1 tasse)",
    "display_name_pt": "Kombucha (1 xícara)",
    "display_name_tr": "Kombucha (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Kombucha drink",
        "name_es": "bebida de kombucha",
        "name_de": "Kombucha-Getränk",
        "name_fr": "boisson kombucha",
        "name_pt": "Bebida Kombucha",
        "name_tr": "Kombucha içeceği"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 60.0,
    "protein_g": 0.0,
    "carbohydrates_g": 14.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 20.0,
    "cholesterol_mg": 0.0,
    "water_ml": 473.0,
    "display_name_en": "Kombucha (16 oz)",
    "display_name_es": "Kombucha (16 onzas)",
    "display_name_de": "Kombucha (473 ml)",
    "display_name_fr": "Kombucha (473 ml)",
    "display_name_pt": "Kombucha (473 ml)",
    "display_name_tr": "Kombucha (16 oz)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Kombucha drink",
        "name_es": "bebida de kombucha",
        "name_de": "Kombucha-Getränk",
        "name_fr": "boisson kombucha",
        "name_pt": "Bebida Kombucha",
        "name_tr": "Kombucha içeceği"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 5.0,
    "carbohydrates_g": 30.0,
    "fat_g": 4.0,
    "fiber_g": 1.0,
    "sodium_mg": 60.0,
    "cholesterol_mg": 15.0,
    "water_ml": 240.0,
    "display_name_en": "Lassi (Mango 1 cup)",
    "display_name_es": "Lassi (Mango 1 taza)",
    "display_name_de": "Lassi (Mango, 1 Tasse)",
    "display_name_fr": "Lassi (Mangue 1 tasse)",
    "display_name_pt": "Lassi (1 xícara de manga)",
    "display_name_tr": "Lassi (Mango 1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Mango",
        "name_es": "mango",
        "name_de": "Mango",
        "name_fr": "mangue",
        "name_pt": "manga",
        "name_tr": "Mango"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Yogurt",
        "name_es": "Yogur",
        "name_de": "Joghurt",
        "name_fr": "Yaourt",
        "name_pt": "Iogurte",
        "name_tr": "Yoğurt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 150.0,
    "protein_g": 1.5,
    "carbohydrates_g": 22.0,
    "fat_g": 6.0,
    "fiber_g": 0.5,
    "sodium_mg": 80.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Lemon Bar (1 square)",
    "display_name_es": "Barra de limón (1 cuadrado)",
    "display_name_de": "Zitronenschnitte (1 Stück)",
    "display_name_fr": "Barre au citron (1 carré)",
    "display_name_pt": "Barra de limão (1 quadrado)",
    "display_name_tr": "Limon Bar (1 kare)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon juice",
        "name_es": "Jugo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "Jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      },
      {
        "category_en": "Produce",
        "name_en": "Lemon zest",
        "name_es": "Ralladura de limón",
        "name_de": "Zitronenschale",
        "name_fr": "Zeste de citron",
        "name_pt": "Raspas de limão",
        "name_tr": "Limon kabuğu rendesi"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Manteca",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 99.0,
    "protein_g": 0.1,
    "carbohydrates_g": 26.0,
    "fat_g": 0.0,
    "fiber_g": 0.1,
    "sodium_mg": 30.0,
    "cholesterol_mg": 0.0,
    "water_ml": 240.0,
    "display_name_en": "Lemonade (1 cup)",
    "display_name_es": "Limonada (1 taza)",
    "display_name_de": "Limonade (1 Tasse)",
    "display_name_fr": "Limonade (1 tasse)",
    "display_name_pt": "Limonada (1 xícara)",
    "display_name_tr": "Limonata (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon juice",
        "name_es": "Zumo de limón",
        "name_de": "Zitronensaft",
        "name_fr": "jus de citron",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Water",
        "name_es": "Agua",
        "name_de": "Wasser",
        "name_fr": "Eau",
        "name_pt": "Água",
        "name_tr": "Su"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 204.0,
    "protein_g": 2.2,
    "carbohydrates_g": 3.9,
    "fat_g": 21.5,
    "fiber_g": 2.4,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Macadamia Nuts (1 oz)",
    "display_name_es": "Nueces de macadamia (1 oz)",
    "display_name_de": "Macadamianüsse (1 oz)",
    "display_name_fr": "Noix de macadamia (1 oz)",
    "display_name_pt": "Nozes de macadâmia (28 g)",
    "display_name_tr": "Macadamia Fındığı (1 oz)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Macadamia nuts",
        "name_es": "Nueces de macadamia",
        "name_de": "Macadamianüsse",
        "name_fr": "noix de macadamia",
        "name_pt": "Nozes de macadâmia",
        "name_tr": "Macadamia fıstığı"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 380.0,
    "protein_g": 5.0,
    "carbohydrates_g": 60.0,
    "fat_g": 14.0,
    "fiber_g": 2.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 60.0,
    "water_ml": 0.0,
    "display_name_en": "Malva Pudding (1 slice)",
    "display_name_es": "Pudín de malva (1 rebanada)",
    "display_name_de": "Malva-Pudding (1 Stück)",
    "display_name_fr": "Pudding Malva (1 tranche)",
    "display_name_pt": "Pudim de Malva (1 fatia)",
    "display_name_tr": "Malva Pudingi (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Apricot jam (optional)",
        "name_es": "Mermelada de albaricoque (opcional)",
        "name_de": "Aprikosenmarmelade (optional)",
        "name_fr": "Confiture d'abricots (facultatif)",
        "name_pt": "Geleia de damasco (opcional)",
        "name_tr": "Kayısı reçeli (isteğe bağlı)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Eggs",
        "name_es": "Huevos",
        "name_de": "Eier",
        "name_fr": "Œufs",
        "name_pt": "Ovos",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 37.0,
    "protein_g": 0.6,
    "carbohydrates_g": 9.3,
    "fat_g": 0.2,
    "fiber_g": 1.3,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Mandarin Orange (1 medium)",
    "display_name_es": "Mandarina (1 mediana)",
    "display_name_de": "Mandarine (1 mittelgroß)",
    "display_name_fr": "Mandarine (1 moyenne)",
    "display_name_pt": "Tangerina (1 média)",
    "display_name_tr": "Mandalina (1 orta boy)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Mandarin orange",
        "name_es": "Mandarina",
        "name_de": "Mandarine",
        "name_fr": "mandarine",
        "name_pt": "Laranja mandarina",
        "name_tr": "Mandalina"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 99.0,
    "protein_g": 1.4,
    "carbohydrates_g": 24.7,
    "fat_g": 0.6,
    "fiber_g": 2.6,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Mango (1 cup slices)",
    "display_name_es": "Mango (1 taza en rodajas)",
    "display_name_de": "Mango (1 Tasse Scheiben)",
    "display_name_fr": "Mangue (1 tasse de tranches)",
    "display_name_pt": "Manga (1 xícara de fatias)",
    "display_name_tr": "Mango (1 su bardağı dilim)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Mango",
        "name_es": "mango",
        "name_de": "Mango",
        "name_fr": "mangue",
        "name_pt": "manga",
        "name_tr": "Mango"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 180.0,
    "protein_g": 6.0,
    "carbohydrates_g": 28.0,
    "fat_g": 5.0,
    "fiber_g": 2.0,
    "sodium_mg": 90.0,
    "cholesterol_mg": 20.0,
    "water_ml": 355.0,
    "display_name_en": "Matcha Latte (12 oz)",
    "display_name_es": "Matcha Latte (355 ml)",
    "display_name_de": "Matcha Latte (355 ml)",
    "display_name_fr": "Matcha Latte (35 cl)",
    "display_name_pt": "Matcha Latte (355 ml)",
    "display_name_tr": "Matcha Latte (12 oz)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Matcha powder",
        "name_es": "Matcha en polvo",
        "name_de": "Matcha-Pulver",
        "name_fr": "Poudre de matcha",
        "name_pt": "Pó de matcha",
        "name_tr": "Matcha tozu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 200.0,
    "protein_g": 6.0,
    "carbohydrates_g": 8.0,
    "fat_g": 18.0,
    "fiber_g": 3.0,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Mixed Nuts (1/4 cup)",
    "display_name_es": "Frutos secos mixtos (1/4 taza)",
    "display_name_de": "Gemischte Nüsse (1/4 Tasse)",
    "display_name_fr": "Noix mélangées (1/4 tasse)",
    "display_name_pt": "Mix de Nozes (1/4 de xícara)",
    "display_name_tr": "Karışık Kuruyemiş (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Almonds",
        "name_es": "Almendras",
        "name_de": "Mandeln",
        "name_fr": "Amandes",
        "name_pt": "Amêndoas",
        "name_tr": "Badem"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cashews",
        "name_es": "Anacardos",
        "name_de": "Cashewnüsse",
        "name_fr": "Noix de cajou",
        "name_pt": "Castanhas de caju",
        "name_tr": "Kaju"
      },
      {
        "category_en": "Pantry",
        "name_en": "Walnuts",
        "name_es": "Nueces",
        "name_de": "Walnüsse",
        "name_fr": "Noix",
        "name_pt": "Nozes",
        "name_tr": "Ceviz"
      },
      {
        "category_en": "Pantry",
        "name_en": "Peanuts",
        "name_es": "Cacahuetes",
        "name_de": "Erdnüsse",
        "name_fr": "Cacahuètes",
        "name_pt": "Amendoins",
        "name_tr": "Yer Fıstığı"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 360.0,
    "protein_g": 12.0,
    "carbohydrates_g": 48.0,
    "fat_g": 15.0,
    "fiber_g": 2.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 45.0,
    "water_ml": 473.0,
    "display_name_en": "Mocha Latte (16oz)",
    "display_name_es": "Café con leche moca (16 oz)",
    "display_name_de": "Mocha Latte (473 ml)",
    "display_name_fr": "Latte moka (473 ml)",
    "display_name_pt": "Mocha Latte (473ml)",
    "display_name_tr": "Mocha Latte (16oz)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Espresso",
        "name_es": "Espresso",
        "name_de": "Espresso",
        "name_fr": "Expresso",
        "name_pt": "Café expresso",
        "name_tr": "Espresso"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cocoa powder",
        "name_es": "Cacao en polvo",
        "name_de": "Kakaopulver",
        "name_fr": "Cacao en poudre",
        "name_pt": "Cacau em pó",
        "name_tr": "Kakao tozu"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 40.0,
    "protein_g": 3.0,
    "carbohydrates_g": 0.5,
    "fat_g": 3.0,
    "fiber_g": 0.0,
    "sodium_mg": 75.0,
    "cholesterol_mg": 10.0,
    "water_ml": 0.0,
    "display_name_en": "Mozzarella (filling 0.5 oz)",
    "display_name_es": "Mozzarella (relleno 0,5 oz)",
    "display_name_de": "Mozzarella (Füllung 0,5 oz)",
    "display_name_fr": "Mozzarella (garniture 0,5 oz)",
    "display_name_pt": "Mussarela (recheio de 14 g)",
    "display_name_tr": "Mozzarella (iç harcı 0,5 oz)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "queso mozzarella",
        "name_de": "Mozzarella-Käse",
        "name_fr": "fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 5.0,
    "protein_g": 0.0,
    "carbohydrates_g": 0.1,
    "fat_g": 0.5,
    "fiber_g": 0.1,
    "sodium_mg": 30.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Olive (garnish)",
    "display_name_es": "Aceituna (guarnición)",
    "display_name_de": "Olive (Garnitur)",
    "display_name_fr": "Olive (garniture)",
    "display_name_pt": "Azeitona (para decorar)",
    "display_name_tr": "Zeytin (süsleme)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Olive",
        "name_es": "Aceituna",
        "name_de": "Olive",
        "name_fr": "Olive",
        "name_pt": "Azeitona",
        "name_tr": "Zeytin"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 280.0,
    "protein_g": 4.0,
    "carbohydrates_g": 30.0,
    "fat_g": 16.0,
    "fiber_g": 3.0,
    "sodium_mg": 500.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Onion Rings (6 rings)",
    "display_name_es": "Aros de cebolla (6 aros)",
    "display_name_de": "Zwiebelringe (6 Ringe)",
    "display_name_fr": "Rondelles d'oignon (6 rondelles)",
    "display_name_pt": "Anéis de cebola (6 anéis)",
    "display_name_tr": "Soğan Halkaları (6 halka)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Breadcrumbs",
        "name_es": "Pan rallado",
        "name_de": "Paniermehl",
        "name_fr": "Chapelure",
        "name_pt": "Farinha de rosca",
        "name_tr": "Ekmek kırıntıları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 62.0,
    "protein_g": 1.2,
    "carbohydrates_g": 15.4,
    "fat_g": 0.2,
    "fiber_g": 3.1,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Orange",
    "display_name_es": "Naranja",
    "display_name_de": "Orange",
    "display_name_fr": "Orange",
    "display_name_pt": "Laranja",
    "display_name_tr": "Turuncu",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Orange",
        "name_es": "Naranja",
        "name_de": "Orange",
        "name_fr": "Orange",
        "name_pt": "Laranja",
        "name_tr": "Turuncu"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 5.0,
    "protein_g": 0.1,
    "carbohydrates_g": 1.0,
    "fat_g": 0.0,
    "fiber_g": 0.2,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Orange Slice (garnish)",
    "display_name_es": "Rodaja de naranja (guarnición)",
    "display_name_de": "Orangenscheibe (Garnitur)",
    "display_name_fr": "Tranche d'orange (garniture)",
    "display_name_pt": "Fatia de laranja (para decorar)",
    "display_name_tr": "Portakal Dilimi (süsleme)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Orange slice",
        "name_es": "rodaja de naranja",
        "name_de": "Orangenscheibe",
        "name_fr": "tranche d'orange",
        "name_pt": "fatia de laranja",
        "name_tr": "Portakal dilimi"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 1,
    "calories_kcal": 320.0,
    "protein_g": 6.0,
    "carbohydrates_g": 50.0,
    "fat_g": 12.0,
    "fiber_g": 3.0,
    "sodium_mg": 200.0,
    "cholesterol_mg": 70.0,
    "water_ml": 0.0,
    "display_name_en": "Panettone (1 slice)",
    "display_name_es": "Panettone (1 rebanada)",
    "display_name_de": "Panettone (1 Stück)",
    "display_name_fr": "Panettone (1 tranche)",
    "display_name_pt": "Panetone (1 fatia)",
    "display_name_tr": "Panettone (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Raisins",
        "name_es": "Pasas",
        "name_de": "Rosinen",
        "name_fr": "Raisins secs",
        "name_pt": "Uvas-passas",
        "name_tr": "Kuru üzüm"
      },
      {
        "category_en": "Produce",
        "name_en": "Candied fruit",
        "name_es": "Fruta confitada",
        "name_de": "Kandierte Früchte",
        "name_fr": "Fruits confits",
        "name_pt": "Frutas cristalizadas",
        "name_tr": "Şekerlenmiş meyve"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Butter",
        "name_es": "Mantequilla",
        "name_de": "Butter",
        "name_fr": "Beurre",
        "name_pt": "Manteiga",
        "name_tr": "Tereyağı"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Eggs",
        "name_es": "Huevos",
        "name_de": "Eier",
        "name_fr": "Œufs",
        "name_pt": "Ovos",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Flour",
        "name_es": "Harina",
        "name_de": "Mehl",
        "name_fr": "Farine",
        "name_pt": "Farinha",
        "name_tr": "Un"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Yeast",
        "name_es": "Levadura",
        "name_de": "Hefe",
        "name_fr": "Levure",
        "name_pt": "Fermento",
        "name_tr": "Maya"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 200.0,
    "protein_g": 4.0,
    "carbohydrates_g": 35.0,
    "fat_g": 5.0,
    "fiber_g": 3.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pani Puri (6 pcs)",
    "display_name_es": "Pani Puri (6 piezas)",
    "display_name_de": "Pani Puri (6 Stück)",
    "display_name_fr": "Pani Puri (6 pièces)",
    "display_name_pt": "Pani Puri (6 unidades)",
    "display_name_tr": "Pani Puri (6 adet)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebel",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Cilantro",
        "name_es": "Cilantro",
        "name_de": "Koriander",
        "name_fr": "Coriandre",
        "name_pt": "Coentro",
        "name_tr": "Kişniş"
      },
      {
        "category_en": "Pantry",
        "name_en": "Semolina shells",
        "name_es": "Conchas de sémola",
        "name_de": "Grießschalen",
        "name_fr": "Coquilles de semoule",
        "name_pt": "Conchas de sêmola",
        "name_tr": "İrmik kabukları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spiced water",
        "name_es": "Agua especiada",
        "name_de": "Gewürzwasser",
        "name_fr": "Eau épicée",
        "name_pt": "Água temperada",
        "name_tr": "Baharatlı su"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 300.0,
    "protein_g": 4.0,
    "carbohydrates_g": 25.0,
    "fat_g": 20.0,
    "fiber_g": 0.0,
    "sodium_mg": 50.0,
    "cholesterol_mg": 70.0,
    "water_ml": 0.0,
    "display_name_en": "Panna Cotta (1 serving)",
    "display_name_es": "Panna Cotta (1 porción)",
    "display_name_de": "Panna Cotta (1 Portion)",
    "display_name_fr": "Panna Cotta (1 portion)",
    "display_name_pt": "Panna Cotta (1 porção)",
    "display_name_tr": "Panna Cotta (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme",
        "name_tr": "Krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Gelatin",
        "name_es": "Gelatina",
        "name_de": "Gelatine",
        "name_fr": "Gélatine",
        "name_pt": "Gelatina",
        "name_tr": "Jelatin"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 62.0,
    "protein_g": 0.6,
    "carbohydrates_g": 15.7,
    "fat_g": 0.4,
    "fiber_g": 2.5,
    "sodium_mg": 12.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Papaya (1 cup cubes)",
    "display_name_es": "Papaya (cubos de 1 taza)",
    "display_name_de": "Papaya (1 Tasse Würfel)",
    "display_name_fr": "Papaye (1 tasse de cubes)",
    "display_name_pt": "Mamão (1 xícara em cubos)",
    "display_name_tr": "Papaya (1 su bardağı küp)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Papaya",
        "name_es": "Papaya",
        "name_de": "Papaya",
        "name_fr": "Papaye",
        "name_pt": "Mamão",
        "name_tr": "Papaya"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 17.0,
    "protein_g": 0.4,
    "carbohydrates_g": 4.2,
    "fat_g": 0.1,
    "fiber_g": 1.9,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Passion Fruit (1 fruit)",
    "display_name_es": "Maracuyá (1 fruta)",
    "display_name_de": "Passionsfrucht (1 Frucht)",
    "display_name_fr": "Fruit de la passion (1 fruit)",
    "display_name_pt": "Maracujá (1 fruta)",
    "display_name_tr": "Çarkıfelek Meyvesi (1 meyve)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Passion fruit",
        "name_es": "Granadilla",
        "name_de": "Passionsfrucht",
        "name_fr": "Fruit de la passion",
        "name_pt": "Maracujá",
        "name_tr": "Tutku meyvesi"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 190.0,
    "protein_g": 7.0,
    "carbohydrates_g": 8.0,
    "fat_g": 16.0,
    "fiber_g": 2.0,
    "sodium_mg": 140.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Peanut Butter (2 tbsp)",
    "display_name_es": "Mantequilla de maní (2 cucharadas)",
    "display_name_de": "Erdnussbutter (2 EL)",
    "display_name_fr": "Beurre de cacahuète (2 cuillères à soupe)",
    "display_name_pt": "Manteiga de amendoim (2 colheres de sopa)",
    "display_name_tr": "Fıstık Ezmesi (2 yemek kaşığı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Peanut butter",
        "name_es": "Manteca de cacahuete",
        "name_de": "Erdnussbutter",
        "name_fr": "beurre de cacahuète",
        "name_pt": "Manteiga de amendoim",
        "name_tr": "Fıstık ezmesi"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 101.0,
    "protein_g": 0.6,
    "carbohydrates_g": 27.0,
    "fat_g": 0.2,
    "fiber_g": 5.5,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pear",
    "display_name_es": "Pera",
    "display_name_de": "Birne",
    "display_name_fr": "Poire",
    "display_name_pt": "Pera",
    "display_name_tr": "Armut",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Pear",
        "name_es": "Pera",
        "name_de": "Birne",
        "name_fr": "Poire",
        "name_pt": "Pera",
        "name_tr": "Armut"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 196.0,
    "protein_g": 2.6,
    "carbohydrates_g": 3.9,
    "fat_g": 20.4,
    "fiber_g": 2.7,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pecans (1 oz)",
    "display_name_es": "Nueces pecanas (1 oz)",
    "display_name_de": "Pekannüsse (1 oz)",
    "display_name_fr": "Noix de pécan (1 oz)",
    "display_name_pt": "Nozes-pecã (28 g)",
    "display_name_tr": "Pekan cevizi (1 ons)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pecans",
        "name_es": "Nueces pecanas",
        "name_de": "Pekannüsse",
        "name_fr": "noix de pécan",
        "name_pt": "Nozes-pecã",
        "name_tr": "Pekan cevizi"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 48.0,
    "protein_g": 1.0,
    "carbohydrates_g": 1.0,
    "fat_g": 5.0,
    "fiber_g": 0.2,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pine Nuts (1/2 tbsp filling)",
    "display_name_es": "Piñones (1/2 cucharada de relleno)",
    "display_name_de": "Pinienkerne (1/2 EL Füllung)",
    "display_name_fr": "Pignons de pin (1/2 cuillère à soupe de garniture)",
    "display_name_pt": "Pinhões (1/2 colher de sopa de recheio)",
    "display_name_tr": "Çam Fıstığı (1/2 yemek kaşığı iç harcı)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pine nuts",
        "name_es": "piñones",
        "name_de": "Pinienkerne",
        "name_fr": "pignons de pin",
        "name_pt": "pinhões",
        "name_tr": "Çam fıstığı"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 250.0,
    "protein_g": 1.0,
    "carbohydrates_g": 25.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 5.0,
    "cholesterol_mg": 5.0,
    "water_ml": 180.0,
    "display_name_en": "Pisco Sour (1 drink)",
    "display_name_es": "Pisco Sour (1 bebida)",
    "display_name_de": "Pisco Sour (1 Getränk)",
    "display_name_fr": "Pisco Sour (1 verre)",
    "display_name_pt": "Pisco Sour (1 dose)",
    "display_name_tr": "Pisco Sour (1 içecek)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lime juice",
        "name_es": "Zumo de lima",
        "name_de": "Limettensaft",
        "name_fr": "Jus de citron vert",
        "name_pt": "Suco de limão",
        "name_tr": "Limon suyu"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Egg white (optional)",
        "name_es": "Clara de huevo (opcional)",
        "name_de": "Eiweiß (optional)",
        "name_fr": "Blanc d'œuf (facultatif)",
        "name_pt": "Clara de ovo (opcional)",
        "name_tr": "Yumurta akı (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pisco",
        "name_es": "Pisco",
        "name_de": "Pisco",
        "name_fr": "Pisco",
        "name_pt": "Pisco",
        "name_tr": "Pisco"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar syrup",
        "name_es": "Jarabe de azúcar",
        "name_de": "Zuckersirup",
        "name_fr": "Sirop de sucre",
        "name_pt": "Xarope de açúcar",
        "name_tr": "Şeker şurubu"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 10.0,
    "protein_g": 0.4,
    "carbohydrates_g": 0.5,
    "fat_g": 0.8,
    "fiber_g": 0.2,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pistachio (garnish)",
    "display_name_es": "Pistacho (guarnición)",
    "display_name_de": "Pistazie (Garnitur)",
    "display_name_fr": "Pistache (garniture)",
    "display_name_pt": "Pistache (para decorar)",
    "display_name_tr": "Antep fıstığı (süsleme)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Pistachio",
        "name_es": "Pistacho",
        "name_de": "Pistazie",
        "name_fr": "Pistache",
        "name_pt": "Pistache",
        "name_tr": "Fıstık"
      }
    ]
  },
  {
    "category": "Nut",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 159.0,
    "protein_g": 5.7,
    "carbohydrates_g": 7.7,
    "fat_g": 12.8,
    "fiber_g": 3.0,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pistachios (1 oz shelled)",
    "display_name_es": "Pistachos (1 oz sin cáscara)",
    "display_name_de": "Pistazien (1 oz geschält)",
    "display_name_fr": "Pistaches (1 oz décortiquées)",
    "display_name_pt": "Pistaches (28 g sem casca)",
    "display_name_tr": "Antep fıstığı (1 ons kabuklu)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pistachios",
        "name_es": "Pistachos",
        "name_de": "Pistazien",
        "name_fr": "Pistaches",
        "name_pt": "Pistaches",
        "name_tr": "Antep fıstığı"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 165.0,
    "protein_g": 5.5,
    "carbohydrates_g": 33.0,
    "fat_g": 1.2,
    "fiber_g": 1.5,
    "sodium_mg": 310.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pita Bread (1 white)",
    "display_name_es": "Pan pita (1 blanco)",
    "display_name_de": "Pitabrot (1 weiß)",
    "display_name_fr": "Pain pita (1 blanc)",
    "display_name_pt": "Pão pita (1 branco)",
    "display_name_tr": "Pide Ekmeği (1 beyaz)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "White pita bread",
        "name_es": "Pan de pita blanco",
        "name_de": "Weißes Pitabrot",
        "name_fr": "pain pita blanc",
        "name_pt": "Pão pita branco",
        "name_tr": "Beyaz pide ekmeği"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 170.0,
    "protein_g": 6.0,
    "carbohydrates_g": 35.0,
    "fat_g": 1.5,
    "fiber_g": 5.0,
    "sodium_mg": 320.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pita Bread (1 whole wheat)",
    "display_name_es": "Pan pita (1 integral)",
    "display_name_de": "Pitabrot (1 Vollkorn)",
    "display_name_fr": "Pain pita (1 pain complet)",
    "display_name_pt": "Pão pita (1 integral)",
    "display_name_tr": "Pide Ekmeği (1 tam buğday)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Whole wheat pita bread",
        "name_es": "Pan de pita integral",
        "name_de": "Vollkorn-Pitabrot",
        "name_fr": "pain pita complet",
        "name_pt": "pão pita integral",
        "name_tr": "Tam buğday pide ekmeği"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 93.0,
    "protein_g": 3.0,
    "carbohydrates_g": 18.6,
    "fat_g": 1.1,
    "fiber_g": 3.6,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Popcorn (3 cups air-popped)",
    "display_name_es": "Palomitas de maíz (3 tazas de palomitas de maíz hechas con aire caliente)",
    "display_name_de": "Popcorn (3 Tassen luftgepoppt)",
    "display_name_fr": "Popcorn (3 tasses soufflées à l'air)",
    "display_name_pt": "Pipoca (3 xícaras estouradas no ar)",
    "display_name_tr": "Patlamış mısır (3 su bardağı hava ile patlatılmış)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Corn kernels",
        "name_es": "Granos de maíz",
        "name_de": "Maiskörner",
        "name_fr": "Grains de maïs",
        "name_pt": "Grãos de milho",
        "name_tr": "Mısır taneleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 160.0,
    "protein_g": 2.0,
    "carbohydrates_g": 15.0,
    "fat_g": 10.0,
    "fiber_g": 1.0,
    "sodium_mg": 170.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Potato Chips (1 oz)",
    "display_name_es": "Papas fritas (1 oz)",
    "display_name_de": "Kartoffelchips (1 oz)",
    "display_name_fr": "Chips (1 oz)",
    "display_name_pt": "Batatas fritas (28 g)",
    "display_name_tr": "Patates Cipsi (1 oz)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Papa",
        "name_de": "Kartoffel",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Grain/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 110.0,
    "protein_g": 3.0,
    "carbohydrates_g": 23.0,
    "fat_g": 1.0,
    "fiber_g": 1.0,
    "sodium_mg": 450.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Pretzels (1 oz)",
    "display_name_es": "Pretzels (1 onza)",
    "display_name_de": "Brezeln (1 oz)",
    "display_name_fr": "Bretzels (1 oz)",
    "display_name_pt": "Pretzels (28 g)",
    "display_name_tr": "Simit (1 oz)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Pretzels",
        "name_es": "Pretzels",
        "name_de": "Brezeln",
        "name_fr": "Bretzels",
        "name_pt": "Pretzels",
        "name_tr": "Simit"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 70.0,
    "protein_g": 0.0,
    "carbohydrates_g": 2.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Prosecco (3 oz)",
    "display_name_es": "Prosecco (3 oz)",
    "display_name_de": "Prosecco (3 oz)",
    "display_name_fr": "Prosecco (3 oz)",
    "display_name_pt": "Prosecco (90 ml)",
    "display_name_tr": "Prosecco (3 ons)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Prosecco wine",
        "name_es": "vino Prosecco",
        "name_de": "Prosecco-Wein",
        "name_fr": "vin Prosecco",
        "name_pt": "Vinho Prosecco",
        "name_tr": "Prosecco şarabı"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 100.0,
    "protein_g": 7.0,
    "carbohydrates_g": 1.0,
    "fat_g": 8.0,
    "fiber_g": 0.0,
    "sodium_mg": 250.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "Provolone Cheese (1 slice)",
    "display_name_es": "Queso provolone (1 rebanada)",
    "display_name_de": "Provolone-Käse (1 Scheibe)",
    "display_name_fr": "Fromage provolone (1 tranche)",
    "display_name_pt": "Queijo Provolone (1 fatia)",
    "display_name_tr": "Provolone Peyniri (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Provolone cheese",
        "name_es": "queso provolone",
        "name_de": "Provolone-Käse",
        "name_fr": "fromage provolone",
        "name_pt": "queijo Provolone",
        "name_tr": "Provolone peyniri"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 130.0,
    "protein_g": 1.3,
    "carbohydrates_g": 34.0,
    "fat_g": 0.2,
    "fiber_g": 1.6,
    "sodium_mg": 5.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Raisins (1/4 cup)",
    "display_name_es": "Pasas (1/4 taza)",
    "display_name_de": "Rosinen (1/4 Tasse)",
    "display_name_fr": "Raisins secs (1/4 tasse)",
    "display_name_pt": "Uvas-passas (1/4 de xícara)",
    "display_name_tr": "Kuru üzüm (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Raisins",
        "name_es": "Pasas",
        "name_de": "Rosinen",
        "name_fr": "Raisins",
        "name_pt": "Uvas passas",
        "name_tr": "Kuru üzüm"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 1,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 64.0,
    "protein_g": 1.5,
    "carbohydrates_g": 14.7,
    "fat_g": 0.8,
    "fiber_g": 8.0,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Raspberries (1 cup)",
    "display_name_es": "Frambuesas (1 taza)",
    "display_name_de": "Himbeeren (1 Tasse)",
    "display_name_fr": "Framboises (1 tasse)",
    "display_name_pt": "Framboesas (1 xícara)",
    "display_name_tr": "Ahududu (1 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Raspberries",
        "name_es": "Frambuesas",
        "name_de": "Himbeeren",
        "name_fr": "Framboises",
        "name_pt": "Framboesas",
        "name_tr": "Ahududu"
      }
    ]
  },
  {
    "category": "Grain",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 51.0,
    "protein_g": 1.1,
    "carbohydrates_g": 11.1,
    "fat_g": 0.1,
    "fiber_g": 0.1,
    "sodium_mg": 0.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Rice (1/4 cup filling)",
    "display_name_es": "Arroz (1/4 taza de relleno)",
    "display_name_de": "Reis (1/4 Tasse Füllung)",
    "display_name_fr": "Riz (garniture de 1/4 de tasse)",
    "display_name_pt": "Arroz (1/4 de xícara de recheio)",
    "display_name_tr": "Pirinç (1/4 su bardağı iç harç)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "White rice",
        "name_es": "arroz blanco",
        "name_de": "Weißer Reis",
        "name_fr": "riz blanc",
        "name_pt": "Arroz branco",
        "name_tr": "Beyaz pirinç"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 49.0,
    "protein_g": 3.2,
    "carbohydrates_g": 0.8,
    "fat_g": 3.8,
    "fiber_g": 0.0,
    "sodium_mg": 23.0,
    "cholesterol_mg": 14.0,
    "water_ml": 0.0,
    "display_name_en": "Ricotta (filling 1 oz)",
    "display_name_es": "Ricotta (relleno 1 oz)",
    "display_name_de": "Ricotta (Füllung 1 oz)",
    "display_name_fr": "Ricotta (garniture 1 oz)",
    "display_name_pt": "Ricota (recheio de 30 g)",
    "display_name_tr": "Ricotta (dolgu 1 oz)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Ricotta cheese",
        "name_es": "Queso ricotta",
        "name_de": "Ricotta-Käse",
        "name_fr": "fromage ricotta",
        "name_pt": "Queijo Ricota",
        "name_tr": "Ricotta peyniri"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 140.0,
    "protein_g": 2.0,
    "carbohydrates_g": 25.0,
    "fat_g": 4.0,
    "fiber_g": 1.0,
    "sodium_mg": 90.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "S'more (1 serving)",
    "display_name_es": "S'more (1 porción)",
    "display_name_de": "S'more (1 Portion)",
    "display_name_fr": "S'more (1 portion)",
    "display_name_pt": "S'more (1 porção)",
    "display_name_tr": "S'more (1 porsiyon)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Graham cracker",
        "name_es": "Galleta Graham",
        "name_de": "Graham-Cracker",
        "name_fr": "Biscuit Graham",
        "name_pt": "Biscoito Graham",
        "name_tr": "Graham kraker"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chocolate",
        "name_es": "Chocolate",
        "name_de": "Schokolade",
        "name_fr": "Chocolat",
        "name_pt": "Chocolate",
        "name_tr": "Çikolata"
      },
      {
        "category_en": "Pantry",
        "name_en": "Marshmallow",
        "name_es": "Malvavisco",
        "name_de": "Marshmallow",
        "name_fr": "Guimauve",
        "name_pt": "Marshmallow",
        "name_tr": "Hatmi"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 130.0,
    "protein_g": 2.0,
    "carbohydrates_g": 18.0,
    "fat_g": 6.0,
    "fiber_g": 2.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Samosa (1 piece vegetable)",
    "display_name_es": "Samosa (1 pieza vegetal)",
    "display_name_de": "Samosa (1 Stück Gemüse)",
    "display_name_fr": "Samosa (1 pièce de légumes)",
    "display_name_pt": "Samosa (1 unidade de vegetais)",
    "display_name_tr": "Samosa (1 adet sebze)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Patata",
        "name_de": "Kartoffeln",
        "name_fr": "Pommes de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Produce",
        "name_en": "Peas",
        "name_es": "Guisantes",
        "name_de": "Erbsen",
        "name_fr": "Petits pois",
        "name_pt": "Ervilha",
        "name_tr": "Bezelye"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignons",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Pantry",
        "name_en": "Pastry dough",
        "name_es": "Masa de hojaldre",
        "name_de": "Blätterteig",
        "name_fr": "Pâte à tarte",
        "name_pt": "Massa folhada",
        "name_tr": "Hamur işleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Spices",
        "name_es": "Especias",
        "name_de": "Gewürze",
        "name_fr": "Épices",
        "name_pt": "Especiarias",
        "name_tr": "Baharatlar"
      }
    ]
  },
  {
    "category": "Protein/Seafood",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 60.0,
    "protein_g": 10.0,
    "carbohydrates_g": 1.0,
    "fat_g": 1.0,
    "fiber_g": 0.0,
    "sodium_mg": 300.0,
    "cholesterol_mg": 110.0,
    "water_ml": 0.0,
    "display_name_en": "Shrimp Cocktail (4 large shrimp)",
    "display_name_es": "Cóctel de camarones (4 camarones grandes)",
    "display_name_de": "Garnelencocktail (4 große Garnelen)",
    "display_name_fr": "Cocktail de crevettes (4 grosses crevettes)",
    "display_name_pt": "Coquetel de camarão (4 camarões grandes)",
    "display_name_tr": "Karides Kokteyli (4 büyük karides)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Lemon",
        "name_es": "Limón",
        "name_de": "Zitrone",
        "name_fr": "Citron",
        "name_pt": "Limão",
        "name_tr": "Limon"
      },
      {
        "category_en": "Produce",
        "name_en": "Lettuce (bed)",
        "name_es": "Lechuga (cama)",
        "name_de": "Salat (Beet)",
        "name_fr": "Laitue (lit)",
        "name_pt": "Alface (cama)",
        "name_tr": "Marul (yatak)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Shrimp",
        "name_es": "Camarones",
        "name_de": "Garnelen",
        "name_fr": "Crevettes",
        "name_pt": "Camarão",
        "name_tr": "Karides"
      },
      {
        "category_en": "Pantry",
        "name_en": "Cocktail sauce",
        "name_es": "Salsa cóctel",
        "name_de": "Cocktailsauce",
        "name_fr": "Sauce cocktail",
        "name_pt": "Molho cocktail",
        "name_tr": "Kokteyl sosu"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 140.0,
    "protein_g": 0.0,
    "carbohydrates_g": 39.0,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 45.0,
    "cholesterol_mg": 0.0,
    "water_ml": 355.0,
    "display_name_en": "Soda (1 can Coke)",
    "display_name_es": "Refresco (1 lata de Coca-Cola)",
    "display_name_de": "Limonade (1 Dose Cola)",
    "display_name_fr": "Soda (1 canette de Coca-Cola)",
    "display_name_pt": "Refrigerante (1 lata de Coca-Cola)",
    "display_name_tr": "Soda (1 kutu Kola)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Cola soda",
        "name_es": "Refresco de cola",
        "name_de": "Cola-Limonade",
        "name_fr": "soda cola",
        "name_pt": "Refrigerante de cola",
        "name_tr": "Kola sodası"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 160.0,
    "protein_g": 5.0,
    "carbohydrates_g": 6.0,
    "fat_g": 14.0,
    "fiber_g": 2.0,
    "sodium_mg": 350.0,
    "cholesterol_mg": 30.0,
    "water_ml": 0.0,
    "display_name_en": "Spinach Artichoke Dip (1/4 cup)",
    "display_name_es": "Dip de espinacas y alcachofas (1/4 taza)",
    "display_name_de": "Spinat-Artischocken-Dip (1/4 Tasse)",
    "display_name_fr": "Trempette aux épinards et aux artichauts (1/4 tasse)",
    "display_name_pt": "Pasta de espinafre com alcachofra (1/4 de xícara)",
    "display_name_tr": "Ispanak Enginar Sosu (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Spinach",
        "name_es": "Espinacas",
        "name_de": "Spinat",
        "name_fr": "Épinards",
        "name_pt": "Espinafre",
        "name_tr": "Ispanak"
      },
      {
        "category_en": "Produce",
        "name_en": "Artichoke",
        "name_es": "Alcachofa",
        "name_de": "Artischocke",
        "name_fr": "Artichauts",
        "name_pt": "Alcachofra",
        "name_tr": "Enginar"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream cheese",
        "name_es": "Queso crema",
        "name_de": "Frischkäse",
        "name_fr": "Fromage à la crème",
        "name_pt": "Queijo cremoso",
        "name_tr": "Krema peyniri"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Sour cream",
        "name_es": "Crema agria",
        "name_de": "Saure Sahne",
        "name_fr": "Crème fraîche",
        "name_pt": "Creme azedo",
        "name_tr": "Ekşi krema"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Parmesan cheese",
        "name_es": "Queso parmesano",
        "name_de": "Parmesan",
        "name_fr": "Parmesan",
        "name_pt": "Queijo parmesão",
        "name_tr": "Parmesan peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Garlic",
        "name_es": "Ajo",
        "name_de": "Knoblauch",
        "name_fr": "Ail",
        "name_pt": "Alho",
        "name_tr": "Sarımsak"
      }
    ]
  },
  {
    "category": "Dairy",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 1,
    "diet_keto": 1,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 80.0,
    "protein_g": 6.0,
    "carbohydrates_g": 1.0,
    "fat_g": 6.0,
    "fiber_g": 0.0,
    "sodium_mg": 210.0,
    "cholesterol_mg": 20.0,
    "water_ml": 0.0,
    "display_name_en": "String Cheese (1 stick)",
    "display_name_es": "Queso en tiras (1 barra)",
    "display_name_de": "Käsesticks (1 Stück)",
    "display_name_fr": "Fromage en bâtonnets (1 bâtonnet)",
    "display_name_pt": "Queijo em palitos (1 unidade)",
    "display_name_tr": "Tel Peynir (1 çubuk)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "queso mozzarella",
        "name_de": "Mozzarella-Käse",
        "name_fr": "fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      }
    ]
  },
  {
    "category": "Meal/Vegetarian",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 150.0,
    "protein_g": 3.0,
    "carbohydrates_g": 20.0,
    "fat_g": 7.0,
    "fiber_g": 3.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Stuffed Grape Leaves (3 pcs)",
    "display_name_es": "Hojas de parra rellenas (3 piezas)",
    "display_name_de": "Gefüllte Weinblätter (3 Stück)",
    "display_name_fr": "Feuilles de vigne farcies (3 pièces)",
    "display_name_pt": "Folhas de uva recheadas (3 unidades)",
    "display_name_tr": "Yaprak Sarma (3 adet)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Grape leaves",
        "name_es": "Hojas de parra",
        "name_de": "Weinblätter",
        "name_fr": "Feuilles de vigne",
        "name_pt": "Folhas de uva",
        "name_tr": "Üzüm yaprakları"
      },
      {
        "category_en": "Produce",
        "name_en": "Onion",
        "name_es": "Cebolla",
        "name_de": "Zwiebeln",
        "name_fr": "Oignon",
        "name_pt": "Cebola",
        "name_tr": "Soğan"
      },
      {
        "category_en": "Produce",
        "name_en": "Herbs",
        "name_es": "Hierbas",
        "name_de": "Kräuter",
        "name_fr": "Herbes",
        "name_pt": "Ervas",
        "name_tr": "Otlar"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice",
        "name_es": "Arroz",
        "name_de": "Reis",
        "name_fr": "Riz",
        "name_pt": "Arroz",
        "name_tr": "Pirinç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive oil",
        "name_es": "Aceite de oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 1,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 200.0,
    "protein_g": 8.0,
    "carbohydrates_g": 25.0,
    "fat_g": 8.0,
    "fiber_g": 2.0,
    "sodium_mg": 400.0,
    "cholesterol_mg": 25.0,
    "water_ml": 0.0,
    "display_name_en": "Supplì (1 piece fried rice ball)",
    "display_name_es": "Supplì (1 pieza de bola de arroz frito)",
    "display_name_de": "Supplì (1 Stück frittierter Reisball)",
    "display_name_fr": "Supplì (1 boulette de riz frit)",
    "display_name_pt": "Supplì (1 bolinho de arroz frito)",
    "display_name_tr": "Supplì (1 adet kızarmış pirinç topu)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomato (in sauce)",
        "name_es": "Tomate (en salsa)",
        "name_de": "Tomate (in Soße)",
        "name_fr": "Tomate (en sauce)",
        "name_pt": "Tomate (em molho)",
        "name_tr": "Domates (soslu)"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mozzarella cheese",
        "name_es": "queso mozzarella",
        "name_de": "Mozzarella-Käse",
        "name_fr": "fromage mozzarella",
        "name_pt": "Queijo mussarela",
        "name_tr": "Mozzarella peyniri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Rice",
        "name_es": "Arroz",
        "name_de": "Reis",
        "name_fr": "Riz",
        "name_pt": "Arroz",
        "name_tr": "Pirinç"
      },
      {
        "category_en": "Pantry",
        "name_en": "Breadcrumbs",
        "name_es": "Pan rallado",
        "name_de": "Paniermehl",
        "name_fr": "Chapelure",
        "name_pt": "Farinha de rosca",
        "name_tr": "Ekmek kırıntıları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Oil",
        "name_es": "Aceite",
        "name_de": "Öl",
        "name_fr": "Huile",
        "name_pt": "Óleo",
        "name_tr": "Yağ"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 250.0,
    "protein_g": 3.0,
    "carbohydrates_g": 35.0,
    "fat_g": 12.0,
    "fiber_g": 0.0,
    "sodium_mg": 50.0,
    "cholesterol_mg": 35.0,
    "water_ml": 300.0,
    "display_name_en": "Thai Iced Tea (1 glass)",
    "display_name_es": "Té helado tailandés (1 vaso)",
    "display_name_de": "Thailändischer Eistee (1 Glas)",
    "display_name_fr": "Thé glacé thaï (1 verre)",
    "display_name_pt": "Chá gelado tailandês (1 copo)",
    "display_name_tr": "Tay Buzlu Çayı (1 bardak)",
    "ingredients_details": [
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Milk",
        "name_es": "Leche",
        "name_de": "Milch",
        "name_fr": "Lait",
        "name_pt": "Leite",
        "name_tr": "Süt"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme",
        "name_tr": "Krema"
      },
      {
        "category_en": "Pantry",
        "name_en": "Thai tea",
        "name_es": "Té tailandés",
        "name_de": "Thai-Tee",
        "name_fr": "Thé thaï",
        "name_pt": "Chá tailandês",
        "name_tr": "Tay çayı"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Dessert",
    "meal_type": "Snack",
    "is_bonus": 1,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 0,
    "diet_mediterranean": 0,
    "calories_kcal": 450.0,
    "protein_g": 7.0,
    "carbohydrates_g": 42.0,
    "fat_g": 28.0,
    "fiber_g": 2.0,
    "sodium_mg": 150.0,
    "cholesterol_mg": 180.0,
    "water_ml": 250.0,
    "display_name_en": "Tiramisu (1 slice)",
    "display_name_es": "Tiramisú (1 rebanada)",
    "display_name_de": "Tiramisu (1 Stück)",
    "display_name_fr": "Tiramisu (1 tranche)",
    "display_name_pt": "Tiramisu (1 fatia)",
    "display_name_tr": "Tiramisu (1 dilim)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cocoa powder",
        "name_es": "Cacao en polvo",
        "name_de": "Kakaopulver",
        "name_fr": "Poudre de cacao",
        "name_pt": "Cacau em pó",
        "name_tr": "Kakao tozu"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Mascarpone cheese",
        "name_es": "Queso mascarpone",
        "name_de": "Mascarpone-Käse",
        "name_fr": "Fromage mascarpone",
        "name_pt": "Queijo mascarpone",
        "name_tr": "Mascarpone peyniri"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Cream",
        "name_es": "Crema",
        "name_de": "Sahne",
        "name_fr": "Crème",
        "name_pt": "Creme",
        "name_tr": "Krema"
      },
      {
        "category_en": "Pantry",
        "name_en": "Ladyfingers",
        "name_es": "Bizcochos de soletilla",
        "name_de": "Löffelbiskuits",
        "name_fr": "Biscuits à la cuillère",
        "name_pt": "Biscoitos champanhe",
        "name_tr": "Kedi Parmakları"
      },
      {
        "category_en": "Pantry",
        "name_en": "Espresso",
        "name_es": "Espresso",
        "name_de": "Espresso",
        "name_fr": "Espresso",
        "name_pt": "Café expresso",
        "name_tr": "Espresso"
      },
      {
        "category_en": "Pantry",
        "name_en": "Sugar",
        "name_es": "Azúcar",
        "name_de": "Zucker",
        "name_fr": "Sucre",
        "name_pt": "Açúcar",
        "name_tr": "Şeker"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 140.0,
    "protein_g": 2.0,
    "carbohydrates_g": 19.0,
    "fat_g": 7.0,
    "fiber_g": 2.0,
    "sodium_mg": 120.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Tortilla Chips (1 oz)",
    "display_name_es": "Chips de tortilla (1 oz)",
    "display_name_de": "Tortilla-Chips (1 oz)",
    "display_name_fr": "Chips tortilla (1 oz)",
    "display_name_pt": "Tortilhas chips (28 g)",
    "display_name_tr": "Tortilla Cipsleri (1 oz)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Corn tortilla chips",
        "name_es": "Totopos de maíz",
        "name_de": "Maistortilla-Chips",
        "name_fr": "Chips de tortillas de maïs",
        "name_pt": "Tortilhas de milho chips",
        "name_tr": "Mısır tortilla cipsleri"
      },
      {
        "category_en": "Pantry",
        "name_en": "Salt",
        "name_es": "Sal",
        "name_de": "Salz",
        "name_fr": "Sel",
        "name_pt": "Sal",
        "name_tr": "Tuz"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 1,
    "calories_kcal": 190.0,
    "protein_g": 5.0,
    "carbohydrates_g": 20.0,
    "fat_g": 12.0,
    "fiber_g": 3.0,
    "sodium_mg": 50.0,
    "cholesterol_mg": 0.0,
    "water_ml": 250.0,
    "display_name_en": "Trail Mix (1/4 cup)",
    "display_name_es": "Mezcla de frutos secos (1/4 taza)",
    "display_name_de": "Studentenfutter (1/4 Tasse)",
    "display_name_fr": "Mélange de fruits secs (1/4 tasse)",
    "display_name_pt": "Mistura de trilha (1/4 de xícara)",
    "display_name_tr": "Kuruyemiş Karışımı (1/4 su bardağı)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Raisins",
        "name_es": "Pasas",
        "name_de": "Rosinen",
        "name_fr": "Raisins secs",
        "name_pt": "Uvas-passas",
        "name_tr": "Kuru üzüm"
      },
      {
        "category_en": "Produce",
        "name_en": "Dried fruit",
        "name_es": "Frutos secos",
        "name_de": "Trockenfrüchte",
        "name_fr": "Fruits secs",
        "name_pt": "Frutas secas",
        "name_tr": "Kuru meyve"
      },
      {
        "category_en": "Pantry",
        "name_en": "Mixed nuts",
        "name_es": "Frutos secos mixtos",
        "name_de": "Gemischte Nüsse",
        "name_fr": "Noix mélangées",
        "name_pt": "Mix de nozes",
        "name_tr": "Karışık kuruyemişler"
      },
      {
        "category_en": "Pantry",
        "name_en": "Chocolate pieces",
        "name_es": "Trozos de chocolate",
        "name_de": "Schokoladenstückchen",
        "name_fr": "Morceaux de chocolat",
        "name_pt": "Pedaços de chocolate",
        "name_tr": "Çikolata parçaları"
      }
    ]
  },
  {
    "category": "Beverage",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 5.0,
    "protein_g": 0.2,
    "carbohydrates_g": 0.5,
    "fat_g": 0.0,
    "fiber_g": 0.0,
    "sodium_mg": 1.0,
    "cholesterol_mg": 0.0,
    "water_ml": 60.0,
    "display_name_en": "Turkish Coffee (1 small cup)",
    "display_name_es": "Café turco (1 taza pequeña)",
    "display_name_de": "Türkischer Kaffee (1 kleine Tasse)",
    "display_name_fr": "Café turc (1 petite tasse)",
    "display_name_pt": "Café turco (1 xícara pequena)",
    "display_name_tr": "Türk Kahvesi (1 küçük fincan)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Cardamom (optional)",
        "name_es": "Cardamomo (opcional)",
        "name_de": "Kardamom (optional)",
        "name_fr": "Cardamome (facultatif)",
        "name_pt": "Cardamomo (opcional)",
        "name_tr": "Kakule (isteğe bağlı)"
      },
      {
        "category_en": "Pantry",
        "name_en": "Turkish coffee",
        "name_es": "café turco",
        "name_de": "Türkischer Kaffee",
        "name_fr": "café turc",
        "name_pt": "café turco",
        "name_tr": "Türk kahvesi"
      }
    ]
  },
  {
    "category": "Snack/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 0,
    "diet_vegan": 0,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 130.0,
    "protein_g": 1.0,
    "carbohydrates_g": 17.0,
    "fat_g": 7.0,
    "fiber_g": 1.0,
    "sodium_mg": 220.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Veggie Straws (1 oz)",
    "display_name_es": "Pajitas de verduras (1 oz)",
    "display_name_de": "Gemüsestrohhalme (1 oz)",
    "display_name_fr": "Pailles de légumes (1 oz)",
    "display_name_pt": "Palitos de Vegetais (28 g)",
    "display_name_tr": "Sebze Pipetleri (1 oz)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Potato",
        "name_es": "Patata",
        "name_de": "Kartoffeln",
        "name_fr": "Pomme de terre",
        "name_pt": "Batata",
        "name_tr": "Patates"
      },
      {
        "category_en": "Produce",
        "name_en": "Spinach",
        "name_es": "Espinaca",
        "name_de": "Spinat",
        "name_fr": "Épinards",
        "name_pt": "Espinafre",
        "name_tr": "Ispanak"
      },
      {
        "category_en": "Produce",
        "name_en": "Tomato",
        "name_es": "Tomate",
        "name_de": "Tomaten",
        "name_fr": "Tomate",
        "name_pt": "Tomate",
        "name_tr": "Domates"
      },
      {
        "category_en": "Pantry",
        "name_en": "Veggie snack mix",
        "name_es": "Mezcla de bocadillos vegetarianos",
        "name_de": "Gemüsesnackmischung",
        "name_fr": "Mélange de légumes pour grignotage",
        "name_pt": "Mix de petiscos de vegetais",
        "name_tr": "Vejetaryen atıştırmalık karışımı"
      }
    ]
  },
  {
    "category": "Grain/Processed",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 0,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 70.0,
    "protein_g": 1.5,
    "carbohydrates_g": 12.0,
    "fat_g": 1.5,
    "fiber_g": 0.5,
    "sodium_mg": 150.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Water Cracker (5 crackers)",
    "display_name_es": "Galleta de agua (5 galletas)",
    "display_name_de": "Wassercracker (5 Cracker)",
    "display_name_fr": "Craquelins à l'eau (5 crackers)",
    "display_name_pt": "Biscoito de água (5 biscoitos)",
    "display_name_tr": "Kraker (5 kraker)",
    "ingredients_details": [
      {
        "category_en": "Pantry",
        "name_en": "Water crackers",
        "name_es": "Galletas de agua",
        "name_de": "Wassercracker",
        "name_fr": "Craquelins à l'eau",
        "name_pt": "biscoitos de água",
        "name_tr": "Su krakerleri"
      }
    ]
  },
  {
    "category": "Fruit",
    "meal_type": "Snack",
    "is_bonus": 0,
    "diet_vegetarian": 1,
    "diet_vegan": 1,
    "diet_high_protein": 0,
    "diet_low_carb": 0,
    "diet_keto": 0,
    "diet_balanced": 0,
    "diet_high_fiber": 0,
    "diet_low_sodium": 1,
    "diet_low_cholesterol": 1,
    "diet_mediterranean": 0,
    "calories_kcal": 46.0,
    "protein_g": 0.9,
    "carbohydrates_g": 11.5,
    "fat_g": 0.2,
    "fiber_g": 0.6,
    "sodium_mg": 2.0,
    "cholesterol_mg": 0.0,
    "water_ml": 0.0,
    "display_name_en": "Watermelon (1 cup diced)",
    "display_name_es": "Sandía (1 taza cortada en cubitos)",
    "display_name_de": "Wassermelone (1 Tasse gewürfelt)",
    "display_name_fr": "Pastèque (1 tasse coupée en dés)",
    "display_name_pt": "Melancia (1 xícara picada)",
    "display_name_tr": "Karpuz (1 su bardağı küp doğranmış)",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Watermelon",
        "name_es": "Sandía",
        "name_de": "Wassermelone",
        "name_fr": "Pastèque",
        "name_pt": "Melancia",
        "name_tr": "Karpuz"
      }
    ]
  },
  {
    "display_name_en": "Oatmeal with Berries",
    "display_name_es": "Avena con bayas",
    "display_name_de": "Haferflocken mit Beeren",
    "display_name_fr": "Flocons d'avoine aux baies",
    "display_name_pt": "Aveia com frutas vermelhas",
    "display_name_tr": "Orman Meyveli Yulaf Ezmesi",
    "category": "Meal/Cereal",
    "meal_type": "Breakfast",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
    "calories_kcal": 300.0, "protein_g": 10.0, "carbohydrates_g": 50.0, "fat_g": 6.0, "fiber_g": 8.0, "sodium_mg": 10.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Oats", "Mixed Berries", "Almond Milk", "Honey"]
  },
  {
    "display_name_en": "Turkish Breakfast Plate",
    "display_name_es": "Plato de desayuno turco",
    "display_name_de": "Türkischer Frühstücksteller",
    "display_name_fr": "Assiette petit-déjeuner turc",
    "display_name_pt": "Prato de café da manhã turco",
    "display_name_tr": "Klasik Kahvaltı Tabağı",
    "category": "Meal/Mixed",
    "meal_type": "Breakfast",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
    "calories_kcal": 450.0, "protein_g": 18.0, "carbohydrates_g": 35.0, "fat_g": 25.0, "fiber_g": 4.0, "sodium_mg": 600.0, "cholesterol_mg": 200.0, "water_ml": 0.0,
    "ingredients": ["Feta Cheese", "Olives", "Cucumber", "Tomato", "Egg", "Whole Wheat Bread"]
  },
  {
    "display_name_en": "Menemen",
    "display_name_es": "Menemen",
    "display_name_de": "Menemen",
    "display_name_fr": "Menemen",
    "display_name_pt": "Menemen",
    "display_name_tr": "Menemen",
    "category": "Meal/Protein",
    "meal_type": "Breakfast",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
    "calories_kcal": 340.0, "protein_g": 18.0, "carbohydrates_g": 12.0, "fat_g": 24.0, "fiber_g": 4.0, "sodium_mg": 450.0, "cholesterol_mg": 400.0, "water_ml": 0.0,
    "ingredients": ["Eggs", "Tomatoes", "Green Peppers", "Olive Oil", "Onion"]
  },
  {
    "display_name_en": "Simit & Cheese",
    "display_name_es": "Simit y queso",
    "display_name_de": "Simit & Käse",
    "display_name_fr": "Simit & fromage",
    "display_name_pt": "Simit e queijo",
    "display_name_tr": "Simit & Peynir",
    "category": "Meal/Grain",
    "meal_type": "Breakfast",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 0, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
    "calories_kcal": 400.0, "protein_g": 12.0, "carbohydrates_g": 55.0, "fat_g": 15.0, "fiber_g": 3.0, "sodium_mg": 500.0, "cholesterol_mg": 30.0, "water_ml": 0.0,
    "ingredients": ["Simit", "Cream Cheese", "Cucumber"]
  },
  {
    "display_name_en": "Chia Pudding",
    "display_name_es": "Pudín de chía",
    "display_name_de": "Chia-Pudding",
    "display_name_fr": "Pudding de chia",
    "display_name_pt": "Pudim de chia",
    "display_name_tr": "Chia Puding",
    "category": "Meal/Plant",
    "meal_type": "Breakfast",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
    "calories_kcal": 250.0, "protein_g": 8.0, "carbohydrates_g": 20.0, "fat_g": 12.0, "fiber_g": 10.0, "sodium_mg": 10.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Chia Seeds", "Coconut Milk", "Vanilla Extract", "Strawberries"]
  },
  {
    "display_name_en": "Mushroom Omelette",
    "display_name_es": "Tortilla de champiñones",
    "display_name_de": "Pilzomelett",
    "display_name_fr": "Omelette aux champignons",
    "display_name_pt": "Omelete de cogumelos",
    "display_name_tr": "Mantarlı Omlet",
    "category": "Meal/Protein",
    "meal_type": "Breakfast",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
    "calories_kcal": 320.0, "protein_g": 20.0, "carbohydrates_g": 5.0, "fat_g": 22.0, "fiber_g": 2.0, "sodium_mg": 300.0, "cholesterol_mg": 380.0, "water_ml": 0.0,
    "ingredients": ["Eggs", "Mushrooms", "Butter", "Parsley", "Salt"]
  },
  {
    "display_name_en": "Avocado Toast",
    "display_name_es": "Tostada de aguacate",
    "display_name_de": "Avocado-Toast",
    "display_name_fr": "Toast à l'avocat",
    "display_name_pt": "Torrada de abacate",
    "display_name_tr": "Avokadolu Tost",
    "category": "Meal/Plant",
    "meal_type": "Breakfast",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
    "calories_kcal": 350.0, "protein_g": 8.0, "carbohydrates_g": 35.0, "fat_g": 20.0, "fiber_g": 9.0, "sodium_mg": 250.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Whole Grain Bread", "Avocado", "Lemon Juice", "Chili Flakes"]
  },
  {
    "display_name_en": "Greek Yogurt Parfait",
    "display_name_es": "Parfait de yogur griego",
    "display_name_de": "Griechisches Joghurt-Parfait",
    "display_name_fr": "Parfait au yaourt grec",
    "display_name_pt": "Parfait de iogurte grego",
    "display_name_tr": "Yoğurtlu Parfe",
    "category": "Meal/Dairy",
    "meal_type": "Breakfast",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
    "calories_kcal": 280.0, "protein_g": 20.0, "carbohydrates_g": 30.0, "fat_g": 8.0, "fiber_g": 3.0, "sodium_mg": 80.0, "cholesterol_mg": 15.0, "water_ml": 0.0,
    "ingredients": ["Greek Yogurt", "Granola", "Honey", "Blueberries"]
  },
  {
    "display_name_en": "Walnuts (Handful)",
    "display_name_es": "Nueces",
    "display_name_de": "Walnüsse",
    "display_name_fr": "Noix",
    "display_name_pt": "Nozes",
    "display_name_tr": "Ceviz (Bir Avuç)",
    "category": "Snack",
    "meal_type": "Snack",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
    "calories_kcal": 185.0, "protein_g": 4.0, "carbohydrates_g": 4.0, "fat_g": 18.0, "fiber_g": 2.0, "sodium_mg": 0.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Walnuts"]
  },
  {
    "display_name_en": "Dried Apricots",
    "display_name_es": "Albaricoques secos",
    "display_name_de": "Getrocknete Aprikosen",
    "display_name_fr": "Abricots secs",
    "display_name_pt": "Damascos secos",
    "display_name_tr": "Kuru Kayısı",
    "category": "Snack",
    "meal_type": "Snack",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
    "calories_kcal": 120.0, "protein_g": 2.0, "carbohydrates_g": 30.0, "fat_g": 0.0, "fiber_g": 4.0, "sodium_mg": 5.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Dried Apricots"]
  },
  {
    "display_name_en": "Kefir",
    "display_name_es": "Kéfir",
    "display_name_de": "Kefir",
    "display_name_fr": "Kéfir",
    "display_name_pt": "Kefir",
    "display_name_tr": "Kefir",
    "category": "Snack",
    "meal_type": "Snack",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
    "calories_kcal": 110.0, "protein_g": 9.0, "carbohydrates_g": 10.0, "fat_g": 3.0, "fiber_g": 0.0, "sodium_mg": 80.0, "cholesterol_mg": 10.0, "water_ml": 200.0,
    "ingredients": ["Kefir"]
  },
  {
    "display_name_en": "Dark Chocolate (2 squares)",
    "display_name_es": "Chocolate negro",
    "display_name_de": "Dunkle Schokolade",
    "display_name_fr": "Chocolat noir",
    "display_name_pt": "Chocolate amargo",
    "display_name_tr": "Bitter Çikolata (2 kare)",
    "category": "Snack",
    "meal_type": "Snack",
    "is_bonus": 1, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 0,
    "calories_kcal": 120.0, "protein_g": 2.0, "carbohydrates_g": 10.0, "fat_g": 9.0, "fiber_g": 2.0, "sodium_mg": 5.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Dark Chocolate"]
  },
  {
    "display_name_en": "Banana",
    "display_name_es": "Plátano",
    "display_name_de": "Banane",
    "display_name_fr": "Banane",
    "display_name_pt": "Banana",
    "display_name_tr": "Muz",
    "category": "Snack",
    "meal_type": "Snack",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
    "calories_kcal": 105.0, "protein_g": 1.3, "carbohydrates_g": 27.0, "fat_g": 0.3, "fiber_g": 3.0, "sodium_mg": 1.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Banana"]
  },
  {
    "display_name_en": "Apple with Peanut Butter",
    "display_name_es": "Manzana con mantequilla de maní",
    "display_name_de": "Apfel mit Erdnussbutter",
    "display_name_fr": "Pomme au beurre de cacahuète",
    "display_name_pt": "Maçã com manteiga de amendoim",
    "display_name_tr": "Fıstık Ezmeli Elma",
    "category": "Snack",
    "meal_type": "Snack",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 0,
    "calories_kcal": 200.0, "protein_g": 5.0, "carbohydrates_g": 25.0, "fat_g": 10.0, "fiber_g": 5.0, "sodium_mg": 50.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Apple", "Peanut Butter"]
  },
  {
    "display_name_en": "Carrot Sticks with Hummus",
    "display_name_es": "Palitos de zanahoria con humus",
    "display_name_de": "Karottenstifte mit Hummus",
    "display_name_fr": "Bâtonnets de carotte au houmous",
    "display_name_pt": "Palitos de cenoura com homus",
    "display_name_tr": "Humuslu Havuç",
    "category": "Snack",
    "meal_type": "Snack",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 0, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
    "calories_kcal": 150.0, "protein_g": 4.0, "carbohydrates_g": 18.0, "fat_g": 8.0, "fiber_g": 6.0, "sodium_mg": 200.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Carrots", "Chickpeas", "Tahini", "Lemon Juice"]
  },
  {
    "display_name_en": "Mercimek Koftesi",
    "display_name_es": "Koftas de lentejas",
    "display_name_de": "Linsen-Köfte",
    "display_name_fr": "Boulettes de lentilles",
    "display_name_pt": "Almôndegas de lentilha",
    "display_name_tr": "Mercimek Köftesi (Porsiyon)",
    "category": "Meal/Plant",
    "meal_type": "Lunch",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 0, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
    "calories_kcal": 300.0, "protein_g": 12.0, "carbohydrates_g": 45.0, "fat_g": 8.0, "fiber_g": 8.0, "sodium_mg": 400.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Red Lentils", "Bulgur", "Onion", "Tomato Paste", "Parsley"]
  },
  {
    "display_name_en": "Karniyarik (Stuffed Eggplant)",
    "display_name_es": "Berenjena rellena",
    "display_name_de": "Karniyarik",
    "display_name_fr": "Aubergine farcie",
    "display_name_pt": "Berinjela recheada",
    "display_name_tr": "Karnıyarık",
    "category": "Meal/Mixed",
    "meal_type": "Dinner",
    "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
    "calories_kcal": 380.0, "protein_g": 14.0, "carbohydrates_g": 18.0, "fat_g": 25.0, "fiber_g": 6.0, "sodium_mg": 500.0, "cholesterol_mg": 40.0, "water_ml": 0.0,
    "ingredients": ["Eggplant", "Ground Beef", "Onion", "Tomato", "Garlic"]
  },
  {
    "display_name_en": "Grilled Sea Bass",
    "display_name_es": "Lubina a la parrilla",
    "display_name_de": "Gegrillter Wolfsbarsch",
    "display_name_fr": "Bar grillé",
    "display_name_pt": "Robalo grelhado",
    "display_name_tr": "Izgara Levrek",
    "category": "Meal/Fish",
    "meal_type": "Dinner",
    "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
    "calories_kcal": 350.0, "protein_g": 30.0, "carbohydrates_g": 0.0, "fat_g": 15.0, "fiber_g": 0.0, "sodium_mg": 100.0, "cholesterol_mg": 60.0, "water_ml": 0.0,
    "ingredients": ["Sea Bass", "Lemon", "Olive Oil", "Herbs"]
  },
  {
    "display_name_en": "Chicken Shish Kebab",
    "display_name_es": "Brocheta de pollo",
    "display_name_de": "Hähnchenspieß",
    "display_name_fr": "Brochette de poulet",
    "display_name_pt": "Espetinho de frango",
    "display_name_tr": "Tavuk Şiş (Porsiyon)",
    "category": "Meal/Protein",
    "meal_type": "Dinner",
    "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
    "calories_kcal": 380.0, "protein_g": 40.0, "carbohydrates_g": 5.0, "fat_g": 15.0, "fiber_g": 1.0, "sodium_mg": 600.0, "cholesterol_mg": 100.0, "water_ml": 0.0,
    "ingredients": ["Chicken Breast", "Peppers", "Onion", "Yogurt Marinade"]
  },
  {
    "display_name_en": "Caesar Salad",
    "display_name_es": "Ensalada César",
    "display_name_de": "Caesar Salad",
    "display_name_fr": "Salade César",
    "display_name_pt": "Salada Caesar",
    "display_name_tr": "Sezar Salata",
    "category": "Meal/Salad",
    "meal_type": "Lunch",
    "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
    "calories_kcal": 420.0, "protein_g": 25.0, "carbohydrates_g": 15.0, "fat_g": 28.0, "fiber_g": 3.0, "sodium_mg": 500.0, "cholesterol_mg": 60.0, "water_ml": 0.0,
    "ingredients": ["Romaine Lettuce", "Chicken Breast", "Parmesan Cheese", "Croutons", "Caesar Dressing"]
  },
  {
    "display_name_en": "Pasta with Tomato Sauce",
    "display_name_es": "Pasta con salsa de tomate",
    "display_name_de": "Nudeln mit Tomatensoße",
    "display_name_fr": "Pâtes à la sauce tomate",
    "display_name_pt": "Macarrão com molho de tomate",
    "display_name_tr": "Domates Soslu Makarna",
    "category": "Meal/Grain",
    "meal_type": "Lunch",
    "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
    "calories_kcal": 350.0, "protein_g": 10.0, "carbohydrates_g": 65.0, "fat_g": 4.0, "fiber_g": 3.0, "sodium_mg": 200.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
    "ingredients": ["Pasta", "Tomatoes", "Garlic", "Basil", "Olive Oil"]
  },
  {
    "display_name_en": "Salmon Bowl",
    "display_name_es": "Bol de salmón",
    "display_name_de": "Lachs-Bowl",
    "display_name_fr": "Bol de saumon",
    "display_name_pt": "Tigela de salmão",
    "display_name_tr": "Somon Bowl",
    "category": "Meal/Fish",
    "meal_type": "Lunch",
    "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
    "calories_kcal": 450.0, "protein_g": 30.0, "carbohydrates_g": 40.0, "fat_g": 18.0, "fiber_g": 5.0, "sodium_mg": 300.0, "cholesterol_mg": 50.0, "water_ml": 0.0,
    "ingredients": ["Salmon", "Brown Rice", "Avocado", "Cucumber", "Edamame"]
  },
  {
      "display_name_en": "Grilled Chicken Salad",
      "display_name_es": "Ensalada de pollo a la parrilla",
      "display_name_de": "Gegrillter Hähnchensalat",
      "display_name_fr": "Salade de poulet grillé",
      "display_name_pt": "Salada de Frango Grelhado",
      "display_name_tr": "Izgara Tavuk Salatası",
      "category": "Meal/Protein",
      "meal_type": "Lunch",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
      "calories_kcal": 350.0, "protein_g": 30.0, "carbohydrates_g": 10.0, "fat_g": 20.0, "fiber_g": 5.0, "sodium_mg": 400.0, "cholesterol_mg": 80.0, "water_ml": 0.0,
      "ingredients": ["Chicken Breast", "Mixed Greens", "Cucumber", "Tomatoes", "Olive Oil Dressing"]
  },
  {
      "display_name_en": "Quinoa Vegetable Bowl",
      "display_name_es": "Bol de quinoa y verduras",
      "display_name_de": "Quinoa-Gemüse-Bowl",
      "display_name_fr": "Bol de quinoa aux légumes",
      "display_name_pt": "Tigela de quinoa com vegetais",
      "display_name_tr": "Sebzeli Kinoa Kasesi",
      "category": "Meal/Plant",
      "meal_type": "Lunch",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 400.0, "protein_g": 12.0, "carbohydrates_g": 65.0, "fat_g": 10.0, "fiber_g": 8.0, "sodium_mg": 150.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
      "ingredients": ["Quinoa", "Roasted Vegetables", "Chickpeas", "Lemon Dressing"]
  },
  {
      "display_name_en": "Tuna Salad",
      "display_name_es": "Ensalada de atún",
      "display_name_de": "Thunfischsalat",
      "display_name_fr": "Salade de thon",
      "display_name_pt": "Salada de atum",
      "display_name_tr": "Ton Balıklı Salata",
      "category": "Meal/Fish",
      "meal_type": "Lunch",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
      "calories_kcal": 320.0, "protein_g": 28.0, "carbohydrates_g": 8.0, "fat_g": 18.0, "fiber_g": 3.0, "sodium_mg": 500.0, "cholesterol_mg": 40.0, "water_ml": 0.0,
      "ingredients": ["Canned Tuna", "Lettuce", "Corn", "Cucumber", "Olive Oil"]
  },
  {
      "display_name_en": "Lentil Soup",
      "display_name_es": "Sopa de lentejas",
      "display_name_de": "Linsensuppe",
      "display_name_fr": "Soupe aux lentilles",
      "display_name_pt": "Sopa de lentilha",
      "display_name_tr": "Mercimek Çorbası",
      "category": "Meal/Soup",
      "meal_type": "Lunch",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 0, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 280.0, "protein_g": 15.0, "carbohydrates_g": 40.0, "fat_g": 5.0, "fiber_g": 15.0, "sodium_mg": 600.0, "cholesterol_mg": 0.0, "water_ml": 200.0,
      "ingredients": ["Lentils", "Onion", "Carrot", "Potato", "Stock"]
  },
  {
      "display_name_en": "Salmon with Asparagus",
      "display_name_es": "Salmón con espárragos",
      "display_name_de": "Lachs mit Spargel",
      "display_name_fr": "Saumon aux asperges",
      "display_name_pt": "Salmão com espargos",
      "display_name_tr": "Kuşkonmazlı Somon",
      "category": "Meal/Fish",
      "meal_type": "Dinner",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
      "calories_kcal": 450.0, "protein_g": 35.0, "carbohydrates_g": 5.0, "fat_g": 28.0, "fiber_g": 4.0, "sodium_mg": 100.0, "cholesterol_mg": 70.0, "water_ml": 0.0,
      "ingredients": ["Salmon Fillet", "Asparagus", "Butter", "Lemon"]
  },
  {
      "display_name_en": "Turkey Wrap",
      "display_name_es": "Wrap de pavo",
      "display_name_de": "Puten-Wrap",
      "display_name_fr": "Wrap à la dinde",
      "display_name_pt": "Wrap de peru",
      "display_name_tr": "Hindi Füme Dürüm",
      "category": "Meal/Sandwich",
      "meal_type": "Lunch",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 380.0, "protein_g": 25.0, "carbohydrates_g": 35.0, "fat_g": 12.0, "fiber_g": 3.0, "sodium_mg": 800.0, "cholesterol_mg": 50.0, "water_ml": 0.0,
      "ingredients": ["Tortilla", "Turkey Breast", "Lettuce", "Cheese", "Mustard"]
  },
  {
      "display_name_en": "Vegetable Stir Fry",
      "display_name_es": "Salteado de verduras",
      "display_name_de": "Gemüsepfanne",
      "display_name_fr": "Poêlée de légumes",
      "display_name_pt": "Refogado de legumes",
      "display_name_tr": "Sebzeli Sote",
      "category": "Meal/Plant",
      "meal_type": "Dinner",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 250.0, "protein_g": 8.0, "carbohydrates_g": 20.0, "fat_g": 15.0, "fiber_g": 8.0, "sodium_mg": 300.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
      "ingredients": ["Broccoli", "Carrots", "Peppers", "Soy Sauce", "Ginger"]
  },
  {
      "display_name_en": "Beef Steak with Broccoli",
      "display_name_es": "Bistec de res con brócoli",
      "display_name_de": "Rindersteak mit Brokkoli",
      "display_name_fr": "Steak de boeuf au brocoli",
      "display_name_pt": "Bife com brócolis",
      "display_name_tr": "Brokolili Biftek",
      "category": "Meal/Protein",
      "meal_type": "Dinner",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 500.0, "protein_g": 45.0, "carbohydrates_g": 10.0, "fat_g": 30.0, "fiber_g": 5.0, "sodium_mg": 150.0, "cholesterol_mg": 100.0, "water_ml": 0.0,
      "ingredients": ["Beef Steak", "Broccoli", "Garlic", "Butter"]
  },
  {
      "display_name_en": "Chicken Curry",
      "display_name_es": "Pollo al curry",
      "display_name_de": "Hühnchen-Curry",
      "display_name_fr": "Poulet au curry",
      "display_name_pt": "Frango ao curry",
      "display_name_tr": "Tavuk Köri",
      "category": "Meal/Protein",
      "meal_type": "Dinner",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 450.0, "protein_g": 30.0, "carbohydrates_g": 20.0, "fat_g": 25.0, "fiber_g": 2.0, "sodium_mg": 600.0, "cholesterol_mg": 80.0, "water_ml": 0.0,
      "ingredients": ["Chicken Breast", "Coconut Milk", "Curry Powder", "Rice"]
  },
  {
      "display_name_en": "Zucchini Noodles with Pesto",
      "display_name_es": "Fideos de calabacín con pesto",
      "display_name_de": "Zucchini-Nudeln mit Pesto",
      "display_name_fr": "Nouilles de courgettes au pesto",
      "display_name_pt": "Macarrão de abobrinha com pesto",
      "display_name_tr": "Pestolu Kabak Spagetti",
      "category": "Meal/Plant",
      "meal_type": "Dinner",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 0, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 280.0, "protein_g": 8.0, "carbohydrates_g": 10.0, "fat_g": 22.0, "fiber_g": 4.0, "sodium_mg": 300.0, "cholesterol_mg": 10.0, "water_ml": 0.0,
      "ingredients": ["Zucchini", "Basil Pesto", "Parmesan Cheese", "Pine Nuts"]
  },
  {
      "display_name_en": "Kofte",
      "display_name_es": "Kofte",
      "display_name_de": "Köfte",
      "display_name_fr": "Kofte",
      "display_name_pt": "Kofte",
      "display_name_tr": "Izgara Köfte",
      "category": "Meal/Protein",
      "meal_type": "Dinner",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
      "calories_kcal": 400.0, "protein_g": 28.0, "carbohydrates_g": 10.0, "fat_g": 25.0, "fiber_g": 2.0, "sodium_mg": 550.0, "cholesterol_mg": 90.0, "water_ml": 0.0,
      "ingredients": ["Ground Beef", "Onion", "Spices", "Parsley"]
  },
  {
      "display_name_en": "Green Beans with Olive Oil",
      "display_name_es": "Judías verdes con aceite de oliva",
      "display_name_de": "Grüne Bohnen mit Olivenöl",
      "display_name_fr": "Haricots verts à l'huile d'olive",
      "display_name_pt": "Vagem com azeite",
      "display_name_tr": "Zeytinyağlı Taze Fasulye",
      "category": "Meal/Plant",
      "meal_type": "Lunch",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 1, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 200.0, "protein_g": 4.0, "carbohydrates_g": 15.0, "fat_g": 14.0, "fiber_g": 6.0, "sodium_mg": 300.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
      "ingredients": ["Green Beans", "Olive Oil", "Onion", "Tomato"]
  },
  {
      "display_name_en": "Stuffed Peppers (Dolma)",
      "display_name_es": "Pimientos rellenos",
      "display_name_de": "Gefüllte Paprika",
      "display_name_fr": "Poivrons farcis",
      "display_name_pt": "Pimentões recheados",
      "display_name_tr": "Biber Dolması",
      "category": "Meal/Mixed",
      "meal_type": "Dinner",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
      "calories_kcal": 350.0, "protein_g": 15.0, "carbohydrates_g": 40.0, "fat_g": 15.0, "fiber_g": 5.0, "sodium_mg": 500.0, "cholesterol_mg": 40.0, "water_ml": 0.0,
      "ingredients": ["Bell Peppers", "Rice", "Ground Beef", "Herbs"]
  },
  {
      "display_name_en": "Shakshuka",
      "display_name_es": "Shakshuka",
      "display_name_de": "Shakshuka",
      "display_name_fr": "Shakshuka",
      "display_name_pt": "Shakshuka",
      "display_name_tr": "Şakşuka",
      "category": "Meal/Protein",
      "meal_type": "Breakfast",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
      "calories_kcal": 300.0, "protein_g": 14.0, "carbohydrates_g": 12.0, "fat_g": 20.0, "fiber_g": 4.0, "sodium_mg": 450.0, "cholesterol_mg": 250.0, "water_ml": 0.0,
      "ingredients": ["Eggs", "Tomatoes", "Peppers", "Onion", "Cumin"]
  },
  {
      "display_name_en": "Smoothie Bowl",
      "display_name_es": "Bol de batido",
      "display_name_de": "Smoothie-Bowl",
      "display_name_fr": "Bol de smoothie",
      "display_name_pt": "Tigela de smoothie",
      "display_name_tr": "Smoothie Kasesi",
      "category": "Meal/Plant",
      "meal_type": "Breakfast",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 0,
      "calories_kcal": 280.0, "protein_g": 8.0, "carbohydrates_g": 45.0, "fat_g": 6.0, "fiber_g": 9.0, "sodium_mg": 20.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
      "ingredients": ["Banana", "Berries", "Spinach", "Almond Milk", "Granola"]
  },
  {
      "display_name_en": "Club Sandwich",
      "display_name_es": "Sándwich club",
      "display_name_de": "Club-Sandwich",
      "display_name_fr": "Club sandwich",
      "display_name_pt": "Club sandwich",
      "display_name_tr": "Kulüp Sandviç",
      "category": "Meal/Sandwich",
      "meal_type": "Lunch",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 0, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 450.0, "protein_g": 25.0, "carbohydrates_g": 40.0, "fat_g": 20.0, "fiber_g": 4.0, "sodium_mg": 850.0, "cholesterol_mg": 60.0, "water_ml": 0.0,
      "ingredients": ["Bread", "Chicken", "Bacon", "Lettuce", "Tomato", "Mayo"]
  },
  {
      "display_name_en": "Beef Stir Fry",
      "display_name_es": "Salteado de ternera",
      "display_name_de": "Rindfleischpfanne",
      "display_name_fr": "Sauté de boeuf",
      "display_name_pt": "Refogado de carne",
      "display_name_tr": "Et Sote",
      "category": "Meal/Protein",
      "meal_type": "Dinner",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 420.0, "protein_g": 35.0, "carbohydrates_g": 15.0, "fat_g": 22.0, "fiber_g": 3.0, "sodium_mg": 500.0, "cholesterol_mg": 80.0, "water_ml": 0.0,
      "ingredients": ["Beef Strips", "Bell Peppers", "Onion", "Soy Sauce"]
  },
  {
      "display_name_en": "Boiled Egg (1 large)",
      "display_name_es": "Huevo duro",
      "display_name_de": "Gekochtes Ei",
      "display_name_fr": "Œuf dur",
      "display_name_pt": "Ovo cozido",
      "display_name_tr": "Haşlanmış Yumurta",
      "category": "Snack",
      "meal_type": "Snack",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
      "calories_kcal": 78.0, "protein_g": 6.0, "carbohydrates_g": 0.6, "fat_g": 5.0, "fiber_g": 0.0, "sodium_mg": 62.0, "cholesterol_mg": 186.0, "water_ml": 0.0,
      "ingredients": ["Egg"]
  },
  {
      "display_name_en": "Ayran",
      "display_name_es": "Ayran",
      "display_name_de": "Ayran",
      "display_name_fr": "Ayran",
      "display_name_pt": "Ayran",
      "display_name_tr": "Ayran (300ml)",
      "category": "Snack",
      "meal_type": "Snack",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 0, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 1,
      "calories_kcal": 110.0, "protein_g": 6.0, "carbohydrates_g": 9.0, "fat_g": 6.0, "fiber_g": 0.0, "sodium_mg": 300.0, "cholesterol_mg": 15.0, "water_ml": 250.0,
      "ingredients": ["Yogurt", "Water", "Salt"]
  },
  {
      "display_name_en": "Tomato Soup",
      "display_name_es": "Sopa de tomate",
      "display_name_de": "Tomatensuppe",
      "display_name_fr": "Soupe à la tomate",
      "display_name_pt": "Sopa de tomate",
      "display_name_tr": "Domates Çorbası",
      "category": "Meal/Soup",
      "meal_type": "Lunch",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 150.0, "protein_g": 3.0, "carbohydrates_g": 20.0, "fat_g": 6.0, "fiber_g": 2.0, "sodium_mg": 400.0, "cholesterol_mg": 5.0, "water_ml": 200.0,
      "ingredients": ["Tomatoes", "Onion", "Garlic", "Cream", "Stock"]
  },
  {
      "display_name_en": "Grilled Cheese Sandwich",
      "display_name_es": "Sándwich de queso a la parrilla",
      "display_name_de": "Käsetoast",
      "display_name_fr": "Croque-monsieur au fromage",
      "display_name_pt": "Queijo quente",
      "display_name_tr": "Kaşarlı Tost",
      "category": "Meal/Grain",
      "meal_type": "Breakfast",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 0, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 350.0, "protein_g": 15.0, "carbohydrates_g": 30.0, "fat_g": 18.0, "fiber_g": 2.0, "sodium_mg": 600.0, "cholesterol_mg": 40.0, "water_ml": 0.0,
      "ingredients": ["Bread", "Cheddar Cheese", "Butter"]
  },
  {
      "display_name_en": "Chicken Wrap",
      "display_name_es": "Wrap de pollo",
      "display_name_de": "Hähnchen-Wrap",
      "display_name_fr": "Wrap au poulet",
      "display_name_pt": "Wrap de frango",
      "display_name_tr": "Tavuk Dürüm",
      "category": "Meal/Sandwich",
      "meal_type": "Lunch",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 420.0, "protein_g": 28.0, "carbohydrates_g": 35.0, "fat_g": 16.0, "fiber_g": 3.0, "sodium_mg": 700.0, "cholesterol_mg": 60.0, "water_ml": 0.0,
      "ingredients": ["Tortilla", "Chicken Breast", "Lettuce", "Tomatoes"]
  },
  {
      "display_name_en": "Rice Pudding",
      "display_name_es": "Arroz con leche",
      "display_name_de": "Milchreis",
      "display_name_fr": "Riz au lait",
      "display_name_pt": "Arroz doce",
      "display_name_tr": "Sütlaç",
      "category": "Snack",
      "meal_type": "Snack",
      "is_bonus": 1, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 0, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 280.0, "protein_g": 6.0, "carbohydrates_g": 45.0, "fat_g": 8.0, "fiber_g": 1.0, "sodium_mg": 80.0, "cholesterol_mg": 15.0, "water_ml": 0.0,
      "ingredients": ["Rice", "Milk", "Sugar", "Cinnamon"]
  },
  {
      "display_name_en": "Hummus with Veggies",
      "display_name_es": "Humus con verduras",
      "display_name_de": "Hummus mit Gemüse",
      "display_name_fr": "Houmous aux légumes",
      "display_name_pt": "Homus com legumes",
      "display_name_tr": "Sebzeli Humus",
      "category": "Snack",
      "meal_type": "Snack",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 0, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 200.0, "protein_g": 6.0, "carbohydrates_g": 20.0, "fat_g": 10.0, "fiber_g": 6.0, "sodium_mg": 300.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
      "ingredients": ["Chickpeas", "Tahini", "Carrots", "Cucumber", "Olive Oil"]
  },
  {
      "display_name_en": "Beef Burger (Homemade)",
      "display_name_es": "Hamburguesa casera",
      "display_name_de": "Hausgemachter Burger",
      "display_name_fr": "Burger maison",
      "display_name_pt": "Hambúrguer caseiro",
      "display_name_tr": "Ev Yapımı Hamburger",
      "category": "Meal/Mixed",
      "meal_type": "Dinner",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 0, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 550.0, "protein_g": 35.0, "carbohydrates_g": 40.0, "fat_g": 25.0, "fiber_g": 3.0, "sodium_mg": 600.0, "cholesterol_mg": 80.0, "water_ml": 0.0,
      "ingredients": ["Ground Beef", "Burger Bun", "Lettuce", "Tomato", "Pickles"]
  },
  {
      "display_name_en": "Quinoa Salad",
      "display_name_es": "Ensalada de quinoa",
      "display_name_de": "Quinoa-Salat",
      "display_name_fr": "Salade de quinoa",
      "display_name_pt": "Salada de quinoa",
      "display_name_tr": "Kinoa Salatası",
      "category": "Meal/Salad",
      "meal_type": "Lunch",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 350.0, "protein_g": 12.0, "carbohydrates_g": 45.0, "fat_g": 14.0, "fiber_g": 6.0, "sodium_mg": 200.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
      "ingredients": ["Quinoa", "Cucumber", "Cherry Tomatoes", "Parsley", "Lemon Juice"]
  },
  {
      "display_name_en": "Protein Bar",
      "display_name_es": "Barra de proteínas",
      "display_name_de": "Proteinriegel",
      "display_name_fr": "Barre protéinée",
      "display_name_pt": "Barra de proteína",
      "display_name_tr": "Protein Bar",
      "category": "Snack",
      "meal_type": "Snack",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 0, "diet_high_protein": 1, "diet_low_carb": 1, "diet_keto": 0, "diet_balanced": 0, "diet_high_fiber": 1, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 200.0, "protein_g": 20.0, "carbohydrates_g": 20.0, "fat_g": 7.0, "fiber_g": 5.0, "sodium_mg": 150.0, "cholesterol_mg": 5.0, "water_ml": 0.0,
      "ingredients": ["Protein Bar"]
  },
  {
      "display_name_en": "Green Smoothie",
      "display_name_es": "Batido verde",
      "display_name_de": "Grüner Smoothie",
      "display_name_fr": "Smoothie vert",
      "display_name_pt": "Suco verde",
      "display_name_tr": "Yeşil Smoothie",
      "category": "Snack",
      "meal_type": "Snack",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 1, "diet_high_fiber": 1, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 150.0, "protein_g": 4.0, "carbohydrates_g": 30.0, "fat_g": 1.0, "fiber_g": 5.0, "sodium_mg": 30.0, "cholesterol_mg": 0.0, "water_ml": 200.0,
      "ingredients": ["Spinach", "Apple", "Cucumber", "Lemon", "Ginger"]
  },
  {
      "display_name_en": "Lahmacun",
      "display_name_es": "Lahmacun",
      "display_name_de": "Lahmacun",
      "display_name_fr": "Lahmacun",
      "display_name_pt": "Lahmacun",
      "display_name_tr": "Lahmacun (1 adet)",
      "category": "Meal/Mixed",
      "meal_type": "Dinner",
      "is_bonus": 0, "diet_vegetarian": 0, "diet_vegan": 0, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 0, "diet_high_fiber": 0, "diet_low_sodium": 0, "diet_low_cholesterol": 0, "diet_mediterranean": 0,
      "calories_kcal": 380.0, "protein_g": 15.0, "carbohydrates_g": 45.0, "fat_g": 14.0, "fiber_g": 3.0, "sodium_mg": 700.0, "cholesterol_mg": 35.0, "water_ml": 0.0,
      "ingredients": ["Dough", "Ground Beef", "Tomatoes", "Onion", "Parsley"]
  },
  {
      "display_name_en": "Etsiz Çiğ Köfte",
      "display_name_es": "Çiğ Köfte Vegano",
      "display_name_de": "Çiğ Köfte Vegan",
      "display_name_fr": "Çiğ Köfte Végétarien",
      "display_name_pt": "Çiğ Köfte Vegano",
      "display_name_tr": "Etsiz Çiğ Köfte (4 adet)",
      "category": "Snack",
      "meal_type": "Snack",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 0, "diet_keto": 0, "diet_balanced": 0, "diet_high_fiber": 1, "diet_low_sodium": 0, "diet_low_cholesterol": 1, "diet_mediterranean": 0,
      "calories_kcal": 240.0, "protein_g": 5.0, "carbohydrates_g": 35.0, "fat_g": 8.0, "fiber_g": 6.0, "sodium_mg": 500.0, "cholesterol_mg": 0.0, "water_ml": 0.0,
      "ingredients": ["Bulgur", "Tomato Paste", "Spices", "Pomegranate Syrup", "Lettuce"]
  },
  {
      "display_name_en": "Filter Coffee (Black)",
      "display_name_es": "Café de filtro",
      "display_name_de": "Filterkaffee",
      "display_name_fr": "Café filtre",
      "display_name_pt": "Café coado",
      "display_name_tr": "Filtre Kahve (Sade)",
      "category": "Snack",
      "meal_type": "Snack",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 2.0, "protein_g": 0.0, "carbohydrates_g": 0.0, "fat_g": 0.0, "fiber_g": 0.0, "sodium_mg": 5.0, "cholesterol_mg": 0.0, "water_ml": 240.0,
      "ingredients": ["Coffee"]
  },
  {
      "display_name_en": "Turkish Tea",
      "display_name_es": "Té turco",
      "display_name_de": "Türkischer Tee",
      "display_name_fr": "Thé turc",
      "display_name_pt": "Chá turco",
      "display_name_tr": "Çay (Şekersiz)",
      "category": "Snack",
      "meal_type": "Snack",
      "is_bonus": 0, "diet_vegetarian": 1, "diet_vegan": 1, "diet_high_protein": 0, "diet_low_carb": 1, "diet_keto": 1, "diet_balanced": 1, "diet_high_fiber": 0, "diet_low_sodium": 1, "diet_low_cholesterol": 1, "diet_mediterranean": 1,
      "calories_kcal": 1.0, "protein_g": 0.0, "carbohydrates_g": 0.0, "fat_g": 0.0, "fiber_g": 0.0, "sodium_mg": 0.0, "cholesterol_mg": 0.0, "water_ml": 100.0,
      "ingredients": ["Tea"]
  },
  {
    "category": "Meal/Breakfast",
    "meal_type": "Breakfast",
    "is_bonus": 0,
    "diet_vegetarian": 1, 
    "diet_vegan": 0, 
    "diet_high_protein": 1, 
    "diet_low_carb": 1, 
    "diet_keto": 1, 
    "diet_balanced": 1, 
    "diet_high_fiber": 0, 
    "diet_low_sodium": 0, 
    "diet_low_cholesterol": 0, 
    "diet_mediterranean": 1,
    "calories_kcal": 340.0, 
    "protein_g": 18.0, 
    "carbohydrates_g": 12.0, 
    "fat_g": 24.0, 
    "fiber_g": 4.0, 
    "sodium_mg": 450.0, 
    "cholesterol_mg": 400.0, 
    "water_ml": 0.0,
    "display_name_en": "Menemen Example",
    "display_name_es": "Menemen",
    "display_name_de": "Menemen",
    "display_name_fr": "Menemen",
    "display_name_pt": "Menemen",
    "display_name_tr": "Menemen",
    "ingredients_details": [
      {
        "category_en": "Produce",
        "name_en": "Tomatoes",
        "name_es": "Tomates",
        "name_de": "Tomaten",
        "name_fr": "Tomates",
        "name_pt": "Tomates",
        "name_tr": "Domates"
      },
      {
        "category_en": "Produce",
        "name_en": "Green Peppers",
        "name_es": "Pimientos Verdes",
        "name_de": "Grüne Paprika",
        "name_fr": "Poivrons Verts",
        "name_pt": "Pimentão Verde",
        "name_tr": "Yeşil Biber"
      },
      {
        "category_en": "Dairy & Eggs",
        "name_en": "Eggs",
        "name_es": "Huevos",
        "name_de": "Eier",
        "name_fr": "Œufs",
        "name_pt": "Ovos",
        "name_tr": "Yumurta"
      },
      {
        "category_en": "Pantry",
        "name_en": "Olive Oil",
        "name_es": "Aceite de Oliva",
        "name_de": "Olivenöl",
        "name_fr": "Huile d'Olive",
        "name_pt": "Azeite",
        "name_tr": "Zeytinyağı"
      }
    ]
  }
];
